import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="150%" height="150%" viewBox="0 0 488 476">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="">
          <path
            fill="#FAFEFD"
            opacity="1.000000"
            stroke="none"
            d="
M1.000000,113.000000 
	C1.000000,75.342964 1.000000,38.185921 0.999999,1.021662 
	C163.614899,1.014442 326.229797,1.014442 488.922363,1.014442 
	C488.922363,159.573761 488.922363,318.147583 488.922363,476.860718 
	C326.333405,476.860718 163.666733,476.860718 1.000000,476.860718 
	C1.000000,355.770111 1.000000,234.635056 1.000000,113.000000 
M56.775906,47.862511 
	C56.775906,47.862511 56.720070,47.656506 56.174801,47.782333 
	C55.998470,48.093132 55.822136,48.403931 55.775852,48.773678 
	C55.775852,48.773678 55.711327,48.646301 55.177929,48.755600 
	C54.980629,49.043755 54.783329,49.331905 54.592834,49.573986 
	C54.592834,49.573986 54.546673,49.580143 53.946758,49.783684 
	C52.650074,51.200111 51.353390,52.616535 50.011284,53.994335 
	C50.011284,53.994335 50.029190,54.051128 49.427025,54.149208 
	C49.151554,54.672432 48.876087,55.195652 48.747303,55.793690 
	C48.747303,55.793690 48.729591,55.629990 48.101826,55.775841 
	C47.875992,56.129116 47.650162,56.482391 46.922318,56.930882 
	C46.629379,57.319984 46.336441,57.709087 45.528305,58.168957 
	C45.355453,58.454536 45.182606,58.740116 44.459167,59.229458 
	C43.967442,59.817459 43.475716,60.405457 42.502361,61.156216 
	C42.355469,61.449947 42.208576,61.743683 42.012028,61.995060 
	C42.012028,61.995060 42.034134,62.056408 41.432281,62.157249 
	C41.154945,62.677704 40.877609,63.198154 40.747444,63.793804 
	C40.747444,63.793804 40.730270,63.629429 40.103291,63.780155 
	C39.871929,64.129204 39.640572,64.478249 39.127014,64.839714 
	C39.127014,64.839714 39.026787,65.103806 38.378120,65.258507 
	C36.472626,67.385376 34.567131,69.512245 32.735107,71.970474 
	C32.735107,71.970474 32.697220,71.633293 32.142437,71.741783 
	C31.970953,72.059479 31.799467,72.377182 31.862761,72.726120 
	C31.862761,72.726120 31.645706,72.631325 31.072266,72.749779 
	C30.562237,73.309860 30.052206,73.869942 29.559940,74.520317 
	C29.559940,74.520317 29.477144,74.560493 29.007088,74.745781 
	C28.864382,75.040337 28.721676,75.334892 28.868654,75.842041 
	C28.868654,75.842041 28.614281,75.588257 28.103176,75.717896 
	C27.926334,76.007149 27.749493,76.296402 27.850349,76.634651 
	C27.850349,76.634651 27.591324,76.523186 27.026953,76.668167 
	C26.696259,77.119911 26.365564,77.571655 25.999748,77.999695 
	C25.999748,77.999695 26.023434,78.034836 25.436296,78.181671 
	C25.157566,78.695869 24.878838,79.210075 24.741892,79.776772 
	C24.741892,79.776772 24.692266,79.633957 24.146523,79.747314 
	C23.972916,80.057014 23.799311,80.366714 23.850916,80.833450 
	C23.850916,80.833450 23.667746,80.628929 23.140471,80.745094 
	C22.958439,81.038857 22.776409,81.332619 22.561256,81.626495 
	C22.561256,81.626495 22.551161,81.594948 21.942242,81.790306 
	C20.435762,83.344460 18.929283,84.898613 17.012043,87.248894 
	C16.983181,187.835983 16.950262,288.423065 16.968651,389.010162 
	C16.968899,390.356842 17.618565,391.703400 17.991518,392.995148 
	C17.991518,392.995148 17.946590,393.036987 18.188213,393.661194 
	C20.779955,396.124207 23.371696,398.587250 25.995729,400.997498 
	C25.995729,400.997498 25.948732,401.038422 26.182396,401.662903 
	C28.436489,403.799805 30.690582,405.936707 32.996292,408.012115 
	C32.996292,408.012115 32.920460,408.038422 33.024971,408.586151 
	C33.336147,408.755554 33.647324,408.924957 33.979607,409.012726 
	C33.979607,409.012726 33.911301,409.062103 34.133995,409.670807 
	C35.415215,410.788666 36.696434,411.906525 38.000305,413.000000 
	C38.000305,413.000000 37.972668,413.018127 38.087914,413.539368 
	C38.381054,413.713104 38.674198,413.886871 38.997890,414.002960 
	C38.997890,414.002960 38.939770,414.032623 39.063850,414.562469 
	C39.371208,414.730988 39.678570,414.899506 40.105034,415.531921 
	C40.276245,415.836487 40.535973,416.003082 41.016556,416.577454 
	C41.334473,416.741211 41.652390,416.904938 41.990486,417.000977 
	C41.990486,417.000977 41.935909,417.045868 42.174351,417.668854 
	C44.430569,419.804230 46.686783,421.939636 48.995987,424.013031 
	C48.995987,424.013031 48.918861,424.039520 49.023151,424.588776 
	C49.335522,424.756317 49.647892,424.923859 49.979977,425.010803 
	C49.979977,425.010803 49.913532,425.060486 50.145580,425.664886 
	C51.425457,426.782043 52.705334,427.899200 54.000000,429.000000 
	C54.000000,429.000000 53.984207,429.015594 54.160637,429.618530 
	C55.092747,430.431885 56.024857,431.245239 56.999722,432.005585 
	C56.999722,432.005585 56.936623,432.031219 57.045322,432.573730 
	C57.356907,432.730255 57.668488,432.886780 57.994530,432.996399 
	C57.994530,432.996399 57.958565,433.030243 58.219658,433.641602 
	C60.470230,435.774567 62.720802,437.907532 65.001915,440.002045 
	C65.001915,440.002045 64.956467,440.020325 65.053421,440.566010 
	C65.357101,440.738159 65.660789,440.910309 65.984932,441.006714 
	C65.984932,441.006714 65.921669,441.053070 66.168945,441.677368 
	C72.045151,447.569550 77.745461,453.655518 83.899529,459.241577 
	C85.871574,461.031586 89.015930,462.335297 91.671356,462.422882 
	C101.322205,462.741119 110.993149,462.398254 120.656532,462.396423 
	C197.974655,462.381836 275.292786,462.385468 352.610901,462.390594 
	C367.940918,462.391602 383.273621,462.272797 398.598969,462.549133 
	C402.284180,462.615570 404.834839,461.628326 407.380066,459.061188 
	C427.084564,439.187744 446.777100,419.298676 466.776184,399.723816 
	C471.516144,395.084412 473.498688,390.455078 473.482605,383.680908 
	C473.252289,286.533936 473.323914,189.386200 473.420105,92.238739 
	C473.424164,88.135437 472.379974,85.083046 469.365601,82.114082 
	C451.460236,64.478188 433.780457,46.613388 415.934692,28.916422 
	C414.660950,27.653255 412.667877,27.115446 410.579193,25.718025 
	C409.204041,24.416162 407.828918,23.114302 406.431335,21.155632 
	C405.773438,20.383770 405.115540,19.611906 404.252899,17.980455 
	C402.225159,17.623751 400.197632,16.956112 398.169678,16.954945 
	C296.938141,16.896704 195.706558,16.894205 94.474991,16.898554 
	C92.651093,16.898632 90.827187,17.055122 88.281197,16.966547 
	C85.751846,19.205839 83.222496,21.445131 81.023705,23.872627 
	C81.023705,23.872627 80.696999,23.670622 80.094727,23.780998 
	C79.604164,24.399321 79.113602,25.017641 78.960213,25.855976 
	C78.960213,25.855976 78.620621,25.626230 78.049339,25.767042 
	C77.540222,26.357582 77.031097,26.948120 76.081100,27.724932 
	C75.801239,27.914917 75.626274,28.175377 75.157799,28.700027 
	C75.157799,28.700027 74.972282,29.103086 74.441429,29.262899 
	C74.001297,29.839327 73.561172,30.415756 72.734802,31.235937 
	C72.734802,31.235937 72.655785,31.685770 72.938667,31.943459 
	C72.938667,31.943459 72.681389,31.660204 72.094193,31.783371 
	C71.594360,32.380859 71.094521,32.978352 70.779968,33.960873 
	C70.779968,33.960873 70.560661,33.594124 69.944290,33.786392 
	C68.488846,35.361080 67.033401,36.935768 65.726295,38.559208 
	C65.726295,38.559208 65.572060,38.583546 65.069862,38.780197 
	C64.930054,39.100033 64.790245,39.419868 64.811829,39.752987 
	C64.811829,39.752987 64.679161,39.660126 64.081779,39.781738 
	C63.595432,40.399830 63.109085,41.017921 62.978840,41.767757 
	C62.978840,41.767757 62.622135,41.620914 62.199642,41.714050 
	C62.199642,41.714050 62.003521,42.101814 61.464462,42.277130 
	C60.994316,42.854031 60.524170,43.430935 59.692211,44.179192 
	C59.692211,44.179192 59.584126,44.564655 59.664364,44.784870 
	C59.664364,44.784870 59.598606,44.573692 59.173679,44.708485 
	C59.173679,44.708485 58.969753,45.104900 58.439495,45.264523 
	C58.000015,45.840408 57.560532,46.416294 56.734787,47.236053 
	C56.734787,47.236053 56.655907,47.686001 56.775906,47.862511 
z"
          />
          <path
            fill="#01BF62"
            opacity="1.000000"
            stroke="none"
            d="
M39.026787,65.103806 
	C39.026787,65.103806 39.127014,64.839714 39.606163,64.787712 
	C40.300301,64.366951 40.515285,63.998192 40.730270,63.629429 
	C40.730270,63.629429 40.747444,63.793804 40.993065,63.733322 
	C41.503834,63.134033 41.768982,62.595219 42.034134,62.056408 
	C42.034134,62.056408 42.012028,61.995060 42.359558,62.023804 
	C43.136921,62.032070 43.566750,62.011597 44.316353,61.949478 
	C45.086018,61.270294 45.535908,60.632755 46.003700,59.679298 
	C46.028900,58.941654 46.036201,58.519924 46.043503,58.098194 
	C46.336441,57.709087 46.629379,57.319984 47.510475,56.835297 
	C48.308949,56.369801 48.519268,55.999893 48.729591,55.629990 
	C48.729591,55.629990 48.747303,55.793690 48.994469,55.734833 
	C49.504154,55.134357 49.766674,54.592743 50.029190,54.051128 
	C50.029190,54.051128 50.011284,53.994335 50.405807,54.016312 
	C52.049107,52.552242 53.297890,51.066193 54.546669,49.580139 
	C54.546673,49.580143 54.592834,49.573986 54.897141,49.616024 
	C55.371407,49.320808 55.541367,48.983555 55.711327,48.646301 
	C55.711327,48.646301 55.775852,48.773678 56.013367,48.726719 
	C56.407280,48.338676 56.563675,47.997589 56.720070,47.656506 
	C56.720070,47.656506 56.775906,47.862511 56.914257,47.829018 
	C57.176395,47.746899 57.300179,47.698273 57.423962,47.649651 
	C57.322990,47.430489 57.222019,47.211334 57.121048,46.992176 
	C57.560532,46.416294 58.000015,45.840408 58.695847,45.414536 
	C58.952194,45.564545 58.979687,46.024216 59.210075,46.279945 
	C61.111832,47.152470 62.783199,47.769268 64.781189,48.506599 
	C64.040741,46.657860 63.504887,45.319946 62.962261,43.582355 
	C62.844372,42.662090 62.733253,42.141502 62.622131,41.620914 
	C62.622135,41.620914 62.978840,41.767757 63.174530,41.782391 
	C63.806534,41.084724 64.242851,40.372425 64.679161,39.660126 
	C64.679161,39.660126 64.811829,39.752987 65.034164,39.706703 
	C65.361687,39.301460 65.466873,38.942505 65.572060,38.583546 
	C65.572060,38.583546 65.726295,38.559208 66.038895,38.694290 
	C66.901459,38.881031 67.451424,38.932686 68.319916,38.945305 
	C69.086136,38.271553 69.533836,37.636837 70.130562,36.673660 
	C70.373276,35.428169 70.466972,34.511147 70.560661,33.594124 
	C70.560661,33.594124 70.779968,33.960873 71.059662,33.866943 
	C71.786690,33.068745 72.234039,32.364475 72.681389,31.660202 
	C72.681389,31.660204 72.938667,31.943459 72.995560,31.869434 
	C73.176262,31.746828 73.300064,31.698248 73.423866,31.649668 
	C73.322929,31.430506 73.221985,31.211344 73.121040,30.992184 
	C73.561172,30.415756 74.001297,29.839327 74.703812,29.411007 
	C74.966194,29.559113 75.015152,30.013042 75.210281,30.262939 
	C76.592209,29.673317 77.778999,28.833796 78.958344,27.593391 
	C78.840797,26.670418 78.730713,26.148323 78.620621,25.626230 
	C78.620621,25.626230 78.960213,25.855976 79.164398,25.826843 
	C79.811394,25.088682 80.254196,24.379652 80.696999,23.670622 
	C80.696999,23.670622 81.023705,23.872627 81.218712,23.876362 
	C82.609108,23.255735 83.804497,22.631376 85.352859,21.998302 
	C86.467789,21.325155 87.229736,20.660723 87.995850,19.998108 
	C88.000000,19.999924 87.996178,19.991348 88.370239,19.998863 
	C90.872879,19.943716 93.435242,22.492758 95.412125,18.973776 
	C100.224411,18.981939 104.613556,18.985506 109.234253,19.261375 
	C110.644028,19.686249 111.822250,19.838821 113.054718,20.384439 
	C115.255486,21.518393 117.401192,22.904520 119.548653,22.907225 
	C206.069992,23.016220 292.591492,23.000286 379.112946,22.999290 
	C380.277557,22.999277 381.648987,23.367205 382.552277,22.877705 
	C383.584839,22.318174 384.201050,20.990360 385.416473,19.995827 
	C387.888885,19.662529 389.942963,19.329784 392.447083,18.999569 
	C395.596893,19.004354 398.296661,19.006617 401.062866,19.367361 
	C402.904144,20.421373 404.678986,21.116903 406.453796,21.812437 
	C407.828918,23.114302 409.204041,24.416162 410.828369,26.310886 
	C420.501038,36.648926 429.986755,46.335197 439.302124,56.182659 
	C441.499237,58.505291 443.122589,61.370682 444.878296,64.294548 
	C445.426483,65.998764 446.106323,67.394814 446.786133,68.790863 
	C447.532684,68.177460 448.279236,67.564056 449.322937,67.108040 
	C455.090393,72.207611 460.686371,77.020531 465.967499,82.157150 
	C468.009552,84.143333 470.261749,86.675331 470.793518,89.289185 
	C471.807892,94.275368 471.905029,99.497063 471.942230,104.624176 
	C472.065491,121.622498 471.994598,138.622238 471.994781,155.621445 
	C471.995575,230.117935 472.032623,304.614471 471.924438,379.110809 
	C471.915741,385.111847 472.185822,391.520081 466.872498,396.050629 
	C464.038300,398.467316 460.886261,400.545074 458.249298,403.151764 
	C453.503815,407.842712 449.149445,412.928375 444.423889,417.640717 
	C439.714813,422.336609 434.526062,426.563141 429.948547,431.376678 
	C422.216522,439.507538 415.024811,448.162659 407.106720,456.099335 
	C404.907532,458.303711 400.950897,459.843048 397.797089,459.848999 
	C295.968933,460.040894 194.140320,460.017700 92.311874,459.931061 
	C90.311600,459.929382 87.838387,459.332916 86.397690,458.080231 
	C81.205635,453.565704 76.446396,448.556915 71.333023,443.946198 
	C69.858528,442.616608 67.743202,441.997742 65.921677,441.053040 
	C65.921669,441.053070 65.984932,441.006714 65.892654,440.797119 
	C65.519073,440.398438 65.237770,440.209381 64.956467,440.020325 
	C64.956467,440.020325 65.001915,440.002045 65.007187,439.645599 
	C63.776428,435.945923 61.956272,433.261017 57.958565,433.030243 
	C57.958565,433.030243 57.994530,432.996399 57.894615,432.778687 
	C57.508671,432.384399 57.222649,432.207825 56.936623,432.031219 
	C56.936623,432.031219 56.999722,432.005585 57.006187,431.688599 
	C56.681007,430.576477 56.349361,429.781403 55.924805,428.820190 
	C55.531471,428.736755 55.231052,428.819427 54.692398,428.916870 
	C54.454159,428.931641 53.984207,429.015594 53.984207,429.015594 
	C53.984207,429.015594 54.000000,429.000000 54.007462,428.626709 
	C52.647797,427.189087 51.280674,426.124786 49.913540,425.060486 
	C49.913532,425.060486 49.979977,425.010803 49.883652,424.801422 
	C49.497841,424.407867 49.208359,424.223694 48.918869,424.039490 
	C48.918861,424.039520 48.995987,424.013031 48.999107,423.670471 
	C47.980465,419.733734 46.114479,417.089142 41.935909,417.045868 
	C41.935909,417.045868 41.990486,417.000977 41.884281,416.785187 
	C41.480122,416.390167 41.182163,416.210907 40.884209,416.031647 
	C40.535973,416.003082 40.276245,415.836487 39.957382,415.052307 
	C39.519745,414.392639 39.229759,414.212646 38.939770,414.032623 
	C38.939770,414.032623 38.997890,414.002960 38.903954,413.786530 
	C38.530899,413.386108 38.251781,413.202118 37.972664,413.018127 
	C37.972668,413.018127 38.000305,413.000000 38.005604,412.630249 
	C36.644367,411.194366 35.277832,410.128235 33.911301,409.062103 
	C33.911301,409.062103 33.979607,409.012726 33.883789,408.803223 
	C33.498798,408.408600 33.209629,408.223511 32.920460,408.038422 
	C32.920460,408.038422 32.996292,408.012115 32.998802,407.665222 
	C31.802742,403.931000 29.966560,401.259674 25.948732,401.038422 
	C25.948732,401.038422 25.995729,400.997498 25.999943,400.648590 
	C24.638218,396.414398 22.314348,393.591919 17.946590,393.036987 
	C17.946590,393.036987 17.991518,392.995148 18.003792,392.591370 
	C18.013056,390.461823 18.010046,388.735992 18.383924,387.002869 
	C19.694162,386.834045 20.627516,386.672607 21.051928,386.599182 
	C20.671453,383.386475 20.035486,380.509613 20.033215,377.632233 
	C19.977873,307.531982 19.989992,237.431702 19.989988,167.331421 
	C19.989986,146.517792 20.034304,125.703903 19.904753,104.891090 
	C19.894524,103.247887 18.675987,101.612198 18.019211,99.549347 
	C18.023178,97.430580 18.026937,95.735481 18.389259,93.950912 
	C19.489616,91.572678 20.231413,89.283913 21.046801,86.635101 
	C21.597317,84.715027 22.074240,83.154984 22.551163,81.594948 
	C22.551161,81.594948 22.561256,81.626495 22.885235,81.641785 
	C23.362059,81.314362 23.514902,80.971642 23.667744,80.628929 
	C23.667746,80.628929 23.850916,80.833450 24.043125,80.748657 
	C24.387644,80.320564 24.539957,79.977264 24.692268,79.633957 
	C24.692266,79.633957 24.741892,79.776772 24.992481,79.723923 
	C25.503191,79.125664 25.763313,78.580254 26.023434,78.034836 
	C26.023434,78.034836 25.999748,77.999695 26.341932,77.982513 
	C26.986517,77.484619 27.288918,77.003899 27.591322,76.523186 
	C27.591324,76.523186 27.850349,76.634651 28.023371,76.637070 
	C28.335688,76.289085 28.474983,75.938667 28.614281,75.588257 
	C28.614281,75.588257 28.868654,75.842041 29.036222,75.740753 
	C29.294909,75.279808 29.386026,74.920151 29.477146,74.560493 
	C29.477144,74.560493 29.559940,74.520317 29.918226,74.621277 
	C30.732912,74.025276 31.189310,73.328300 31.645706,72.631325 
	C31.645706,72.631325 31.862761,72.726120 32.051109,72.697777 
	C32.392048,72.324051 32.544632,71.978676 32.697220,71.633293 
	C32.697220,71.633293 32.735107,71.970474 33.078335,71.916077 
	C35.289970,69.609047 37.158379,67.356430 39.026787,65.103806 
M444.829010,78.714211 
	C444.891602,78.473083 444.954163,78.231964 444.926971,77.353096 
	C444.284943,76.902878 443.642944,76.452660 442.708588,75.402710 
	C435.962189,68.435699 429.233429,61.451492 422.464203,54.506775 
	C416.353943,48.238132 410.444672,41.739105 403.939514,35.907513 
	C401.456818,33.681908 401.013519,29.096544 396.341156,29.211527 
	C391.776733,29.323854 387.203552,29.005140 382.634216,29.004351 
	C294.676727,28.989157 206.719254,28.997864 118.761787,28.963516 
	C116.627785,28.962683 114.475166,28.221886 112.363708,28.352272 
	C106.992340,28.683973 100.241196,27.450092 96.565392,30.206947 
	C88.503555,36.253342 82.067436,44.446224 74.840782,51.635269 
	C70.523766,55.929813 65.906319,59.920807 61.534763,64.162491 
	C57.059181,68.505112 52.436504,72.746750 48.405602,77.481583 
	C44.967781,81.519768 42.278374,86.195099 39.236893,91.080910 
	C39.155476,91.401001 39.036606,91.706520 38.240284,92.397408 
	C37.497299,96.562378 36.111538,100.726471 36.105854,104.892448 
	C35.981552,195.988419 35.983364,287.084656 36.126900,378.180573 
	C36.131763,381.267334 37.110645,384.923096 38.939697,387.317322 
	C42.711666,392.254761 47.292381,396.592438 51.731064,400.984100 
	C52.446053,401.691437 54.145229,401.404053 55.128677,401.882172 
	C55.128677,401.882172 55.421062,401.606567 55.202312,402.348389 
	C56.560776,406.992554 59.075436,410.350586 64.010712,410.918182 
	C64.010712,410.918182 64.398430,410.621155 64.194977,411.359772 
	C65.453354,414.746063 67.203674,417.567780 71.102318,418.019928 
	C71.102318,418.019928 71.389290,417.624451 71.156143,418.385773 
	C72.622337,420.599854 73.704918,423.255859 75.637161,424.933014 
	C79.297653,428.110321 83.445549,430.726135 87.157318,433.868927 
	C87.157318,433.868927 87.426361,433.607239 87.172073,434.366669 
	C88.307213,439.110931 96.437531,446.759735 100.921219,446.948425 
	C105.826897,447.154846 110.747879,446.998566 115.662186,446.998596 
	C149.320038,446.998901 182.977905,446.998627 216.635757,446.998840 
	C275.287048,446.999207 333.938385,447.022034 392.589508,446.916718 
	C394.880127,446.912598 397.743439,446.325439 399.344116,444.895386 
	C403.277069,441.381653 406.525543,437.115875 410.237335,433.337250 
	C415.935394,427.536560 421.701385,421.795990 427.604462,416.205078 
	C433.908783,410.234131 440.484711,404.549896 446.787781,398.577667 
	C450.343872,395.208191 453.589172,391.510681 457.436890,388.510834 
	C459.599030,388.054291 461.761169,387.597717 463.923340,387.141174 
	C463.863281,386.531128 463.803223,385.921112 463.743195,385.311066 
	C461.829590,384.540344 459.916016,383.769623 457.995422,382.061737 
	C457.998566,287.374725 458.001740,192.687729 458.725922,97.923996 
	C465.604401,94.320076 467.460297,91.689896 466.289093,88.457245 
	C463.386505,89.000793 460.678253,89.507950 457.426636,89.622406 
	C454.953156,87.082214 452.479675,84.542030 450.491486,81.621338 
	C450.441284,80.908592 450.391083,80.195854 450.340851,79.483109 
	C449.893890,79.989494 449.446960,80.495888 448.264954,80.983803 
	C447.529846,80.975632 446.794769,80.967461 446.002045,80.998451 
	C446.002045,80.998451 446.039734,80.939888 445.979370,80.295708 
	C445.498749,80.002937 445.018158,79.710167 444.524231,79.337791 
	C444.524231,79.337791 444.447388,79.362442 444.829010,78.714211 
M79.716232,31.997339 
	C79.978729,32.157818 80.241226,32.318295 80.503723,32.478775 
	C80.340652,32.217587 80.177582,31.956396 79.716232,31.997339 
M447.524261,76.641144 
	C447.471375,76.846283 447.418488,77.051430 447.365601,77.256577 
	C447.494568,77.125153 447.623505,76.993729 447.524261,76.641144 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M66.045311,441.365204 
	C67.743202,441.997742 69.858528,442.616608 71.333023,443.946198 
	C76.446396,448.556915 81.205635,453.565704 86.397690,458.080231 
	C87.838387,459.332916 90.311600,459.929382 92.311874,459.931061 
	C194.140320,460.017700 295.968933,460.040894 397.797089,459.848999 
	C400.950897,459.843048 404.907532,458.303711 407.106720,456.099335 
	C415.024811,448.162659 422.216522,439.507538 429.948547,431.376678 
	C434.526062,426.563141 439.714813,422.336609 444.423889,417.640717 
	C449.149445,412.928375 453.503815,407.842712 458.249298,403.151764 
	C460.886261,400.545074 464.038300,398.467316 466.872498,396.050629 
	C472.185822,391.520081 471.915741,385.111847 471.924438,379.110809 
	C472.032623,304.614471 471.995575,230.117935 471.994781,155.621445 
	C471.994598,138.622238 472.065491,121.622498 471.942230,104.624176 
	C471.905029,99.497063 471.807892,94.275368 470.793518,89.289185 
	C470.261749,86.675331 468.009552,84.143333 465.967499,82.157150 
	C460.686371,77.020531 455.090393,72.207611 449.308441,66.729973 
	C447.667816,65.458473 446.338867,64.722427 445.009918,63.986382 
	C443.122589,61.370682 441.499237,58.505291 439.302124,56.182659 
	C429.986755,46.335197 420.501038,36.648926 411.043396,26.572054 
	C412.667877,27.115446 414.660950,27.653255 415.934692,28.916422 
	C433.780457,46.613388 451.460236,64.478188 469.365601,82.114082 
	C472.379974,85.083046 473.424164,88.135437 473.420105,92.238739 
	C473.323914,189.386200 473.252289,286.533936 473.482605,383.680908 
	C473.498688,390.455078 471.516144,395.084412 466.776184,399.723816 
	C446.777100,419.298676 427.084564,439.187744 407.380066,459.061188 
	C404.834839,461.628326 402.284180,462.615570 398.598969,462.549133 
	C383.273621,462.272797 367.940918,462.391602 352.610901,462.390594 
	C275.292786,462.385468 197.974655,462.381836 120.656532,462.396423 
	C110.993149,462.398254 101.322205,462.741119 91.671356,462.422882 
	C89.015930,462.335297 85.871574,461.031586 83.899529,459.241577 
	C77.745461,453.655518 72.045151,447.569550 66.045311,441.365204 
z"
          />
          <path
            fill="#1DAE66"
            opacity="1.000000"
            stroke="none"
            d="
M400.996429,19.008879 
	C398.296661,19.006617 395.596893,19.004354 392.168671,18.713285 
	C388.946320,18.296515 386.452454,18.168550 383.492523,18.036991 
	C293.366272,18.037483 203.706024,18.041569 113.654625,18.031025 
	C111.843208,18.340620 110.422958,18.664848 109.002708,18.989075 
	C104.613556,18.985506 100.224411,18.981939 95.147400,18.698357 
	C92.639870,18.279179 90.820206,18.140011 89.000710,17.785290 
	C89.000885,17.569733 89.003288,17.138630 89.003288,17.138630 
	C90.827187,17.055122 92.651093,16.898632 94.474991,16.898554 
	C195.706558,16.894205 296.938141,16.896704 398.169678,16.954945 
	C400.197632,16.956112 402.225159,17.623751 404.040710,18.443083 
	C402.884521,18.940100 401.940460,18.974489 400.996429,19.008879 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M18.007038,387.010193 
	C18.010046,388.735992 18.013056,390.461823 17.990591,392.618835 
	C17.618565,391.703400 16.968899,390.356842 16.968651,389.010162 
	C16.950262,288.423065 16.983181,187.835983 17.366413,86.997543 
	C17.720785,86.746201 18.028053,87.027969 18.018345,87.463959 
	C18.015991,89.946770 18.023344,91.993576 18.030697,94.040390 
	C18.026937,95.735481 18.023178,97.430580 18.012154,100.020935 
	C18.005604,196.280869 18.006321,291.645538 18.007038,387.010193 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M88.642242,17.052589 
	C89.003288,17.138630 89.000885,17.569733 88.756577,17.952280 
	C88.340240,18.887001 88.168205,19.439175 87.996178,19.991348 
	C87.996178,19.991348 88.000000,19.999924 87.675529,20.026045 
	C86.567337,20.703783 85.783607,21.355402 84.999886,22.007019 
	C83.804497,22.631376 82.609108,23.255735 81.053436,23.782259 
	C83.222496,21.445131 85.751846,19.205839 88.642242,17.052589 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M18.067402,393.349091 
	C22.314348,393.591919 24.638218,396.414398 25.983797,400.674988 
	C23.371696,398.587250 20.779955,396.124207 18.067402,393.349091 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M42.055130,417.357361 
	C46.114479,417.089142 47.980465,419.733734 48.972614,423.701477 
	C46.686783,421.939636 44.430569,419.804230 42.055130,417.357361 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M26.065563,401.350647 
	C29.966560,401.259674 31.802742,403.931000 32.972996,407.695984 
	C30.690582,405.936707 28.436489,403.799805 26.065563,401.350647 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M62.969032,43.982033 
	C63.504887,45.319946 64.040741,46.657860 64.781189,48.506599 
	C62.783199,47.769268 61.111832,47.152470 59.442894,46.106327 
	C59.496414,45.309219 59.547508,44.941456 59.598602,44.573692 
	C59.598606,44.573692 59.664364,44.784870 59.815964,44.757118 
	C60.097416,44.704170 60.227276,44.678978 60.357132,44.653782 
	C60.256096,44.438465 60.155060,44.223152 60.054024,44.007835 
	C60.524170,43.430935 60.994316,42.854031 61.753609,42.471340 
	C62.351513,43.104378 62.660275,43.543205 62.969032,43.982033 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M38.702454,65.181152 
	C37.158379,67.356430 35.289970,69.609047 33.041603,71.750397 
	C34.567131,69.512245 36.472626,67.385376 38.702454,65.181152 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M58.089111,433.335938 
	C61.956272,433.261017 63.776428,435.945923 64.991920,439.664856 
	C62.720802,437.907532 60.470230,435.774567 58.089111,433.335938 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M22.246702,81.692627 
	C22.074240,83.154984 21.597317,84.715027 20.678886,86.636230 
	C19.500940,87.007599 18.764496,87.017784 18.028053,87.027969 
	C18.028053,87.027969 17.720785,86.746201 17.571795,86.599487 
	C18.929283,84.898613 20.435762,83.344460 22.246702,81.692627 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M70.252472,33.690258 
	C70.466972,34.511147 70.373276,35.428169 69.868103,36.794025 
	C68.971550,37.823353 68.486473,38.403847 68.001396,38.984341 
	C67.451424,38.932686 66.901459,38.881031 65.964722,38.669914 
	C67.033401,36.935768 68.488846,35.361080 70.252472,33.690258 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M401.062866,19.367361 
	C401.940460,18.974489 402.884521,18.940100 404.143097,18.872875 
	C405.115540,19.611906 405.773438,20.383770 406.442566,21.484034 
	C404.678986,21.116903 402.904144,20.421373 401.062866,19.367361 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M54.246712,49.681911 
	C53.297890,51.066193 52.049107,52.552242 50.428513,54.035625 
	C51.353390,52.616535 52.650074,51.200111 54.246712,49.681911 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M34.022644,409.366455 
	C35.277832,410.128235 36.644367,411.194366 37.994278,412.642395 
	C36.696434,411.906525 35.415215,410.788666 34.022644,409.366455 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M50.029564,425.362671 
	C51.280674,426.124786 52.647797,427.189087 54.000069,428.634888 
	C52.705334,427.899200 51.425457,426.782043 50.029564,425.362671 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M45.985802,59.995216 
	C45.535908,60.632755 45.086018,61.270294 44.205475,61.730515 
	C43.573189,61.279068 43.309578,61.092487 42.983990,60.993458 
	C43.475716,60.405457 43.967442,59.817459 44.839611,59.340988 
	C45.416759,59.716007 45.672009,59.896908 45.985802,59.995216 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M56.017715,428.986298 
	C56.349361,429.781403 56.681007,430.576477 56.984810,431.715088 
	C56.024857,431.245239 55.092747,430.431885 54.072422,429.317078 
	C53.984207,429.015594 54.454159,428.931641 54.963547,428.949738 
	C55.654530,428.973999 55.836124,428.980164 56.017715,428.986298 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M31.358986,72.690552 
	C31.189310,73.328300 30.732912,74.025276 29.909344,74.576134 
	C30.052206,73.869942 30.562237,73.309860 31.358986,72.690552 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M72.387787,31.721786 
	C72.234039,32.364475 71.786690,33.068745 70.967018,33.674431 
	C71.094521,32.978352 71.594360,32.380859 72.387787,31.721786 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M78.334976,25.696636 
	C78.730713,26.148323 78.840797,26.670418 78.634415,27.595875 
	C77.885399,28.008543 77.452858,28.017849 76.897240,27.903488 
	C76.774170,27.779821 76.521980,27.538658 76.521980,27.538658 
	C77.031097,26.948120 77.540222,26.357582 78.334976,25.696636 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M80.395859,23.725811 
	C80.254196,24.379652 79.811394,25.088682 78.995819,25.716837 
	C79.113602,25.017641 79.604164,24.399321 80.395859,23.725811 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M64.380470,39.720932 
	C64.242851,40.372425 63.806534,41.084724 62.996475,41.716518 
	C63.109085,41.017921 63.595432,40.399830 64.380470,39.720932 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M42.743176,61.074837 
	C43.309578,61.092487 43.573189,61.279068 43.885700,61.772160 
	C43.566750,62.011597 43.136921,62.032070 42.384384,62.044979 
	C42.208576,61.743683 42.355469,61.449947 42.743176,61.074837 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M41.733208,62.106827 
	C41.768982,62.595219 41.503834,63.134033 40.919479,63.695724 
	C40.877609,63.198154 41.154945,62.677704 41.733208,62.106827 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M62.962265,43.582355 
	C62.660275,43.543205 62.351513,43.104378 62.023136,42.383682 
	C62.003521,42.101814 62.199642,41.714050 62.410889,41.667480 
	C62.733253,42.141502 62.844372,42.662090 62.962265,43.582355 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M46.003700,59.679298 
	C45.672009,59.896908 45.416759,59.716007 45.114906,59.239105 
	C45.182606,58.740116 45.355453,58.454536 45.785904,58.133575 
	C46.036201,58.519924 46.028900,58.941654 46.003700,59.679298 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M49.728107,54.100166 
	C49.766674,54.592743 49.504154,55.134357 48.921127,55.697422 
	C48.876087,55.195652 49.151554,54.672432 49.728107,54.100166 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M25.729866,78.108253 
	C25.763313,78.580254 25.503191,79.125664 24.921589,79.697678 
	C24.878838,79.210075 25.157566,78.695869 25.729866,78.108253 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M27.309135,76.595673 
	C27.288918,77.003899 26.986517,77.484619 26.359493,77.994370 
	C26.365564,77.571655 26.696259,77.119911 27.309135,76.595673 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M65.320961,38.681870 
	C65.466873,38.942505 65.361687,39.301460 64.953461,39.700066 
	C64.790245,39.419868 64.930054,39.100033 65.320961,38.681870 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M59.873116,44.093513 
	C60.155060,44.223152 60.256096,44.438465 60.357132,44.653782 
	C60.227276,44.678978 60.097416,44.704170 59.775841,44.647011 
	C59.584126,44.564655 59.692211,44.179192 59.873116,44.093513 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M59.386139,44.641090 
	C59.547508,44.941456 59.496414,45.309219 59.212502,45.850601 
	C58.979687,46.024216 58.952194,45.564545 58.960976,45.334724 
	C58.969753,45.104900 59.173679,44.708485 59.386139,44.641090 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M39.001808,414.297546 
	C39.229759,414.212646 39.519745,414.392639 39.897831,414.820374 
	C39.678570,414.899506 39.371208,414.730988 39.001808,414.297546 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M23.404106,80.687012 
	C23.514902,80.971642 23.362059,81.314362 22.901798,81.641724 
	C22.776409,81.332619 22.958439,81.038857 23.404106,80.687012 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M65.004944,440.293152 
	C65.237770,440.209381 65.519073,440.398438 65.882431,440.834961 
	C65.660789,440.910309 65.357101,440.738159 65.004944,440.293152 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M56.990974,432.302490 
	C57.222649,432.207825 57.508671,432.384399 57.887383,432.802155 
	C57.668488,432.886780 57.356907,432.730255 56.990974,432.302490 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M48.971012,424.314148 
	C49.208359,424.223694 49.497841,424.407867 49.873795,424.841736 
	C49.647892,424.923859 49.335522,424.756317 48.971012,424.314148 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M24.419395,79.690636 
	C24.539957,79.977264 24.387644,80.320564 23.930519,80.670135 
	C23.799311,80.366714 23.972916,80.057014 24.419395,79.690636 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M40.950382,416.304565 
	C41.182163,416.210907 41.480122,416.390167 41.874191,416.819031 
	C41.652390,416.904938 41.334473,416.741211 40.950382,416.304565 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M38.030289,413.278748 
	C38.251781,413.202118 38.530899,413.386108 38.888680,413.815369 
	C38.674198,413.886871 38.381054,413.713104 38.030289,413.278748 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M75.556221,28.506308 
	C75.626274,28.175377 75.801239,27.914917 76.301544,27.631794 
	C76.521980,27.538658 76.774170,27.779821 76.781204,28.115160 
	C76.588058,28.715139 76.332619,28.905722 75.906021,28.892799 
	C75.790108,28.763350 75.556221,28.506308 75.556221,28.506308 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M32.972717,408.312286 
	C33.209629,408.223511 33.498798,408.408600 33.873234,408.844025 
	C33.647324,408.924957 33.336147,408.755554 32.972717,408.312286 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M75.015152,30.013042 
	C75.015152,30.013042 74.966194,29.559113 74.969238,29.331100 
	C74.972282,29.103086 75.157799,28.700027 75.357010,28.603168 
	C75.556221,28.506308 75.790108,28.763350 75.789444,29.105330 
	C75.586357,29.711710 75.328484,29.900288 75.015152,30.013042 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M72.927917,31.114059 
	C73.221985,31.211344 73.322929,31.430506 73.423866,31.649668 
	C73.300064,31.698248 73.176262,31.746828 72.854126,31.740589 
	C72.655785,31.685770 72.734802,31.235937 72.927917,31.114059 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M40.416782,63.704792 
	C40.515285,63.998192 40.300301,64.366951 39.747265,64.781502 
	C39.640572,64.478249 39.871929,64.129204 40.416782,63.704792 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M29.242117,74.653137 
	C29.386026,74.920151 29.294909,75.279808 28.891380,75.634460 
	C28.721676,75.334892 28.864382,75.040337 29.242117,74.653137 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M32.419827,71.687538 
	C32.544632,71.978676 32.392048,72.324051 31.933720,72.682159 
	C31.799467,72.377182 31.970953,72.059479 32.419827,71.687538 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M56.447433,47.719421 
	C56.563675,47.997589 56.407280,48.338676 55.948341,48.697243 
	C55.822136,48.403931 55.998470,48.093132 56.447433,47.719421 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M55.444626,48.700951 
	C55.541367,48.983555 55.371407,49.320808 54.893734,49.639061 
	C54.783329,49.331905 54.980629,49.043755 55.444626,48.700951 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M48.415707,55.702915 
	C48.519268,55.999893 48.308949,56.369801 47.761482,56.787689 
	C47.650162,56.482391 47.875992,56.129116 48.415707,55.702915 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M56.927917,47.114113 
	C57.222019,47.211334 57.322990,47.430489 57.423962,47.649651 
	C57.300179,47.698273 57.176395,47.746899 56.854256,47.740761 
	C56.655907,47.686001 56.734787,47.236053 56.927917,47.114113 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M28.358727,75.653076 
	C28.474983,75.938667 28.335688,76.289085 27.884521,76.612579 
	C27.749493,76.296402 27.926334,76.007149 28.358727,75.653076 
z"
          />
          <path
            fill="#F4FEFA"
            opacity="1.000000"
            stroke="none"
            d="
M38.880287,91.997475 
	C39.036606,91.706520 39.155476,91.401001 39.568329,90.696487 
	C58.281006,71.944504 76.731949,53.645653 94.973137,35.140045 
	C97.927162,32.143200 100.876549,31.015757 105.023262,31.019949 
	C199.668777,31.115664 294.314484,31.121025 388.959900,30.978388 
	C393.879852,30.970976 397.317291,32.449158 400.730072,35.922020 
	C414.493896,49.928185 428.534271,63.662537 442.494385,77.485710 
	C442.516296,77.474144 442.560059,77.495613 442.648438,77.739532 
	C443.038788,78.132408 443.340729,78.281364 443.640076,78.453339 
	C443.637482,78.476357 443.613312,78.515877 443.676361,78.720932 
	C443.900757,79.192451 444.136749,79.337936 444.447388,79.362442 
	C444.447388,79.362442 444.524231,79.337791 444.610168,79.650940 
	C445.143951,80.289352 445.591858,80.614616 446.039734,80.939880 
	C446.039734,80.939888 446.002045,80.998451 446.132141,81.297699 
	C447.762238,83.158470 449.080505,84.966606 450.798309,86.232590 
	C454.969696,89.306816 455.985168,93.275055 455.978241,98.335182 
	C455.849731,192.497131 455.903351,286.659332 455.774414,380.821289 
	C455.771423,382.997772 454.648041,385.711548 453.121460,387.264923 
	C435.262207,405.437775 417.199615,423.410645 399.266144,441.511047 
	C396.887695,443.911621 394.411346,444.969086 390.939972,444.965942 
	C298.444550,444.882172 205.948425,444.760437 113.454369,445.131592 
	C103.419891,445.171844 95.209206,443.761108 89.353294,435.101105 
	C88.920677,434.461395 88.078262,434.098724 87.426361,433.607239 
	C87.426361,433.607239 87.157318,433.868927 87.147690,433.423004 
	C81.888466,427.859528 76.638885,422.741974 71.389297,417.624451 
	C71.389290,417.624451 71.102318,418.019928 71.120598,417.512726 
	C68.892067,414.877380 66.645256,412.749268 64.398438,410.621155 
	C64.398430,410.621155 64.010712,410.918182 64.090439,410.450684 
	C61.253796,407.190979 58.337429,404.398773 55.421059,401.606567 
	C55.421062,401.606567 55.128677,401.882172 55.136749,401.428558 
	C51.066231,396.809113 47.155201,392.459015 42.849564,388.542816 
	C40.026569,385.975189 38.998669,383.263916 39.002743,379.446045 
	C39.102127,286.290741 39.078712,193.135254 39.066292,99.979813 
	C39.065937,97.319023 38.944996,94.658257 38.880287,91.997475 
M421.123077,73.179047 
	C420.909943,72.895988 420.626221,72.756805 420.022400,73.001686 
	C420.022400,73.001686 420.261414,72.751862 420.120239,72.095215 
	C411.801575,63.703499 403.580231,55.210693 395.069519,47.018486 
	C393.632507,45.635273 390.948700,44.950150 388.839874,44.947922 
	C294.914886,44.848602 200.989792,44.856216 107.064720,44.908863 
	C105.375168,44.909809 103.685997,45.610043 101.666733,46.274048 
	C101.666733,46.274048 101.659676,46.713291 101.846252,46.894508 
	C101.846252,46.894508 101.706223,46.675323 101.142677,46.766533 
	C100.768440,47.183926 100.394203,47.601315 99.615112,48.224472 
	C99.615112,48.224472 99.469330,48.654572 99.172623,48.699776 
	C99.172623,48.699776 99.006325,48.949619 98.427498,48.989487 
	C98.308899,49.320580 98.190300,49.651672 97.819862,50.527275 
	C97.163628,51.272205 96.507385,52.017136 95.193748,52.857441 
	C94.131897,53.907055 93.070045,54.956665 92.000000,56.000000 
	C92.000000,56.000000 92.006195,56.008156 91.371170,56.199009 
	C89.586594,58.138485 87.802017,60.077961 86.000000,62.000000 
	C86.000000,62.000000 86.017380,62.017490 85.465485,62.156471 
	C85.159775,62.613903 84.854065,63.071335 84.558197,63.616322 
	C84.558197,63.616322 84.470299,63.610165 83.867447,63.838791 
	C81.103432,66.693741 78.339424,69.548698 75.502373,72.509094 
	C75.502373,72.509094 75.397896,72.583504 74.818832,72.820068 
	C73.218361,74.552521 71.617897,76.284981 70.000000,78.000000 
	C70.000000,78.000000 70.017372,78.017502 69.465324,78.156616 
	C69.159645,78.614265 68.853966,79.071915 68.558586,79.617058 
	C68.558586,79.617058 68.470955,79.607933 67.895081,79.816124 
	C66.917282,80.871803 65.939484,81.927490 64.371674,83.293167 
	C61.795677,86.737724 56.880363,88.342125 56.883255,93.823891 
	C56.933170,188.475784 56.906052,283.127747 56.972088,377.779633 
	C56.973263,379.461792 57.399002,381.650513 58.488091,382.747803 
	C71.381760,395.738434 84.439690,408.565979 97.549889,421.448303 
	C97.549889,421.448303 97.562729,421.543610 97.815132,422.153381 
	C100.625092,426.273834 104.510803,427.185333 109.405144,427.178253 
	C200.594574,427.046326 291.784882,426.936462 382.972839,427.326050 
	C391.997070,427.364594 397.684296,424.145874 402.044342,417.053436 
	C402.044342,417.053436 402.262848,417.291168 402.911591,417.122925 
	C405.381012,414.497070 407.850433,411.871216 410.066803,409.167419 
	C410.066803,409.167419 410.299683,409.293365 410.936066,409.113708 
	C413.049988,406.826233 415.163910,404.538757 417.005463,402.057953 
	C417.005463,402.057953 417.261017,402.273193 417.708252,402.205994 
	C418.006989,402.061218 418.176117,401.824036 418.773651,401.272919 
	C419.127686,400.818420 419.481720,400.363922 420.394836,399.632874 
	C421.030548,398.848846 421.666260,398.064819 422.095428,397.068726 
	C422.095428,397.068726 422.265625,397.310913 422.700592,397.183472 
	C422.700592,397.183472 422.948914,396.804291 423.553772,396.563995 
	C427.817352,392.357117 432.269775,388.318512 436.246857,383.856262 
	C437.729675,382.192505 438.867310,379.540100 438.870544,377.336609 
	C439.009674,283.083038 439.012848,188.829269 438.939941,94.575584 
	C438.938538,92.756104 438.315826,90.500191 437.146179,89.201591 
	C433.821716,85.510567 430.063354,82.210365 426.211517,78.184227 
	C425.726532,77.786362 425.241577,77.388496 424.544464,76.521935 
	C424.020172,76.098686 423.495911,75.675438 422.733154,74.844414 
	C422.733154,74.844414 422.285248,74.694397 422.133423,74.775810 
	C422.133423,74.775810 422.305420,74.766037 422.153198,74.242889 
	C421.857056,74.052788 421.560913,73.862686 421.303284,73.673187 
	C421.303284,73.673187 421.297913,73.635033 421.123077,73.179047 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M87.299210,433.986938 
	C88.078262,434.098724 88.920677,434.461395 89.353294,435.101105 
	C95.209206,443.761108 103.419891,445.171844 113.454369,445.131592 
	C205.948425,444.760437 298.444550,444.882172 390.939972,444.965942 
	C394.411346,444.969086 396.887695,443.911621 399.266144,441.511047 
	C417.199615,423.410645 435.262207,405.437775 453.121460,387.264923 
	C454.648041,385.711548 455.771423,382.997772 455.774414,380.821289 
	C455.903351,286.659332 455.849731,192.497131 455.978241,98.335182 
	C455.985168,93.275055 454.969696,89.306816 450.798309,86.232590 
	C449.080505,84.966606 447.762238,83.158470 446.160950,81.278114 
	C446.794769,80.967461 447.529846,80.975632 448.742004,81.212105 
	C449.420227,81.713402 449.682587,81.900551 450.006226,82.001846 
	C452.479675,84.542030 454.953156,87.082214 457.705383,90.261185 
	C457.991058,93.266884 457.997986,95.633797 458.004883,98.000717 
	C458.001740,192.687729 457.998566,287.374725 457.956543,382.893433 
	C457.603271,385.137085 457.288849,386.549011 456.974487,387.960968 
	C453.589172,391.510681 450.343872,395.208191 446.787781,398.577667 
	C440.484711,404.549896 433.908783,410.234131 427.604462,416.205078 
	C421.701385,421.795990 415.935394,427.536560 410.237335,433.337250 
	C406.525543,437.115875 403.277069,441.381653 399.344116,444.895386 
	C397.743439,446.325439 394.880127,446.912598 392.589508,446.916718 
	C333.938385,447.022034 275.287048,446.999207 216.635757,446.998840 
	C182.977905,446.998627 149.320038,446.998901 115.662186,446.998596 
	C110.747879,446.998566 105.826897,447.154846 100.921219,446.948425 
	C96.437531,446.759735 88.307213,439.110931 87.299210,433.986938 
z"
          />
          <path
            fill="#03BD67"
            opacity="1.000000"
            stroke="none"
            d="
M114.045792,18.045654 
	C203.706024,18.041569 293.366272,18.037483 383.528900,18.327637 
	C384.353607,19.080040 384.675873,19.538206 384.998169,19.996376 
	C384.201050,20.990360 383.584839,22.318174 382.552277,22.877705 
	C381.648987,23.367205 380.277557,22.999277 379.112946,22.999290 
	C292.591492,23.000286 206.069992,23.016220 119.548653,22.907225 
	C117.401192,22.904520 115.255486,21.518393 113.296249,20.221161 
	C113.670967,19.125109 113.858376,18.585382 114.045792,18.045654 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M442.472504,77.497284 
	C428.534271,63.662537 414.493896,49.928185 400.730072,35.922020 
	C397.317291,32.449158 393.879852,30.970976 388.959900,30.978388 
	C294.314484,31.121025 199.668777,31.115664 105.023262,31.019949 
	C100.876549,31.015757 97.927162,32.143200 94.973137,35.140045 
	C76.731949,53.645653 58.281006,71.944504 39.578827,90.450325 
	C42.278374,86.195099 44.967781,81.519768 48.405602,77.481583 
	C52.436504,72.746750 57.059181,68.505112 61.534763,64.162491 
	C65.906319,59.920807 70.523766,55.929813 74.840782,51.635269 
	C82.067436,44.446224 88.503555,36.253342 96.565392,30.206947 
	C100.241196,27.450092 106.992340,28.683973 112.363708,28.352272 
	C114.475166,28.221886 116.627785,28.962683 118.761787,28.963516 
	C206.719254,28.997864 294.676727,28.989157 382.634216,29.004351 
	C387.203552,29.005140 391.776733,29.323854 396.341156,29.211527 
	C401.013519,29.096544 401.456818,33.681908 403.939514,35.907513 
	C410.444672,41.739105 416.353943,48.238132 422.464203,54.506775 
	C429.233429,61.451492 435.962189,68.435699 442.745392,76.084312 
	C442.678955,77.009712 442.575745,77.253502 442.472504,77.497284 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M38.560287,92.197441 
	C38.944996,94.658257 39.065937,97.319023 39.066292,99.979813 
	C39.078712,193.135254 39.102127,286.290741 39.002743,379.446045 
	C38.998669,383.263916 40.026569,385.975189 42.849564,388.542816 
	C47.155201,392.459015 51.066231,396.809113 55.267128,401.275696 
	C54.145229,401.404053 52.446053,401.691437 51.731064,400.984100 
	C47.292381,396.592438 42.711666,392.254761 38.939697,387.317322 
	C37.110645,384.923096 36.131763,381.267334 36.126900,378.180573 
	C35.983364,287.084656 35.981552,195.988419 36.105854,104.892448 
	C36.111538,100.726471 37.497299,96.562378 38.560287,92.197441 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M18.383924,387.002869 
	C18.006321,291.645538 18.005604,196.280869 18.011946,100.444611 
	C18.675987,101.612198 19.894524,103.247887 19.904753,104.891090 
	C20.034304,125.703903 19.989986,146.517792 19.989988,167.331421 
	C19.989992,237.431702 19.977873,307.531982 20.033215,377.632233 
	C20.035486,380.509613 20.671453,383.386475 21.051928,386.599182 
	C20.627516,386.672607 19.694162,386.834045 18.383924,387.002869 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M71.272720,418.005127 
	C76.638885,422.741974 81.888466,427.859528 87.264511,433.276123 
	C83.445549,430.726135 79.297653,428.110321 75.637161,424.933014 
	C73.704918,423.255859 72.622337,420.599854 71.272720,418.005127 
z"
          />
          <path
            fill="#05BC62"
            opacity="1.000000"
            stroke="none"
            d="
M458.365417,97.962357 
	C457.997986,95.633797 457.991058,93.266884 457.977051,90.457535 
	C460.678253,89.507950 463.386505,89.000793 466.289093,88.457245 
	C467.460297,91.689896 465.604401,94.320076 458.365417,97.962357 
z"
          />
          <path
            fill="#05BC62"
            opacity="1.000000"
            stroke="none"
            d="
M457.205688,388.235901 
	C457.288849,386.549011 457.603271,385.137085 457.960052,383.362030 
	C459.916016,383.769623 461.829590,384.540344 463.743195,385.311066 
	C463.803223,385.921112 463.863281,386.531128 463.923340,387.141174 
	C461.761169,387.597717 459.599030,388.054291 457.205688,388.235901 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M55.311684,401.977478 
	C58.337429,404.398773 61.253796,407.190979 64.276642,410.292480 
	C59.075436,410.350586 56.560776,406.992554 55.311684,401.977478 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M444.878296,64.294548 
	C446.338867,64.722427 447.667816,65.458473 449.011261,66.572594 
	C448.279236,67.564056 447.532684,68.177460 446.786133,68.790863 
	C446.106323,67.394814 445.426483,65.998764 444.878296,64.294548 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M64.296707,410.990479 
	C66.645256,412.749268 68.892067,414.877380 71.255676,417.309753 
	C67.203674,417.567780 65.453354,414.746063 64.296707,410.990479 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M88.370239,19.998863 
	C88.168205,19.439175 88.340240,18.887001 88.756401,18.167835 
	C90.820206,18.140011 92.639870,18.279179 94.724266,18.693764 
	C93.435242,22.492758 90.872879,19.943716 88.370239,19.998863 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M385.416473,19.995823 
	C384.675873,19.538206 384.353607,19.080040 383.994934,18.331230 
	C386.452454,18.168550 388.946320,18.296515 391.718628,18.710758 
	C389.942963,19.329784 387.888885,19.662529 385.416473,19.995823 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M18.018345,87.463959 
	C18.764496,87.017784 19.500940,87.007599 20.605297,86.996277 
	C20.231413,89.283913 19.489616,91.572678 18.389259,93.950912 
	C18.023344,91.993576 18.015991,89.946770 18.018345,87.463959 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M113.654625,18.031025 
	C113.858376,18.585382 113.670967,19.125109 113.242012,19.828117 
	C111.822250,19.838821 110.644028,19.686249 109.234253,19.261375 
	C110.422958,18.664848 111.843208,18.340620 113.654625,18.031025 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M75.210281,30.262939 
	C75.328484,29.900288 75.586357,29.711710 75.905357,29.234779 
	C76.332619,28.905722 76.588058,28.715139 76.904274,28.238827 
	C77.452858,28.017849 77.885399,28.008543 78.641876,27.996756 
	C77.778999,28.833796 76.592209,29.673317 75.210281,30.262939 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M450.248840,81.811600 
	C449.682587,81.900551 449.420227,81.713402 449.109558,81.221344 
	C449.446960,80.495888 449.893890,79.989494 450.340851,79.483109 
	C450.391083,80.195854 450.441284,80.908592 450.248840,81.811600 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M85.352859,21.998304 
	C85.783607,21.355402 86.567337,20.703783 87.671371,20.024227 
	C87.229736,20.660723 86.467789,21.325155 85.352859,21.998304 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M442.494385,77.485718 
	C442.575745,77.253502 442.678955,77.009712 442.891541,76.384178 
	C443.642944,76.452660 444.284943,76.902878 444.606628,77.765144 
	C444.062012,78.290085 443.837677,78.402985 443.613312,78.515877 
	C443.613312,78.515877 443.637482,78.476357 443.637329,78.140137 
	C443.278137,77.701149 442.919098,77.598381 442.560059,77.495621 
	C442.560059,77.495613 442.516296,77.474144 442.494385,77.485718 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M68.319916,38.945305 
	C68.486473,38.403847 68.971550,37.823353 69.719078,37.122490 
	C69.533836,37.636837 69.086136,38.271553 68.319916,38.945305 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M79.865372,31.846273 
	C80.177582,31.956396 80.340652,32.217587 80.503723,32.478775 
	C80.241226,32.318295 79.978729,32.157818 79.865372,31.846273 
z"
          />
          <path
            fill="#1BB36B"
            opacity="1.000000"
            stroke="none"
            d="
M447.638367,76.751724 
	C447.623505,76.993729 447.494568,77.125153 447.365601,77.256577 
	C447.418488,77.051430 447.471375,76.846283 447.638367,76.751724 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M446.009552,80.617798 
	C445.591858,80.614616 445.143951,80.289352 444.616821,79.690735 
	C445.018158,79.710167 445.498749,80.002937 446.009552,80.617798 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M443.676361,78.720932 
	C443.837677,78.402985 444.062012,78.290085 444.651550,78.084015 
	C444.954163,78.231964 444.891602,78.473083 444.638184,79.038330 
	C444.136749,79.337936 443.900757,79.192451 443.676361,78.720932 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M55.924805,428.820190 
	C55.836124,428.980164 55.654530,428.973999 55.201782,428.934937 
	C55.231052,428.819427 55.531471,428.736755 55.924805,428.820190 
z"
          />
          <path
            fill="#01BE64"
            opacity="1.000000"
            stroke="none"
            d="
M99.006325,48.949619 
	C99.006325,48.949619 99.172623,48.699776 99.692215,48.790703 
	C100.468369,48.911377 100.724930,48.941124 101.202057,49.117233 
	C101.517151,48.400833 101.611687,47.538078 101.706223,46.675323 
	C101.706223,46.675323 101.846252,46.894508 102.081894,46.889389 
	C102.888535,46.612740 103.459526,46.341209 104.497101,46.059414 
	C186.519226,46.047146 268.074768,46.045078 349.630310,46.043205 
	C360.282471,46.042961 370.944183,45.782841 381.582123,46.171871 
	C385.863525,46.328438 391.172333,46.619282 394.132751,49.096600 
	C401.461670,55.229614 407.622009,62.743687 414.449585,69.503166 
	C415.969391,71.007759 418.302673,71.690628 420.261414,72.751862 
	C420.261414,72.751862 420.022400,73.001686 420.049255,73.183533 
	C420.057648,73.575768 420.039154,73.786156 420.025208,74.364449 
	C421.258972,75.509903 422.488220,76.287453 423.816254,77.367416 
	C423.978424,78.088051 424.041779,78.506271 424.227905,79.244659 
	C427.840057,82.986839 431.580231,86.198990 434.701508,89.929047 
	C436.042572,91.531639 436.522125,94.187294 436.637085,96.403725 
	C436.798218,99.510231 436.043121,102.653244 436.041718,105.780807 
	C436.003174,190.042313 435.993408,274.303833 436.051544,358.565308 
	C436.055298,364.018829 436.686066,369.470062 436.924438,374.926727 
	C436.980743,376.216614 436.946594,377.675873 436.410828,378.797882 
	C433.969269,383.911133 430.232269,387.291901 424.332855,388.352539 
	C422.817139,388.625031 421.425812,391.020294 420.514099,392.727112 
	C419.888336,393.898560 420.190247,395.565521 419.811462,397.020630 
	C419.368134,397.036865 419.190765,397.043457 418.667938,397.090942 
	C417.901520,398.100281 417.480621,399.068726 417.048889,400.412537 
	C417.112396,401.282990 417.186707,401.778107 417.261017,402.273193 
	C417.261017,402.273193 417.005463,402.057953 416.749969,402.085938 
	C412.401703,402.757355 409.513367,404.440002 410.299683,409.293365 
	C410.299683,409.293365 410.066803,409.167419 409.828003,409.229431 
	C407.074524,411.891571 401.269470,411.478271 402.262848,417.291168 
	C402.262848,417.291168 402.044342,417.053436 401.803650,417.098083 
	C399.529999,418.779846 397.690063,420.791626 395.416962,421.962555 
	C392.329346,423.553070 388.994812,425.014954 385.608490,425.570068 
	C382.596680,426.063812 379.370880,425.054779 376.238037,425.040863 
	C360.407654,424.970459 344.576721,425.008545 328.746002,425.008575 
	C258.757507,425.008728 188.768936,424.975311 118.780548,425.061646 
	C111.872650,425.070160 104.886955,426.259827 98.973236,421.280396 
	C98.741356,421.085144 98.043480,421.443298 97.562729,421.543610 
	C97.562729,421.543610 97.549889,421.448303 97.665909,421.063293 
	C97.367882,419.490753 97.281334,417.985321 96.486961,417.166931 
	C91.104828,411.621582 85.619156,406.174011 80.074768,400.789764 
	C75.944199,396.778503 71.620422,392.966431 67.482704,388.962311 
	C63.115417,384.736023 58.140205,380.354401 58.127789,373.927429 
	C57.952259,283.049683 57.987465,192.171555 58.043655,101.293556 
	C58.047157,95.628914 58.738762,90.049995 64.039612,86.323013 
	C65.000626,85.647331 65.389931,84.158501 66.393005,82.969070 
	C67.318871,81.798027 67.894913,80.702980 68.470955,79.607933 
	C68.470955,79.607933 68.558586,79.617058 68.868805,79.593788 
	C69.458473,79.052841 69.737923,78.535172 70.017365,78.017502 
	C70.017372,78.017502 70.000000,78.000000 70.376991,78.012451 
	C72.301956,76.211105 73.849922,74.397301 75.397888,72.583496 
	C75.397896,72.583504 75.502373,72.509094 75.902740,72.601974 
	C80.260872,70.777237 84.653969,69.250969 84.470299,63.610165 
	C84.470299,63.610165 84.558197,63.616322 84.868599,63.593414 
	C85.458458,63.052834 85.737923,62.535160 86.017380,62.017490 
	C86.017380,62.017490 86.000000,62.000000 86.376190,62.012466 
	C88.503647,60.019341 90.254921,58.013748 92.006195,56.008156 
	C92.006195,56.008156 92.000000,56.000000 92.401169,56.012138 
	C93.818611,54.936878 94.834885,53.849472 95.851151,52.762070 
	C96.507385,52.017136 97.163628,51.272205 98.161194,50.143608 
	C98.771339,49.552567 98.939270,49.282459 99.006325,48.949619 
M271.948364,332.090881 
	C271.948364,332.090881 271.882782,332.192047 271.672668,331.614014 
	C271.119873,331.403900 270.567108,331.193787 270.000000,331.000000 
	C270.000000,331.000000 270.012970,330.983124 269.763519,330.532715 
	C269.459869,330.391998 269.156250,330.251312 268.945892,330.079407 
	C268.945892,330.079407 268.911011,330.171387 268.663635,329.598694 
	C268.095825,329.401825 267.528015,329.204956 266.281219,328.804474 
	C259.505341,326.834412 252.841202,323.882202 245.930664,323.096069 
	C230.944885,321.391388 217.909256,326.520660 206.314911,337.126373 
	C204.221329,341.347015 206.476959,344.252045 212.781876,344.664154 
	C213.113602,344.571472 213.445343,344.478821 213.884750,345.219696 
	C214.693359,346.762421 211.201187,350.239563 216.513718,350.330719 
	C217.125168,350.775604 217.736633,351.220520 218.372208,351.769104 
	C218.372208,351.769104 218.425781,351.677094 218.174850,352.488739 
	C218.854614,353.715424 219.258240,355.274628 220.263474,356.109344 
	C223.968338,359.185730 226.203644,355.339844 229.415237,354.207733 
	C229.612564,354.474731 229.809906,354.741730 229.562454,355.586395 
	C225.809586,357.740723 226.571350,361.074280 227.718674,364.116699 
	C228.801956,366.989258 231.033417,368.416718 234.592163,366.736481 
	C234.592163,366.736481 234.952759,366.691620 234.909729,367.561798 
	C234.609085,370.149963 233.722443,372.847412 234.178909,375.294342 
	C234.603104,377.568420 236.273941,381.176666 237.726456,381.344940 
	C240.247696,381.637115 243.023849,379.729187 245.855652,379.011292 
	C245.855652,379.011292 245.741287,378.721954 246.470901,378.800568 
	C247.584595,376.489929 249.885284,373.978912 249.536835,371.915131 
	C248.999329,368.731720 249.810089,367.593475 252.527985,367.051514 
	C255.052780,366.548126 256.462189,365.556335 254.933563,362.323853 
	C255.323334,361.890198 255.713104,361.456573 256.615173,360.542175 
	C258.109711,359.306335 259.645874,358.116913 261.087372,356.822021 
	C262.622070,355.443359 266.826355,356.328522 265.326447,351.624786 
	C265.859161,351.083466 266.391846,350.542175 267.646179,349.932037 
	C270.039642,348.436890 273.110901,347.437378 274.657349,345.322784 
	C276.650635,342.597229 277.635712,339.030182 278.445068,335.678253 
	C278.543488,335.270660 274.866333,333.951385 272.986816,332.996368 
	C272.986816,332.996368 272.962433,333.067444 272.757721,332.580750 
	C272.450623,332.432404 272.143555,332.284058 271.948364,332.090881 
M141.967682,128.712311 
	C141.967682,128.712311 141.711105,128.687668 141.455353,128.194061 
	C141.353622,127.837875 141.251892,127.481689 141.591949,127.173958 
	C141.591949,127.173958 142.017395,127.038086 142.469437,126.818832 
	C142.669220,126.554352 142.869003,126.289864 143.180923,125.647224 
	C143.180923,125.647224 143.079147,125.266159 143.685211,125.326729 
	C144.441025,125.599442 145.196838,125.872154 146.063339,126.774429 
	C147.054733,126.864288 148.046112,126.954147 149.491180,126.726151 
	C149.614883,126.389702 149.738602,126.053261 150.266068,125.397636 
	C150.723480,125.162392 151.180908,124.927155 152.243042,124.760513 
	C152.502106,124.475349 152.761185,124.190178 153.494049,123.543205 
	C154.379089,122.751144 155.264130,121.959084 156.812820,121.069695 
	C157.175400,120.346535 157.537994,119.623383 158.058426,118.898415 
	C158.058426,118.898415 158.094818,119.052010 158.814529,119.032227 
	C160.557571,117.291504 162.300613,115.550781 164.751648,113.894447 
	C166.458450,113.236900 168.165268,112.579353 170.238113,111.863503 
	C170.331604,111.784958 170.517517,111.672501 170.503204,111.633499 
	C170.425400,111.421455 170.298218,111.227524 170.029312,110.370514 
	C169.975891,109.923325 169.922485,109.476135 170.572937,108.971733 
	C171.730103,108.017799 172.887268,107.063866 174.644104,105.999207 
	C174.831711,105.920975 175.019333,105.842751 175.885742,106.008842 
	C176.590378,106.149803 177.295013,106.290764 178.175583,107.049652 
	C181.608902,105.913025 185.042206,104.776390 188.475510,103.639771 
	C188.153366,103.010216 187.831223,102.380661 187.875015,100.978722 
	C187.942001,99.844177 188.008987,98.709625 188.340805,97.376930 
	C188.520493,97.245071 188.717316,97.147934 189.084717,97.349617 
	C189.185760,97.388374 189.286804,97.427132 189.387848,97.465897 
	C189.282852,97.290985 189.177856,97.116074 189.039398,96.149162 
	C188.565033,92.193008 189.802689,90.304070 194.140564,92.579750 
	C194.448746,93.040428 194.756927,93.501106 195.044052,94.715103 
	C195.626709,95.273384 196.209366,95.831665 197.379745,96.670998 
	C198.237839,96.742302 199.095917,96.813606 200.437302,97.449867 
	C204.138306,96.192711 209.305511,96.016632 211.209412,93.434433 
	C214.357162,89.165245 216.991974,89.419067 221.109955,91.955460 
	C225.741806,91.722771 230.446884,91.850624 234.940674,90.938103 
	C235.789017,90.765831 235.780197,86.451515 236.219513,84.058128 
	C236.261536,83.829147 236.679794,83.669220 237.839462,82.755302 
	C239.678696,90.935844 244.743744,92.478867 252.489029,91.578674 
	C258.657837,90.861717 265.172729,92.964729 271.509308,93.971260 
	C272.913208,94.194260 274.234772,95.025543 275.556885,95.655151 
	C278.536469,97.074066 281.228271,97.953995 284.127411,95.034851 
	C286.382538,92.764198 288.038391,93.928185 289.145660,96.833351 
	C289.797150,98.542725 291.173340,100.291321 292.702698,101.284790 
	C295.849945,103.329247 299.152924,105.434212 302.696991,106.491814 
	C307.172791,107.827469 311.125366,109.553108 314.385315,112.984764 
	C315.126251,113.764694 317.108826,114.179977 318.107544,113.766678 
	C324.187897,111.250511 325.546143,114.741524 326.176239,119.616531 
	C326.318115,120.713982 326.928467,121.841393 327.588806,122.765076 
	C329.990326,126.124329 333.587830,125.804649 335.029449,121.907051 
	C337.421509,115.439949 339.607971,108.887711 341.613495,102.290009 
	C342.875458,98.138443 342.332031,93.470673 337.997681,92.164780 
	C335.251740,91.337456 331.186249,93.111404 328.341980,94.787117 
	C323.531372,97.621269 319.258057,101.357292 314.656067,104.566734 
	C313.964081,105.049301 312.715607,104.733849 311.794220,104.783783 
	C313.095703,101.667603 314.140869,98.918312 315.382965,96.261078 
	C316.601959,93.653366 317.753571,91.122063 321.698761,92.638657 
	C325.036835,93.921883 326.877686,91.225586 327.357788,88.634758 
	C327.633514,87.146828 326.326111,84.668419 324.971405,83.709206 
	C321.254486,81.077461 317.183350,78.925491 313.163422,76.747826 
	C308.742126,74.352722 302.315826,78.446587 304.645844,81.934669 
	C308.060211,87.046013 305.641052,91.151161 305.558197,95.963348 
	C305.558197,95.963348 305.420868,96.210556 304.691620,96.338676 
	C303.519531,97.262161 302.347473,98.185646 301.175385,99.109131 
	C300.680481,98.935219 300.185577,98.761314 299.690674,98.587410 
	C300.039764,92.094360 300.306335,85.595383 300.771545,79.110664 
	C301.017151,75.687408 301.195404,72.757950 297.423035,70.667107 
	C293.588287,68.541679 290.918762,69.416893 288.257874,72.309448 
	C285.901398,74.871101 283.470337,77.364204 281.050751,79.910110 
	C278.439056,77.058037 282.377716,71.940414 276.661469,70.830612 
	C276.661469,70.830612 276.582581,70.537041 276.805603,69.783218 
	C274.613220,65.292740 262.389313,60.538342 257.855988,62.495876 
	C257.450653,62.670906 257.362610,63.580818 257.033356,64.578880 
	C257.033356,64.578880 256.811829,64.958588 256.114136,65.103645 
	C255.075272,67.251732 254.036407,69.399826 253.045609,71.448524 
	C252.006393,68.481064 251.022430,65.671440 249.634933,62.652908 
	C249.377884,62.481274 249.170502,62.262543 248.849701,61.306179 
	C244.998718,59.609291 241.669174,61.569469 241.706009,65.384865 
	C241.721237,66.959938 241.280533,68.539398 240.390182,69.972183 
	C239.944901,69.958443 239.499619,69.944710 238.548401,69.566467 
	C238.269775,69.015968 237.991135,68.465462 238.279846,67.977432 
	C238.515869,67.822197 238.751892,67.666962 238.987915,67.511719 
	C238.468323,67.482811 237.948746,67.453903 237.109512,67.158371 
	C236.919266,66.946365 236.795059,66.700943 236.774323,65.790207 
	C236.454193,65.552780 236.134079,65.315361 235.430984,64.828812 
	C235.186188,64.626968 235.029083,64.371239 235.072861,63.533642 
	C235.061203,63.354099 235.049561,63.174557 234.883865,62.302193 
	C233.010254,60.466766 231.153107,58.249798 228.282684,62.057461 
	C227.442917,63.212658 225.990448,64.314285 225.883835,65.533577 
	C225.615967,68.596954 226.241959,71.744858 225.907455,74.792793 
	C225.779678,75.956947 224.010864,76.941002 222.915298,77.345474 
	C222.234741,76.269051 221.554184,75.192619 220.726364,73.641968 
	C220.548584,73.347969 220.299072,73.140015 219.959427,72.261101 
	C218.315216,70.158386 216.671005,68.055672 214.366455,65.780838 
	C213.922882,65.681206 213.479294,65.581573 212.348907,65.127365 
	C207.739929,64.389870 204.771408,65.181969 204.731216,70.999763 
	C204.704025,74.934326 203.224594,78.858864 202.111130,84.130516 
	C200.583069,81.680084 199.751480,80.346504 198.947708,78.190308 
	C198.374527,76.845970 200.227341,73.797173 196.385086,74.515060 
	C196.385086,74.515060 196.340958,74.327583 196.581650,73.791985 
	C196.299515,73.565926 196.017380,73.339859 195.352325,72.710838 
	C195.217712,72.177147 195.083115,71.643456 195.038925,70.351845 
	C194.215851,69.690048 192.929153,68.309990 192.649719,68.490379 
	C191.418732,69.284988 190.478256,70.529625 189.106888,71.973625 
	C188.804382,72.349670 188.501892,72.725716 187.784790,73.162010 
	C187.935181,73.410210 188.085571,73.658409 188.486771,74.501686 
	C188.607925,74.914009 188.729095,75.326340 188.095291,76.017731 
	C187.820267,77.518814 187.545227,79.019905 186.990158,82.049400 
	C185.191650,80.267975 184.082230,78.902222 182.715576,77.880531 
	C180.854279,76.489052 178.498901,74.069412 176.897202,74.438980 
	C174.802780,74.922218 173.089401,77.582573 171.528015,79.556259 
	C171.003403,80.219414 171.445038,81.646980 171.445038,83.400925 
	C164.698761,81.163132 158.887207,82.149796 153.373093,87.102661 
	C152.972244,87.809258 152.571381,88.515846 152.039627,89.108864 
	C152.039627,89.108864 152.200333,89.173759 151.459641,89.124825 
	C149.515915,90.331520 147.187744,92.916252 145.696701,92.500282 
	C140.009811,90.913780 139.838760,94.021736 139.577927,98.426125 
	C140.252533,101.168770 140.097870,104.561516 144.412888,104.600204 
	C144.412888,104.600204 144.487534,104.691696 144.416367,105.266998 
	C144.741272,105.418785 145.066162,105.570580 145.892563,106.045341 
	C146.467239,106.840996 147.041916,107.636650 147.326843,109.150002 
	C148.672592,111.502052 150.018341,113.854103 151.313965,116.266159 
	C151.313965,116.266159 151.279114,116.336143 150.520920,116.193398 
	C149.228546,117.005524 147.936172,117.817650 146.203674,118.539246 
	C146.203674,118.539246 145.835510,118.281647 145.711349,117.676262 
	C145.348770,117.534920 144.986176,117.393578 144.121078,116.963554 
	C143.559036,116.195396 142.997009,115.427246 142.668579,114.050247 
	C142.467270,113.683434 142.265961,113.316620 141.937698,112.267197 
	C140.027344,109.805573 138.426987,106.969353 136.084015,105.030533 
	C134.792160,103.961510 132.059341,103.806892 130.345245,104.367867 
	C129.216248,104.737366 128.247574,107.061104 128.077042,108.605812 
	C127.654701,112.431740 131.704697,117.230576 136.645218,119.124199 
	C136.865189,119.348122 137.027985,119.607864 136.937363,119.808418 
	C136.937363,119.808418 136.776093,119.955200 136.410446,120.202774 
	C136.202423,120.437134 136.110764,120.710548 135.930313,121.826149 
	C135.900040,122.100792 135.869781,122.375435 135.358704,122.601006 
	C135.358704,122.601006 134.910309,122.420601 134.679596,121.705399 
	C133.317963,121.196281 131.956345,120.687164 130.216431,119.782570 
	C129.590012,119.114594 128.963593,118.446617 128.511932,116.959129 
	C127.646729,116.345268 126.864365,115.434753 125.902725,115.166183 
	C120.103516,113.546532 117.773613,118.290108 114.826622,121.578369 
	C108.023865,129.168945 108.307930,128.995361 116.105019,135.806763 
	C119.545120,138.811966 125.697784,140.720627 123.340714,147.820633 
	C123.340714,147.820633 123.128799,148.046204 122.363739,148.077759 
	C120.684242,148.044342 118.945053,148.278336 117.338165,147.919632 
	C114.358528,147.254456 111.456177,146.243027 108.217094,145.299408 
	C108.217094,145.299408 107.980133,145.093430 107.945053,144.359268 
	C105.923111,143.330505 103.463799,141.063004 101.988960,141.583740 
	C100.107315,142.248108 98.353302,145.011795 97.857315,147.172089 
	C97.585724,148.355026 99.831917,150.375214 101.281631,151.624680 
	C102.882927,153.004791 104.814461,154.044510 106.704926,155.036652 
	C109.830009,156.676758 109.155754,158.360291 106.309830,160.269913 
	C105.881264,160.210068 105.452690,160.150223 104.873398,159.312592 
	C102.704521,158.862076 100.358833,158.792664 98.402092,157.884903 
	C93.756165,155.729553 91.257385,158.631760 89.600967,161.842468 
	C87.780121,165.371887 89.566422,168.436768 92.530533,170.971329 
	C96.690025,174.528076 100.504791,178.493591 104.724556,181.971802 
	C106.752151,183.643097 109.933922,186.124588 111.585930,185.514069 
	C113.961311,184.636230 115.417709,181.271683 117.231995,179.011368 
	C111.387787,174.141678 111.778786,172.469040 117.506081,169.789978 
	C119.783501,168.724655 121.725395,166.442078 123.221413,164.296310 
	C128.554108,156.647446 133.744705,148.892303 138.739777,141.019226 
	C140.480835,138.275024 144.206055,136.140640 142.352005,131.348984 
	C142.333176,130.974533 142.314346,130.600098 142.516052,129.896362 
	C142.389938,129.566254 142.263824,129.236145 141.967682,128.712311 
M350.531128,113.347527 
	C350.380157,113.936234 350.229187,114.524940 350.237885,115.122147 
	C350.237885,115.122147 350.259155,115.280602 349.497650,115.153877 
	C347.902618,117.175980 346.307617,119.198074 344.127686,121.961739 
	C341.977417,122.186150 337.693909,121.311790 337.320526,126.296494 
	C337.180786,128.161987 338.359161,130.126205 338.994049,132.797272 
	C339.278534,137.610138 342.732025,140.517365 346.530914,141.356110 
	C350.270905,142.181854 351.906921,144.026901 353.375122,147.326935 
	C353.375122,147.326935 353.432373,147.684494 353.122375,148.300659 
	C353.088806,148.527420 353.055267,148.754166 352.526428,149.446732 
	C352.738251,151.163803 352.475403,153.167084 353.291138,154.520020 
	C354.162109,155.964600 355.251038,159.599274 358.606232,156.196320 
	C359.394226,156.794357 360.182220,157.392380 360.715454,158.601624 
	C362.159119,163.821442 363.110382,169.251740 365.219910,174.186951 
	C366.622375,177.468018 369.133209,180.996368 372.124268,182.708405 
	C376.613525,185.278015 380.964874,182.997437 384.528564,179.436279 
	C385.833252,178.132507 387.432587,176.483749 389.062622,176.273666 
	C392.888489,175.780594 394.776794,173.129562 394.520081,170.268784 
	C394.029236,164.798920 392.664581,159.343552 390.987488,154.098022 
	C390.652374,153.049973 387.324493,152.790894 385.328888,152.521591 
	C384.492889,152.408813 383.532593,153.217255 381.835541,153.948853 
	C387.000854,146.601471 386.996826,146.477966 381.999969,139.341476 
	C381.997925,138.896637 381.995911,138.451782 381.998383,137.231750 
	C382.939941,134.708954 383.881500,132.186157 384.992706,129.208771 
	C381.873169,130.705673 379.379089,131.902420 376.920166,133.080811 
	C376.920166,133.080811 376.922668,133.064331 376.972229,132.281189 
	C376.224121,131.232300 375.476013,130.183411 374.370331,128.912750 
	C374.162415,128.719513 374.004333,128.491714 373.941528,127.466370 
	C371.931000,125.986443 369.920502,124.506516 367.454071,122.672905 
	C366.960571,122.111488 366.467072,121.550064 365.825470,120.563881 
	C365.825470,120.563881 365.899567,120.120186 366.590454,119.965294 
	C366.588226,118.675644 367.128143,116.754845 366.489410,116.206169 
	C363.796204,113.892685 360.868530,111.789574 357.804535,109.986923 
	C354.318787,107.936119 352.525360,109.020638 353.289612,113.281853 
	C353.289612,113.281853 353.278625,113.417015 352.582428,113.116745 
	C352.079132,113.087280 351.575836,113.057816 350.531128,113.347527 
M174.654770,382.206848 
	C174.173828,382.883881 173.692902,383.560883 173.022781,383.997559 
	C173.022781,383.997559 173.217773,384.237000 172.439987,383.969025 
	C171.947220,382.411743 171.439102,380.859070 170.966110,379.295807 
	C170.511124,377.792023 170.857269,375.197571 167.421478,377.147095 
	C167.064789,377.159119 166.708115,377.171173 165.762802,377.237213 
	C165.541931,377.544708 165.321060,377.852173 165.056946,378.020050 
	C165.056946,378.020050 165.142258,378.138702 164.341537,378.045654 
	C163.230789,377.037018 162.120056,376.028351 161.009003,374.326843 
	C160.665375,373.543945 160.321747,372.761078 159.678375,371.543396 
	C159.359573,371.421021 159.040771,371.298645 158.404449,371.256409 
	C158.404449,371.256409 158.084869,371.327850 157.997467,370.562927 
	C153.847214,360.442657 151.731354,358.799652 142.962646,359.343079 
	C142.962646,357.220215 142.927658,355.124634 142.971115,353.030670 
	C143.031555,350.118011 141.825607,348.672028 138.798218,349.218933 
	C138.798218,349.218933 138.788864,349.189728 138.917282,348.418976 
	C139.196228,345.497131 138.093796,344.309479 134.492966,345.722717 
	C134.038986,345.894257 133.585022,346.065796 132.717377,345.625519 
	C129.079224,344.523712 128.985962,346.788208 128.804718,349.875885 
	C126.483162,351.670593 124.225006,353.555939 121.822899,355.235413 
	C119.222305,357.053619 119.738815,358.541199 122.503609,360.550751 
	C126.654434,361.450348 130.835510,362.240204 134.923813,363.366699 
	C135.544037,363.537567 135.733368,365.272217 136.002121,366.646851 
	C135.896957,366.883789 135.747009,367.087799 134.716431,367.210938 
	C131.315094,370.736023 132.640366,374.544037 134.675217,377.852417 
	C137.878632,383.060730 141.667130,384.082184 148.409119,382.264648 
	C150.473923,381.708008 152.400360,380.995361 152.220734,384.693726 
	C152.220734,384.693726 152.097275,385.010162 151.310806,385.035919 
	C147.152832,386.146210 149.042435,388.867706 150.063629,390.851807 
	C151.402435,393.452942 153.623489,394.558350 156.700928,393.189728 
	C158.056396,392.586914 159.682007,392.591553 161.177078,392.666718 
	C161.177078,392.666718 161.009445,392.969879 160.498856,393.358582 
	C160.654053,394.563751 160.809250,395.768890 161.020676,396.974487 
	C161.020676,396.974487 161.028229,397.030182 161.035721,397.792633 
	C162.034393,398.497925 163.033066,399.203217 164.031723,399.908539 
	C164.548080,399.153503 165.064438,398.398468 165.639511,397.665222 
	C165.639511,397.665222 165.682205,397.619415 166.249008,397.652191 
	C166.397003,397.334534 166.545013,397.016846 166.888519,396.720703 
	C166.888519,396.720703 166.707169,396.644562 167.469070,396.840759 
	C169.142181,396.122406 170.815292,395.404022 173.327408,394.325439 
	C172.703354,396.183411 171.925156,397.467468 171.923950,398.752289 
	C171.922226,400.563049 172.496002,402.374420 173.064148,404.829163 
	C175.649384,406.465179 178.090820,408.425354 180.857361,409.652679 
	C184.086685,411.085266 186.020370,409.139740 186.012985,405.514862 
	C186.009216,403.663513 186.873337,401.801727 187.400589,399.960510 
	C187.886810,398.262726 188.447159,396.586182 189.726501,394.947632 
	C190.475800,394.920746 191.225098,394.893860 192.645065,394.986145 
	C192.870178,395.015839 193.095276,395.045563 193.214661,395.852081 
	C192.009186,399.790100 190.929398,403.772552 189.557831,407.651855 
	C188.489716,410.672791 189.681335,411.553162 192.699692,411.476624 
	C193.579300,409.236084 194.465012,406.979950 195.321075,404.799377 
	C199.492203,404.645599 198.974136,407.494110 199.034851,409.908508 
	C199.099304,412.471497 199.086472,415.051178 203.271835,414.404846 
	C203.271835,412.411102 203.126495,410.465668 203.318710,408.554169 
	C203.467453,407.074860 203.973221,405.616760 204.436951,404.187073 
	C205.202042,401.828278 206.061340,399.500061 206.963196,396.357941 
	C205.826721,391.490631 199.234299,388.980438 192.357986,390.903778 
	C191.884628,390.280182 191.411270,389.656616 190.823792,388.318176 
	C189.549408,387.878387 188.275024,387.438599 186.379715,386.901245 
	C185.595688,386.620728 184.811661,386.340210 183.670822,385.409424 
	C181.806595,384.947418 179.942352,384.485413 177.984039,384.025421 
	C177.984039,384.025421 177.973251,383.931946 177.961472,383.335266 
	C177.265823,383.015137 176.570175,382.694977 175.620605,382.354218 
	C175.620605,382.354218 175.375778,382.282471 174.654770,382.206848 
M374.394440,320.793213 
	C374.587311,320.501831 374.780182,320.210480 375.180115,319.505402 
	C375.377594,319.256592 375.626038,319.079163 376.421326,318.755463 
	C376.535248,318.428802 376.649200,318.102142 376.758972,317.766479 
	C376.758972,317.766479 376.741516,317.753357 377.497406,317.787933 
	C382.134308,314.058868 378.366211,309.733032 378.753204,304.708954 
	C375.507965,305.204651 372.759430,305.624481 369.734436,306.565186 
	C369.195892,306.798309 368.657318,307.031433 367.802704,306.807129 
	C366.517639,306.218140 365.232544,305.629150 363.430695,304.636871 
	C361.872833,305.402069 360.314972,306.167267 357.999176,306.988098 
	C357.336121,307.934784 356.253021,308.814331 356.088959,309.840790 
	C355.601807,312.888092 355.476593,315.993225 355.015137,319.618683 
	C354.729126,320.101349 354.443085,320.584015 353.512726,321.083405 
	C353.805756,322.662476 354.098755,324.241516 354.436707,326.062775 
	C353.679413,326.718811 352.336609,327.882080 350.749786,329.224640 
	C350.749786,329.224640 350.447021,329.222260 349.720642,329.094452 
	C348.995056,329.941040 347.581696,330.859772 347.661652,331.621857 
	C348.028442,335.118286 348.580231,338.422394 343.375153,338.161011 
	C343.329346,339.138275 343.283539,340.115509 342.953217,341.646423 
	C342.266296,342.421173 341.579376,343.195923 340.480560,344.229370 
	C340.218750,344.451416 340.072876,344.733398 340.032013,345.034515 
	C340.032013,345.034515 340.070282,345.057526 339.484039,345.530090 
	C338.723145,348.681519 339.446411,352.649811 334.532471,353.927856 
	C334.532471,353.927856 334.090454,354.063904 333.591034,354.252228 
	C333.432587,354.558197 333.274139,354.864197 333.000916,355.609253 
	C333.000916,355.609253 332.756165,355.991394 332.055542,355.999725 
	C325.735443,361.415619 319.407074,366.821960 313.123108,372.279449 
	C312.847260,372.519012 312.978485,373.227264 312.659271,374.281860 
	C312.090149,374.842163 311.521057,375.402496 310.265778,376.023865 
	C307.975891,376.973572 305.624847,377.800415 303.410797,378.902557 
	C300.294678,380.453766 295.452332,379.661011 294.678406,385.428345 
	C294.433746,385.958832 294.189087,386.489349 293.100250,387.000366 
	C291.078979,387.694763 289.057678,388.389160 286.938110,389.701324 
	C286.894073,390.115997 286.850067,390.530670 286.369171,391.444000 
	C285.442780,391.999542 284.546997,392.940186 283.582550,393.016846 
	C282.265747,393.121490 280.896667,392.568207 279.042816,392.271057 
	C278.709351,392.214264 278.375854,392.157471 277.632477,391.527374 
	C276.829742,392.164520 276.027008,392.801666 275.094910,393.947815 
	C274.992401,394.282440 274.889923,394.617065 273.955261,394.992737 
	C273.127350,395.099884 272.299469,395.207031 271.169891,395.294739 
	C271.169891,395.294739 270.954559,395.082520 270.871613,394.368622 
	C269.653809,393.972748 268.436005,393.576843 267.218262,393.180939 
	C267.311493,394.003387 267.404755,394.825806 267.610107,396.054504 
	C267.631531,396.335571 267.622101,396.615631 266.929871,397.139435 
	C265.559082,399.321014 264.295593,400.742157 262.847076,397.112823 
	C262.045868,395.105255 260.859894,394.064453 259.299988,397.122162 
	C258.876312,397.114777 258.452637,397.107391 257.733765,396.618805 
	C257.153076,397.031036 256.572388,397.443268 255.630081,398.214752 
	C255.416809,398.478729 255.203537,398.742676 254.131363,398.989532 
	C252.133224,398.945221 250.135086,398.900909 247.898300,398.201019 
	C242.245880,395.298126 238.199524,396.249664 235.578110,401.241791 
	C235.313828,401.445160 235.128479,401.704895 234.356216,402.014801 
	C233.912338,402.007355 233.468460,401.999908 232.953125,401.406372 
	C232.637207,400.936005 232.321289,400.465668 231.913635,399.270142 
	C228.486938,394.505280 220.740509,394.379700 217.045563,399.690979 
	C217.036865,400.135284 217.028183,400.579590 216.999664,401.000000 
	C216.999664,401.000000 217.024811,401.017548 216.306198,401.108673 
	C211.817642,405.808075 211.879700,411.281708 216.745224,415.118408 
	C216.893768,415.337616 216.996811,415.576447 217.228195,416.364532 
	C217.546173,416.527618 217.864136,416.690735 218.025406,416.839508 
	C218.025406,416.839508 218.176346,416.794952 218.159470,417.547913 
	C224.581116,422.452393 229.943542,421.485352 232.760330,415.004883 
	C233.491165,415.017700 234.222000,415.030518 234.914276,415.737427 
	C235.117111,416.821991 234.930130,418.354156 235.582626,418.922455 
	C242.724609,425.142609 252.094101,421.593750 254.094330,412.158325 
	C254.411270,410.663300 255.869156,409.410095 256.974152,408.832428 
	C257.349152,410.748016 257.401611,412.815277 258.207275,414.528290 
	C258.789215,415.765686 260.372375,416.532135 261.508972,417.508636 
	C261.882904,417.120544 262.256836,416.732452 262.630768,416.344330 
	C262.386719,414.585663 261.922577,412.821533 261.965790,411.069916 
	C262.002716,409.575867 262.622894,408.096222 263.418732,407.169983 
	C267.143524,409.700256 268.554352,415.612762 275.278107,414.613403 
	C275.459045,412.360657 275.894318,410.090881 275.744904,407.860260 
	C275.611908,405.874939 274.831329,403.933014 274.186127,401.375519 
	C276.894531,405.418365 279.050690,408.636871 281.058929,411.884460 
	C281.058929,411.884460 281.181427,411.796539 281.166138,412.542847 
	C283.104156,414.880768 284.402679,414.922089 284.771332,411.235352 
	C284.771332,411.235352 284.957855,410.987061 285.517181,410.533051 
	C285.847839,409.159729 286.178497,407.786407 286.569641,406.161896 
	C288.311096,406.775177 289.822021,407.307312 292.143616,407.854614 
	C293.559967,407.854614 294.976349,407.854614 297.602570,407.854614 
	C296.573761,404.754303 295.782501,402.369873 294.839203,399.447052 
	C294.828705,399.074493 294.818207,398.701904 294.890045,397.576630 
	C294.949005,396.364441 295.007996,395.152283 295.081238,393.647003 
	C296.277893,394.627289 297.115570,395.313477 298.248627,396.630707 
	C300.169922,398.761047 302.091248,400.891418 304.105469,403.697784 
	C305.448730,404.066803 307.414032,405.164764 308.009064,404.656982 
	C309.355042,403.508392 310.024841,401.567444 310.985748,399.984436 
	C310.985748,399.984436 310.948364,399.966095 311.713867,399.910522 
	C313.125519,398.972778 315.694977,398.095795 315.747894,397.086731 
	C315.974396,392.769989 318.733398,392.882263 321.642975,393.005768 
	C328.590546,393.300568 331.837921,386.717834 330.841370,382.208466 
	C330.512421,380.720001 328.864990,379.522980 327.820404,378.192688 
	C326.871857,379.437225 325.923309,380.681763 324.951965,382.448792 
	C324.943665,382.622864 324.935364,382.796906 324.279907,383.076660 
	C323.196411,383.729858 322.112915,384.383026 320.999603,385.001678 
	C320.999603,385.001678 320.964813,384.972137 320.480804,384.453766 
	C319.044159,383.324219 317.495331,382.299622 316.261505,380.980408 
	C316.001404,380.702301 316.659637,379.051208 317.299713,378.533203 
	C320.277008,376.123566 323.396606,373.889740 326.711273,371.408875 
	C327.312653,371.656738 329.100189,372.393494 331.151672,373.515930 
	C331.352814,373.759918 331.591949,373.958069 331.954376,374.856171 
	C332.194122,377.896912 333.882141,379.267700 337.085571,379.776093 
	C338.945007,379.272766 341.137512,379.185028 342.515411,378.080841 
	C343.150299,377.572083 342.758606,374.448914 341.834686,373.609772 
	C339.986420,371.931183 337.450836,371.009399 335.071808,369.051025 
	C334.390228,367.240509 333.708649,365.429993 333.027069,363.619446 
	C333.419312,363.281372 333.811554,362.943298 334.203796,362.605225 
	C336.366180,363.855133 338.489471,365.180328 340.703247,366.331421 
	C342.503998,367.267792 344.413208,367.995575 346.840942,368.866486 
	C347.219666,368.880280 347.598358,368.894104 348.340271,369.414001 
	C349.586914,367.998413 350.833527,366.582825 352.080170,365.167236 
	C350.373901,364.453217 348.667664,363.739166 346.983490,363.006165 
	C346.983490,363.006165 346.972382,363.036896 347.006805,362.294708 
	C347.255737,359.029846 349.077728,360.345825 350.844360,360.855835 
	C355.369659,362.162231 361.691193,358.239349 361.878906,353.685364 
	C362.083038,348.733429 361.174591,343.580078 366.999359,341.001068 
	C366.999359,341.001068 366.972717,340.982269 367.670074,340.890564 
	C369.471893,339.282684 370.119019,337.891266 366.704742,336.576599 
	C366.197205,335.633423 365.689636,334.690247 365.554810,334.439667 
	C367.856293,333.068115 369.839508,331.886292 372.033447,330.070526 
	C372.427032,329.035797 372.820648,328.001099 373.892487,326.846069 
	C374.736267,323.485779 374.658813,323.166138 371.071228,323.092560 
	C367.480713,323.018860 364.909210,322.182373 365.388336,317.621552 
	C365.864441,317.366821 366.340515,317.112091 367.507263,317.186310 
	C368.472931,317.468567 369.438599,317.750793 370.334991,318.699585 
	C371.514801,319.446014 372.694641,320.192413 374.394440,320.793213 
M215.259277,152.925598 
	C214.839554,152.944717 214.419846,152.963852 214.001038,152.212112 
	C214.503372,150.287521 215.005722,148.362930 215.543945,146.300903 
	C209.106064,147.452652 208.042709,149.241516 209.940353,155.735336 
	C209.585632,157.113846 209.230911,158.492371 208.277832,160.015274 
	C207.524094,160.345993 206.770340,160.676697 205.198975,161.003174 
	C203.934616,161.242386 201.790405,161.139664 201.543747,161.774353 
	C199.386307,167.325821 196.439590,164.408585 192.195068,161.414429 
	C193.358902,166.674652 194.731461,170.353882 194.862442,174.076797 
	C195.047272,179.330139 194.603500,184.660980 193.794174,189.859940 
	C193.553925,191.403290 191.398682,193.158768 189.725449,193.827286 
	C188.004913,194.514740 185.796448,194.085297 183.810028,193.981552 
	C179.501450,193.756500 177.725922,195.841812 177.985519,200.011322 
	C178.078201,201.499771 178.115311,203.009491 177.978668,204.491135 
	C177.548462,209.156128 178.393051,212.274719 184.172424,210.127060 
	C184.507736,210.002457 185.120239,210.623734 184.620163,210.340179 
	C183.019165,213.009521 181.343643,215.202744 180.300797,217.664047 
	C177.969360,223.166672 179.524216,228.801559 179.722641,234.483841 
	C179.961105,241.313202 182.935104,241.997284 189.882828,240.376099 
	C190.970428,240.122299 191.965302,239.471054 193.053970,239.590637 
	C193.363281,240.057983 193.672607,240.525330 194.797684,240.998169 
	C196.932114,241.025299 199.285065,241.358139 199.869781,237.993866 
	C204.579849,237.995712 209.289932,237.997559 214.031952,238.819656 
	C217.567993,243.262177 228.269623,240.855927 231.638474,235.054245 
	C232.425262,235.371857 233.212051,235.689468 234.011154,236.756500 
	C235.018433,237.661453 236.141678,239.431488 237.012024,239.314850 
	C240.051361,238.907501 243.003326,237.848190 246.905960,237.021683 
	C250.270905,237.011887 253.635849,237.002075 257.292664,237.444534 
	C257.855072,237.285049 258.417511,237.125580 259.135071,236.234161 
	C260.755615,235.820068 262.376129,235.405975 264.001801,235.001328 
	C264.001801,235.001328 264.010834,235.006104 264.296021,235.634415 
	C266.189911,236.751602 268.083801,237.868774 270.571930,239.244614 
	C273.137695,240.964859 275.353760,240.906235 277.680450,237.992081 
	C280.854187,238.165665 283.259369,241.835632 287.123657,239.583939 
	C289.149689,238.403397 291.997314,238.729584 294.306244,237.905563 
	C295.993591,237.303360 297.407379,235.934677 298.993683,234.986862 
	C298.993683,234.986862 298.914246,234.936661 299.665863,234.977936 
	C300.352844,234.220718 301.039856,233.463501 301.882416,233.004654 
	C301.882416,233.004654 301.699097,232.722321 302.454468,232.840729 
	C303.249359,232.152100 304.728821,231.460953 304.726288,230.775253 
	C304.711670,226.794113 304.608459,222.775436 304.021942,218.846054 
	C303.539032,215.610855 301.850464,213.005386 298.000366,213.001816 
	C298.000366,213.001816 297.963715,213.053818 298.004395,212.285980 
	C297.916016,210.497528 297.827637,208.709076 297.626770,206.314270 
	C297.669861,205.907364 297.712952,205.500443 298.382874,204.673996 
	C298.554810,203.893021 299.002411,203.055679 298.856049,202.339798 
	C297.413849,195.286377 287.286774,191.948608 281.818604,196.682571 
	C280.569061,197.764389 279.348846,198.880051 278.115112,199.980118 
	C280.808197,191.374146 279.328796,183.514145 275.989777,176.167953 
	C274.371857,172.608353 270.846130,169.915909 267.983093,166.255356 
	C267.372192,165.784561 266.761292,165.313766 265.944489,164.203354 
	C262.173889,161.678574 258.403320,159.153778 255.067810,156.920334 
	C255.850174,155.703903 256.798523,154.229431 257.747955,152.859955 
	C257.747955,152.859955 257.728699,152.745117 258.499634,152.887436 
	C259.343414,152.322998 260.937958,151.720642 260.911682,151.200165 
	C260.709839,147.203156 260.441895,143.174286 259.688995,139.252350 
	C259.163177,136.513153 257.998871,133.854416 256.828613,131.292725 
	C255.621567,128.650421 256.890717,124.053391 251.756866,124.237724 
	C251.756866,124.237724 251.784912,124.358856 251.541504,123.656212 
	C250.844070,123.511215 250.146637,123.366211 249.211502,123.309219 
	C249.211502,123.309219 249.024155,123.138512 248.649490,122.539124 
	C245.049744,121.006081 237.696777,122.709564 235.909210,125.899055 
	C235.125717,127.297012 234.899155,130.642334 235.420456,130.876617 
	C239.449081,132.687195 236.625259,135.781433 237.077087,137.997314 
	C237.077087,137.997314 237.184235,138.142548 236.438751,138.143234 
	C231.393707,139.822769 234.053223,144.973328 231.322418,148.001007 
	C230.871902,148.003525 230.421402,148.006058 229.234863,147.675186 
	C221.486481,145.884460 218.315155,146.969299 216.483795,152.149643 
	C216.234390,152.346039 216.035385,152.584503 215.259277,152.925598 
M323.998474,278.998199 
	C323.998474,278.998199 323.984924,279.027008 324.003113,278.257629 
	C324.002594,277.488129 324.002045,276.718658 324.548157,275.892151 
	C324.910217,275.835785 325.272278,275.779388 326.304779,275.829437 
	C326.739563,274.688568 327.884857,273.039917 327.492157,272.490356 
	C325.187073,269.264709 322.030334,268.087463 318.096313,269.586700 
	C316.468414,270.207092 314.737030,270.555969 312.595551,271.212952 
	C312.309174,271.400299 312.112061,271.656342 311.339172,271.961243 
	C310.900269,271.899139 310.461334,271.837036 309.986481,271.092773 
	C307.532928,267.235657 304.542664,265.111450 299.404816,268.042389 
	C298.936523,268.362000 298.468262,268.681610 297.999847,269.500000 
	C297.999847,269.500000 297.998779,269.998779 297.220123,269.997314 
	C296.146332,268.998199 295.072571,267.999115 294.505035,266.444794 
	C295.306854,266.287201 296.296417,266.369843 296.870605,265.921051 
	C297.996826,265.040833 298.891754,263.864624 299.882385,262.810913 
	C298.720978,262.208984 297.613403,261.409760 296.379639,261.073090 
	C295.526550,260.840271 294.499146,261.246094 293.000000,261.436279 
	C293.000000,263.443115 293.000000,265.221558 292.141846,267.000000 
	C289.521790,266.857178 286.901703,266.714386 284.017242,266.557159 
	C283.436188,267.917542 282.820068,269.359955 282.090485,271.068024 
	C280.232697,270.323486 278.601562,269.669800 276.178772,269.013336 
	C275.119598,269.007294 274.060394,269.001282 272.979706,268.237885 
	C271.375275,267.267975 269.770813,266.298065 268.166382,265.328125 
	C267.450317,266.558624 266.734283,267.789124 266.000732,269.000000 
	C266.000732,269.000000 266.014526,269.020508 265.287354,269.014679 
	C264.306702,269.621857 263.326050,270.229034 262.345398,270.836182 
	C263.211670,271.558746 264.077911,272.281342 264.933167,273.593292 
	C264.636719,274.067322 264.340240,274.541321 263.251068,275.030304 
	C262.100555,276.804657 260.950043,278.579041 259.209198,281.263855 
	C258.386719,277.816895 257.692749,274.908447 256.999969,271.200012 
	C256.999573,270.133331 256.999176,269.066681 257.743286,267.982574 
	C258.392029,267.307800 259.040802,266.633026 259.689575,265.958252 
	C258.277283,265.313995 256.860229,264.117920 255.453598,264.130035 
	C251.404831,264.164825 247.347702,264.588867 243.324219,265.099304 
	C242.483276,265.205963 241.772552,266.339264 240.201401,267.000000 
	C239.134262,267.000000 238.067139,267.000000 236.268494,266.999695 
	C235.178986,267.333282 234.089493,267.666840 232.451660,267.615906 
	C230.301514,267.410187 228.151367,267.204468 226.000320,266.171722 
	C225.999359,265.519897 226.191666,264.786987 225.958939,264.232422 
	C225.400497,262.901733 224.642487,261.654816 223.965012,260.374084 
	C223.503174,261.651764 223.323700,263.155029 222.520660,264.160126 
	C220.850372,266.250671 218.849808,268.077332 216.997299,270.000000 
	C216.997299,270.000000 216.992416,270.011169 216.776749,269.565704 
	C216.574463,269.288879 216.309631,269.099487 215.564133,268.490509 
	C214.712387,268.335083 213.860657,268.179657 212.657074,267.536224 
	C207.607529,266.951355 202.557983,266.366486 198.370163,265.881409 
	C196.889084,263.400696 195.851746,261.663208 195.047699,260.316498 
	C192.737274,262.305450 191.259079,264.661835 189.613953,264.784790 
	C185.213623,265.113647 180.734467,264.572174 176.300323,264.209320 
	C172.427719,263.892426 168.573730,263.347992 164.711517,262.904083 
	C164.677612,263.317444 164.643707,263.730835 164.609802,264.144196 
	C167.740479,265.429047 170.871155,266.713928 173.854630,268.733368 
	C171.236008,268.822662 168.617401,268.911957 165.192169,269.000275 
	C164.199158,268.941681 163.118942,269.117340 162.227646,268.785522 
	C157.323776,266.959961 155.126434,268.356781 155.018326,273.636719 
	C154.933258,277.791748 154.882034,281.954681 155.042694,286.105316 
	C155.172577,289.460846 156.247726,292.701965 160.179428,292.874786 
	C163.932266,293.039795 167.722290,292.312988 171.498642,292.011719 
	C173.061569,291.887054 174.633698,291.755005 176.197723,291.792084 
	C179.713135,291.875488 183.227188,292.188812 186.739563,292.157379 
	C188.668137,292.140106 190.630737,291.209869 192.511108,291.389893 
	C198.571182,291.970032 204.587845,293.246857 210.648071,293.448547 
	C212.720703,293.517517 214.872665,291.203735 217.033798,289.492645 
	C217.033798,289.492645 217.094910,289.008392 217.897491,289.003754 
	C220.212936,289.984894 222.470978,291.616486 224.854477,291.826874 
	C232.447403,292.497162 240.087753,292.908752 247.708298,292.887695 
	C252.598419,292.874176 256.804199,288.478760 257.860199,284.043854 
	C259.106201,284.916199 261.284576,285.643982 261.445953,286.684570 
	C262.445801,293.130890 266.661987,295.769501 272.733124,293.563416 
	C274.987793,292.744141 277.447449,292.101196 279.823120,292.068634 
	C291.056030,291.914795 302.292816,291.936981 313.526703,292.049622 
	C315.973450,292.074127 318.486877,292.470612 320.843231,293.140381 
	C327.202209,294.947754 328.881073,293.755707 328.981903,286.144806 
	C328.636017,283.781921 330.131836,280.496674 325.973419,280.033630 
	C325.973419,280.033630 325.968658,280.077332 325.672485,279.537994 
	C325.106018,279.364899 324.539581,279.191803 323.998474,278.998199 
M273.999939,155.996109 
	C273.999939,155.996109 273.995880,156.021225 273.994324,156.756866 
	C274.330170,158.171646 274.666016,159.586426 274.535248,161.340866 
	C274.497406,161.873749 274.459564,162.406616 274.421722,162.939499 
	C274.577148,162.941849 274.732574,162.944199 274.888000,162.946564 
	C274.924652,162.297012 274.961334,161.647476 275.729340,161.003281 
	C276.833221,162.018906 277.876923,163.112000 279.057129,164.029449 
	C280.365021,165.046173 281.797668,165.902390 283.100769,166.827621 
	C283.100769,166.827621 283.163300,166.869370 283.036743,167.700256 
	C284.760468,174.525131 286.298279,181.406128 288.330292,188.137939 
	C288.882172,189.966248 290.925507,191.344330 292.284302,192.929047 
	C293.499084,190.992050 295.867462,188.959229 295.716003,187.135727 
	C295.228271,181.264465 294.632935,175.142563 292.483093,169.754074 
	C290.870209,165.711380 286.797546,162.650085 283.891998,158.994247 
	C283.891998,158.994247 283.853363,159.163055 283.874329,158.455963 
	C283.178680,157.998520 282.483063,157.541092 281.364624,156.908813 
	C281.127106,156.692657 280.993561,156.424683 280.986511,155.313660 
	C279.894562,154.580109 278.802582,153.846558 277.334381,152.994980 
	C277.088348,152.862885 276.926880,152.662628 276.934540,151.598267 
	C275.380707,147.870590 270.240692,144.943604 266.566193,145.826706 
	C266.972778,146.727844 267.366577,147.600632 267.637421,148.648880 
	C267.637421,148.648880 267.482758,148.797195 267.167542,148.464325 
	C267.023590,148.492828 266.879669,148.521332 266.735718,148.549820 
	C266.990601,148.664230 267.245483,148.778625 267.466431,149.545959 
	C267.475220,149.981567 267.484039,150.417160 266.864471,151.158096 
	C266.843079,156.283051 270.504486,156.005569 273.999939,155.996109 
M120.009476,315.707733 
	C120.123108,315.649048 120.236732,315.590332 120.350365,315.531647 
	C120.179886,315.372925 120.009407,315.214203 119.819870,314.325287 
	C119.433983,311.277252 117.491570,311.547333 115.081284,311.610046 
	C113.006111,311.664062 110.900764,310.558319 109.503723,309.789520 
	C116.589317,305.506226 116.589317,305.506226 115.078972,301.190857 
	C110.586891,304.153320 106.225822,307.029388 101.322243,310.027802 
	C100.882782,310.356354 100.443314,310.684906 99.297539,311.100769 
	C97.424873,314.353424 97.986427,316.099884 102.104164,316.375854 
	C104.409683,316.530334 107.502144,314.038116 108.990799,318.006439 
	C108.990799,318.006439 108.979027,317.963135 108.422379,318.075165 
	C108.154884,318.337158 107.887383,318.599182 106.952644,319.022949 
	C100.681679,323.052765 100.663307,323.102539 104.610016,327.598053 
	C107.245026,327.717834 109.920044,327.606720 112.498375,328.053558 
	C113.813431,328.281464 114.954903,329.511017 115.836800,330.688538 
	C115.344673,330.844879 114.852554,331.001221 113.503929,331.043823 
	C110.739555,332.366364 106.361565,333.108368 105.623489,335.159912 
	C104.721909,337.665924 105.317284,342.206421 110.498344,343.330170 
	C110.658104,343.876984 110.817856,344.423767 110.468254,345.424347 
	C110.362694,345.726501 110.096802,346.238800 110.175789,346.299042 
	C111.245438,347.115173 112.298157,348.345398 113.486404,348.506866 
	C114.742531,348.677551 121.630791,342.389984 121.781425,341.342529 
	C121.915863,341.229462 122.050293,341.116425 122.837944,340.905762 
	C126.069801,340.028625 129.301651,339.151489 132.638931,338.245728 
	C131.662689,336.853333 130.790039,335.737427 130.055130,334.537109 
	C127.574745,330.486023 125.143272,326.405029 122.711052,322.297546 
	C122.711052,322.297546 122.702316,322.257080 122.811943,321.527771 
	C120.664078,321.088379 118.516212,320.648987 116.893417,320.316986 
	C117.872353,318.613007 118.719467,317.138489 119.640358,315.647064 
	C119.640358,315.647064 119.640022,315.571350 120.009476,315.707733 
M317.352234,265.916107 
	C316.164276,262.123199 311.792389,261.694458 308.044098,265.574188 
	C311.247040,265.888763 314.024933,266.161560 317.352234,265.916107 
M149.153870,275.309113 
	C149.153870,279.330627 149.153870,283.352112 149.153870,287.373627 
	C149.926437,287.310242 150.698990,287.246857 151.471558,287.183472 
	C150.851898,283.009521 150.232254,278.835602 149.153870,275.309113 
M278.276031,263.298218 
	C280.082092,263.526093 281.888153,263.753967 283.694244,263.981873 
	C283.344788,262.818298 282.995331,261.654724 282.645874,260.491180 
	C281.142395,261.174194 279.638947,261.857239 278.276031,263.298218 
M327.666046,262.170471 
	C326.365845,261.462372 325.069366,260.230927 323.764191,260.221680 
	C322.821686,260.215027 321.867645,261.833130 320.918732,262.726624 
	C321.215027,263.219574 321.511292,263.712494 321.807587,264.205444 
	C323.597504,263.727905 325.387421,263.250366 327.666046,262.170471 
M184.242798,259.000793 
	C182.355057,259.149078 180.467331,259.297333 178.579590,259.445618 
	C178.631027,259.740326 178.682480,260.035065 178.733932,260.329773 
	C181.603027,260.329773 184.472137,260.329773 187.341232,260.329773 
	C187.343582,260.026794 187.345932,259.723816 187.348267,259.420837 
	C186.591476,259.282227 185.834686,259.143585 184.242798,259.000793 
M268.546173,260.014801 
	C267.805939,260.627716 267.065704,261.240601 266.325470,261.853516 
	C268.309113,262.282440 270.292786,262.711365 272.276428,263.140289 
	C272.441833,262.568420 272.607208,261.996582 272.772583,261.424713 
	C271.630432,260.952667 270.488281,260.480621 268.546173,260.014801 
M215.759781,261.505096 
	C215.314438,260.129486 214.869095,258.753845 214.423752,257.378235 
	C213.681335,257.880249 212.938904,258.382294 212.196487,258.884308 
	C213.172226,259.858093 214.147980,260.831879 215.759781,261.505096 
M246.380219,258.567322 
	C247.576675,259.152039 248.773132,259.736755 249.969574,260.321503 
	C250.119598,259.612823 250.269623,258.904144 250.419662,258.195496 
	C249.183212,258.120178 247.946777,258.044861 246.380219,258.567322 
M306.648529,258.923828 
	C307.232727,258.578644 307.816956,258.233429 308.401154,257.888245 
	C307.899048,257.620850 307.396942,257.353485 306.894836,257.086090 
	C306.596863,257.648346 306.298859,258.210602 306.648529,258.923828 
M302.911957,207.348862 
	C302.570557,206.767319 302.229126,206.185776 301.887756,205.604248 
	C301.623627,206.103989 301.019318,206.863876 301.162994,207.051773 
	C301.511261,207.507248 302.207825,207.696396 302.911957,207.348862 
M267.381958,160.797287 
	C268.180695,161.420944 268.979431,162.044617 269.778198,162.668274 
	C269.990662,162.195328 270.203125,161.722366 270.415588,161.249405 
	C269.539490,160.956512 268.663391,160.663635 267.381958,160.797287 
M171.467606,257.697174 
	C170.508713,257.594513 169.549805,257.491852 168.590912,257.389191 
	C168.601944,257.852295 168.612961,258.315369 168.623993,258.778473 
	C169.569290,258.636475 170.514587,258.494507 171.467606,257.697174 
M318.509644,257.145233 
	C318.208313,257.570343 317.907013,257.995483 317.605682,258.420593 
	C318.051636,258.533875 318.497589,258.647156 318.943512,258.760468 
	C318.996857,258.263031 319.050171,257.765564 318.509644,257.145233 
M280.801971,175.403336 
	C280.797668,175.790085 280.793365,176.176834 280.789062,176.563583 
	C280.949646,176.565231 281.249847,176.577728 281.250671,176.567001 
	C281.280548,176.182114 281.282410,175.795044 280.801971,175.403336 
M231.403320,136.196686 
	C231.790451,136.201096 232.177597,136.205505 232.564728,136.209915 
	C232.566238,136.049301 232.578629,135.749115 232.567703,135.748245 
	C232.182556,135.718216 231.795242,135.716278 231.403320,136.196686 
M228.196945,130.596298 
	C228.201263,130.210526 228.205582,129.824753 228.209885,129.438980 
	C228.049911,129.437332 227.750900,129.424911 227.750061,129.435608 
	C227.720291,129.819489 227.718369,130.205536 228.196945,130.596298 
M275.584747,267.516632 
	C275.584747,267.516632 275.477203,267.580078 275.584747,267.516632 
z"
          />
          <path
            fill="#20B672"
            opacity="1.000000"
            stroke="none"
            d="
M420.077484,397.010986 
	C420.190247,395.565521 419.888336,393.898560 420.514099,392.727112 
	C421.425812,391.020294 422.817139,388.625031 424.332855,388.352539 
	C430.232269,387.291901 433.969269,383.911133 436.410828,378.797882 
	C436.946594,377.675873 436.980743,376.216614 436.924438,374.926727 
	C436.686066,369.470062 436.055298,364.018829 436.051544,358.565308 
	C435.993408,274.303833 436.003174,190.042313 436.041718,105.780807 
	C436.043121,102.653244 436.798218,99.510231 436.637085,96.403725 
	C436.522125,94.187294 436.042572,91.531639 434.701508,89.929047 
	C431.580231,86.198990 427.840057,82.986839 424.623230,79.246628 
	C425.422455,78.871048 425.949097,78.813683 426.475769,78.756317 
	C430.063354,82.210365 433.821716,85.510567 437.146179,89.201591 
	C438.315826,90.500191 438.938538,92.756104 438.939941,94.575584 
	C439.012848,188.829269 439.009674,283.083038 438.870544,377.336609 
	C438.867310,379.540100 437.729675,382.192505 436.246857,383.856262 
	C432.269775,388.318512 427.817352,392.357117 423.117981,396.557068 
	C422.543335,396.803711 422.404480,397.057312 422.265625,397.310913 
	C422.265625,397.310913 422.095428,397.068726 421.832031,397.088257 
	C421.071564,397.075562 420.574524,397.043274 420.077484,397.010986 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M97.688934,421.848511 
	C98.043480,421.443298 98.741356,421.085144 98.973236,421.280396 
	C104.886955,426.259827 111.872650,425.070160 118.780548,425.061646 
	C188.768936,424.975311 258.757507,425.008728 328.746002,425.008575 
	C344.576721,425.008545 360.407654,424.970459 376.238037,425.040863 
	C379.370880,425.054779 382.596680,426.063812 385.608490,425.570068 
	C388.994812,425.014954 392.329346,423.553070 395.416962,421.962555 
	C397.690063,420.791626 399.529999,418.779846 401.925568,417.203918 
	C397.684296,424.145874 391.997070,427.364594 382.972839,427.326050 
	C291.784882,426.936462 200.594574,427.046326 109.405144,427.178253 
	C104.510803,427.185333 100.625092,426.273834 97.688934,421.848511 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M66.043175,83.045067 
	C65.389931,84.158501 65.000626,85.647331 64.039612,86.323013 
	C58.738762,90.049995 58.047157,95.628914 58.043655,101.293556 
	C57.987465,192.171555 57.952259,283.049683 58.127789,373.927429 
	C58.140205,380.354401 63.115417,384.736023 67.482704,388.962311 
	C71.620422,392.966431 75.944199,396.778503 80.074768,400.789764 
	C85.619156,406.174011 91.104828,411.621582 96.486961,417.166931 
	C97.281334,417.985321 97.367882,419.490753 97.618195,421.057343 
	C84.439690,408.565979 71.381760,395.738434 58.488091,382.747803 
	C57.399002,381.650513 56.973263,379.461792 56.972088,377.779633 
	C56.906052,283.127747 56.933170,188.475784 56.883255,93.823891 
	C56.880363,88.342125 61.795677,86.737724 64.936874,83.156837 
	C65.682434,83.028687 65.862801,83.036873 66.043175,83.045067 
z"
          />
          <path
            fill="#3CA977"
            opacity="1.000000"
            stroke="none"
            d="
M420.190826,72.423538 
	C418.302673,71.690628 415.969391,71.007759 414.449585,69.503166 
	C407.622009,62.743687 401.461670,55.229614 394.132751,49.096600 
	C391.172333,46.619282 385.863525,46.328438 381.582123,46.171871 
	C370.944183,45.782841 360.282471,46.042961 349.630310,46.043205 
	C268.074768,46.045078 186.519226,46.047146 104.158035,46.039375 
	C102.900475,46.014397 102.448563,45.999187 101.996651,45.983986 
	C103.685997,45.610043 105.375168,44.909809 107.064720,44.908863 
	C200.989792,44.856216 294.914886,44.848602 388.839874,44.947922 
	C390.948700,44.950150 393.632507,45.635273 395.069519,47.018486 
	C403.580231,55.210693 411.801575,63.703499 420.190826,72.423538 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M84.168869,63.724480 
	C84.653969,69.250969 80.260872,70.777237 75.939255,72.549255 
	C78.339424,69.548698 81.103432,66.693741 84.168869,63.724480 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M410.617859,409.203552 
	C409.513367,404.440002 412.401703,402.757355 416.886169,402.182617 
	C415.163910,404.538757 413.049988,406.826233 410.617859,409.203552 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M402.587219,417.207031 
	C401.269470,411.478271 407.074524,411.891571 409.954529,409.268402 
	C407.850433,411.871216 405.381012,414.497070 402.587219,417.207031 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M91.688683,56.103584 
	C90.254921,58.013748 88.503647,60.019341 86.384911,62.021187 
	C87.802017,60.077961 89.586594,58.138485 91.688683,56.103584 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M75.108360,72.701782 
	C73.849922,74.397301 72.301956,76.211105 70.385712,78.021179 
	C71.617897,76.284981 73.218361,74.552521 75.108360,72.701782 
z"
          />
          <path
            fill="#20B672"
            opacity="1.000000"
            stroke="none"
            d="
M423.717468,77.065002 
	C422.488220,76.287453 421.258972,75.509903 420.352142,74.301460 
	C420.882355,73.792053 421.090118,73.713547 421.297913,73.635033 
	C421.297913,73.635033 421.303284,73.673187 421.311981,73.966339 
	C421.648926,74.428345 421.977173,74.597191 422.305420,74.766037 
	C422.305420,74.766037 422.133423,74.775810 422.162537,74.925079 
	C422.451660,75.133621 422.711639,75.192909 422.971619,75.252190 
	C423.495911,75.675438 424.020172,76.098686 424.389801,76.760559 
	C424.062592,77.021118 423.890045,77.043060 423.717468,77.065002 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M66.393005,82.969070 
	C65.862801,83.036873 65.682434,83.028687 65.231880,83.001846 
	C65.939484,81.927490 66.917282,80.871803 68.183014,79.712029 
	C67.894913,80.702980 67.318871,81.798027 66.393005,82.969070 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M419.811462,397.020630 
	C420.574524,397.043274 421.071564,397.075562 421.935272,397.194305 
	C421.666260,398.064819 421.030548,398.848846 419.882965,399.563141 
	C419.251862,398.678955 419.132629,397.864502 419.013428,397.050049 
	C419.190765,397.043457 419.368134,397.036865 419.811462,397.020630 
z"
          />
          <path
            fill="#20B672"
            opacity="1.000000"
            stroke="none"
            d="
M418.667908,397.090942 
	C419.132629,397.864502 419.251862,398.678955 419.603394,399.701416 
	C419.481720,400.363922 419.127686,400.818420 418.370117,401.088715 
	C417.664246,400.615387 417.361938,400.326263 417.059692,400.037140 
	C417.480621,399.068726 417.901520,398.100281 418.667908,397.090942 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M95.522446,52.809753 
	C94.834885,53.849472 93.818611,54.936878 92.405273,56.015282 
	C93.070045,54.956665 94.131897,53.907055 95.522446,52.809753 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M101.424454,46.720928 
	C101.611687,47.538078 101.517151,48.400833 101.096382,48.907333 
	C100.598030,48.263836 100.347969,48.086376 100.019966,48.018703 
	C100.394203,47.601315 100.768440,47.183926 101.424454,46.720928 
z"
          />
          <path
            fill="#3CA977"
            opacity="1.000000"
            stroke="none"
            d="
M423.816254,77.367416 
	C423.890045,77.043060 424.062592,77.021118 424.495880,76.994904 
	C425.241577,77.388496 425.726532,77.786362 426.343628,78.470276 
	C425.949097,78.813683 425.422455,78.871048 424.500458,78.926460 
	C424.041779,78.506271 423.978424,78.088051 423.816254,77.367416 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M85.741432,62.086983 
	C85.737923,62.535160 85.458458,63.052834 84.863678,63.549633 
	C84.854065,63.071335 85.159775,62.613903 85.741432,62.086983 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M417.048859,400.412537 
	C417.361938,400.326263 417.664246,400.615387 418.091064,401.199463 
	C418.176117,401.824036 418.006989,402.061218 417.484619,402.239594 
	C417.186707,401.778107 417.112396,401.282990 417.048859,400.412537 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M101.831696,46.129013 
	C102.448563,45.999187 102.900475,46.014397 103.691452,46.049644 
	C103.459526,46.341209 102.888535,46.612740 101.988609,46.798782 
	C101.659676,46.713291 101.666733,46.274048 101.831696,46.129013 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M69.741348,78.087059 
	C69.737923,78.535172 69.458473,79.052841 68.863663,79.550041 
	C68.853966,79.071915 69.159645,78.614265 69.741348,78.087059 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M442.648438,77.739532 
	C442.919098,77.598381 443.278137,77.701149 443.639923,78.117126 
	C443.340729,78.281364 443.038788,78.132408 442.648438,77.739532 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M422.483124,397.247192 
	C422.404480,397.057312 422.543335,396.803711 422.815552,396.677185 
	C422.948914,396.804291 422.700592,397.183472 422.483124,397.247192 
z"
          />
          <path
            fill="#3CA977"
            opacity="1.000000"
            stroke="none"
            d="
M99.817535,48.121590 
	C100.347969,48.086376 100.598030,48.263836 100.875824,48.760979 
	C100.724930,48.941124 100.468369,48.911377 99.840569,48.768097 
	C99.469330,48.654572 99.615112,48.224472 99.817535,48.121590 
z"
          />
          <path
            fill="#3CA977"
            opacity="1.000000"
            stroke="none"
            d="
M422.852386,75.048302 
	C422.711639,75.192909 422.451660,75.133621 422.238464,74.884369 
	C422.285248,74.694397 422.733154,74.844414 422.852386,75.048302 
z"
          />
          <path
            fill="#3CA977"
            opacity="1.000000"
            stroke="none"
            d="
M422.229309,74.504463 
	C421.977173,74.597191 421.648926,74.428345 421.292725,73.966042 
	C421.560913,73.862686 421.857056,74.052788 422.229309,74.504463 
z"
          />
          <path
            fill="#3CA977"
            opacity="1.000000"
            stroke="none"
            d="
M421.210510,73.407043 
	C421.090118,73.713547 420.882355,73.792053 420.347595,73.933556 
	C420.039154,73.786156 420.057648,73.575768 420.174011,73.063431 
	C420.626221,72.756805 420.909943,72.895988 421.210510,73.407043 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M98.716911,48.969551 
	C98.939270,49.282459 98.771339,49.552567 98.287117,49.871353 
	C98.190300,49.651672 98.308899,49.320580 98.716911,48.969551 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M250.038483,62.861813 
	C251.022430,65.671440 252.006393,68.481064 253.045609,71.448524 
	C254.036407,69.399826 255.075272,67.251732 256.554993,65.447815 
	C256.245270,70.727570 255.603683,75.682709 254.722366,80.594841 
	C252.649902,92.146118 251.827164,89.742470 263.351410,91.677132 
	C270.917084,92.947250 276.531891,89.044594 277.536072,81.853951 
	C278.025635,78.348167 277.143158,74.650787 276.881714,71.040138 
	C282.377716,71.940414 278.439056,77.058037 281.050751,79.910110 
	C283.470337,77.364204 285.901398,74.871101 288.257874,72.309448 
	C290.918762,69.416893 293.588287,68.541679 297.423035,70.667107 
	C301.195404,72.757950 301.017151,75.687408 300.771545,79.110664 
	C300.306335,85.595383 300.039764,92.094360 299.690674,98.587410 
	C300.185577,98.761314 300.680481,98.935219 301.175385,99.109131 
	C302.347473,98.185646 303.519531,97.262161 305.033813,96.655853 
	C304.836029,98.182007 303.873962,99.386169 303.860077,100.601166 
	C303.841583,102.219582 304.560822,103.846436 304.963165,105.469658 
	C306.457703,104.737144 308.557678,104.396629 309.333282,103.198662 
	C311.668854,99.591232 313.279755,95.513390 315.629517,91.917084 
	C316.396576,90.743126 319.092865,89.493759 320.000580,89.977928 
	C324.024445,92.124313 324.912018,89.886459 325.792755,86.635674 
	C320.947876,84.108208 316.207794,81.743385 311.575287,79.183884 
	C307.992493,77.204391 306.494690,78.486786 306.024445,82.135071 
	C307.792664,83.345062 309.406403,84.449341 311.665436,85.995201 
	C309.580048,89.350739 307.609497,92.521523 305.638916,95.692322 
	C305.641052,91.151161 308.060211,87.046013 304.645844,81.934669 
	C302.315826,78.446587 308.742126,74.352722 313.163422,76.747826 
	C317.183350,78.925491 321.254486,81.077461 324.971405,83.709206 
	C326.326111,84.668419 327.633514,87.146828 327.357788,88.634758 
	C326.877686,91.225586 325.036835,93.921883 321.698761,92.638657 
	C317.753571,91.122063 316.601959,93.653366 315.382965,96.261078 
	C314.140869,98.918312 313.095703,101.667603 311.794220,104.783783 
	C312.715607,104.733849 313.964081,105.049301 314.656067,104.566734 
	C319.258057,101.357292 323.531372,97.621269 328.341980,94.787117 
	C331.186249,93.111404 335.251740,91.337456 337.997681,92.164780 
	C342.332031,93.470673 342.875458,98.138443 341.613495,102.290009 
	C339.607971,108.887711 337.421509,115.439949 335.029449,121.907051 
	C333.587830,125.804649 329.990326,126.124329 327.588806,122.765076 
	C326.928467,121.841393 326.318115,120.713982 326.176239,119.616531 
	C325.546143,114.741524 324.187897,111.250511 318.107544,113.766678 
	C317.108826,114.179977 315.126251,113.764694 314.385315,112.984764 
	C311.125366,109.553108 307.172791,107.827469 302.696991,106.491814 
	C299.152924,105.434212 295.849945,103.329247 292.702698,101.284790 
	C291.173340,100.291321 289.797150,98.542725 289.145660,96.833351 
	C288.038391,93.928185 286.382538,92.764198 284.127411,95.034851 
	C281.228271,97.953995 278.536469,97.074066 275.556885,95.655151 
	C274.234772,95.025543 272.913208,94.194260 271.509308,93.971260 
	C265.172729,92.964729 258.657837,90.861717 252.489029,91.578674 
	C244.743744,92.478867 239.678696,90.935844 237.839462,82.755302 
	C236.679794,83.669220 236.261536,83.829147 236.219513,84.058128 
	C235.780197,86.451515 235.789017,90.765831 234.940674,90.938103 
	C230.446884,91.850624 225.741806,91.722771 221.041382,91.496094 
	C220.972809,91.036728 221.189240,90.818291 221.535797,90.880066 
	C222.565155,90.868362 223.247940,90.794876 224.215546,90.760437 
	C225.027191,90.616592 225.554047,90.433716 226.526672,90.236832 
	C234.063187,89.905334 234.065414,89.905342 234.096878,82.809204 
	C234.106033,80.744576 234.098312,78.679871 234.098312,76.256775 
	C240.735016,79.635460 239.741165,91.102234 249.902847,89.266975 
	C249.902847,80.680565 249.902847,72.433350 249.943771,63.855507 
	C250.002640,63.303856 250.020569,63.082832 250.038483,62.861813 
M339.885925,100.627632 
	C340.960144,98.052200 340.290070,95.990105 337.757416,94.893448 
	C336.422760,94.315529 334.351654,93.602859 333.427948,94.203735 
	C326.493500,98.714699 319.762207,103.537964 312.761871,108.406441 
	C315.164825,111.447182 317.029510,112.807114 320.521118,110.499565 
	C323.494080,108.534782 329.405487,112.877235 328.446381,116.295753 
	C327.299866,120.382362 329.395142,121.612686 332.880859,123.015411 
	C335.212494,115.605644 337.453949,108.482506 339.885925,100.627632 
M289.234314,92.284515 
	C290.192719,93.447433 291.936157,94.589279 291.968079,95.777077 
	C292.081360,99.996643 294.549652,100.465378 298.256653,100.573776 
	C298.256653,91.987953 298.402374,83.752357 298.174835,75.527092 
	C298.098785,72.778442 292.573853,70.585815 290.742767,72.679382 
	C285.146179,79.078094 279.972748,85.846878 274.634735,92.471695 
	C274.855682,93.060471 275.076630,93.649254 275.297577,94.238029 
	C277.430664,93.976814 280.504547,94.499031 281.506500,93.295845 
	C283.789276,90.554672 285.894135,90.926025 289.234314,92.284515 
z"
          />
          <path
            fill="#03BE61"
            opacity="1.000000"
            stroke="none"
            d="
M193.003052,239.003571 
	C191.965302,239.471054 190.970428,240.122299 189.882828,240.376099 
	C182.935104,241.997284 179.961105,241.313202 179.722641,234.483841 
	C179.524216,228.801559 177.969360,223.166672 180.300797,217.664047 
	C181.343643,215.202744 183.019165,213.009521 184.620163,210.340179 
	C185.120239,210.623734 184.507736,210.002457 184.172424,210.127060 
	C178.393051,212.274719 177.548462,209.156128 177.978668,204.491135 
	C178.115311,203.009491 178.078201,201.499771 177.985519,200.011322 
	C177.725922,195.841812 179.501450,193.756500 183.810028,193.981552 
	C185.796448,194.085297 188.004913,194.514740 189.725449,193.827286 
	C191.398682,193.158768 193.553925,191.403290 193.794174,189.859940 
	C194.603500,184.660980 195.047272,179.330139 194.862442,174.076797 
	C194.731461,170.353882 193.358902,166.674652 192.195068,161.414429 
	C196.439590,164.408585 199.386307,167.325821 201.543747,161.774353 
	C201.790405,161.139664 203.934616,161.242386 205.473282,161.303223 
	C205.275940,163.798447 204.804291,165.993622 204.319656,168.172028 
	C204.306686,168.155273 204.276550,168.177841 203.977386,168.216202 
	C203.622879,168.887451 203.567551,169.520355 203.429840,170.387482 
	C203.347427,170.621719 203.022354,170.997177 202.656815,171.055756 
	C197.904770,178.515533 196.512329,186.138657 200.857803,194.698532 
	C193.390320,195.929230 193.840332,202.005173 194.257721,207.051712 
	C194.718521,212.623108 191.001358,214.910950 187.863953,217.884689 
	C187.795639,218.474457 187.903854,219.225937 188.008957,219.986267 
	C188.005844,219.995102 188.023590,220.000656 188.007935,220.392670 
	C186.112091,228.520721 186.112091,228.520721 189.290039,232.183685 
	C190.700211,234.603439 191.851639,236.803513 193.003052,239.003571 
z"
          />
          <path
            fill="#02BE61"
            opacity="1.000000"
            stroke="none"
            d="
M231.000610,235.004272 
	C228.269623,240.855927 217.567993,243.262177 214.371033,238.368866 
	C223.039734,233.090057 225.667038,224.581833 221.033386,216.009857 
	C219.581879,213.324692 216.973801,211.264725 214.915649,208.965714 
	C214.936172,209.012848 214.876907,208.920151 215.206970,208.796204 
	C216.375961,207.245178 217.214890,205.818100 217.899841,204.652954 
	C219.711639,205.910416 221.296432,207.010330 222.918686,208.501846 
	C223.124847,210.022781 222.907104,211.817719 223.523636,212.175644 
	C228.282898,214.938644 232.949188,218.340042 238.134064,219.779526 
	C245.897766,221.934982 253.844635,220.612045 261.535431,217.970383 
	C266.197784,216.368942 271.472534,210.797043 271.530182,207.080597 
	C273.009521,206.520493 274.141510,206.000977 275.272156,205.482071 
	C277.960663,211.370300 276.993103,213.588425 270.671051,216.892639 
	C270.846558,218.932190 271.202454,220.814056 271.106232,222.672516 
	C271.030945,224.126877 270.395264,225.552216 269.807007,227.224884 
	C267.738037,227.301422 265.870605,227.143509 263.628174,226.986420 
	C262.503143,226.987000 261.753143,226.986786 260.966309,226.636749 
	C260.041443,224.997894 259.153381,223.708847 258.265320,222.419830 
	C257.407501,223.123917 256.549683,223.828003 255.483139,224.703415 
	C257.387421,225.671692 258.704254,226.341263 259.794495,227.297821 
	C258.513031,228.033630 257.491333,228.744995 256.397247,228.883240 
	C252.762344,229.342529 249.049332,230.137711 245.463455,229.792984 
	C240.812836,229.345901 235.419647,230.700089 231.997177,225.549728 
	C231.569046,224.905457 228.206589,225.128418 227.453415,226.013245 
	C225.987518,227.735413 225.407669,230.211792 224.420486,232.467926 
	C226.702835,233.347672 228.851730,234.175964 231.000610,235.004272 
M225.514969,226.427536 
	C225.514969,226.427536 225.567291,226.521088 225.514969,226.427536 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M222.881226,208.110245 
	C221.296432,207.010330 219.711639,205.910416 217.899841,204.652954 
	C217.214890,205.818100 216.375961,207.245178 215.216278,208.381195 
	C215.367447,203.208618 214.117783,199.175751 209.261261,197.043259 
	C205.528564,195.404251 202.048355,196.058395 199.130844,198.802963 
	C195.111237,202.584320 195.597366,207.049881 197.636917,211.139984 
	C195.654541,213.641937 193.217316,215.564453 192.331787,218.041656 
	C189.055313,227.207520 189.677536,237.041718 203.128387,235.989365 
	C205.935593,235.769745 208.962509,236.547318 211.545532,235.752213 
	C214.480545,234.848770 218.096130,233.342117 219.541351,230.960297 
	C223.314362,224.742111 219.118423,214.863800 213.984543,212.436203 
	C214.153473,211.783554 214.524277,210.351044 214.895096,208.918549 
	C216.973801,211.264725 219.581879,213.324692 221.033386,216.009857 
	C225.667038,224.581833 223.039734,233.090057 214.355042,237.958740 
	C209.289932,237.997559 204.579849,237.995712 199.107697,237.850769 
	C194.875885,236.125778 194.026901,238.025223 193.981934,240.992676 
	C193.672607,240.525330 193.363281,240.057983 193.028503,239.297104 
	C191.851639,236.803513 190.700211,234.603439 189.283905,231.730316 
	C188.687225,227.371704 188.355408,223.686188 188.023590,220.000656 
	C188.023590,220.000656 188.005844,219.995102 188.013153,219.664368 
	C188.027145,218.904556 188.033813,218.475479 188.040482,218.046402 
	C191.001358,214.910950 194.718521,212.623108 194.257721,207.051712 
	C193.840332,202.005173 193.390320,195.929230 200.857803,194.698532 
	C196.512329,186.138657 197.904770,178.515533 202.638123,171.442871 
	C201.124298,177.918350 198.672729,184.021637 201.773666,190.647858 
	C204.058578,184.692093 204.675156,178.144547 207.356491,172.594543 
	C210.139404,166.834366 214.920853,162.039719 218.909012,156.907578 
	C218.989761,156.992355 219.148026,157.164917 219.109161,157.540955 
	C220.039246,158.948441 221.008194,159.979919 221.974701,161.376236 
	C221.018906,162.199875 220.101837,162.896957 219.101822,163.049225 
	C218.137329,163.196075 216.433258,162.317444 216.174500,162.682816 
	C213.140274,166.967087 207.941193,170.104095 208.366928,176.446198 
	C209.847214,176.860504 211.169510,177.230606 212.491806,177.600693 
	C207.660950,178.095688 207.315094,181.369568 206.685822,185.051208 
	C206.122849,188.344955 204.425888,191.444870 203.213257,194.672867 
	C205.136108,194.672867 207.572876,194.672867 210.009659,194.672867 
	C208.953384,193.706406 207.897125,192.739960 206.840851,191.773499 
	C209.901337,190.631546 212.961823,189.489609 216.692902,188.097443 
	C214.209442,187.212494 212.641327,186.653702 211.007050,186.071350 
	C217.651154,174.476807 217.651154,174.476807 213.212143,170.939651 
	C214.453720,170.343216 215.775864,170.189972 216.969986,170.511795 
	C218.449692,170.910568 219.823273,171.703049 221.162308,172.652557 
	C220.406448,174.657837 219.730988,176.336014 218.816620,178.329559 
	C218.088013,183.426636 217.598328,188.208374 217.047806,193.369720 
	C219.074692,198.429321 221.162415,203.109299 223.157669,207.869263 
	C223.065216,207.949249 222.881226,208.110245 222.881226,208.110245 
z"
          />
          <path
            fill="#E1F4EA"
            opacity="1.000000"
            stroke="none"
            d="
M249.902847,64.186134 
	C249.902847,72.433350 249.902847,80.680565 249.902847,89.266975 
	C239.741165,91.102234 240.735016,79.635460 234.098312,76.256775 
	C234.098312,78.679871 234.106033,80.744576 234.096878,82.809204 
	C234.065414,89.905342 234.063187,89.905334 226.504578,89.796120 
	C226.079376,88.492676 226.122040,87.615952 226.514755,86.710144 
	C227.123322,85.114510 227.381851,83.547958 227.720764,81.549118 
	C227.880875,75.395859 227.960587,69.674889 228.471588,63.957935 
	C230.921814,63.995174 232.940765,64.028397 234.959702,64.061623 
	C235.029083,64.371239 235.186188,64.626968 235.669464,65.240417 
	C236.184265,65.908722 236.460571,66.165413 236.736893,66.422104 
	C236.795059,66.700943 236.919266,66.946365 237.293030,67.440765 
	C237.476562,67.723167 237.712509,67.914963 237.712509,67.914963 
	C237.991135,68.465462 238.269775,69.015968 238.805481,70.100754 
	C240.347015,72.584038 241.631485,74.533035 242.915939,76.482040 
	C243.236832,76.341301 243.557724,76.200569 243.878616,76.059830 
	C243.716400,74.345207 243.554184,72.630592 243.438629,70.506927 
	C243.994522,67.812805 244.503754,65.527733 245.400848,63.396568 
	C247.160080,63.762367 248.531464,63.974251 249.902847,64.186134 
z"
          />
          <path
            fill="#DFF5E9"
            opacity="1.000000"
            stroke="none"
            d="
M276.771606,70.935379 
	C277.143158,74.650787 278.025635,78.348167 277.536072,81.853951 
	C276.531891,89.044594 270.917084,92.947250 263.351410,91.677132 
	C251.827164,89.742470 252.649902,92.146118 254.722366,80.594841 
	C255.603683,75.682709 256.245270,70.727570 256.903809,65.375282 
	C256.811829,64.958588 257.033356,64.578880 257.475769,64.399490 
	C264.575104,65.039139 271.353027,65.500626 276.582581,70.537041 
	C276.582581,70.537041 276.661469,70.830612 276.771606,70.935379 
M264.395599,86.098427 
	C269.304626,85.369362 271.236816,82.900864 271.294495,77.632561 
	C271.352783,72.308929 267.788361,71.531776 263.021484,71.084053 
	C262.281494,75.361450 261.428314,79.530739 260.970612,83.742996 
	C260.900299,84.390518 262.650543,85.235840 264.395599,86.098427 
z"
          />
          <path
            fill="#ADF9D8"
            opacity="1.000000"
            stroke="none"
            d="
M207.031342,337.006134 
	C217.909256,326.520660 230.944885,321.391388 245.930664,323.096069 
	C252.841202,323.882202 259.505341,326.834412 266.774353,329.162964 
	C267.815308,329.738098 268.363159,329.954742 268.911011,330.171387 
	C268.911011,330.171387 268.945892,330.079407 269.005859,330.334412 
	C269.381561,330.720673 269.697266,330.851898 270.012970,330.983124 
	C270.012970,330.983124 270.000000,331.000000 270.149963,331.249634 
	C270.827545,331.730225 271.355164,331.961151 271.882782,332.192047 
	C271.882782,332.192047 271.948364,332.090881 271.984467,332.361328 
	C272.334534,332.776978 272.648468,332.922211 272.962433,333.067444 
	C272.962433,333.067444 272.986816,332.996368 273.094543,333.341064 
	C274.479004,335.785370 278.857452,336.768555 276.052338,340.322144 
	C274.404083,342.410187 272.743866,345.871643 268.991913,343.012695 
	C269.001343,343.000458 268.973175,343.012024 268.905701,342.771942 
	C268.631958,342.232666 268.347076,342.083984 267.849365,341.864502 
	C267.285065,341.376221 266.855011,341.109314 266.260284,340.597961 
	C265.731232,340.258911 265.366821,340.164276 264.683319,339.930420 
	C250.105896,328.139221 229.994614,331.297424 219.604538,339.788452 
	C218.831345,340.204956 218.357361,340.550232 217.942657,340.902985 
	C218.001923,340.910461 217.896347,340.854523 217.588928,340.903809 
	C216.544022,341.642090 215.806549,342.331085 214.842957,343.120117 
	C214.336899,343.608826 214.056992,343.997498 213.777069,344.386169 
	C213.445343,344.478821 213.113602,344.571472 212.328461,344.472107 
	C210.260483,341.855408 208.645905,339.430786 207.031342,337.006134 
M263.640686,330.789337 
	C244.985123,319.842865 221.538254,326.161652 210.404984,338.454895 
	C211.548080,340.831390 212.482758,341.280731 215.181778,339.536255 
	C220.288513,336.235535 225.666794,332.759979 231.431396,331.191040 
	C245.077667,327.476959 257.765472,330.391022 269.013336,339.227692 
	C269.986145,339.991974 271.732971,339.771057 273.120270,340.007812 
	C272.687500,338.675446 272.652649,336.873413 271.743591,336.103271 
	C269.479004,334.184814 266.816528,332.736023 263.640686,330.789337 
z"
          />
          <path
            fill="#DDF4E8"
            opacity="1.000000"
            stroke="none"
            d="
M169.872070,111.921799 
	C168.165268,112.579353 166.458450,113.236900 164.286087,113.536659 
	C160.371521,107.672775 156.698776,102.288864 153.590240,96.596840 
	C152.442932,94.496033 152.624725,91.669365 152.200333,89.173759 
	C152.200333,89.173759 152.039627,89.108864 152.395264,89.132263 
	C153.216492,88.850945 153.682083,88.546234 154.523453,88.228973 
	C156.810318,87.254158 158.688568,86.218849 160.638458,85.342972 
	C167.199615,82.395744 172.096725,85.378281 172.190414,92.331612 
	C172.233566,95.532928 177.910690,100.552490 182.209320,101.091583 
	C182.700623,101.366478 182.888260,101.613625 182.873535,102.189651 
	C182.473907,102.943405 182.190018,103.434029 181.687347,103.997528 
	C181.183502,104.196312 180.931519,104.370163 180.415039,104.623657 
	C179.660278,105.011154 179.203094,105.366966 178.516266,105.854660 
	C178.190979,106.134933 178.095322,106.283325 177.999649,106.431717 
	C177.295013,106.290764 176.590378,106.149803 175.477112,105.585518 
	C174.396667,104.748856 173.724838,104.335518 172.894958,103.686600 
	C172.169128,102.958122 171.601349,102.465218 170.897247,101.642487 
	C169.188126,101.108917 167.615326,100.905167 166.042526,100.701416 
	C166.121384,101.612000 166.200241,102.522591 166.414627,103.712837 
	C166.963715,104.710495 167.377258,105.428482 167.825531,106.399063 
	C168.087311,106.896317 168.314346,107.140976 168.613953,107.664337 
	C169.080704,108.305008 169.474884,108.666977 169.869064,109.028946 
	C169.922485,109.476135 169.975891,109.923325 170.008301,110.914917 
	C169.987289,111.459312 169.872070,111.921799 169.872070,111.921799 
M159.753876,92.564308 
	C160.385635,93.982292 161.017395,95.400284 161.723114,96.984253 
	C162.994324,96.395241 164.074753,96.248245 164.386841,95.679581 
	C165.135986,94.314507 165.524460,92.751503 166.058456,91.268364 
	C164.084518,91.522171 162.110580,91.775978 159.753876,92.564308 
z"
          />
          <path
            fill="#35B477"
            opacity="1.000000"
            stroke="none"
            d="
M381.996918,140.009247 
	C386.996826,146.477966 387.000854,146.601471 381.835541,153.948853 
	C383.532593,153.217255 384.492889,152.408813 385.328888,152.521591 
	C387.324493,152.790894 390.652374,153.049973 390.987488,154.098022 
	C392.664581,159.343552 394.029236,164.798920 394.520081,170.268784 
	C394.776794,173.129562 392.888489,175.780594 389.062622,176.273666 
	C387.432587,176.483749 385.833252,178.132507 384.528564,179.436279 
	C380.964874,182.997437 376.613525,185.278015 372.124268,182.708405 
	C369.133209,180.996368 366.622375,177.468018 365.219910,174.186951 
	C363.110382,169.251740 362.159119,163.821442 361.284149,158.284485 
	C371.543976,159.124908 376.656464,151.102402 384.609924,147.615356 
	C383.034454,145.414185 382.021118,143.998398 380.817169,142.316269 
	C378.323730,143.894836 376.234283,145.213684 374.148895,146.538895 
	C371.902039,147.966721 369.675476,149.427231 367.409912,150.824631 
	C364.804779,152.431458 362.151825,151.983047 361.144073,149.290802 
	C360.538391,147.672668 361.232788,144.810455 362.424438,143.465530 
	C363.971954,141.718918 366.594604,140.924866 368.809448,140.087372 
	C367.640167,141.704803 366.301544,142.866272 365.229614,144.236359 
	C364.444977,145.239182 364.010651,146.516098 363.420197,147.670853 
	C364.839050,147.748291 366.611938,148.408813 367.614288,147.800232 
	C371.541199,145.415863 375.224915,142.630890 379.373718,140.003586 
	C380.497925,140.011353 381.247406,140.010300 381.996918,140.009247 
M364.460022,166.949020 
	C365.957947,170.287521 367.164886,173.798386 369.017731,176.926666 
	C372.318146,182.499023 378.670135,182.439392 382.548950,177.254898 
	C383.458679,176.038895 385.172943,175.062531 386.684265,174.725357 
	C391.642273,173.619202 393.997955,170.533218 392.530792,165.680450 
	C391.349396,161.772827 389.474182,158.074951 387.722656,153.838669 
	C380.106903,157.047089 372.917938,159.994202 365.831512,163.170135 
	C364.998291,163.543564 364.729065,165.175323 364.460022,166.949020 
z"
          />
          <path
            fill="#C9F9E5"
            opacity="1.000000"
            stroke="none"
            d="
M249.024155,123.138512 
	C249.024155,123.138512 249.211502,123.309219 249.559723,123.512413 
	C250.533600,123.930023 251.159256,124.144440 251.784912,124.358856 
	C251.784912,124.358856 251.756866,124.237724 251.861862,124.603088 
	C252.700806,127.860970 253.425415,130.755890 254.172852,133.644913 
	C254.515045,134.967575 254.513885,136.630356 255.334152,137.535751 
	C259.511108,142.146027 259.944702,147.202118 257.728699,152.745117 
	C257.728699,152.745117 257.747955,152.859955 257.403137,152.958649 
	C252.760483,153.725250 248.476273,154.832947 244.161957,154.966156 
	C236.089432,155.215363 232.549133,149.866943 235.314468,142.176376 
	C235.813950,140.787277 236.554825,139.484955 237.184235,138.142548 
	C237.184235,138.142548 237.077087,137.997314 237.438599,137.943756 
	C238.375534,136.533325 239.568298,135.107147 239.425018,133.830994 
	C238.567719,126.195518 241.012695,123.341484 249.024155,123.138512 
M249.088074,138.800903 
	C248.090530,138.830490 247.092972,138.885666 246.095444,138.885330 
	C241.380219,138.883713 238.818298,141.546219 238.708603,146.253952 
	C238.589279,151.374420 242.016724,151.172241 245.500595,151.056854 
	C246.832428,151.012741 248.166992,151.057480 249.499680,151.030426 
	C254.586609,150.927139 256.412964,148.831558 254.673523,144.138184 
	C253.905075,142.064758 251.562485,140.574722 249.088074,138.800903 
z"
          />
          <path
            fill="#EAF7F0"
            opacity="1.000000"
            stroke="none"
            d="
M128.337173,117.778648 
	C128.963593,118.446617 129.590012,119.114594 130.337006,120.160629 
	C130.457581,120.538689 130.559830,120.911194 130.461243,121.140106 
	C130.940140,121.825882 131.517609,122.282753 132.452209,122.756073 
	C133.509659,122.655205 134.209991,122.537903 134.910309,122.420601 
	C134.910309,122.420601 135.358704,122.601006 135.674591,122.916176 
	C137.710373,124.529396 139.430267,125.827454 141.150146,127.125504 
	C141.251892,127.481689 141.353622,127.837875 141.444901,128.853699 
	C141.474686,130.365295 141.514938,131.217255 141.344879,132.359604 
	C138.518646,136.141190 135.902695,139.632385 133.008057,143.184845 
	C132.541260,143.558884 132.353134,143.871658 132.187653,144.191833 
	C132.210312,144.199219 132.213211,144.246750 131.846848,144.163177 
	C130.003265,143.388702 128.526047,142.697800 126.739136,141.868378 
	C121.558304,137.569626 116.687172,133.409363 111.557083,129.027954 
	C114.035240,126.039024 116.176414,123.533722 118.230972,120.959297 
	C120.903831,117.610123 124.163643,116.282692 128.337173,117.778648 
M130.659500,129.353134 
	C129.465149,130.835983 128.270798,132.318832 126.917664,133.998825 
	C128.569519,135.421585 129.868774,136.540665 132.085480,138.449951 
	C133.393646,135.284073 134.384460,132.886200 135.375275,130.488342 
	C133.995346,129.995667 132.615417,129.503006 130.659500,129.353134 
M125.040916,128.390915 
	C125.048653,126.825844 125.056396,125.260780 125.064133,123.695709 
	C123.918411,123.885590 122.257881,123.682114 121.743950,124.354721 
	C120.909615,125.446693 120.826469,127.112625 120.426224,128.536255 
	C121.786110,128.671982 123.145988,128.807709 125.040916,128.390915 
z"
          />
          <path
            fill="#E0F6EB"
            opacity="1.000000"
            stroke="none"
            d="
M145.952652,126.144867 
	C145.196838,125.872154 144.441025,125.599442 143.244492,124.969727 
	C140.913727,123.042953 139.023682,121.473190 137.133636,119.903427 
	C137.027985,119.607864 136.865189,119.348122 136.406204,118.649750 
	C133.864487,115.216537 131.561783,112.257767 129.026428,109.000069 
	C130.742172,107.676758 132.087906,106.638824 133.478806,105.566055 
	C136.167282,108.382454 138.441299,110.764679 140.843719,113.399330 
	C141.273529,113.867325 141.574936,114.082901 141.979248,114.445587 
	C142.082123,114.592712 142.434967,114.659088 142.434967,114.659088 
	C142.997009,115.427246 143.559036,116.195396 144.475922,117.379318 
	C145.165665,117.957268 145.500595,118.119461 145.835510,118.281647 
	C145.835510,118.281647 146.203674,118.539246 146.698761,118.805099 
	C148.555588,118.159355 149.917343,117.247749 151.279114,116.336136 
	C151.279114,116.336143 151.313965,116.266159 151.629196,116.150085 
	C153.325974,111.892250 149.989334,110.436661 147.616592,108.432304 
	C147.041916,107.636650 146.467239,106.840996 145.581818,105.642441 
	C145.106201,104.919044 144.845016,104.736427 144.487534,104.691696 
	C144.487534,104.691696 144.412888,104.600204 144.326233,104.233871 
	C143.217499,101.960991 142.195389,100.054459 141.449707,97.967300 
	C142.826889,96.856430 143.927628,95.926178 145.331467,94.739784 
	C149.577896,99.709633 153.623459,104.444397 157.695023,109.620590 
	C158.009766,112.431145 158.298508,114.800278 158.418152,117.458076 
	C158.197632,118.181839 158.146225,118.616920 158.094818,119.052010 
	C158.094818,119.052010 158.058426,118.898415 157.656296,118.957138 
	C156.885834,119.732918 156.517517,120.449974 156.149185,121.167023 
	C155.264130,121.959084 154.379089,122.751144 152.966522,123.724541 
	C152.172104,124.167885 151.905212,124.429901 151.638321,124.691910 
	C151.180908,124.927155 150.723480,125.162392 149.748260,125.506287 
	C148.822784,125.726021 148.415146,125.837097 147.659485,125.892960 
	C146.858536,125.940117 146.405594,126.042488 145.952652,126.144867 
z"
          />
          <path
            fill="#D2FAE7"
            opacity="1.000000"
            stroke="none"
            d="
M297.756012,205.093536 
	C297.712952,205.500443 297.669861,205.907364 297.475708,206.888580 
	C298.064117,209.266373 294.062317,211.611755 297.963715,213.053818 
	C297.963715,213.053818 298.000366,213.001816 298.107361,213.338348 
	C303.329681,219.300690 304.329773,225.679382 301.699097,232.722321 
	C301.699097,232.722321 301.882416,233.004654 301.509155,232.935684 
	C300.395325,233.556702 299.654785,234.246674 298.914246,234.936661 
	C298.914246,234.936661 298.993683,234.986862 298.556030,235.005157 
	C291.742920,235.005081 285.367432,234.986710 278.852356,234.747925 
	C278.389801,234.428864 278.066864,234.330200 277.762390,234.272705 
	C277.780914,234.313843 277.693085,234.334534 277.794159,233.872467 
	C277.980652,232.478607 278.066071,231.546844 278.451080,230.723785 
	C279.501862,231.215485 280.253052,231.598450 281.294006,232.279633 
	C286.371552,232.337479 291.159332,232.097122 296.217529,231.615509 
	C297.359406,229.701050 298.792633,228.092987 298.995636,226.342270 
	C299.572754,221.364761 296.737793,216.370071 293.193237,215.215240 
	C286.640686,213.080383 280.077667,215.484024 276.811920,221.009735 
	C275.917816,220.177460 275.390808,219.415756 274.892334,218.304489 
	C275.272461,217.207916 275.421936,216.167725 276.009369,215.762634 
	C279.232635,213.539856 279.894348,210.860672 278.976929,207.011490 
	C278.525482,205.117416 279.546265,202.298355 280.854462,200.658844 
	C286.367462,193.749725 294.070160,195.864197 297.756012,205.093536 
M293.043640,208.544693 
	C292.357208,206.222412 292.230103,203.401962 290.773041,201.766052 
	C289.909119,200.796112 286.270294,200.925323 285.103455,201.951889 
	C283.707672,203.179871 282.805603,206.029846 283.126495,207.935364 
	C283.877136,212.392654 288.371735,212.864761 293.043640,208.544693 
z"
          />
          <path
            fill="#E5F6EE"
            opacity="1.000000"
            stroke="none"
            d="
M182.989304,101.926506 
	C182.888260,101.613625 182.700623,101.366478 182.077271,100.787231 
	C181.435532,99.112144 181.142944,97.834877 180.819366,96.243530 
	C180.524231,95.619041 180.260071,95.308640 179.832611,94.681824 
	C179.042908,92.121986 178.416534,89.878548 177.740021,87.286499 
	C177.333374,86.662415 176.976837,86.386940 176.377289,85.855606 
	C175.278168,83.331291 174.422028,81.062836 173.633102,78.972473 
	C177.265488,76.004761 179.638947,76.401741 180.685059,80.475853 
	C182.200989,86.379669 185.806503,83.664078 188.757095,82.387512 
	C193.302414,80.421013 190.162018,77.988121 188.850250,75.738663 
	C188.729095,75.326340 188.607925,74.914009 188.425232,73.999832 
	C188.363693,73.497986 188.199402,73.101768 188.199402,73.101761 
	C188.501892,72.725716 188.804382,72.349670 189.573959,71.790680 
	C191.676865,71.441742 193.312683,71.275749 194.948517,71.109764 
	C195.083115,71.643456 195.217712,72.177147 195.533447,73.162971 
	C195.771072,73.986671 195.979874,74.224167 196.340958,74.327583 
	C196.340958,74.327583 196.385086,74.515060 196.442505,74.911606 
	C196.949875,76.541466 197.399796,77.774780 197.854309,79.394157 
	C199.263458,83.492027 200.667999,87.203850 202.041321,91.341446 
	C202.051483,92.905655 202.092880,94.044083 201.922318,95.368393 
	C201.124908,95.997826 200.539459,96.441368 199.954010,96.884911 
	C199.095917,96.813606 198.237839,96.742302 197.060165,96.216629 
	C196.556366,95.151375 196.372147,94.540489 196.180695,93.543907 
	C195.817703,92.062576 195.442963,90.972679 195.109406,89.870323 
	C193.577896,84.808899 190.444717,87.878670 188.007965,88.631958 
	C185.304581,89.467674 183.503845,91.060181 186.243668,94.241760 
	C186.272980,95.134087 186.270645,95.726753 186.193420,96.748520 
	C186.065842,98.574059 186.013168,99.970490 185.766174,101.607758 
	C185.423386,101.991829 185.274918,102.135063 184.772888,102.200623 
	C183.942673,102.057472 183.465988,101.991989 182.989304,101.926506 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M328.978363,286.963379 
	C328.881073,293.755707 327.202209,294.947754 320.843231,293.140381 
	C318.486877,292.470612 315.973450,292.074127 313.526703,292.049622 
	C302.292816,291.936981 291.056030,291.914795 279.823120,292.068634 
	C277.447449,292.101196 274.987793,292.744141 272.733124,293.563416 
	C266.661987,295.769501 262.445801,293.130890 261.445953,286.684570 
	C261.284576,285.643982 259.106201,284.916199 257.429749,284.022430 
	C256.999329,284.001007 256.890717,283.900818 256.885712,283.476440 
	C255.890640,279.379791 254.900574,275.707520 254.296478,272.024963 
	C255.454544,272.009796 256.226654,272.004883 256.998779,272.000000 
	C257.692749,274.908447 258.386719,277.816895 259.209198,281.263855 
	C260.950043,278.579041 262.100555,276.804657 263.640747,275.446777 
	C264.744995,280.210510 265.459625,284.557770 266.384644,288.947144 
	C266.595001,288.989227 266.996368,289.140869 267.309326,289.403748 
	C272.130127,289.403900 276.638000,289.141144 281.106323,288.910522 
	C281.066772,288.942657 281.077240,288.841309 281.250793,289.139740 
	C282.588654,289.219513 283.752960,289.000854 284.980835,288.409424 
	C286.873016,284.847687 291.383789,283.773804 292.062775,286.400970 
	C292.915131,289.698853 294.791016,288.921967 297.198883,288.905457 
	C298.402527,288.941833 299.205170,288.947571 300.429871,288.969116 
	C301.995178,286.888031 303.138519,284.791168 304.831360,281.686432 
	C305.858521,283.042816 307.292755,284.313721 307.913422,285.902435 
	C308.842010,288.279297 310.072815,289.465088 313.090576,288.850769 
	C318.914307,290.172546 324.376953,291.918976 328.978363,286.963379 
z"
          />
          <path
            fill="#E1F7EC"
            opacity="1.000000"
            stroke="none"
            d="
M368.754456,139.720795 
	C366.594604,140.924866 363.971954,141.718918 362.424438,143.465530 
	C361.232788,144.810455 360.538391,147.672668 361.144073,149.290802 
	C362.151825,151.983047 364.804779,152.431458 367.409912,150.824631 
	C369.675476,149.427231 371.902039,147.966721 374.148895,146.538895 
	C376.234283,145.213684 378.323730,143.894836 380.817169,142.316269 
	C382.021118,143.998398 383.034454,145.414185 384.609924,147.615356 
	C376.656464,151.102402 371.543976,159.124908 361.411530,157.978882 
	C360.182220,157.392380 359.394226,156.794357 358.225861,155.769348 
	C356.582336,153.220016 355.319183,151.097672 354.050049,148.720261 
	C353.840149,148.204971 353.636261,147.944733 353.432373,147.684494 
	C353.432373,147.684494 353.375122,147.326935 353.381531,146.820450 
	C353.827332,144.726944 354.266724,143.139923 354.979370,141.390747 
	C357.819458,139.136780 360.386261,137.044968 362.977142,134.975662 
	C363.001221,134.998169 362.958038,134.947144 363.302765,134.961243 
	C365.069000,133.960892 366.490540,132.946442 368.063324,131.842682 
	C368.214600,131.753372 368.445221,131.488327 368.783569,131.418335 
	C373.577179,128.693085 374.371155,131.991241 375.132141,135.259583 
	C374.998932,135.392700 374.770477,135.692154 374.428711,135.718048 
	C372.312561,137.010895 370.538116,138.277847 368.729065,139.587097 
	C368.694458,139.629395 368.754456,139.720795 368.754456,139.720795 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M298.069458,204.883759 
	C294.070160,195.864197 286.367462,193.749725 280.854462,200.658844 
	C279.546265,202.298355 278.525482,205.117416 278.976929,207.011490 
	C279.894348,210.860672 279.232635,213.539856 276.009369,215.762634 
	C275.421936,216.167725 275.272461,217.207916 274.613922,218.596924 
	C271.370331,225.905701 272.567413,231.242477 277.693085,234.334534 
	C277.693085,234.334534 277.780914,234.313843 277.880371,234.512329 
	C278.317230,234.796646 278.654572,234.882492 278.991943,234.968353 
	C285.367432,234.986710 291.742920,235.005081 298.530762,234.965546 
	C297.407379,235.934677 295.993591,237.303360 294.306244,237.905563 
	C291.997314,238.729584 289.149689,238.403397 287.123657,239.583939 
	C283.259369,241.835632 280.854187,238.165665 277.186768,237.679016 
	C272.566132,235.077850 269.794617,232.148621 271.776337,226.971115 
	C271.187073,226.977570 270.597809,226.984009 270.008545,226.990448 
	C270.395264,225.552216 271.030945,224.126877 271.106232,222.672516 
	C271.202454,220.814056 270.846558,218.932190 270.671051,216.892639 
	C276.993103,213.588425 277.960663,211.370300 275.272156,205.482071 
	C274.141510,206.000977 273.009521,206.520493 271.339447,206.913712 
	C270.678467,206.671463 270.555603,206.555496 270.657349,206.171036 
	C273.908630,200.855698 276.207275,195.791260 276.172302,189.523865 
	C276.123932,180.860138 272.582092,173.840927 268.014526,166.987686 
	C268.070343,166.934647 268.184143,166.830856 268.184143,166.830856 
	C270.846130,169.915909 274.371857,172.608353 275.989777,176.167953 
	C279.328796,183.514145 280.808197,191.374146 278.115112,199.980118 
	C279.348846,198.880051 280.569061,197.764389 281.818604,196.682571 
	C287.286774,191.948608 297.413849,195.286377 298.856049,202.339798 
	C299.002411,203.055679 298.554810,203.893021 298.069458,204.883759 
z"
          />
          <path
            fill="#E1F7EC"
            opacity="1.000000"
            stroke="none"
            d="
M365.899567,120.120186 
	C365.899567,120.120186 365.825470,120.563881 365.860901,121.211113 
	C365.942230,123.594643 365.988190,125.330933 365.645142,127.123184 
	C364.217926,127.302406 363.179657,127.425667 361.894714,127.230324 
	C361.251312,125.655945 361.210693,124.030411 360.377411,123.228104 
	C359.010803,121.912308 357.129425,121.131149 355.465149,120.124519 
	C355.598663,121.689651 355.292877,123.470726 355.938507,124.784126 
	C359.563263,132.157974 359.101135,134.492508 352.178467,139.487885 
	C346.038635,139.932709 342.939667,136.213943 340.166748,131.509323 
	C340.013824,130.074509 339.534943,128.958908 339.836578,128.125931 
	C340.359161,126.682892 341.365204,125.414948 342.168457,124.073570 
	C343.216858,125.140060 344.407654,126.105537 345.261780,127.309807 
	C345.800476,128.069305 345.533661,129.555389 346.158783,130.066483 
	C347.517700,131.177383 349.216553,131.872467 350.776428,132.737518 
	C350.831665,131.138779 351.526337,129.146881 350.828186,128.011368 
	C348.214325,123.760132 348.009430,119.634476 350.259155,115.280602 
	C350.259155,115.280602 350.237885,115.122147 350.393677,115.122795 
	C350.549438,115.123444 350.916229,114.826401 351.215912,114.845039 
	C352.103271,114.381454 352.690948,113.899231 353.278625,113.417007 
	C353.278625,113.417015 353.289612,113.281853 353.603821,113.326584 
	C356.111847,113.798271 358.305603,114.225212 360.629150,114.908501 
	C361.383820,115.575813 362.008789,115.986786 362.796997,116.603210 
	C363.312531,117.197395 363.664734,117.586128 364.010010,118.281815 
	C364.539795,119.148010 365.076508,119.707230 365.714294,120.287598 
	C365.815369,120.308746 365.899567,120.120186 365.899567,120.120186 
z"
          />
          <path
            fill="#F0F8F6"
            opacity="1.000000"
            stroke="none"
            d="
M105.024124,160.090378 
	C105.452690,160.150223 105.881264,160.210068 106.960640,160.456238 
	C111.316406,160.883423 115.021370,161.124252 118.806808,161.749176 
	C119.299507,162.769592 119.711716,163.405899 120.091721,164.333359 
	C119.762428,165.114624 119.465340,165.604752 118.725967,166.064606 
	C116.239388,166.793777 112.944374,164.107010 112.104385,168.460052 
	C112.074844,168.653900 111.852577,168.976974 111.495384,169.058258 
	C110.845749,170.248428 110.553314,171.357330 110.227707,172.805786 
	C110.151001,174.046432 110.107460,174.947495 110.121635,176.100235 
	C110.436569,176.568893 110.693794,176.785904 111.158127,177.293884 
	C111.775963,179.283630 112.186684,180.982391 112.597412,182.681168 
	C111.982231,182.961212 111.367058,183.241257 110.751877,183.521317 
	C108.752357,181.797516 106.752831,180.073715 104.702507,178.054398 
	C104.306076,177.604477 103.960457,177.450089 103.312149,177.167435 
	C100.720711,174.940353 98.431946,172.841537 96.079834,170.447449 
	C95.551529,169.847198 95.086571,169.542221 94.375839,169.142258 
	C93.767403,168.680222 93.404739,168.313171 93.037323,167.603195 
	C92.647545,166.489380 92.262512,165.718506 91.925156,164.634567 
	C92.326027,163.558090 92.679230,162.794678 93.342484,161.991577 
	C94.130150,161.344788 94.607750,160.737671 95.497749,160.097382 
	C98.948143,160.072922 101.986130,160.081650 105.024124,160.090378 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M216.988373,289.978607 
	C214.872665,291.203735 212.720703,293.517517 210.648071,293.448547 
	C204.587845,293.246857 198.571182,291.970032 192.511108,291.389893 
	C190.630737,291.209869 188.668137,292.140106 186.739563,292.157379 
	C183.227188,292.188812 179.713135,291.875488 176.197723,291.792084 
	C174.633698,291.755005 173.061569,291.887054 171.498642,292.011719 
	C167.722290,292.312988 163.932266,293.039795 160.179428,292.874786 
	C156.247726,292.701965 155.172577,289.460846 155.042694,286.105316 
	C154.882034,281.954681 154.933258,277.791748 155.018326,273.636719 
	C155.126434,268.356781 157.323776,266.959961 162.227646,268.785522 
	C163.118942,269.117340 164.199158,268.941681 165.595810,269.306702 
	C165.999344,270.021149 165.999222,270.429108 165.591171,270.900665 
	C162.834778,271.980042 160.486328,272.995819 158.066711,274.472656 
	C157.986893,278.592621 158.086487,282.256012 157.936768,285.909210 
	C157.807037,289.074585 159.656372,290.135803 162.229095,289.831818 
	C165.442566,289.452026 168.592911,288.538177 172.091125,287.984558 
	C173.269943,288.420868 174.128128,288.727539 175.284363,289.315002 
	C179.415314,289.437836 183.248245,289.279877 187.420715,289.027405 
	C187.826431,286.951202 187.892578,284.969574 188.367157,282.992371 
	C189.861893,283.000824 190.948242,283.004852 192.029968,283.427185 
	C192.566177,285.791626 193.106995,287.737701 193.647827,289.683777 
	C194.804337,289.161804 195.960861,288.639832 197.441223,288.013367 
	C198.184647,286.938354 198.604233,285.967804 199.420624,284.998291 
	C200.875320,284.998840 201.933182,284.998322 203.033875,285.360901 
	C204.512955,287.137512 205.761673,289.415802 207.426178,289.776764 
	C210.484344,290.439972 213.787399,289.973938 216.988373,289.978607 
z"
          />
          <path
            fill="#49B882"
            opacity="1.000000"
            stroke="none"
            d="
M110.063934,175.848572 
	C110.107460,174.947495 110.151001,174.046432 110.485199,172.587387 
	C111.134766,171.011932 111.493668,169.994461 111.852577,168.976974 
	C111.852577,168.976974 112.074844,168.653900 112.487183,168.347336 
	C114.989090,167.392136 117.078667,166.743500 119.168243,166.094864 
	C119.465340,165.604752 119.762428,165.114624 120.346802,164.121094 
	C124.493790,157.160706 128.353500,150.703720 132.213211,144.246750 
	C132.213211,144.246750 132.210312,144.199219 132.450562,144.112747 
	C132.889450,143.725372 133.088089,143.424469 133.286743,143.123581 
	C135.902695,139.632385 138.518646,136.141190 141.559479,132.321045 
	C141.984360,131.992096 142.414719,131.907867 142.414719,131.907867 
	C144.206055,136.140640 140.480835,138.275024 138.739777,141.019226 
	C133.744705,148.892303 128.554108,156.647446 123.221413,164.296310 
	C121.725395,166.442078 119.783501,168.724655 117.506081,169.789978 
	C111.778786,172.469040 111.387787,174.141678 117.231995,179.011368 
	C115.417709,181.271683 113.961311,184.636230 111.585930,185.514069 
	C109.933922,186.124588 106.752151,183.643097 104.724556,181.971802 
	C100.504791,178.493591 96.690025,174.528076 92.530533,170.971329 
	C89.566422,168.436768 87.780121,165.371887 89.600967,161.842468 
	C91.257385,158.631760 93.756165,155.729553 98.402092,157.884903 
	C100.358833,158.792664 102.704521,158.862076 104.948761,159.701477 
	C101.986130,160.081650 98.948143,160.072922 95.162125,160.039688 
	C93.953529,160.687210 93.492973,161.359222 93.032425,162.031250 
	C92.679230,162.794678 92.326027,163.558090 91.696877,164.819489 
	C91.961311,166.193665 92.501694,167.069901 93.042068,167.946121 
	C93.404739,168.313171 93.767403,168.680222 94.476257,169.413086 
	C95.262688,170.100189 95.702927,170.421448 96.143173,170.742722 
	C98.431946,172.841537 100.720711,174.940353 103.441841,177.401794 
	C104.167236,177.959595 104.460266,178.154755 104.753311,178.349930 
	C106.752831,180.073715 108.752357,181.797516 110.751877,183.521317 
	C111.367058,183.241257 111.982231,182.961212 112.597412,182.681168 
	C112.186684,180.982391 111.775963,179.283630 111.130936,177.028595 
	C110.619072,176.264420 110.341499,176.056488 110.063934,175.848572 
z"
          />
          <path
            fill="#11B76A"
            opacity="1.000000"
            stroke="none"
            d="
M266.424927,340.842407 
	C266.855011,341.109314 267.285065,341.376221 267.960083,342.070740 
	C268.403992,342.754852 268.660034,342.926086 268.973175,343.012024 
	C268.973175,343.012024 269.001343,343.000458 268.955444,343.373596 
	C267.817871,344.893829 266.726227,346.040924 265.384430,346.969421 
	C260.748199,344.157654 256.362122,341.564453 251.756531,338.710999 
	C250.648331,338.353699 249.759689,338.256683 248.918442,338.130066 
	C248.965851,338.100464 248.932449,338.207153 248.689896,337.859924 
	C244.096680,337.346893 239.745575,337.083130 235.395752,337.102814 
	C234.584778,337.106476 233.778946,338.248108 232.760101,338.941956 
	C232.549438,339.019348 232.100830,339.034088 231.750458,339.016663 
	C230.605270,339.346069 229.810471,339.692841 229.008972,340.018982 
	C229.002274,339.998322 229.031677,340.030853 228.649887,340.012115 
	C227.200027,340.689850 226.131973,341.386322 225.027985,342.062012 
	C224.992065,342.041199 225.073975,342.053162 224.849594,342.113037 
	C224.336502,342.316711 224.122910,342.534302 223.753769,343.007446 
	C223.032806,343.501221 222.542542,343.813202 221.924896,343.946960 
	C221.519501,344.151886 221.241455,344.534973 220.819519,345.195221 
	C219.842575,346.088562 219.009521,346.704742 218.001099,347.076477 
	C217.225250,347.880188 216.624786,348.928406 216.024323,349.976654 
	C211.201187,350.239563 214.693359,346.762421 213.830902,344.802917 
	C214.056992,343.997498 214.336899,343.608826 215.198303,343.111877 
	C216.485321,342.287201 217.190842,341.570862 217.896362,340.854523 
	C217.896347,340.854523 218.001923,340.910461 218.271500,340.912781 
	C218.995300,340.515808 219.449539,340.116486 219.903748,339.717163 
	C229.994614,331.297424 250.105896,328.139221 264.858704,340.154816 
	C265.710449,340.626434 266.067688,340.734406 266.424927,340.842407 
z"
          />
          <path
            fill="#A9F9D6"
            opacity="1.000000"
            stroke="none"
            d="
M251.976059,338.971252 
	C256.362122,341.564453 260.748199,344.157654 265.566101,347.227722 
	C266.306793,348.470001 266.615662,349.235443 266.924561,350.000854 
	C266.391846,350.542175 265.859161,351.083466 264.903015,352.009277 
	C262.768524,354.237549 261.088776,356.209290 258.214478,353.629089 
	C257.744965,353.137909 257.420044,352.909943 256.995728,352.492432 
	C256.698395,352.071228 256.447083,351.950989 255.934799,351.680054 
	C254.526337,350.838806 253.325546,350.259705 251.908569,349.499817 
	C251.143936,349.204132 250.595459,349.089233 249.779938,348.691711 
	C244.643494,348.565125 239.774094,348.721161 234.903564,348.855713 
	C234.902420,348.834198 234.860565,348.824066 234.506714,348.826050 
	C232.372528,349.802979 230.592178,350.777924 228.794556,351.785065 
	C228.777283,351.817230 228.735550,351.757324 228.401474,351.834473 
	C224.754013,355.924072 221.560425,355.011871 218.425781,351.677094 
	C218.425781,351.677094 218.372208,351.769104 218.276932,351.356934 
	C218.179932,349.736847 218.178207,348.528900 218.176483,347.320953 
	C219.009521,346.704742 219.842575,346.088562 221.051849,345.144165 
	C221.732254,344.672546 221.940323,344.442291 222.052261,344.125153 
	C222.542542,343.813202 223.032806,343.501221 224.002945,343.001404 
	C224.813416,342.663910 225.010468,342.410461 225.073975,342.053162 
	C225.073975,342.053162 224.992065,342.041199 225.352905,342.011841 
	C226.819717,341.331970 227.925690,340.681396 229.031677,340.030853 
	C229.031677,340.030853 229.002274,339.998322 229.347412,340.023010 
	C230.495300,339.709808 231.298065,339.371948 232.100830,339.034088 
	C232.100830,339.034088 232.549438,339.019348 233.181702,338.978058 
	C238.853455,338.693573 243.892960,338.450348 248.932449,338.207153 
	C248.932449,338.207153 248.965851,338.100464 249.135498,338.391541 
	C250.195450,338.778839 251.085754,338.875061 251.976059,338.971252 
M263.277374,348.870056 
	C251.400421,336.450134 228.849487,338.680084 219.703384,351.093872 
	C222.638748,350.731628 224.691696,351.070557 225.961716,350.228577 
	C236.879089,342.990601 247.698120,342.962036 258.408722,350.407867 
	C260.782928,352.058350 262.214630,351.885742 263.277374,348.870056 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M324.974792,381.926331 
	C325.923309,380.681763 326.871857,379.437225 327.820435,378.192688 
	C328.864990,379.522980 330.512421,380.720001 330.841370,382.208466 
	C331.837921,386.717834 328.590546,393.300568 321.642975,393.005768 
	C318.733398,392.882263 315.974396,392.769989 315.747894,397.086731 
	C315.694977,398.095795 313.125519,398.972778 311.256836,399.562347 
	C309.307068,398.772827 307.735962,398.496582 306.346649,397.837311 
	C305.257263,397.320374 303.896393,396.482117 303.593689,395.498169 
	C303.372253,394.778412 304.514160,393.420868 305.333618,392.651306 
	C306.514191,391.542633 307.953522,390.709473 309.282410,389.758759 
	C309.054840,389.190674 308.827240,388.622589 308.599640,388.054535 
	C306.702332,388.407623 304.800659,389.031158 302.909546,389.000641 
	C301.951141,388.985199 301.011780,387.789398 300.371918,386.950684 
	C301.916504,386.050842 303.405426,385.553101 304.313843,384.536591 
	C305.117401,383.637421 305.274536,382.160522 305.717072,380.938721 
	C305.235413,380.702759 304.753754,380.466827 304.272095,380.230865 
	C301.774170,381.785370 299.276245,383.339844 296.476776,384.899170 
	C295.773163,384.908783 295.371124,384.913513 294.969055,384.918213 
	C295.452332,379.661011 300.294678,380.453766 303.410797,378.902557 
	C305.624847,377.800415 307.975891,376.973572 310.447327,376.362366 
	C309.177368,383.167633 310.820007,387.426331 316.009033,390.649323 
	C320.228607,393.270172 326.894714,390.609314 327.990204,385.760437 
	C328.510986,383.455536 328.440796,381.262848 324.974792,381.926331 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M346.274323,368.815826 
	C344.413208,367.995575 342.503998,367.267792 340.703247,366.331421 
	C338.489471,365.180328 336.366180,363.855133 334.203796,362.605225 
	C333.811554,362.943298 333.419312,363.281372 333.027069,363.619446 
	C333.708649,365.429993 334.390228,367.240509 335.076355,369.481384 
	C335.080902,369.911713 334.960144,370.045959 334.710327,370.006104 
	C334.298431,370.013000 334.136383,370.059753 333.670898,369.952576 
	C331.732056,367.411011 330.096680,365.023315 328.119263,362.136261 
	C327.105438,362.925293 325.297668,364.332275 323.664215,365.603577 
	C326.574982,368.275024 328.955475,370.459778 331.223267,372.765350 
	C331.110535,372.886169 330.887756,373.130249 330.887756,373.130249 
	C329.100189,372.393494 327.312653,371.656738 326.711273,371.408875 
	C323.396606,373.889740 320.277008,376.123566 317.299713,378.533203 
	C316.659637,379.051208 316.001404,380.702301 316.261505,380.980408 
	C317.495331,382.299622 319.044159,383.324219 320.582855,384.776001 
	C320.799744,385.077576 320.914612,385.056915 321.029419,385.036255 
	C322.112915,384.383026 323.196411,383.729858 324.817383,383.227417 
	C323.878510,384.880249 321.535706,387.902161 321.067688,387.635376 
	C318.232300,386.019043 314.525604,384.127716 313.540741,381.438232 
	C311.384857,375.550842 318.254272,376.024414 321.230835,373.446381 
	C317.974365,370.031586 315.515991,373.158325 312.920135,373.717224 
	C312.978485,373.227264 312.847260,372.519012 313.123108,372.279449 
	C319.407074,366.821960 325.735443,361.415619 332.513062,356.326874 
	C337.405121,360.707977 341.839722,364.761902 346.274323,368.815826 
z"
          />
          <path
            fill="#D6F1E3"
            opacity="1.000000"
            stroke="none"
            d="
M131.846848,144.163177 
	C128.353500,150.703720 124.493790,157.160706 120.378998,163.829956 
	C119.711716,163.405899 119.299507,162.769592 118.785645,161.463623 
	C112.426460,156.444031 106.168915,152.094086 99.964211,147.780869 
	C102.267326,142.682053 102.267326,142.682053 107.980133,145.093430 
	C107.980133,145.093430 108.217094,145.299408 108.526581,145.641541 
	C112.575768,148.351898 116.315460,150.720154 120.445702,153.335709 
	C121.521690,151.214493 122.325241,149.630341 123.128799,148.046204 
	C123.128799,148.046204 123.340714,147.820633 123.677582,147.510712 
	C125.025917,145.469498 126.037376,143.738205 127.048836,142.006897 
	C128.526047,142.697800 130.003265,143.388702 131.846848,144.163177 
z"
          />
          <path
            fill="#DDF4E8"
            opacity="1.000000"
            stroke="none"
            d="
M305.598572,95.827835 
	C307.609497,92.521523 309.580048,89.350739 311.665436,85.995201 
	C309.406403,84.449341 307.792664,83.345062 306.024445,82.135071 
	C306.494690,78.486786 307.992493,77.204391 311.575287,79.183884 
	C316.207794,81.743385 320.947876,84.108208 325.792755,86.635674 
	C324.912018,89.886459 324.024445,92.124313 320.000580,89.977928 
	C319.092865,89.493759 316.396576,90.743126 315.629517,91.917084 
	C313.279755,95.513390 311.668854,99.591232 309.333282,103.198662 
	C308.557678,104.396629 306.457703,104.737144 304.963165,105.469658 
	C304.560822,103.846436 303.841583,102.219582 303.860077,100.601166 
	C303.873962,99.386169 304.836029,98.182007 305.398438,96.591789 
	C305.420868,96.210556 305.558197,95.963348 305.598572,95.827835 
z"
          />
          <path
            fill="#45B581"
            opacity="1.000000"
            stroke="none"
            d="
M177.790146,87.635117 
	C178.416534,89.878548 179.042908,92.121986 179.868103,94.990433 
	C180.328064,95.929504 180.589203,96.243561 180.850357,96.557617 
	C181.142944,97.834877 181.435532,99.112144 181.860168,100.693756 
	C177.910690,100.552490 172.233566,95.532928 172.190414,92.331612 
	C172.096725,85.378281 167.199615,82.395744 160.638458,85.342972 
	C158.688568,86.218849 156.810318,87.254158 154.484009,87.929146 
	C154.065948,87.440407 154.063095,87.238937 154.060226,87.037460 
	C158.887207,82.149796 164.698761,81.163132 171.445038,83.400925 
	C171.445038,81.646980 171.003403,80.219414 171.528015,79.556259 
	C173.089401,77.582573 174.802780,74.922218 176.897202,74.438980 
	C178.498901,74.069412 180.854279,76.489052 182.715576,77.880531 
	C184.082230,78.902222 185.191650,80.267975 186.990158,82.049400 
	C187.545227,79.019905 187.820267,77.518814 188.472778,75.878197 
	C190.162018,77.988121 193.302414,80.421013 188.757095,82.387512 
	C185.806503,83.664078 182.200989,86.379669 180.685059,80.475853 
	C179.638947,76.401741 177.265488,76.004761 173.633102,78.972473 
	C174.422028,81.062836 175.278168,83.331291 176.474625,86.180298 
	C177.140015,87.052269 177.465088,87.343689 177.790146,87.635117 
z"
          />
          <path
            fill="#CDFAE7"
            opacity="1.000000"
            stroke="none"
            d="
M152.097275,385.010162 
	C152.097275,385.010162 152.220734,384.693726 152.518982,384.335022 
	C153.919464,381.644684 155.021729,379.313019 156.351044,376.788452 
	C156.700607,376.023956 156.823120,375.452362 156.968048,374.564758 
	C157.355270,373.275085 157.720062,372.301453 158.084869,371.327850 
	C158.084869,371.327850 158.404449,371.256409 158.598083,371.454468 
	C158.791733,371.652496 158.974457,372.098877 159.138031,372.420654 
	C159.601517,373.656006 159.901459,374.569580 160.164276,375.800598 
	C159.704819,377.085266 159.282486,378.052460 158.644730,379.198425 
	C158.333603,379.733459 158.237900,380.089691 158.141068,380.713440 
	C158.023514,381.316589 157.907074,381.652191 157.493973,382.029388 
	C156.836243,382.490997 156.475174,382.911011 156.305054,383.579956 
	C157.395477,383.888184 158.638474,384.354767 159.134827,383.936127 
	C161.257370,382.145996 163.159637,380.094727 165.142242,378.138702 
	C165.142258,378.138702 165.056946,378.020050 165.352875,378.025909 
	C165.883026,377.748901 166.117218,377.466064 166.351410,377.183228 
	C166.708115,377.171173 167.064789,377.159119 167.840927,377.439148 
	C168.475388,379.021149 169.117371,380.420868 168.819611,381.578949 
	C168.125687,384.278046 166.932404,386.846008 166.090729,389.514191 
	C166.008072,389.776184 166.959503,390.364349 167.754669,390.763611 
	C168.391983,390.204041 168.705582,389.682007 169.236252,388.908752 
	C170.708145,387.184052 171.962967,385.710510 173.217773,384.237000 
	C173.217773,384.237000 173.022781,383.997559 173.418365,384.050842 
	C174.322281,383.753113 174.830627,383.402069 175.464813,383.058228 
	C175.590652,383.065369 175.842606,383.057068 176.128754,383.121704 
	C176.934357,383.434845 177.453796,383.683411 177.973236,383.931946 
	C177.973251,383.931946 177.984039,384.025421 177.990082,384.335205 
	C177.385406,385.450653 176.774673,386.256348 175.911346,387.138550 
	C175.443542,387.484009 175.228348,387.752930 175.006561,388.010529 
	C175.000000,387.999207 175.021881,388.013947 174.797638,388.103516 
	C174.291275,388.375549 174.098557,388.626678 173.997223,388.976013 
	C173.999207,389.005615 173.941208,388.993195 173.729218,389.093689 
	C173.254028,389.386841 173.078415,389.640228 172.840714,390.260071 
	C170.696426,392.592041 168.701797,394.618317 166.707169,396.644562 
	C166.707169,396.644562 166.888519,396.720703 166.549957,396.770294 
	C165.889603,396.990234 165.713211,397.256744 165.682205,397.619415 
	C165.682205,397.619415 165.639511,397.665222 165.279999,397.716644 
	C163.623062,397.522095 162.325653,397.276154 161.028229,397.030182 
	C161.028229,397.030182 161.020676,396.974487 160.979156,396.574707 
	C160.961578,395.106598 160.985504,394.038239 161.009445,392.969879 
	C161.009445,392.969879 161.177078,392.666718 161.440826,392.242981 
	C162.422302,389.715546 163.140030,387.611847 164.319672,384.154175 
	C161.098587,386.669769 159.002029,388.307129 156.645264,389.753784 
	C155.880539,389.192078 155.376053,388.821106 154.871552,388.450134 
	C154.547028,389.485931 154.222504,390.521729 153.609848,391.443695 
	C152.864197,390.925903 152.406677,390.521881 151.965942,389.752075 
	C151.967880,388.898285 151.953064,388.410309 151.962524,387.956085 
	C151.986801,387.989807 151.907806,387.963989 152.137131,387.864380 
	C152.367722,387.200287 152.368988,386.635803 152.340515,385.796143 
	C152.239609,385.350647 152.168442,385.180389 152.097275,385.010162 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M156.123978,376.981354 
	C155.021729,379.313019 153.919464,381.644684 152.515930,384.165222 
	C152.400360,380.995361 150.473923,381.708008 148.409119,382.264648 
	C141.667130,384.082184 137.878632,383.060730 134.675217,377.852417 
	C132.640366,374.544037 131.315094,370.736023 135.062012,367.603760 
	C133.839417,373.882568 136.000229,378.918488 140.878204,380.746124 
	C145.224884,382.374725 151.206818,379.296875 153.508881,374.247314 
	C155.701782,369.437195 154.043701,364.601532 149.194504,362.048859 
	C143.441345,359.020386 139.876755,363.004181 136.121994,366.283539 
	C135.733368,365.272217 135.544037,363.537567 134.923813,363.366699 
	C130.835510,362.240204 126.654434,361.450348 122.547173,360.117035 
	C124.232025,358.568237 125.873322,357.453125 127.665344,356.235626 
	C128.865585,357.496277 129.945236,358.751434 131.150192,359.871826 
	C134.106171,362.620422 137.747452,362.370209 140.252808,359.205841 
	C143.263397,355.403381 140.405380,352.395721 138.771988,349.240936 
	C141.825607,348.672028 143.031555,350.118011 142.971115,353.030670 
	C142.927658,355.124634 142.962646,357.220215 142.962646,359.343079 
	C151.731354,358.799652 153.847214,360.442657 158.041168,370.945374 
	C157.720062,372.301453 157.355270,373.275085 156.762085,374.776001 
	C156.397125,375.862610 156.260544,376.421997 156.123978,376.981354 
z"
          />
          <path
            fill="#24B26F"
            opacity="1.000000"
            stroke="none"
            d="
M217.011078,289.735626 
	C213.787399,289.973938 210.484344,290.439972 207.426178,289.776764 
	C205.761673,289.415802 204.512955,287.137512 203.035507,284.987000 
	C202.953690,283.503876 202.913071,282.757690 202.809372,281.769470 
	C202.163406,281.348480 201.580505,281.169586 200.688370,280.997070 
	C199.969742,281.048523 199.560349,281.093567 199.034302,281.028809 
	C198.917633,280.919037 198.686371,280.697296 198.770004,280.319702 
	C198.853638,278.654938 198.853638,277.367737 198.853638,275.029663 
	C197.031250,276.676208 196.193359,277.433258 195.718872,277.861969 
	C193.821747,276.179749 192.054520,274.612671 190.287292,273.045624 
	C189.988159,273.438873 189.689026,273.832123 189.389893,274.225372 
	C190.553665,276.498047 191.717438,278.770721 192.513214,281.027954 
	C190.384537,279.474182 188.623840,277.935883 186.578522,276.148926 
	C186.343506,277.239410 186.154037,278.118500 185.608810,278.961151 
	C183.907425,278.266113 182.561798,277.607574 181.308411,276.994141 
	C183.605270,275.705963 185.486938,274.650604 187.368607,273.595276 
	C187.137360,273.006256 186.906113,272.417267 186.674866,271.828247 
	C183.439438,271.828247 180.204025,271.828247 177.079010,271.455597 
	C179.474030,270.738525 181.748596,270.262634 184.046112,270.086517 
	C186.351746,269.909851 188.680267,270.032074 191.246964,270.026123 
	C191.495163,270.028931 191.991455,270.028717 192.313843,270.033325 
	C193.065063,270.043182 193.493912,270.048462 193.938385,270.395081 
	C195.048615,271.546509 196.381638,273.242859 197.199142,273.022949 
	C202.531403,271.588440 207.751892,269.738403 213.008911,268.024231 
	C213.860657,268.179657 214.712387,268.335083 215.879547,268.968262 
	C216.397018,269.724335 216.662842,269.912750 216.992416,270.011169 
	C216.992416,270.011169 216.997299,270.000000 216.996338,270.360657 
	C217.002106,271.430939 217.008835,272.140503 216.767090,272.886475 
	C216.353210,272.948730 216.187790,272.974609 216.014191,272.993469 
	C216.006027,272.986450 215.984665,272.983643 215.707825,272.707947 
	C212.856995,272.582489 210.283005,272.732697 207.392090,272.928497 
	C206.375107,273.963043 205.675018,274.951996 204.752502,276.220581 
	C204.382004,277.658905 204.233963,278.817596 204.020172,280.317261 
	C204.010147,281.114655 204.065857,281.571136 204.090332,282.356140 
	C204.314606,283.281342 204.570129,283.877991 204.809387,284.624512 
	C204.793091,284.774414 204.992844,285.000397 205.082550,285.303162 
	C205.649582,285.581116 206.126907,285.556335 206.779037,285.660034 
	C206.953827,285.788483 207.349686,285.610870 207.380432,285.599182 
	C207.411179,285.587494 207.474884,285.603851 207.500229,285.629456 
	C207.525574,285.655090 207.498581,285.721008 207.233063,286.131714 
	C208.378433,290.143280 211.342209,288.984009 214.296356,288.847351 
	C215.417770,288.603180 216.221054,288.341156 217.040848,288.311523 
	C217.057373,288.543945 217.094910,289.008392 217.094910,289.008392 
	C217.094910,289.008392 217.033798,289.492645 217.011078,289.735626 
z"
          />
          <path
            fill="#D0FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M350.447021,329.222260 
	C350.447021,329.222260 350.749786,329.224640 351.249695,329.186279 
	C352.505615,329.068665 353.261566,328.989441 354.364685,328.957397 
	C355.338013,328.750275 355.964233,328.496002 356.886780,328.325775 
	C357.786865,328.309875 358.390625,328.209930 359.373657,328.140198 
	C361.151581,328.051331 362.550262,327.932281 365.360596,327.693054 
	C362.914703,326.589935 361.683380,326.034576 360.189941,325.282043 
	C358.004272,323.745483 356.080658,322.406067 354.157074,321.066681 
	C354.443085,320.584015 354.729126,320.101349 355.456238,319.406860 
	C361.669617,321.785492 367.441925,324.375916 373.214233,326.966370 
	C372.820648,328.001099 372.427032,329.035797 371.496033,330.422424 
	C366.495575,331.299805 362.032501,331.825348 357.569458,332.350861 
	C357.521667,332.728821 357.473877,333.106781 357.426086,333.484741 
	C360.593140,335.036255 363.760193,336.587769 366.966919,338.493195 
	C366.995300,339.558838 366.984009,340.270538 366.972717,340.982269 
	C366.972717,340.982269 366.999359,341.001068 366.585083,341.002930 
	C362.038116,339.666901 357.915344,338.297424 353.769989,336.999939 
	C349.588287,335.691101 348.155792,333.267303 350.447021,329.222260 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M350.083832,329.158356 
	C348.155792,333.267303 349.588287,335.691101 353.769989,336.999939 
	C357.915344,338.297424 362.038116,339.666901 366.576782,340.989258 
	C361.174591,343.580078 362.083038,348.733429 361.878906,353.685364 
	C361.691193,358.239349 355.369659,362.162231 350.844360,360.855835 
	C349.077728,360.345825 347.255737,359.029846 346.660645,362.580139 
	C342.529541,359.827209 338.744568,356.788910 334.959625,353.750580 
	C339.446411,352.649811 338.723145,348.681519 339.807739,345.696899 
	C340.132660,351.916534 342.489319,356.341858 348.935669,358.391052 
	C351.143097,358.409576 353.039703,358.193268 355.254883,357.884979 
	C356.725464,356.548340 357.877502,355.303680 359.319214,353.864929 
	C359.968811,352.100861 360.328705,350.530884 360.753784,348.677216 
	C360.561432,347.898010 360.303925,347.402435 359.998993,346.566132 
	C356.995056,344.141510 354.038544,342.057648 350.966064,339.778259 
	C350.657959,339.267578 350.393524,339.185394 349.693481,339.272217 
	C348.222412,339.525574 347.114655,339.842865 345.710907,340.162659 
	C344.982117,340.461182 344.549316,340.757202 344.074066,341.050110 
	C344.031647,341.046997 344.036896,341.131897 343.837250,341.119446 
	C343.637604,341.107025 343.237762,341.092773 343.237762,341.092773 
	C343.283539,340.115509 343.329346,339.138275 343.375153,338.161011 
	C348.580231,338.422394 348.028442,335.118286 347.661652,331.621857 
	C347.581696,330.859772 348.995056,329.941040 350.083832,329.158356 
z"
          />
          <path
            fill="#C9F9E5"
            opacity="1.000000"
            stroke="none"
            d="
M206.880920,397.158936 
	C206.061340,399.500061 205.202042,401.828278 204.436951,404.187073 
	C203.973221,405.616760 203.467453,407.074860 203.318710,408.554169 
	C203.126495,410.465668 203.271835,412.411102 203.271835,414.404846 
	C199.086472,415.051178 199.099304,412.471497 199.034851,409.908508 
	C198.974136,407.494110 199.492203,404.645599 195.321075,404.799377 
	C194.465012,406.979950 193.579300,409.236084 192.699692,411.476624 
	C189.681335,411.553162 188.489716,410.672791 189.557831,407.651855 
	C190.929398,403.772552 192.009186,399.790100 193.513519,395.222290 
	C194.992981,393.848297 196.503235,392.218750 197.296661,392.514191 
	C200.608704,393.747467 203.705322,395.559265 206.880920,397.158936 
M198.942398,401.778778 
	C200.258408,400.998749 201.574417,400.218689 202.890442,399.438660 
	C201.408859,398.172211 199.927277,396.905762 198.445694,395.639343 
	C197.816849,396.033600 197.187988,396.427856 196.559143,396.822113 
	C197.122391,398.382568 197.685623,399.943054 198.942398,401.778778 
z"
          />
          <path
            fill="#C6F9E4"
            opacity="1.000000"
            stroke="none"
            d="
M276.849945,152.394180 
	C276.926880,152.662628 277.088348,152.862885 277.678009,153.336868 
	C279.002411,154.487473 279.983215,155.296188 280.963989,156.104904 
	C280.993561,156.424683 281.127106,156.692657 281.702240,157.273895 
	C282.644348,158.146988 283.248871,158.655029 283.853363,159.163055 
	C283.853363,159.163055 283.891998,158.994247 283.932068,159.408890 
	C289.329559,167.451309 293.048676,175.713806 293.496674,185.164948 
	C293.583801,187.003265 293.123718,188.867523 292.916077,190.719833 
	C292.269226,190.714218 291.622375,190.708618 290.975555,190.703018 
	C290.564758,189.079834 290.260376,187.420593 289.724548,185.839813 
	C287.576477,179.503098 285.356628,173.190735 283.163300,166.869370 
	C283.163300,166.869370 283.100769,166.827621 283.090332,166.489197 
	C280.051880,162.774277 277.023865,159.397751 273.995880,156.021225 
	C273.995880,156.021225 273.999939,155.996109 273.850403,155.702011 
	C271.631500,153.889526 269.562195,152.371155 267.492859,150.852768 
	C267.484039,150.417160 267.475220,149.981567 267.464966,149.196411 
	C267.463501,148.846863 267.482758,148.797195 267.482758,148.797195 
	C267.482758,148.797195 267.637421,148.648880 268.002441,148.473724 
	C271.194977,149.663757 274.022461,151.028976 276.849945,152.394180 
z"
          />
          <path
            fill="#C8F9E5"
            opacity="1.000000"
            stroke="none"
            d="
M136.062057,366.465210 
	C139.876755,363.004181 143.441345,359.020386 149.194504,362.048859 
	C154.043701,364.601532 155.701782,369.437195 153.508881,374.247314 
	C151.206818,379.296875 145.224884,382.374725 140.878204,380.746124 
	C136.000229,378.918488 133.839417,373.882568 135.479950,367.627747 
	C135.747009,367.087799 135.896957,366.883789 136.062057,366.465210 
M141.062531,367.679016 
	C138.459457,370.202606 137.555939,373.087982 140.344208,375.855621 
	C142.875427,378.368134 145.579010,377.189423 147.677261,374.967133 
	C149.827545,372.689789 152.245468,370.193024 149.304153,366.877502 
	C146.714905,363.958893 144.100952,364.773102 141.062531,367.679016 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M217.015549,272.850098 
	C217.008835,272.140503 217.002106,271.430939 216.990173,270.366882 
	C218.849808,268.077332 220.850372,266.250671 222.520660,264.160126 
	C223.323700,263.155029 223.503174,261.651764 223.965012,260.374084 
	C224.642487,261.654816 225.400497,262.901733 225.958939,264.232422 
	C226.191666,264.786987 225.999359,265.519897 226.154724,266.895935 
	C229.997971,272.267700 230.639389,272.304138 233.000000,268.000427 
	C234.089493,267.666840 235.178986,267.333282 236.669983,267.343140 
	C238.043884,268.890259 239.016296,270.093933 239.988693,271.297607 
	C240.535324,271.159912 241.081940,271.022186 241.628555,270.884491 
	C241.419647,269.589478 241.210739,268.294495 241.001831,266.999481 
	C241.772552,266.339264 242.483276,265.205963 243.324219,265.099304 
	C247.347702,264.588867 251.404831,264.164825 255.453598,264.130035 
	C256.860229,264.117920 258.277283,265.313995 259.689575,265.958252 
	C259.040802,266.633026 258.392029,267.307800 256.983154,267.944214 
	C249.345200,265.900757 245.781143,266.842285 243.918655,271.397583 
	C243.239548,271.800873 242.675705,271.932465 241.675064,272.042999 
	C240.073288,272.076324 238.908325,272.130646 237.348755,272.129578 
	C231.210052,272.789795 235.921967,277.955841 233.318726,280.233368 
	C232.005569,278.675751 230.664337,277.084808 229.249420,275.152771 
	C227.862381,271.677826 225.812088,271.077820 222.669296,273.041321 
	C220.727310,273.099304 219.137909,273.137848 217.388641,273.138336 
	C217.228760,273.100250 217.015549,272.850098 217.015549,272.850098 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M231.319550,235.029266 
	C228.851730,234.175964 226.702835,233.347672 224.420486,232.467926 
	C225.407669,230.211792 225.987518,227.735413 227.453415,226.013245 
	C228.206589,225.128418 231.569046,224.905457 231.997177,225.549728 
	C235.419647,230.700089 240.812836,229.345901 245.463455,229.792984 
	C249.049332,230.137711 252.762344,229.342529 256.397247,228.883240 
	C257.491333,228.744995 258.513031,228.033630 260.039917,227.294098 
	C260.511963,227.003387 261.003113,226.986572 261.003113,226.986572 
	C261.753143,226.986786 262.503143,226.987000 263.846436,227.113953 
	C264.633820,227.691422 264.827911,228.142181 264.616516,228.672241 
	C253.349899,232.205353 242.484482,233.341537 231.497803,229.152786 
	C230.634613,228.823700 229.293930,229.747086 228.175156,230.088379 
	C228.969208,230.969116 229.597046,232.294296 230.582626,232.662842 
	C242.312347,237.049316 253.969284,236.510742 265.747070,231.914276 
	C265.327332,233.010025 264.661987,234.000946 263.996643,234.991882 
	C262.376129,235.405975 260.755615,235.820068 258.727905,236.606934 
	C257.880768,236.983902 257.440765,236.988098 257.000793,236.992279 
	C253.635849,237.002075 250.270905,237.011887 245.995300,237.019257 
	C241.389359,236.680252 237.694092,236.343674 233.998825,236.007080 
	C233.212051,235.689468 232.425262,235.371857 231.319550,235.029266 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M328.980133,286.554077 
	C324.376953,291.918976 318.914307,290.172546 312.985107,288.535950 
	C312.635468,284.794525 307.895538,282.093964 311.450500,278.096558 
	C311.475616,276.519440 311.259766,275.213928 310.945862,273.680054 
	C310.636078,273.160339 310.350067,273.014618 309.952240,272.815521 
	C309.914612,272.616455 309.873779,272.213348 309.899902,272.099976 
	C309.925995,271.986633 310.022430,271.774963 310.022430,271.774963 
	C310.461334,271.837036 310.900269,271.899139 311.894073,271.871338 
	C312.726440,271.591522 312.927704,271.340454 313.052734,271.028320 
	C314.737030,270.555969 316.468414,270.207092 318.096313,269.586700 
	C322.030334,268.087463 325.187073,269.264709 327.492157,272.490356 
	C327.884857,273.039917 326.739563,274.688568 326.054382,275.397430 
	C325.353912,270.251038 321.585114,271.966278 319.348999,272.208191 
	C317.747253,272.381500 315.160065,274.589050 315.174561,275.864441 
	C315.194733,277.638092 316.959351,279.704803 318.495636,281.057220 
	C319.931702,282.321442 322.044098,282.817383 323.858826,283.651459 
	C323.729065,284.304260 323.599274,284.957031 323.469513,285.609802 
	C321.536072,285.412506 319.605927,285.164032 317.667786,285.039703 
	C316.713562,284.978455 315.744629,285.146851 314.782349,285.211334 
	C315.193878,286.162231 315.565430,287.912445 316.023346,287.935333 
	C319.182953,288.093323 322.623688,288.553406 325.393066,287.453522 
	C326.394501,287.055786 325.801208,282.642822 325.935608,280.062073 
	C330.131836,280.496674 328.636017,283.781921 328.980133,286.554077 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M217.496201,289.006073 
	C217.094910,289.008392 217.057373,288.543945 217.041168,288.279419 
	C217.024963,288.014923 217.087128,288.029541 217.463531,288.022186 
	C219.551605,287.680450 221.263260,287.346100 223.100830,287.373383 
	C224.324554,288.153168 225.422409,288.571350 227.117889,289.217163 
	C227.117889,285.166016 227.117889,282.083893 227.413025,279.161255 
	C228.821976,281.313080 229.731888,283.460754 231.101501,285.258118 
	C232.792114,287.476746 234.318008,290.855957 238.389343,287.826019 
	C239.715744,287.492798 240.746307,287.285034 241.848282,287.308105 
	C241.919678,287.538910 242.100433,287.987061 242.256348,288.376770 
	C244.862885,288.838348 247.462570,289.446777 249.719177,288.820038 
	C251.689178,288.272858 253.272720,286.334351 255.179474,284.771973 
	C255.851547,284.322510 256.371124,284.111664 256.890717,283.900818 
	C256.890717,283.900818 256.999329,284.001007 257.055237,284.050903 
	C256.804199,288.478760 252.598419,292.874176 247.708298,292.887695 
	C240.087753,292.908752 232.447403,292.497162 224.854477,291.826874 
	C222.470978,291.616486 220.212936,289.984894 217.496201,289.006073 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M236.811493,138.142883 
	C236.554825,139.484955 235.813950,140.787277 235.314468,142.176376 
	C232.549133,149.866943 236.089432,155.215363 244.161957,154.966156 
	C248.476273,154.832947 252.760483,153.725250 257.402588,152.906158 
	C256.798523,154.229431 255.850174,155.703903 255.067810,156.920334 
	C258.403320,159.153778 262.173889,161.678574 265.980072,164.596069 
	C266.015656,164.988800 265.881805,165.135483 265.546570,165.051147 
	C262.521240,163.598083 259.831116,162.229355 257.131073,160.875641 
	C257.121124,160.890640 257.130188,160.887924 256.961548,160.630890 
	C256.203613,160.306412 255.614334,160.238953 254.559677,160.107117 
	C248.070374,160.392899 242.046432,160.743027 235.758911,161.042358 
	C235.318878,160.961914 235.142410,160.932251 235.033478,160.565353 
	C235.741592,159.183975 236.382141,158.139816 236.251785,158.352310 
	C234.526306,154.152847 233.262238,151.076385 231.998169,147.999908 
	C234.053223,144.973328 231.393707,139.822769 236.811493,138.142883 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M212.832993,267.780212 
	C207.751892,269.738403 202.531403,271.588440 197.199142,273.022949 
	C196.381638,273.242859 195.048615,271.546509 194.327805,270.375732 
	C196.062332,269.618103 197.423080,269.221191 198.783829,268.824280 
	C198.638367,268.119751 198.492905,267.415222 198.347427,266.710724 
	C196.232437,267.139069 194.117432,267.567413 191.768311,267.725677 
	C185.690079,267.636627 179.845947,267.817688 174.001831,267.998779 
	C170.871155,266.713928 167.740479,265.429047 164.609802,264.144196 
	C164.643707,263.730835 164.677612,263.317444 164.711517,262.904083 
	C168.573730,263.347992 172.427719,263.892426 176.300323,264.209320 
	C180.734467,264.572174 185.213623,265.113647 189.613953,264.784790 
	C191.259079,264.661835 192.737274,262.305450 195.047699,260.316498 
	C195.851746,261.663208 196.889084,263.400696 198.370163,265.881409 
	C202.557983,266.366486 207.607529,266.951355 212.832993,267.780212 
z"
          />
          <path
            fill="#C9F9E5"
            opacity="1.000000"
            stroke="none"
            d="
M138.785095,349.229919 
	C140.405380,352.395721 143.263397,355.403381 140.252808,359.205841 
	C137.747452,362.370209 134.106171,362.620422 131.150192,359.871826 
	C129.945236,358.751434 128.865585,357.496277 127.665344,356.235626 
	C125.873322,357.453125 124.232025,358.568237 122.317238,359.861084 
	C119.738815,358.541199 119.222305,357.053619 121.822899,355.235413 
	C124.225006,353.555939 126.483162,351.670593 129.308899,349.524841 
	C130.919052,348.194977 132.025040,347.216156 133.131042,346.237335 
	C133.585022,346.065796 134.038986,345.894257 135.045990,345.823486 
	C136.662292,347.012756 137.725571,348.101257 138.788864,349.189728 
	C138.788864,349.189728 138.798218,349.218933 138.785095,349.229919 
M137.022614,356.571869 
	C136.622330,354.881927 136.222046,353.191986 135.821777,351.502045 
	C134.527954,351.901398 133.036530,352.037964 132.018234,352.803711 
	C131.454041,353.228027 131.331024,355.451782 131.609634,355.582275 
	C133.135330,356.296844 134.847092,356.614075 137.022614,356.571869 
z"
          />
          <path
            fill="#D0FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M267.581848,396.894623 
	C267.622101,396.615631 267.631531,396.335571 267.891663,395.777344 
	C269.100342,395.360962 270.027435,395.221741 270.954559,395.082520 
	C270.954559,395.082520 271.169891,395.294739 271.397736,395.706116 
	C272.606354,402.344177 273.587128,408.570923 274.567871,414.797638 
	C268.554352,415.612762 267.143524,409.700256 263.124878,406.573975 
	C260.630890,404.998230 258.430786,404.018494 256.117859,402.682312 
	C255.926407,401.584045 255.847763,400.842224 256.127716,399.948364 
	C257.984009,399.531830 259.481689,399.267426 261.269623,399.173035 
	C263.732727,401.897858 265.905609,404.452606 268.078491,407.007355 
	C268.473022,406.784393 268.867554,406.561401 269.262085,406.338440 
	C268.701996,403.190491 268.141907,400.042572 267.581848,396.894623 
z"
          />
          <path
            fill="#ADF9D8"
            opacity="1.000000"
            stroke="none"
            d="
M234.952759,366.691620 
	C234.952759,366.691620 234.592163,366.736481 234.201065,366.529785 
	C231.559784,364.687347 229.309601,363.051605 227.189743,361.510590 
	C236.515411,350.537720 250.639481,351.008759 256.102875,361.022919 
	C255.713104,361.456573 255.323334,361.890198 254.511383,362.747559 
	C252.160629,364.607422 251.046799,367.546753 247.538986,365.060120 
	C242.537399,361.514496 239.581299,362.174866 234.952759,366.691620 
M244.898880,356.226471 
	C239.992813,355.782318 235.346817,356.132690 230.730438,361.649811 
	C233.396362,361.840179 235.145935,362.494598 236.367096,361.954437 
	C240.260010,360.232483 243.855270,360.042877 247.792038,361.924072 
	C249.061325,362.530609 251.025101,361.683746 252.671188,361.501770 
	C252.688889,360.871185 252.706573,360.240631 252.724274,359.610046 
	C250.379639,358.548706 248.035004,357.487335 244.898880,356.226471 
z"
          />
          <path
            fill="#1EB56E"
            opacity="1.000000"
            stroke="none"
            d="
M234.931244,367.126709 
	C239.581299,362.174866 242.537399,361.514496 247.538986,365.060120 
	C251.046799,367.546753 252.160629,364.607422 254.395508,363.020142 
	C256.462189,365.556335 255.052780,366.548126 252.527985,367.051514 
	C249.810089,367.593475 248.999329,368.731720 249.536835,371.915131 
	C249.885284,373.978912 247.584595,376.489929 246.204620,378.417114 
	C246.285065,377.470215 246.963303,376.880890 246.921600,376.347900 
	C246.733292,373.941071 247.132751,370.800232 245.785431,369.378174 
	C244.593063,368.119690 240.828903,367.877075 239.208984,368.855804 
	C237.679703,369.779694 236.322922,373.355194 236.966248,374.899628 
	C237.739395,376.755768 240.633606,377.837921 242.765396,378.958496 
	C243.500580,379.344910 244.703735,378.841003 245.693115,378.743835 
	C243.023849,379.729187 240.247696,381.637115 237.726456,381.344940 
	C236.273941,381.176666 234.603104,377.568420 234.178909,375.294342 
	C233.722443,372.847412 234.609085,370.149963 234.931244,367.126709 
z"
          />
          <path
            fill="#D0FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M358.757080,306.932434 
	C360.314972,306.167267 361.872833,305.402069 363.652161,305.190613 
	C360.729706,311.316315 360.729706,311.316315 363.725800,314.291595 
	C365.238525,311.871857 366.678650,309.568237 368.118774,307.264587 
	C368.657318,307.031433 369.195892,306.798309 370.268494,306.280273 
	C374.031494,306.976349 378.477905,306.530548 377.621887,312.268677 
	C377.249573,313.667999 377.116760,314.816986 376.965973,316.267334 
	C376.879181,316.963562 376.810364,317.358459 376.741516,317.753357 
	C376.741516,317.753357 376.758972,317.766479 376.524292,317.885986 
	C376.168213,318.328064 376.046844,318.650604 375.925476,318.973145 
	C375.626038,319.079163 375.377594,319.256592 374.833801,319.721191 
	C374.487488,319.936981 374.014618,320.048187 373.847473,319.794617 
	C373.131592,318.760712 372.582794,317.980347 372.234558,316.972961 
	C372.993225,316.162415 373.551361,315.578827 374.258789,314.927948 
	C374.676514,314.586395 374.667236,314.312378 374.364990,313.652466 
	C373.700989,312.257996 373.052246,311.249542 372.403503,310.241089 
	C371.526886,310.906525 370.473816,311.432465 369.812897,312.268433 
	C368.684601,313.695648 367.802277,315.317352 366.816620,316.857361 
	C366.340515,317.112091 365.864441,317.366821 364.796478,317.749847 
	C357.903107,316.862976 356.842010,314.730927 358.757080,306.932434 
z"
          />
          <path
            fill="#C8FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M217.054321,415.834961 
	C216.996811,415.576447 216.893768,415.337616 216.495300,414.587860 
	C213.959656,409.558563 215.178543,405.269318 217.024811,401.017548 
	C217.024811,401.017548 216.999664,401.000000 217.292542,400.910950 
	C218.137314,400.251801 218.689224,399.681732 219.623047,399.043213 
	C223.839615,397.217651 227.446014,397.681671 230.967239,400.355164 
	C231.434250,401.079742 231.786667,401.538757 232.112198,402.324280 
	C231.133423,403.329132 230.181534,404.007446 229.065430,404.391632 
	C226.788742,401.345184 224.219757,400.333893 221.296097,402.677521 
	C218.813919,404.667236 218.322479,410.471161 220.288162,412.724823 
	C222.756851,415.555115 225.386108,415.178436 228.353546,412.890472 
	C229.168640,412.843109 229.631943,412.772675 230.152496,412.809723 
	C230.209778,412.917206 230.451920,412.890869 230.347748,413.287354 
	C228.615738,415.170013 227.178665,417.499512 225.310272,417.922089 
	C223.128876,418.415497 220.570923,417.244080 218.176346,416.794952 
	C218.176346,416.794952 218.025406,416.839508 218.017670,416.586670 
	C217.691406,416.167542 217.372864,416.001251 217.054321,415.834961 
z"
          />
          <path
            fill="#D5FDEE"
            opacity="1.000000"
            stroke="none"
            d="
M110.977600,344.970581 
	C110.817856,344.423767 110.658104,343.876984 110.234924,342.803406 
	C109.029404,339.969910 108.087288,337.663177 107.195358,335.479279 
	C109.921738,333.834839 112.141090,332.496216 114.360428,331.157593 
	C114.852554,331.001221 115.344673,330.844879 116.371887,330.420410 
	C124.212906,326.755463 127.085159,328.720703 127.751877,338.206818 
	C126.320007,336.924255 125.543053,335.021881 124.142723,333.892273 
	C123.065125,333.023041 121.203438,333.125763 119.082626,332.663910 
	C120.482925,336.428345 121.333824,338.715851 122.184731,341.003357 
	C122.050293,341.116425 121.915863,341.229462 121.304398,341.553772 
	C119.209129,339.897125 117.590889,338.029175 115.717018,335.866180 
	C107.264961,337.935242 114.967552,342.440704 114.771057,346.342651 
	C113.249023,345.792145 112.113312,345.381378 110.977600,344.970581 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M158.454681,119.042114 
	C158.146225,118.616920 158.197632,118.181839 158.713776,117.287392 
	C160.566177,113.905266 160.526459,111.264183 157.669037,109.179169 
	C153.623459,104.444397 149.577896,99.709633 145.331467,94.739784 
	C143.927628,95.926178 142.826889,96.856430 141.159714,97.900238 
	C140.395813,97.995644 140.198334,97.977486 140.000854,97.959328 
	C139.838760,94.021736 140.009811,90.913780 145.696701,92.500282 
	C147.187744,92.916252 149.515915,90.331520 151.829987,89.149292 
	C152.624725,91.669365 152.442932,94.496033 153.590240,96.596840 
	C156.698776,102.288864 160.371521,107.672775 163.932098,113.494461 
	C162.300613,115.550781 160.557571,117.291504 158.454681,119.042114 
z"
          />
          <path
            fill="#CEFAE7"
            opacity="1.000000"
            stroke="none"
            d="
M294.823730,385.173279 
	C295.371124,384.913513 295.773163,384.908783 296.860992,384.931946 
	C298.385773,385.682281 299.224792,386.404755 300.063812,387.127197 
	C301.011780,387.789398 301.951141,388.985199 302.909546,389.000641 
	C304.800659,389.031158 306.702332,388.407623 308.599640,388.054535 
	C308.827240,388.622589 309.054840,389.190674 309.282410,389.758759 
	C307.953522,390.709473 306.514191,391.542633 305.333618,392.651306 
	C304.514160,393.420868 303.372253,394.778412 303.593689,395.498169 
	C303.896393,396.482117 305.257263,397.320374 306.346649,397.837311 
	C307.735962,398.496582 309.307068,398.772827 310.874084,399.590149 
	C310.948364,399.966095 310.985748,399.984436 310.622131,399.996124 
	C308.176514,401.012482 306.094543,402.017120 304.012543,403.021759 
	C302.091248,400.891418 300.169922,398.761047 298.172546,395.952332 
	C296.712463,392.522583 295.328461,389.771210 293.944458,387.019836 
	C294.189087,386.489349 294.433746,385.958832 294.823730,385.173279 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M122.511337,340.954559 
	C121.333824,338.715851 120.482925,336.428345 119.082626,332.663910 
	C121.203438,333.125763 123.065125,333.023041 124.142723,333.892273 
	C125.543053,335.021881 126.320007,336.924255 127.751877,338.206818 
	C127.085159,328.720703 124.212906,326.755463 116.540909,330.220032 
	C114.954903,329.511017 113.813431,328.281464 112.498375,328.053558 
	C109.920044,327.606720 107.245026,327.717834 104.719772,327.249451 
	C109.906281,326.348999 115.005219,325.935516 120.041107,325.128601 
	C121.048424,324.967194 121.815331,323.305420 122.693085,322.335449 
	C125.143272,326.405029 127.574745,330.486023 130.055130,334.537109 
	C130.790039,335.737427 131.662689,336.853333 132.638931,338.245728 
	C129.301651,339.151489 126.069801,340.028625 122.511337,340.954559 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M283.100037,167.284821 
	C285.356628,173.190735 287.576477,179.503098 289.724548,185.839813 
	C290.260376,187.420593 290.564758,189.079834 290.975555,190.703018 
	C291.622375,190.708618 292.269226,190.714218 292.916077,190.719833 
	C293.123718,188.867523 293.583801,187.003265 293.496674,185.164948 
	C293.048676,175.713806 289.329559,167.451309 283.896057,159.487701 
	C286.797546,162.650085 290.870209,165.711380 292.483093,169.754074 
	C294.632935,175.142563 295.228271,181.264465 295.716003,187.135727 
	C295.867462,188.959229 293.499084,190.992050 292.284302,192.929047 
	C290.925507,191.344330 288.882172,189.966248 288.330292,188.137939 
	C286.298279,181.406128 284.760468,174.525131 283.100037,167.284821 
z"
          />
          <path
            fill="#C9F9E5"
            opacity="1.000000"
            stroke="none"
            d="
M274.787415,394.951691 
	C274.889923,394.617065 274.992401,394.282440 275.474426,393.625061 
	C276.583435,392.901764 277.312897,392.501221 278.042389,392.100647 
	C278.375854,392.157471 278.709351,392.214264 279.486511,392.569336 
	C282.953674,395.320129 285.977112,397.772614 289.000702,400.419891 
	C289.000854,400.614655 289.016205,401.003876 288.864624,401.315765 
	C288.404053,402.246307 288.095032,402.864990 287.480347,403.324829 
	C285.529541,402.106262 283.884430,401.046539 281.314453,399.391052 
	C282.812592,404.159180 283.885223,407.573120 284.957855,410.987061 
	C284.957855,410.987061 284.771332,411.235352 284.403961,411.430725 
	C283.084869,411.682922 282.133148,411.739716 281.181427,411.796539 
	C281.181427,411.796539 281.058929,411.884460 281.077301,411.506470 
	C278.992920,405.736237 276.890167,400.343964 274.787415,394.951691 
z"
          />
          <path
            fill="#1EB56E"
            opacity="1.000000"
            stroke="none"
            d="
M256.359009,360.782532 
	C250.639481,351.008759 236.515411,350.537720 227.189743,361.510590 
	C229.309601,363.051605 231.559784,364.687347 234.027115,366.582245 
	C231.033417,368.416718 228.801956,366.989258 227.718674,364.116699 
	C226.571350,361.074280 225.809586,357.740723 230.145126,355.234314 
	C233.783722,353.921661 236.783340,352.495361 239.909683,352.117401 
	C243.893753,351.635681 247.980347,352.001740 252.433517,352.000305 
	C253.943680,351.979553 255.043076,351.960876 256.142456,351.942200 
	C256.447083,351.950989 256.698395,352.071228 257.093933,352.794006 
	C257.647339,353.487518 258.003204,353.689880 258.359039,353.892242 
	C261.088776,356.209290 262.768524,354.237549 264.794800,352.272888 
	C266.826355,356.328522 262.622070,355.443359 261.087372,356.822021 
	C259.645874,358.116913 258.109711,359.306335 256.359009,360.782532 
z"
          />
          <path
            fill="#D5FDEE"
            opacity="1.000000"
            stroke="none"
            d="
M312.789703,373.999542 
	C315.515991,373.158325 317.974365,370.031586 321.230835,373.446381 
	C318.254272,376.024414 311.384857,375.550842 313.540741,381.438232 
	C314.525604,384.127716 318.232300,386.019043 321.067688,387.635376 
	C321.535706,387.902161 323.878510,384.880249 325.140991,383.174561 
	C324.935364,382.796906 324.943665,382.622864 324.963379,382.187561 
	C328.440796,381.262848 328.510986,383.455536 327.990204,385.760437 
	C326.894714,390.609314 320.228607,393.270172 316.009033,390.649323 
	C310.820007,387.426331 309.177368,383.167633 310.790405,376.331848 
	C311.521057,375.402496 312.090149,374.842163 312.789703,373.999542 
z"
          />
          <path
            fill="#02BE61"
            opacity="1.000000"
            stroke="none"
            d="
M231.660294,148.000458 
	C233.262238,151.076385 234.526306,154.152847 236.251785,158.352310 
	C236.382141,158.139816 235.741592,159.183975 234.894211,160.673996 
	C234.687378,161.119858 234.333786,161.130249 233.921783,161.081085 
	C232.684448,161.028198 231.859116,161.024475 230.751007,160.821045 
	C227.455704,156.785492 224.864044,162.112045 221.977142,161.011383 
	C221.008194,159.979919 220.039246,158.948441 219.463776,157.481766 
	C223.897659,154.782730 228.774033,153.454376 229.970886,148.008575 
	C230.421402,148.006058 230.871902,148.003525 231.660294,148.000458 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M325.954529,280.047852 
	C325.801208,282.642822 326.394501,287.055786 325.393066,287.453522 
	C322.623688,288.553406 319.182953,288.093323 316.023346,287.935333 
	C315.565430,287.912445 315.193878,286.162231 314.782349,285.211334 
	C315.744629,285.146851 316.713562,284.978455 317.667786,285.039703 
	C319.605927,285.164032 321.536072,285.412506 323.469513,285.609802 
	C323.599274,284.957031 323.729065,284.304260 323.858826,283.651459 
	C322.044098,282.817383 319.931702,282.321442 318.495636,281.057220 
	C316.959351,279.704803 315.194733,277.638092 315.174561,275.864441 
	C315.160065,274.589050 317.747253,272.381500 319.348999,272.208191 
	C321.585114,271.966278 325.353912,270.251038 325.719177,275.344208 
	C325.272278,275.779388 324.910217,275.835785 324.012329,275.648132 
	C321.757385,275.404114 320.038208,275.404114 318.319061,275.404114 
	C318.226074,276.020386 318.133057,276.636658 318.040070,277.252899 
	C320.021698,277.844269 322.003296,278.435638 323.984924,279.027008 
	C323.984924,279.027008 323.998474,278.998199 324.137787,279.267761 
	C324.840942,279.717346 325.404816,279.897339 325.968658,280.077332 
	C325.968658,280.077332 325.973419,280.033630 325.954529,280.047852 
z"
          />
          <path
            fill="#05BC62"
            opacity="1.000000"
            stroke="none"
            d="
M374.770477,135.692154 
	C374.770477,135.692154 374.998932,135.392700 375.423096,135.211212 
	C376.193176,134.386215 376.539124,133.742706 376.885071,133.099182 
	C379.379089,131.902420 381.873169,130.705673 384.992706,129.208771 
	C383.881500,132.186157 382.939941,134.708954 381.643494,137.622131 
	C380.525421,138.673248 379.762238,139.334000 378.999023,139.994751 
	C375.224915,142.630890 371.541199,145.415863 367.614288,147.800232 
	C366.611938,148.408813 364.839050,147.748291 363.420197,147.670853 
	C364.010651,146.516098 364.444977,145.239182 365.229614,144.236359 
	C366.301544,142.866272 367.640167,141.704803 368.809448,140.087357 
	C368.754456,139.720795 368.694458,139.629395 369.109375,139.726898 
	C372.924835,140.544113 374.050964,138.376236 374.770477,135.692154 
z"
          />
          <path
            fill="#49B882"
            opacity="1.000000"
            stroke="none"
            d="
M126.739136,141.868378 
	C126.037376,143.738205 125.025917,145.469498 123.717621,147.361221 
	C125.697784,140.720627 119.545120,138.811966 116.105019,135.806763 
	C108.307930,128.995361 108.023865,129.168945 114.826622,121.578369 
	C117.773613,118.290108 120.103516,113.546532 125.902725,115.166183 
	C126.864365,115.434753 127.646729,116.345268 128.424561,117.368889 
	C124.163643,116.282692 120.903831,117.610123 118.230972,120.959297 
	C116.176414,123.533722 114.035240,126.039024 111.557083,129.027954 
	C116.687172,133.409363 121.558304,137.569626 126.739136,141.868378 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M255.769104,400.100433 
	C255.847763,400.842224 255.926407,401.584045 256.082581,403.044067 
	C256.373230,405.189880 256.586365,406.617493 256.799530,408.045105 
	C255.869156,409.410095 254.411270,410.663300 254.094330,412.158325 
	C252.094101,421.593750 242.724609,425.142609 235.582626,418.922455 
	C234.930130,418.354156 235.117111,416.821991 235.064880,415.281097 
	C235.215485,414.824768 235.478195,414.608093 235.701294,414.873932 
	C238.561905,419.304260 242.183167,419.967865 246.540451,418.174561 
	C254.685303,414.822510 255.258331,405.809326 247.825775,399.221558 
	C247.928131,399.098755 248.136948,398.856598 248.136948,398.856598 
	C250.135086,398.900909 252.133224,398.945221 254.681976,399.190857 
	C255.308395,399.706299 255.487228,399.942383 255.769104,400.100433 
z"
          />
          <path
            fill="#C8FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M348.624908,358.156189 
	C342.489319,356.341858 340.132660,351.916534 340.100861,345.460602 
	C340.070282,345.057526 340.032013,345.034515 340.281372,344.960815 
	C340.651306,344.581604 340.771881,344.276154 340.892456,343.970673 
	C341.579376,343.195923 342.266296,342.421173 343.095490,341.369598 
	C343.237762,341.092773 343.637604,341.107025 343.910217,341.473999 
	C345.236023,342.286560 346.289276,342.732147 347.095398,343.429565 
	C343.628387,346.222839 343.331665,349.055511 346.261871,351.948151 
	C349.855347,355.495514 352.815216,355.422272 357.065125,351.971558 
	C357.954865,352.704346 358.492188,353.381653 359.029510,354.058990 
	C357.877502,355.303680 356.725464,356.548340 354.809906,357.885742 
	C352.239227,358.037720 350.432068,358.096954 348.624908,358.156189 
z"
          />
          <path
            fill="#C6F9E4"
            opacity="1.000000"
            stroke="none"
            d="
M122.702072,322.316498 
	C121.815331,323.305420 121.048424,324.967194 120.041107,325.128601 
	C115.005219,325.935516 109.906281,326.348999 104.405487,326.984741 
	C100.663307,323.102539 100.681679,323.052765 107.575226,318.901703 
	C108.458221,318.508026 108.718628,318.235596 108.979034,317.963135 
	C108.979027,317.963135 108.990799,318.006439 109.248207,317.909119 
	C110.017570,317.559570 110.529518,317.307343 111.075760,317.385223 
	C111.794701,318.168854 112.479355,318.622406 112.983208,319.346558 
	C111.751152,320.492920 110.699905,321.368683 109.633499,322.257080 
	C114.202812,322.257080 118.452568,322.257080 122.702316,322.257080 
	C122.702316,322.257080 122.711052,322.297546 122.702072,322.316498 
z"
          />
          <path
            fill="#4DB783"
            opacity="1.000000"
            stroke="none"
            d="
M349.878418,115.217239 
	C348.009430,119.634476 348.214325,123.760132 350.828186,128.011368 
	C351.526337,129.146881 350.831665,131.138779 350.776428,132.737518 
	C349.216553,131.872467 347.517700,131.177383 346.158783,130.066483 
	C345.533661,129.555389 345.800476,128.069305 345.261780,127.309807 
	C344.407654,126.105537 343.216858,125.140060 342.168457,124.073570 
	C341.365204,125.414948 340.359161,126.682892 339.836578,128.125931 
	C339.534943,128.958908 340.013824,130.074509 339.852539,131.531647 
	C339.354614,132.015381 339.145569,132.030396 338.936523,132.045410 
	C338.359161,130.126205 337.180786,128.161987 337.320526,126.296494 
	C337.693909,121.311790 341.977417,122.186150 344.127686,121.961739 
	C346.307617,119.198074 347.902618,117.175980 349.878418,115.217239 
z"
          />
          <path
            fill="#49B882"
            opacity="1.000000"
            stroke="none"
            d="
M107.962593,144.726349 
	C102.267326,142.682053 102.267326,142.682053 99.964211,147.780869 
	C106.168915,152.094086 112.426460,156.444031 118.705170,161.079529 
	C115.021370,161.124252 111.316406,160.883423 107.284058,160.414764 
	C109.155754,158.360291 109.830009,156.676758 106.704926,155.036652 
	C104.814461,154.044510 102.882927,153.004791 101.281631,151.624680 
	C99.831917,150.375214 97.585724,148.355026 97.857315,147.172089 
	C98.353302,145.011795 100.107315,142.248108 101.988960,141.583740 
	C103.463799,141.063004 105.923111,143.330505 107.962593,144.726349 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M293.998779,267.000000 
	C295.072571,267.999115 296.146332,268.998199 297.612549,270.343628 
	C298.016296,271.150574 298.027588,271.611176 298.034393,272.302032 
	C298.029907,272.532257 298.014038,272.994232 297.791809,273.105103 
	C297.292450,273.418579 297.100708,273.683105 296.634277,273.974823 
	C294.733093,273.367706 293.191956,272.795319 291.465515,272.202759 
	C291.280212,272.182617 290.966217,271.981750 290.932861,271.618439 
	C289.624939,270.596130 288.350342,269.937134 287.075775,269.278137 
	C286.448486,271.321960 285.821198,273.365784 285.205750,275.567017 
	C285.217590,275.724457 285.037201,275.983612 284.717102,276.151062 
	C283.505035,277.558105 282.613068,278.797668 280.846863,281.252106 
	C280.414246,278.676849 280.407593,277.316528 279.926514,276.152191 
	C279.462555,275.029236 278.508850,274.108673 277.585205,273.022949 
	C277.148834,272.833313 276.950989,272.659241 276.867798,272.001251 
	C276.942841,270.724060 276.956665,269.870087 276.970459,269.016113 
	C278.601562,269.669800 280.232697,270.323486 282.090485,271.068024 
	C282.820068,269.359955 283.436188,267.917542 284.017242,266.557159 
	C286.901703,266.714386 289.521790,266.857178 292.820618,267.000000 
	C293.499390,267.000000 293.998779,267.000000 293.998779,267.000000 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M188.974869,394.900269 
	C188.447159,396.586182 187.886810,398.262726 187.400589,399.960510 
	C186.873337,401.801727 186.009216,403.663513 186.012985,405.514862 
	C186.020370,409.139740 184.086685,411.085266 180.857361,409.652679 
	C178.090820,408.425354 175.649384,406.465179 173.034531,404.412048 
	C173.004913,403.994904 173.184738,403.807373 173.535004,403.870697 
	C177.122528,404.979858 179.717026,408.374969 184.717224,407.083252 
	C182.918274,405.617493 181.951294,404.829620 180.934021,403.687592 
	C180.273514,402.164978 179.663315,400.996552 178.587799,398.937073 
	C181.469482,399.310822 183.314667,399.550110 185.354538,399.814667 
	C185.548080,397.957275 185.724152,396.267426 185.975235,393.857788 
	C184.349869,394.668030 183.516953,395.083252 182.678925,395.458801 
	C182.673798,395.419159 182.630203,395.352142 182.751068,394.917664 
	C182.924942,393.302887 182.977951,392.122620 183.400452,390.944763 
	C184.507477,390.940765 185.245026,390.934326 186.111237,391.216827 
	C187.151550,392.637268 188.063217,393.768768 188.974869,394.900269 
z"
          />
          <path
            fill="#D2FAE7"
            opacity="1.000000"
            stroke="none"
            d="
M287.786011,403.483643 
	C288.095032,402.864990 288.404053,402.246307 289.140076,401.409912 
	C289.719574,400.130859 289.872009,399.069550 289.828796,397.724396 
	C289.049530,395.712585 288.465881,393.984558 287.923065,391.871979 
	C287.983734,390.718597 288.003601,389.949829 288.375427,389.007202 
	C290.192749,391.437805 291.658081,394.042236 293.148560,396.920471 
	C293.395538,397.475769 293.617432,397.757202 293.899689,398.051971 
	C293.960022,398.065338 293.922119,398.182953 293.961304,398.460693 
	C294.330719,399.154114 294.660980,399.569763 294.991241,399.985413 
	C295.782501,402.369873 296.573761,404.754303 297.602570,407.854614 
	C294.976349,407.854614 293.559967,407.854614 291.688171,407.522583 
	C290.083801,405.954926 288.934906,404.719269 287.786011,403.483643 
z"
          />
          <path
            fill="#4DB783"
            opacity="1.000000"
            stroke="none"
            d="
M202.072556,90.915665 
	C200.667999,87.203850 199.263458,83.492027 198.122101,79.393219 
	C198.563492,79.008461 198.741684,79.010689 198.919876,79.012917 
	C199.751480,80.346504 200.583069,81.680084 202.111130,84.130516 
	C203.224594,78.858864 204.704025,74.934326 204.731216,70.999763 
	C204.771408,65.181969 207.739929,64.389870 212.624191,65.565659 
	C212.852066,66.176865 212.804672,66.349792 212.448959,66.561867 
	C211.734741,66.681633 211.328812,66.762238 210.547211,66.821198 
	C209.168076,67.560791 208.164612,68.322029 207.066620,69.472107 
	C205.997879,76.613129 205.023651,83.365295 203.785660,90.168251 
	C203.038788,90.451241 202.555664,90.683449 202.072556,90.915665 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M167.088120,396.742676 
	C168.701797,394.618317 170.696426,392.592041 173.063675,390.173035 
	C173.718552,389.591064 173.886856,389.328674 173.941208,388.993195 
	C173.941208,388.993195 173.999207,389.005615 174.236908,388.910278 
	C174.779816,388.631866 174.962234,388.364868 175.021881,388.013947 
	C175.021881,388.013947 175.000000,387.999207 175.257324,387.930664 
	C175.731094,387.595398 175.947510,387.328705 176.163940,387.062012 
	C176.774673,386.256348 177.385406,385.450653 178.037109,384.334167 
	C179.942352,384.485413 181.806595,384.947418 183.837250,385.979309 
	C184.003693,386.549164 183.982727,387.040131 183.568695,387.038940 
	C181.872360,387.138367 179.678635,386.854523 179.448868,387.399170 
	C177.174667,392.790039 175.225739,398.318115 173.184723,403.807373 
	C173.184738,403.807373 173.004913,403.994904 172.914322,404.090210 
	C172.496002,402.374420 171.922226,400.563049 171.923950,398.752289 
	C171.925156,397.467468 172.703354,396.183411 173.327408,394.325439 
	C170.815292,395.404022 169.142181,396.122406 167.088120,396.742676 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M358.378113,306.960266 
	C356.842010,314.730927 357.903107,316.862976 364.587769,317.923828 
	C364.909210,322.182373 367.480713,323.018860 371.071228,323.092560 
	C374.658813,323.166138 374.736267,323.485779 373.553345,326.906219 
	C367.441925,324.375916 361.669617,321.785492 355.553589,319.135406 
	C355.476593,315.993225 355.601807,312.888092 356.088959,309.840790 
	C356.253021,308.814331 357.336121,307.934784 358.378113,306.960266 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M263.999207,234.996597 
	C264.661987,234.000946 265.327332,233.010025 265.832703,231.582870 
	C265.455872,230.295410 265.238953,229.444168 265.022034,228.592926 
	C264.827911,228.142181 264.633820,227.691422 264.221436,227.113144 
	C265.870605,227.143509 267.738037,227.301422 269.807007,227.224884 
	C270.597809,226.984009 271.187073,226.977570 271.776337,226.971115 
	C269.794617,232.148621 272.566132,235.077850 276.849609,237.672882 
	C275.353760,240.906235 273.137695,240.964859 270.279327,238.708862 
	C270.044952,233.248856 266.256287,235.583435 264.010834,235.006104 
	C264.010834,235.006104 264.001801,235.001328 263.999207,234.996597 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M334.746033,353.839233 
	C338.744568,356.788910 342.529541,359.827209 346.643433,362.951233 
	C346.972382,363.036896 346.983490,363.006165 347.090942,363.304443 
	C349.231506,365.110809 350.259369,366.766418 347.977081,368.907898 
	C347.598358,368.894104 347.219666,368.880280 346.557617,368.841156 
	C341.839722,364.761902 337.405121,360.707977 332.863342,356.322693 
	C332.756165,355.991394 333.000916,355.609253 333.302551,355.288147 
	C333.766296,354.666016 333.928375,354.364960 334.090454,354.063904 
	C334.090454,354.063904 334.532471,353.927856 334.746033,353.839233 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M110.722931,345.197449 
	C112.113312,345.381378 113.249023,345.792145 114.771057,346.342651 
	C114.967552,342.440704 107.264961,337.935242 115.717018,335.866180 
	C117.590889,338.029175 119.209129,339.897125 121.158112,341.772919 
	C121.630791,342.389984 114.742531,348.677551 113.486404,348.506866 
	C112.298157,348.345398 111.245438,347.115173 110.175789,346.299042 
	C110.096802,346.238800 110.362694,345.726501 110.722931,345.197449 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M140.715332,113.146904 
	C138.441299,110.764679 136.167282,108.382454 133.478806,105.566055 
	C132.087906,106.638824 130.742172,107.676758 129.026428,109.000069 
	C131.561783,112.257767 133.864487,115.216537 136.212997,118.522568 
	C131.704697,117.230576 127.654701,112.431740 128.077042,108.605812 
	C128.247574,107.061104 129.216248,104.737366 130.345245,104.367867 
	C132.059341,103.806892 134.792160,103.961510 136.084015,105.030533 
	C138.426987,106.969353 140.027344,109.805573 141.965607,112.639252 
	C141.993500,113.011307 141.926285,113.075272 141.622437,113.074295 
	C141.117493,113.097839 140.916412,113.122368 140.715332,113.146904 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M173.928223,268.366089 
	C179.845947,267.817688 185.690079,267.636627 191.766449,267.977997 
	C191.997528,268.668640 191.996338,268.836823 191.775513,269.115875 
	C191.282928,269.431274 191.097229,269.696777 190.998764,270.023315 
	C188.680267,270.032074 186.351746,269.909851 184.046112,270.086517 
	C181.748596,270.262634 179.474030,270.738525 176.857620,271.538635 
	C176.525833,271.994324 176.062424,272.089722 175.635513,272.064514 
	C172.416504,271.738831 169.624405,271.438324 166.620850,271.071411 
	C166.409393,271.004974 165.999100,270.837097 165.999100,270.837097 
	C165.999222,270.429108 165.999344,270.021149 165.999115,269.307190 
	C168.617401,268.911957 171.236008,268.822662 173.928223,268.366089 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M200.195648,97.167389 
	C200.539459,96.441368 201.124908,95.997826 202.277130,95.346039 
	C203.284317,94.965912 203.724731,94.794014 204.523071,94.638733 
	C206.521729,93.594276 209.447433,92.662987 209.570099,91.448578 
	C209.993500,87.256699 213.058472,86.583252 215.771194,86.641350 
	C217.675323,86.682129 219.535309,88.783951 221.328796,90.170746 
	C221.242584,90.376083 221.189240,90.818291 221.189240,90.818291 
	C221.189240,90.818291 220.972809,91.036728 220.865875,91.149910 
	C216.991974,89.419067 214.357162,89.165245 211.209412,93.434433 
	C209.305511,96.016632 204.138306,96.192711 200.195648,97.167389 
z"
          />
          <path
            fill="#0DB867"
            opacity="1.000000"
            stroke="none"
            d="
M362.141418,127.548927 
	C363.179657,127.425667 364.217926,127.302406 365.851837,127.358589 
	C366.934998,126.034218 367.422485,124.530403 367.909973,123.026588 
	C369.920502,124.506516 371.931000,125.986443 373.571167,127.847130 
	C371.615601,129.314713 370.030426,130.401520 368.445221,131.488342 
	C368.445221,131.488327 368.214600,131.753372 367.705719,131.818359 
	C365.783905,132.904617 364.370972,133.925888 362.958038,134.947144 
	C362.958038,134.947144 363.001221,134.998169 362.581909,134.945190 
	C357.444489,132.458023 360.380981,130.001785 362.141418,127.548927 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M258.114166,152.816284 
	C259.944702,147.202118 259.511108,142.146027 255.334152,137.535751 
	C254.513885,136.630356 254.515045,134.967575 254.172852,133.644913 
	C253.425415,130.755890 252.700806,127.860970 251.827698,124.655029 
	C256.890717,124.053391 255.621567,128.650421 256.828613,131.292725 
	C257.998871,133.854416 259.163177,136.513153 259.688995,139.252350 
	C260.441895,143.174286 260.709839,147.203156 260.911682,151.200165 
	C260.937958,151.720642 259.343414,152.322998 258.114166,152.816284 
z"
          />
          <path
            fill="#C9F9E5"
            opacity="1.000000"
            stroke="none"
            d="
M256.886841,408.438782 
	C256.586365,406.617493 256.373230,405.189880 256.195374,403.400513 
	C258.430786,404.018494 260.630890,404.998230 262.908020,406.294098 
	C262.622894,408.096222 262.002716,409.575867 261.965790,411.069916 
	C261.922577,412.821533 262.386719,414.585663 262.630768,416.344330 
	C262.256836,416.732452 261.882904,417.120544 261.508972,417.508636 
	C260.372375,416.532135 258.789215,415.765686 258.207275,414.528290 
	C257.401611,412.815277 257.349152,410.748016 256.886841,408.438782 
z"
          />
          <path
            fill="#B7F2D9"
            opacity="1.000000"
            stroke="none"
            d="
M111.041466,317.055145 
	C110.529518,317.307343 110.017570,317.559570 109.231331,317.893982 
	C107.502144,314.038116 104.409683,316.530334 102.104164,316.375854 
	C97.986427,316.099884 97.424873,314.353424 99.656105,311.452698 
	C101.220749,317.051239 104.387688,314.743439 108.186394,314.407745 
	C106.493195,313.106201 105.752167,312.536591 105.276619,311.782227 
	C106.630981,311.053467 107.719872,310.509399 108.808762,309.965332 
	C110.900764,310.558319 113.006111,311.664062 115.081284,311.610046 
	C117.491570,311.547333 119.433983,311.277252 119.732788,314.800964 
	C119.645699,315.276642 119.640022,315.571350 119.640022,315.571350 
	C119.640022,315.571350 119.640358,315.647064 119.341293,315.706604 
	C118.691505,315.834595 118.340775,315.903046 117.985809,315.581543 
	C116.222397,310.566345 113.335678,314.119202 111.381271,314.032166 
	C111.243393,315.258759 111.142433,316.156952 111.041466,317.055145 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M109.156250,309.877441 
	C107.719872,310.509399 106.630981,311.053467 105.099442,311.520020 
	C103.726112,310.930176 102.795433,310.417816 101.864761,309.905457 
	C106.225822,307.029388 110.586891,304.153320 115.078972,301.190857 
	C116.589317,305.506226 116.589317,305.506226 109.156250,309.877441 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M274.371338,394.972229 
	C276.890167,400.343964 278.992920,405.736237 281.151276,411.491943 
	C279.050690,408.636871 276.894531,405.418365 274.186127,401.375519 
	C274.831329,403.933014 275.611908,405.874939 275.744904,407.860260 
	C275.894318,410.090881 275.459045,412.360657 274.923004,414.705505 
	C273.587128,408.570923 272.606354,402.344177 271.548584,395.715820 
	C272.299469,395.207031 273.127350,395.099884 274.371338,394.972229 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M248.836823,122.838821 
	C241.012695,123.341484 238.567719,126.195518 239.425018,133.830994 
	C239.568298,135.107147 238.375534,136.533325 237.475708,138.026001 
	C236.625259,135.781433 239.449081,132.687195 235.420456,130.876617 
	C234.899155,130.642334 235.125717,127.297012 235.909210,125.899055 
	C237.696777,122.709564 245.049744,121.006081 248.836823,122.838821 
z"
          />
          <path
            fill="#03BD67"
            opacity="1.000000"
            stroke="none"
            d="
M252.022736,352.002380 
	C247.980347,352.001740 243.893753,351.635681 239.909683,352.117401 
	C236.783340,352.495361 233.783722,353.921661 230.367523,354.945465 
	C229.809906,354.741730 229.612564,354.474731 229.189087,353.722229 
	C228.887131,352.743561 228.811340,352.250458 228.735535,351.757324 
	C228.735550,351.757324 228.777283,351.817230 229.188293,351.858765 
	C231.353058,350.874878 233.106812,349.849457 234.860565,348.824036 
	C234.860565,348.824066 234.902420,348.834198 235.347107,348.903564 
	C240.543518,348.973419 245.295242,348.973877 250.046982,348.974335 
	C250.595459,349.089233 251.143936,349.204132 251.868195,349.886505 
	C252.036880,350.970123 252.029816,351.486237 252.022736,352.002380 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M244.033936,271.125854 
	C245.781143,266.842285 249.345200,265.900757 256.610901,267.952942 
	C256.999176,269.066681 256.999573,270.133331 256.999390,271.600006 
	C256.226654,272.004883 255.454544,272.009796 253.929108,272.012207 
	C252.456085,272.142670 251.736389,272.275604 250.634201,272.255371 
	C248.179108,271.776794 246.106522,271.451324 244.033936,271.125854 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M267.285370,349.966431 
	C266.615662,349.235443 266.306793,348.470001 265.816254,347.446289 
	C266.726227,346.040924 267.817871,344.893829 268.945984,343.385864 
	C272.743866,345.871643 274.404083,342.410187 276.052338,340.322144 
	C278.857452,336.768555 274.479004,335.785370 273.070618,333.370178 
	C274.866333,333.951385 278.543488,335.270660 278.445068,335.678253 
	C277.635712,339.030182 276.650635,342.597229 274.657349,345.322784 
	C273.110901,347.437378 270.039642,348.436890 267.285370,349.966431 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M151.704041,385.023041 
	C152.168442,385.180389 152.239609,385.350647 152.195007,386.091492 
	C152.022064,387.096008 151.964935,387.529999 151.907806,387.963989 
	C151.907806,387.963989 151.986801,387.989807 151.731323,388.120300 
	C151.633621,388.873169 151.791397,389.495514 151.949158,390.117889 
	C152.406677,390.521881 152.864197,390.925903 153.838043,391.589905 
	C155.204758,391.214813 156.055130,390.579651 156.905487,389.944489 
	C159.002029,388.307129 161.098587,386.669769 164.319672,384.154175 
	C163.140030,387.611847 162.422302,389.715546 161.444794,392.069824 
	C159.682007,392.591553 158.056396,392.586914 156.700928,393.189728 
	C153.623489,394.558350 151.402435,393.452942 150.063629,390.851807 
	C149.042435,388.867706 147.152832,386.146210 151.704041,385.023041 
z"
          />
          <path
            fill="#35B477"
            opacity="1.000000"
            stroke="none"
            d="
M338.965271,132.421341 
	C339.145569,132.030396 339.354614,132.015381 339.877838,131.978058 
	C342.939667,136.213943 346.038635,139.932709 352.571716,139.806732 
	C353.783173,140.572922 354.244629,141.062912 354.706085,141.552887 
	C354.266724,143.139923 353.827332,144.726944 353.289398,146.664612 
	C351.906921,144.026901 350.270905,142.181854 346.530914,141.356110 
	C342.732025,140.517365 339.278534,137.610138 338.965271,132.421341 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M229.602875,147.841888 
	C228.774033,153.454376 223.897659,154.782730 219.502640,157.105743 
	C219.148026,157.164917 218.989761,156.992355 219.078033,156.614746 
	C220.866974,154.913345 222.702438,153.724045 224.212723,152.210342 
	C224.995331,151.425964 225.202057,150.067032 225.668945,148.967667 
	C224.505920,148.954071 223.179047,148.574493 222.215225,149.005936 
	C220.420303,149.809418 218.836716,151.085022 217.094894,152.097351 
	C217.024612,152.030579 216.880005,151.901459 216.880005,151.901459 
	C218.315155,146.969299 221.486481,145.884460 229.602875,147.841888 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M298.038879,272.071777 
	C298.027588,271.611176 298.016296,271.150574 298.001892,270.344360 
	C297.998779,269.998779 297.999847,269.500000 298.297424,269.229004 
	C299.063324,268.638672 299.531677,268.319336 300.000000,268.000000 
	C304.542664,265.111450 307.532928,267.235657 310.004456,271.433868 
	C310.022430,271.774963 309.925995,271.986633 309.588562,272.047363 
	C308.836121,272.126923 308.421112,272.145752 307.607788,272.087067 
	C306.131287,272.048126 305.053131,272.086700 303.587097,272.043579 
	C302.140778,271.988281 301.082275,272.014679 299.692749,272.023621 
	C298.920746,272.028046 298.479828,272.049927 298.038879,272.071777 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M276.694092,70.160126 
	C271.353027,65.500626 264.575104,65.039139 257.522705,64.184769 
	C257.362610,63.580818 257.450653,62.670906 257.855988,62.495876 
	C262.389313,60.538342 274.613220,65.292740 276.694092,70.160126 
z"
          />
          <path
            fill="#0DB867"
            opacity="1.000000"
            stroke="none"
            d="
M360.499390,114.652161 
	C358.305603,114.225212 356.111847,113.798271 353.540955,113.301170 
	C352.525360,109.020638 354.318787,107.936119 357.804535,109.986923 
	C360.868530,111.789574 363.796204,113.892685 366.489410,116.206169 
	C367.128143,116.754845 366.588226,118.675644 366.244995,120.042740 
	C365.899567,120.120186 365.815369,120.308746 365.811523,119.957840 
	C365.210754,119.062904 364.613861,118.518883 364.016937,117.974854 
	C363.664734,117.586128 363.312531,117.197395 362.853882,116.225777 
	C361.998108,115.312645 361.248749,114.982407 360.499390,114.652161 
z"
          />
          <path
            fill="#35B477"
            opacity="1.000000"
            stroke="none"
            d="
M366.927246,338.139282 
	C363.760193,336.587769 360.593140,335.036255 357.426086,333.484741 
	C357.473877,333.106781 357.521667,332.728821 357.569458,332.350861 
	C362.032501,331.825348 366.495575,331.299805 371.390686,330.739380 
	C369.839508,331.886292 367.856293,333.068115 365.554810,334.439667 
	C365.689636,334.690247 366.197205,335.633423 366.831177,337.124329 
	C366.957642,337.672089 366.927246,338.139282 366.927246,338.139282 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M293.123444,396.646637 
	C291.658081,394.042236 290.192749,391.437805 288.130493,388.963379 
	C287.533569,389.093353 287.036407,389.083557 287.036407,389.083557 
	C289.057678,388.389160 291.078979,387.694763 293.522339,387.010101 
	C295.328461,389.771210 296.712463,392.522583 298.024841,395.636841 
	C297.115570,395.313477 296.277893,394.627289 295.081238,393.647003 
	C295.007996,395.152283 294.949005,396.364441 294.626648,397.920837 
	C294.363251,398.265015 293.922119,398.182953 293.922119,398.182953 
	C293.922119,398.182953 293.960022,398.065338 293.864014,397.782715 
	C293.553131,397.215607 293.338287,396.931122 293.123444,396.646637 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M267.255859,397.017029 
	C268.141907,400.042572 268.701996,403.190491 269.262085,406.338440 
	C268.867554,406.561401 268.473022,406.784393 268.078491,407.007355 
	C265.905609,404.452606 263.732727,401.897858 261.168488,398.924713 
	C260.496155,398.055328 260.215210,397.604309 259.934265,397.153290 
	C260.859894,394.064453 262.045868,395.105255 262.847076,397.112823 
	C264.295593,400.742157 265.559082,399.321014 267.255859,397.017029 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M228.040314,63.953926 
	C227.960587,69.674889 227.880875,75.395859 227.364075,81.554825 
	C225.967758,81.993011 225.008499,81.993202 223.830109,81.756012 
	C223.130600,80.572319 222.650223,79.625999 222.374924,78.511635 
	C222.716660,78.231438 222.853287,78.119286 222.989914,78.007133 
	C224.010864,76.941002 225.779678,75.956947 225.907455,74.792793 
	C226.241959,71.744858 225.615967,68.596954 225.883835,65.533577 
	C225.990448,64.314285 227.442917,63.212658 228.666046,62.063179 
	C229.049393,62.068893 229.064560,62.090073 228.936066,62.324547 
	C228.551804,63.023991 228.296051,63.488960 228.040314,63.953926 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M302.076782,232.781525 
	C304.329773,225.679382 303.329681,219.300690 298.081482,213.356781 
	C301.850464,213.005386 303.539032,215.610855 304.021942,218.846054 
	C304.608459,222.775436 304.711670,226.794113 304.726288,230.775253 
	C304.728821,231.460953 303.249359,232.152100 302.076782,232.781525 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M167.430939,390.801117 
	C166.959503,390.364349 166.008072,389.776184 166.090729,389.514191 
	C166.932404,386.846008 168.125687,384.278046 168.819611,381.578949 
	C169.117371,380.420868 168.475388,379.021149 168.108612,377.449921 
	C170.857269,375.197571 170.511124,377.792023 170.966110,379.295807 
	C171.439102,380.859070 171.947220,382.411743 172.828888,384.103027 
	C171.962967,385.710510 170.708145,387.184052 168.964081,389.019287 
	C168.126877,389.854370 167.778915,390.327728 167.430939,390.801117 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M229.229630,404.685791 
	C230.181534,404.007446 231.133423,403.329132 232.333557,402.324219 
	C232.581802,401.997650 233.024582,401.992493 233.024582,401.992493 
	C233.468460,401.999908 233.912338,402.007355 234.872849,402.169678 
	C235.389481,402.324554 235.756317,402.628845 235.611511,402.946320 
	C235.470551,407.045227 235.474380,410.826660 235.478195,414.608093 
	C235.478195,414.608093 235.215485,414.824768 235.084167,414.934021 
	C234.222000,415.030518 233.491165,415.017700 232.357529,414.730530 
	C231.453796,413.934418 230.952866,413.412628 230.451935,412.890869 
	C230.451920,412.890869 230.209778,412.917206 230.119690,412.524902 
	C230.018860,411.747986 230.008087,411.363434 230.209778,410.703674 
	C233.991516,407.532959 231.123703,406.423370 229.019547,405.012238 
	C229.089294,404.903229 229.229630,404.685791 229.229630,404.685791 
z"
          />
          <path
            fill="#49B882"
            opacity="1.000000"
            stroke="none"
            d="
M122.746262,148.061981 
	C122.325241,149.630341 121.521690,151.214493 120.445702,153.335709 
	C116.315460,150.720154 112.575768,148.351898 108.678864,145.679718 
	C111.456177,146.243027 114.358528,147.254456 117.338165,147.919632 
	C118.945053,148.278336 120.684242,148.044342 122.746262,148.061981 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M206.922058,396.758453 
	C203.705322,395.559265 200.608704,393.747467 197.296661,392.514191 
	C196.503235,392.218750 194.992981,393.848297 193.566376,394.833893 
	C193.095276,395.045563 192.870178,395.015839 192.318390,394.594177 
	C192.321213,393.146027 192.650742,392.089844 192.980270,391.033691 
	C199.234299,388.980438 205.826721,391.490631 206.922058,396.758453 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M335.139984,369.843445 
	C337.450836,371.009399 339.986420,371.931183 341.834686,373.609772 
	C342.758606,374.448914 343.150299,377.572083 342.515411,378.080841 
	C341.137512,379.185028 338.945007,379.272766 337.049622,379.375427 
	C337.013672,378.974762 337.145477,378.819946 337.489349,378.805908 
	C340.272797,377.835663 340.865570,376.468567 338.890686,374.410980 
	C337.535583,372.999084 336.267273,371.503906 334.960144,370.045959 
	C334.960144,370.045959 335.080902,369.911713 335.139984,369.843445 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M287.480347,403.324829 
	C288.934906,404.719269 290.083801,405.954926 291.282837,407.514984 
	C289.822021,407.307312 288.311096,406.775177 286.569641,406.161896 
	C286.178497,407.786407 285.847839,409.159729 285.237518,410.760071 
	C283.885223,407.573120 282.812592,404.159180 281.314453,399.391052 
	C283.884430,401.046539 285.529541,402.106262 287.480347,403.324829 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M230.347748,413.287354 
	C230.952866,413.412628 231.453796,413.934418 231.991821,414.751465 
	C229.943542,421.485352 224.581116,422.452393 218.167908,417.171448 
	C220.570923,417.244080 223.128876,418.415497 225.310272,417.922089 
	C227.178665,417.499512 228.615738,415.170013 230.347748,413.287354 
z"
          />
          <path
            fill="#03BE61"
            opacity="1.000000"
            stroke="none"
            d="
M210.016953,155.025436 
	C208.042709,149.241516 209.106064,147.452652 215.543945,146.300903 
	C215.005722,148.362930 214.503372,150.287521 213.708649,152.729340 
	C212.283173,153.839523 211.150055,154.432480 210.016953,155.025436 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M113.932182,331.100708 
	C112.141090,332.496216 109.921738,333.834839 107.195358,335.479279 
	C108.087288,337.663177 109.029404,339.969910 109.994141,342.645020 
	C105.317284,342.206421 104.721909,337.665924 105.623489,335.159912 
	C106.361565,333.108368 110.739555,332.366364 113.932182,331.100708 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M287.882263,392.256561 
	C288.465881,393.984558 289.049530,395.712585 289.802795,398.054291 
	C289.648468,399.187042 289.324493,399.706085 289.000549,400.225128 
	C285.977112,397.772614 282.953674,395.320129 279.740112,392.582336 
	C280.896667,392.568207 282.265747,393.121490 283.582550,393.016846 
	C284.546997,392.940186 285.442780,391.999542 286.758850,391.422668 
	C287.393097,391.686401 287.637665,391.971497 287.882263,392.256561 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M367.161926,317.021851 
	C367.802277,315.317352 368.684601,313.695648 369.812897,312.268433 
	C370.473816,311.432465 371.526886,310.906525 372.403503,310.241089 
	C373.052246,311.249542 373.700989,312.257996 374.245361,313.876953 
	C374.130524,314.656769 374.120026,314.826019 374.109528,314.995270 
	C373.551361,315.578827 372.993225,316.162415 372.004639,317.018433 
	C371.184235,317.538239 370.794250,317.785645 370.404266,318.033051 
	C369.438599,317.750793 368.472931,317.468567 367.161926,317.021851 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M117.990036,315.971497 
	C118.340775,315.903046 118.691505,315.834595 119.304413,315.715057 
	C118.719467,317.138489 117.872353,318.613007 116.893417,320.316986 
	C118.516212,320.648987 120.664078,321.088379 122.757126,321.892426 
	C118.452568,322.257080 114.202812,322.257080 109.633499,322.257080 
	C110.699905,321.368683 111.751152,320.492920 113.286560,319.243591 
	C115.177155,317.903870 116.583595,316.937653 117.990036,315.971497 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M230.852631,400.089569 
	C227.446014,397.681671 223.839615,397.217651 219.272797,399.010315 
	C218.074539,399.040833 217.608444,399.035767 217.142365,399.030701 
	C220.740509,394.379700 228.486938,394.505280 231.670654,399.648560 
	C231.235992,400.047852 231.044312,400.068726 230.852631,400.089569 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M367.960754,307.035858 
	C366.678650,309.568237 365.238525,311.871857 363.725800,314.291595 
	C360.729706,311.316315 360.729706,311.316315 363.910522,305.392273 
	C365.232544,305.629150 366.517639,306.218140 367.960754,307.035858 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M294.251892,266.722412 
	C293.998779,267.000000 293.499390,267.000000 293.249695,267.000000 
	C293.000000,265.221558 293.000000,263.443115 293.000000,261.436279 
	C294.499146,261.246094 295.526550,260.840271 296.379639,261.073090 
	C297.613403,261.409760 298.720978,262.208984 299.882385,262.810913 
	C298.891754,263.864624 297.996826,265.040833 296.870605,265.921051 
	C296.296417,266.369843 295.306854,266.287201 294.251892,266.722412 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M171.033569,101.972321 
	C171.601349,102.465218 172.169128,102.958122 172.888443,104.001411 
	C173.374802,105.071175 173.709610,105.590561 174.044434,106.109940 
	C172.887268,107.063866 171.730103,108.017799 170.221008,109.000336 
	C169.474884,108.666977 169.080704,108.305008 168.658142,107.382492 
	C168.350113,106.596802 168.070465,106.371643 167.790802,106.146469 
	C167.377258,105.428482 166.963715,104.710495 166.727417,103.395096 
	C168.280975,102.522568 169.657272,102.247444 171.033569,101.972321 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M192.669128,390.968750 
	C192.650742,392.089844 192.321213,393.146027 191.983047,394.534576 
	C191.225098,394.893860 190.475800,394.920746 189.350693,394.923950 
	C188.063217,393.768768 187.151550,392.637268 186.222534,390.929443 
	C185.464371,389.248810 184.723557,388.144470 183.982727,387.040131 
	C183.982727,387.040131 184.003693,386.549164 184.015671,386.304443 
	C184.811661,386.340210 185.595688,386.620728 186.848328,387.192627 
	C188.523941,388.000366 189.730927,388.516693 190.937912,389.033020 
	C191.411270,389.656616 191.884628,390.280182 192.669128,390.968750 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M276.574615,269.014709 
	C276.956665,269.870087 276.942841,270.724060 276.428894,271.934631 
	C272.669830,272.302216 269.410919,272.313171 266.033020,272.061584 
	C265.632751,271.542999 265.351440,271.286926 265.150604,270.763611 
	C265.492218,270.004425 265.753387,269.512482 266.014526,269.020508 
	C266.014526,269.020508 266.000732,269.000000 266.444946,269.009521 
	C268.926514,269.011108 270.963867,269.003174 273.001221,268.995239 
	C274.060394,269.001282 275.119598,269.007294 276.574615,269.014709 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M377.119446,317.770630 
	C376.810364,317.358459 376.879181,316.963562 377.203766,316.011108 
	C377.593506,314.308502 377.727478,313.163452 377.861450,312.018372 
	C378.477905,306.530548 374.031494,306.976349 370.406708,306.019836 
	C372.759430,305.624481 375.507965,305.204651 378.753204,304.708954 
	C378.366211,309.733032 382.134308,314.058868 377.119446,317.770630 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M358.994385,328.109985 
	C358.390625,328.209930 357.786865,328.309875 356.531250,328.275391 
	C355.258728,328.397369 354.638153,328.653809 354.017548,328.910248 
	C353.261566,328.989441 352.505615,329.068665 351.371704,329.096619 
	C352.336609,327.882080 353.679413,326.718811 354.436707,326.062775 
	C354.098755,324.241516 353.805756,322.662476 353.834900,321.075043 
	C356.080658,322.406067 358.004272,323.745483 359.978149,325.606110 
	C359.683777,326.788239 359.339081,327.449127 358.994385,328.109985 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M186.212021,93.942101 
	C183.503845,91.060181 185.304581,89.467674 188.007965,88.631958 
	C190.444717,87.878670 193.577896,84.808899 195.109406,89.870323 
	C195.442963,90.972679 195.817703,92.062576 195.899841,93.560410 
	C195.439163,93.962326 195.252136,93.962051 195.065125,93.961777 
	C194.756927,93.501106 194.448746,93.040428 194.055405,91.932861 
	C190.885529,87.848160 188.572815,88.639954 186.212021,93.942101 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M157.790649,381.987793 
	C157.907074,381.652191 158.023514,381.316589 158.358109,380.530914 
	C158.670898,379.727112 158.765518,379.373383 158.860138,379.019653 
	C159.282486,378.052460 159.704819,377.085266 160.365692,375.683472 
	C160.604233,375.248901 161.009308,375.019714 161.009308,375.019714 
	C162.120056,376.028351 163.230789,377.037018 164.741882,378.092163 
	C163.159637,380.094727 161.257370,382.145996 159.134827,383.936127 
	C158.638474,384.354767 157.395477,383.888184 156.589554,383.489929 
	C157.052292,382.763275 157.421478,382.375549 157.790649,381.987793 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M228.401459,351.834473 
	C228.811340,352.250458 228.887131,352.743561 228.963120,353.610321 
	C226.203644,355.339844 223.968338,359.185730 220.263474,356.109344 
	C219.258240,355.274628 218.854614,353.715424 218.300323,352.082916 
	C221.560425,355.011871 224.754013,355.924072 228.401459,351.834473 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M317.077515,266.175232 
	C314.024933,266.161560 311.247040,265.888763 308.044098,265.574188 
	C311.792389,261.694458 316.164276,262.123199 317.077515,266.175232 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M276.892242,151.996216 
	C274.022461,151.028976 271.194977,149.663757 268.063934,148.385986 
	C267.366577,147.600632 266.972778,146.727844 266.566193,145.826706 
	C270.240692,144.943604 275.380707,147.870590 276.892242,151.996216 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M149.383240,274.985382 
	C150.232254,278.835602 150.851898,283.009521 151.471558,287.183472 
	C150.698990,287.246857 149.926437,287.310242 149.153870,287.373627 
	C149.153870,283.352112 149.153870,279.330627 149.383240,274.985382 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M186.243668,94.241760 
	C188.572815,88.639954 190.885529,87.848160 193.997925,91.652832 
	C189.802689,90.304070 188.565033,92.193008 189.018707,96.579269 
	C188.998016,97.009377 188.931259,97.085526 188.931259,97.085526 
	C188.717316,97.147934 188.520493,97.245071 187.941040,97.401382 
	C187.116974,97.057030 186.692642,96.688225 186.268311,96.319420 
	C186.270645,95.726753 186.272980,95.134087 186.243668,94.241760 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M235.997345,400.999573 
	C238.199524,396.249664 242.245880,395.298126 248.017624,398.528809 
	C248.136948,398.856598 247.928131,399.098755 247.412994,399.153320 
	C243.438766,399.997894 239.979660,400.787903 236.389893,401.433228 
	C236.259232,401.288513 235.997345,400.999573 235.997345,400.999573 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M273.995117,156.389038 
	C277.023865,159.397751 280.051880,162.774277 283.127930,166.489639 
	C281.797668,165.902390 280.365021,165.046173 279.057129,164.029449 
	C277.876923,163.112000 276.833221,162.018906 275.364685,161.001648 
	C275.000000,161.000000 275.001892,161.001205 275.001892,161.001205 
	C274.666016,159.586426 274.330170,158.171646 273.995117,156.389038 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M185.126434,102.278290 
	C185.274918,102.135063 185.423386,101.991829 186.004791,101.737648 
	C186.794846,101.668167 187.151962,101.709633 187.509094,101.751106 
	C187.831223,102.380661 188.153366,103.010216 188.475525,103.639763 
	C185.042206,104.776390 181.608902,105.913025 178.087616,106.740685 
	C178.095322,106.283325 178.190979,106.134933 178.852051,105.920082 
	C179.849182,105.433075 180.280899,105.012520 180.712631,104.591980 
	C180.931519,104.370163 181.183502,104.196312 182.031464,104.051010 
	C183.438400,103.447166 184.282425,102.862732 185.126434,102.278290 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M245.013000,63.242657 
	C244.503754,65.527733 243.994522,67.812805 243.105408,70.519485 
	C242.166092,70.666359 241.606628,70.391609 241.047180,70.116867 
	C241.280533,68.539398 241.721237,66.959938 241.706009,65.384865 
	C241.669174,61.569469 244.998718,59.609291 248.592682,61.655685 
	C247.228119,62.417679 246.120560,62.830166 245.013000,63.242657 
z"
          />
          <path
            fill="#EAF7F0"
            opacity="1.000000"
            stroke="none"
            d="
M101.593506,309.966614 
	C102.795433,310.417816 103.726112,310.930176 104.833969,311.704773 
	C105.752167,312.536591 106.493195,313.106201 108.186394,314.407745 
	C104.387688,314.743439 101.220749,317.051239 100.009262,311.409058 
	C100.443314,310.684906 100.882782,310.356354 101.593506,309.966614 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M278.205750,262.919250 
	C279.638947,261.857239 281.142395,261.174194 282.645874,260.491180 
	C282.995331,261.654724 283.344788,262.818298 283.694214,263.981873 
	C281.888153,263.753967 280.082092,263.526093 278.205750,262.919250 
z"
          />
          <path
            fill="#63BC90"
            opacity="1.000000"
            stroke="none"
            d="
M137.035492,119.855927 
	C139.023682,121.473190 140.913727,123.042953 142.941467,124.939438 
	C143.079147,125.266159 143.180923,125.647224 142.879898,125.922440 
	C142.391708,126.477791 142.204559,126.757942 142.017395,127.038086 
	C142.017395,127.038086 141.591949,127.173958 141.371048,127.149734 
	C139.430267,125.827454 137.710373,124.529396 135.915009,122.940704 
	C135.869781,122.375435 135.900040,122.100792 136.222900,121.306442 
	C136.746933,120.554939 136.833801,120.277763 136.776093,119.955200 
	C136.776093,119.955200 136.937363,119.808418 137.035492,119.855927 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M216.665497,401.063110 
	C215.178543,405.269318 213.959656,409.558563 216.353668,414.452209 
	C211.879700,411.281708 211.817642,405.808075 216.665497,401.063110 
z"
          />
          <path
            fill="#35B477"
            opacity="1.000000"
            stroke="none"
            d="
M354.056030,148.975311 
	C355.319183,151.097672 356.582336,153.220016 357.942566,155.666336 
	C355.251038,159.599274 354.162109,155.964600 353.291138,154.520020 
	C352.475403,153.167084 352.738251,151.163803 353.032623,149.218811 
	C353.711212,148.985703 353.883636,148.980515 354.056030,148.975311 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M327.421692,262.471649 
	C325.387421,263.250366 323.597504,263.727905 321.807587,264.205444 
	C321.511292,263.712494 321.215027,263.219574 320.918732,262.726624 
	C321.867645,261.833130 322.821686,260.215027 323.764191,260.221680 
	C325.069366,260.230927 326.365845,261.462372 327.421692,262.471649 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M272.990479,268.616577 
	C270.963867,269.003174 268.926514,269.011108 266.453674,269.019348 
	C266.734283,267.789124 267.450317,266.558624 268.166382,265.328125 
	C269.770813,266.298065 271.375275,267.267975 272.990479,268.616577 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M232.725830,267.808167 
	C230.639389,272.304138 229.997971,272.267700 226.155182,267.309448 
	C228.151367,267.204468 230.301514,267.410187 232.725830,267.808167 
z"
          />
          <path
            fill="#2DB274"
            opacity="1.000000"
            stroke="none"
            d="
M265.070160,271.030884 
	C265.351440,271.286926 265.632751,271.542999 266.031860,272.506531 
	C266.157867,278.444336 266.166077,283.674683 266.174255,288.905029 
	C265.459625,284.557770 264.744995,280.210510 264.037079,275.439270 
	C264.340240,274.541321 264.636719,274.067322 264.962921,272.969757 
	C265.018524,271.907776 265.044342,271.469330 265.070160,271.030884 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M206.673126,337.066254 
	C208.645905,339.430786 210.260483,341.855408 212.082001,344.550171 
	C206.476959,344.252045 204.221329,341.347015 206.673126,337.066254 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M348.158691,369.160950 
	C350.259369,366.766418 349.231506,365.110809 347.079895,363.313934 
	C348.667664,363.739166 350.373901,364.453217 352.080139,365.167236 
	C350.833527,366.582825 349.586914,367.998413 348.158691,369.160950 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M234.004990,236.381790 
	C237.694092,236.343674 241.389359,236.680252 245.536560,237.026733 
	C243.003326,237.848190 240.051361,238.907501 237.012024,239.314850 
	C236.141678,239.431488 235.018433,237.661453 234.004990,236.381790 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M323.994019,278.642334 
	C322.003296,278.435638 320.021698,277.844269 318.040070,277.252899 
	C318.133057,276.636658 318.226074,276.020386 318.319061,275.404114 
	C320.038208,275.404114 321.757385,275.404114 323.739014,275.676636 
	C324.002045,276.718658 324.002594,277.488129 323.994019,278.642334 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M304.059021,403.359772 
	C306.094543,402.017120 308.176514,401.012482 310.614075,399.978271 
	C310.024841,401.567444 309.355042,403.508392 308.009064,404.656982 
	C307.414032,405.164764 305.448730,404.066803 304.059021,403.359772 
z"
          />
          <path
            fill="#4DB783"
            opacity="1.000000"
            stroke="none"
            d="
M215.026794,65.952957 
	C216.671005,68.055672 218.315216,70.158386 219.786041,72.819458 
	C219.489868,73.496628 219.367065,73.615440 219.004425,73.517334 
	C217.535797,71.520943 216.307007,69.741470 215.102234,67.626656 
	C215.093109,66.845192 215.059952,66.399078 215.026794,65.952957 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M368.783569,131.418335 
	C370.030426,130.401520 371.615601,129.314713 373.548401,128.228607 
	C374.004333,128.491714 374.162415,128.719513 374.644501,129.339249 
	C375.586670,130.865280 376.254669,131.964798 376.922668,133.064331 
	C376.922668,133.064331 376.920166,133.080811 376.902618,133.089996 
	C376.539124,133.742706 376.193176,134.386215 375.556274,135.078094 
	C374.371155,131.991241 373.577179,128.693085 368.783569,131.418335 
z"
          />
          <path
            fill="#4DB783"
            opacity="1.000000"
            stroke="none"
            d="
M240.718689,70.044525 
	C241.606628,70.391609 242.166092,70.666359 243.058746,70.928535 
	C243.554184,72.630592 243.716400,74.345207 243.878616,76.059830 
	C243.557724,76.200569 243.236832,76.341301 242.915939,76.482040 
	C241.631485,74.533035 240.347015,72.584038 239.058441,70.283005 
	C239.499619,69.944710 239.944901,69.958443 240.718689,70.044525 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M184.660339,259.002869 
	C185.834686,259.143585 186.591476,259.282227 187.348267,259.420837 
	C187.345932,259.723816 187.343582,260.026794 187.341232,260.329773 
	C184.472137,260.329773 181.603027,260.329773 178.733932,260.329773 
	C178.682480,260.035065 178.631027,259.740326 178.579590,259.445618 
	C180.467331,259.297333 182.355057,259.149078 184.660339,259.002869 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M268.946167,260.011658 
	C270.488281,260.480621 271.630432,260.952667 272.772583,261.424713 
	C272.607208,261.996582 272.441833,262.568420 272.276428,263.140289 
	C270.292786,262.711365 268.309113,262.282440 266.325470,261.853516 
	C267.065704,261.240601 267.805939,260.627716 268.946167,260.011658 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M209.978653,155.380386 
	C211.150055,154.432480 212.283173,153.839523 213.708191,153.114777 
	C214.419846,152.963852 214.839554,152.944717 215.620087,152.950409 
	C215.980881,152.975220 216.077988,153.082794 215.925751,153.375458 
	C213.592102,155.844559 211.410690,158.020996 209.140045,160.116821 
	C209.050842,160.036209 208.876190,159.870880 208.876190,159.870880 
	C209.230911,158.492371 209.585632,157.113846 209.978653,155.380386 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M264.153442,235.320251 
	C266.256287,235.583435 270.044952,233.248856 269.982208,238.579529 
	C268.083801,237.868774 266.189911,236.751602 264.153442,235.320251 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M267.178650,151.005432 
	C269.562195,152.371155 271.631500,153.889526 273.838562,155.707031 
	C270.504486,156.005569 266.843079,156.283051 267.178650,151.005432 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M215.441742,261.655396 
	C214.147980,260.831879 213.172226,259.858093 212.196487,258.884308 
	C212.938904,258.382294 213.681335,257.880249 214.423752,257.378235 
	C214.869095,258.753845 215.314438,260.129486 215.441742,261.655396 
z"
          />
          <path
            fill="#58BA8C"
            opacity="1.000000"
            stroke="none"
            d="
M147.471710,108.791153 
	C149.989334,110.436661 153.325974,111.892250 151.654266,116.120087 
	C150.018341,113.854103 148.672592,111.502052 147.471710,108.791153 
z"
          />
          <path
            fill="#03BE61"
            opacity="1.000000"
            stroke="none"
            d="
M194.389801,240.995422 
	C194.026901,238.025223 194.875885,236.125778 198.671356,237.852020 
	C199.285065,241.358139 196.932114,241.025299 194.389801,240.995422 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M240.601624,266.999756 
	C241.210739,268.294495 241.419647,269.589478 241.628555,270.884491 
	C241.081940,271.022186 240.535324,271.159912 239.988693,271.297607 
	C239.016296,270.093933 238.043884,268.890259 237.035736,267.343292 
	C238.067139,267.000000 239.134262,267.000000 240.601624,266.999756 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M204.332626,168.188797 
	C204.804291,165.993622 205.275940,163.798447 205.882095,161.305344 
	C206.770340,160.676697 207.524094,160.345993 208.577011,159.943085 
	C208.876190,159.870880 209.050842,160.036209 209.032349,160.438293 
	C207.453461,163.289841 205.893051,165.739319 204.332626,168.188797 
z"
          />
          <path
            fill="#58BA8C"
            opacity="1.000000"
            stroke="none"
            d="
M139.789398,98.192726 
	C140.198334,97.977486 140.395813,97.995644 140.883301,98.080864 
	C142.195389,100.054459 143.217499,101.960991 144.291458,104.186157 
	C140.097870,104.561516 140.252533,101.168770 139.789398,98.192726 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M246.545273,258.268433 
	C247.946777,258.044861 249.183212,258.120178 250.419647,258.195496 
	C250.269623,258.904144 250.119598,259.612823 249.969574,260.321503 
	C248.773132,259.736755 247.576675,259.152039 246.545273,258.268433 
z"
          />
          <path
            fill="#45B581"
            opacity="1.000000"
            stroke="none"
            d="
M194.993713,70.730804 
	C193.312683,71.275749 191.676865,71.441742 189.736786,71.609482 
	C190.478256,70.529625 191.418732,69.284988 192.649719,68.490379 
	C192.929153,68.309990 194.215851,69.690048 194.993713,70.730804 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M336.946899,379.051392 
	C333.882141,379.267700 332.194122,377.896912 332.014221,374.397675 
	C332.074066,373.939178 332.278839,373.767792 332.536072,373.956909 
	C334.244019,375.703979 335.694733,377.261963 337.145477,378.819946 
	C337.145477,378.819946 337.013672,378.974762 336.946899,379.051392 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M367.682007,122.849747 
	C367.422485,124.530403 366.934998,126.034218 366.240814,127.302635 
	C365.988190,125.330933 365.942230,123.594643 365.934937,121.423492 
	C366.467072,121.550064 366.960571,122.111488 367.682007,122.849747 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M132.924210,345.931427 
	C132.025040,347.216156 130.919052,348.194977 129.502808,349.255615 
	C128.985962,346.788208 129.079224,344.523712 132.924210,345.931427 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M229.042816,62.059326 
	C231.153107,58.249798 233.010254,60.466766 234.580139,62.609524 
	C232.539139,62.641262 230.801849,62.365665 229.064560,62.090073 
	C229.064560,62.090073 229.049393,62.068893 229.042816,62.059326 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M265.150604,270.763611 
	C265.044342,271.469330 265.018524,271.907776 264.968445,272.675049 
	C264.077911,272.281342 263.211670,271.558746 262.345398,270.836182 
	C263.326050,270.229034 264.306702,269.621857 265.650940,269.017578 
	C265.753387,269.512482 265.492218,270.004425 265.150604,270.763611 
z"
          />
          <path
            fill="#4DB783"
            opacity="1.000000"
            stroke="none"
            d="
M228.936066,62.324547 
	C230.801849,62.365665 232.539139,62.641262 234.657181,62.955933 
	C235.049561,63.174557 235.061203,63.354099 235.016281,63.797630 
	C232.940765,64.028397 230.921814,63.995174 228.471588,63.957939 
	C228.296051,63.488960 228.551804,63.023991 228.936066,62.324547 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M161.031982,397.411407 
	C162.325653,397.276154 163.623062,397.522095 165.250641,397.705750 
	C165.064438,398.398468 164.548080,399.153503 164.031738,399.908539 
	C163.033066,399.203217 162.034393,398.497925 161.031982,397.411407 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M297.984070,212.669891 
	C294.062317,211.611755 298.064117,209.266373 297.531952,207.191772 
	C297.827637,208.709076 297.916016,210.497528 297.984070,212.669891 
z"
          />
          <path
            fill="#C9F9E5"
            opacity="1.000000"
            stroke="none"
            d="
M259.617126,397.137726 
	C260.215210,397.604309 260.496155,398.055328 260.878235,398.754669 
	C259.481689,399.267426 257.984009,399.531830 256.127716,399.948364 
	C255.487228,399.942383 255.308395,399.706299 255.111420,399.199402 
	C255.203537,398.742676 255.416809,398.478729 256.103882,398.080078 
	C257.061432,397.663605 257.545197,397.381805 258.028961,397.100006 
	C258.452637,397.107391 258.876312,397.114777 259.617126,397.137726 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M370.369629,318.366333 
	C370.794250,317.785645 371.184235,317.538239 371.804138,317.245422 
	C372.582794,317.980347 373.131592,318.760712 373.816284,320.017883 
	C373.952179,320.494690 373.874481,320.938812 373.874481,320.938812 
	C372.694641,320.192413 371.514801,319.446014 370.369629,318.366333 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M138.853073,348.804352 
	C137.725571,348.101257 136.662292,347.012756 135.378235,345.674164 
	C138.093796,344.309479 139.196228,345.497131 138.853073,348.804352 
z"
          />
          <path
            fill="#4DB783"
            opacity="1.000000"
            stroke="none"
            d="
M245.400848,63.396568 
	C246.120560,62.830166 247.228119,62.417679 248.674225,62.000954 
	C249.170502,62.262543 249.377884,62.481274 249.836700,62.757362 
	C250.020569,63.082832 250.002640,63.303856 249.943771,63.855507 
	C248.531464,63.974251 247.160080,63.762367 245.400848,63.396568 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M270.913086,394.725586 
	C270.027435,395.221741 269.100342,395.360962 267.835632,395.574219 
	C267.404755,394.825806 267.311493,394.003387 267.218262,393.180969 
	C268.436005,393.576843 269.653809,393.972748 270.913086,394.725586 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M218.001099,347.076477 
	C218.178207,348.528900 218.179932,349.736847 218.264862,351.305115 
	C217.736633,351.220520 217.125168,350.775604 216.269012,350.153687 
	C216.624786,348.928406 217.225250,347.880188 218.001099,347.076477 
z"
          />
          <path
            fill="#DDF4E8"
            opacity="1.000000"
            stroke="none"
            d="
M187.692047,101.364914 
	C187.151962,101.709633 186.794846,101.668167 186.199097,101.496811 
	C186.013168,99.970490 186.065842,98.574059 186.193420,96.748520 
	C186.692642,96.688225 187.116974,97.057030 187.808624,97.500458 
	C188.008987,98.709625 187.942001,99.844177 187.692047,101.364914 
z"
          />
          <path
            fill="#58BA8C"
            opacity="1.000000"
            stroke="none"
            d="
M150.900024,116.264771 
	C149.917343,117.247749 148.555588,118.159355 146.918823,118.850372 
	C147.936172,117.817650 149.228546,117.005524 150.900024,116.264771 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M366.966919,338.493195 
	C366.927246,338.139282 366.957642,337.672089 366.968811,337.440887 
	C370.119019,337.891266 369.471893,339.282684 367.321411,340.936401 
	C366.984009,340.270538 366.995300,339.558838 366.966919,338.493195 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M306.324707,258.848328 
	C306.298859,258.210602 306.596863,257.648346 306.894836,257.086090 
	C307.396942,257.353485 307.899048,257.620850 308.401154,257.888245 
	C307.816956,258.233429 307.232727,258.578644 306.324707,258.848328 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M281.173767,412.169678 
	C282.133148,411.739716 283.084869,411.682922 284.393005,411.585602 
	C284.402679,414.922089 283.104156,414.880768 281.173767,412.169678 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M302.838013,207.670868 
	C302.207825,207.696396 301.511261,207.507248 301.162994,207.051773 
	C301.019318,206.863876 301.623627,206.103989 301.887756,205.604248 
	C302.229126,206.185776 302.570557,206.767319 302.838013,207.670868 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M267.584625,160.584015 
	C268.663391,160.663635 269.539490,160.956512 270.415588,161.249405 
	C270.203125,161.722366 269.990662,162.195328 269.778198,162.668274 
	C268.979431,162.044617 268.180695,161.420944 267.584625,160.584015 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M171.463745,258.024841 
	C170.514587,258.494507 169.569290,258.636475 168.623993,258.778473 
	C168.612961,258.315369 168.601944,257.852295 168.590912,257.389191 
	C169.549805,257.491852 170.508713,257.594513 171.463745,258.024841 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M190.880859,388.675598 
	C189.730927,388.516693 188.523941,388.000366 187.158813,387.241394 
	C188.275024,387.438599 189.549408,387.878387 190.880859,388.675598 
z"
          />
          <path
            fill="#45B581"
            opacity="1.000000"
            stroke="none"
            d="
M198.933792,78.601608 
	C198.741684,79.010689 198.563492,79.008461 198.117493,79.007164 
	C197.399796,77.774780 196.949875,76.541466 196.491150,74.994720 
	C200.227341,73.797173 198.374527,76.845970 198.933792,78.601608 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M318.806580,257.206665 
	C319.050171,257.765564 318.996857,258.263031 318.943542,258.760468 
	C318.497589,258.647156 318.051636,258.533875 317.605682,258.420593 
	C317.907013,257.995483 318.208313,257.570343 318.806580,257.206665 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M280.975250,155.709290 
	C279.983215,155.296188 279.002411,154.487473 277.866150,153.395874 
	C278.802582,153.846558 279.894562,154.580109 280.975250,155.709290 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M160.754150,393.164246 
	C160.985504,394.038239 160.961578,395.106598 160.951050,396.574524 
	C160.809250,395.768890 160.654053,394.563751 160.754150,393.164246 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M277.837433,391.814026 
	C277.312897,392.501221 276.583435,392.901764 275.539124,393.370544 
	C276.027008,392.801666 276.829742,392.164520 277.837433,391.814026 
z"
          />
          <path
            fill="#0DB867"
            opacity="1.000000"
            stroke="none"
            d="
M379.373718,140.003601 
	C379.762238,139.334000 380.525421,138.673248 381.641266,138.009720 
	C381.995911,138.451782 381.997925,138.896637 381.998444,139.675354 
	C381.247406,140.010300 380.497925,140.011353 379.373718,140.003601 
z"
          />
          <path
            fill="#0DB867"
            opacity="1.000000"
            stroke="none"
            d="
M376.947449,132.672760 
	C376.254669,131.964798 375.586670,130.865280 374.823303,129.450134 
	C375.476013,130.183411 376.224121,131.232300 376.947449,132.672760 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M299.290039,234.957306 
	C299.654785,234.246674 300.395325,233.556702 301.431335,232.786499 
	C301.039856,233.463501 300.352844,234.220718 299.290039,234.957306 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M130.559830,120.911194 
	C130.559830,120.911194 130.457581,120.538689 130.526154,120.358368 
	C131.956345,120.687164 133.317963,121.196281 134.794952,122.063004 
	C134.209991,122.537903 133.509659,122.655205 132.320816,122.356873 
	C131.408142,121.597885 130.983978,121.254539 130.559830,120.911194 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M220.873627,74.116196 
	C221.554184,75.192619 222.234741,76.269051 222.952606,77.676300 
	C222.853287,78.119286 222.716660,78.231438 222.166534,78.262405 
	C221.166672,77.060440 220.580261,75.939667 220.212952,74.642159 
	C220.579239,74.349014 220.726425,74.232605 220.873627,74.116196 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M146.007996,126.459648 
	C146.405594,126.042488 146.858536,125.940117 147.755402,126.136017 
	C148.478714,126.637527 148.758102,126.840767 149.037506,127.044006 
	C148.046112,126.954147 147.054733,126.864288 146.007996,126.459648 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M174.344269,106.054573 
	C173.709610,105.590561 173.374802,105.071175 173.046494,104.236984 
	C173.724838,104.335518 174.396667,104.748856 175.137726,105.463364 
	C175.019333,105.842751 174.831711,105.920975 174.344269,106.054573 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M281.045105,175.405823 
	C281.282410,175.795044 281.280548,176.182114 281.250671,176.567001 
	C281.249847,176.577728 280.949646,176.565231 280.789062,176.563583 
	C280.793365,176.176834 280.797668,175.790085 281.045105,175.405823 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M153.716660,87.070061 
	C154.063095,87.238937 154.065948,87.440407 154.108231,87.941696 
	C153.682083,88.546234 153.216492,88.850945 152.460709,89.189056 
	C152.571381,88.515846 152.972244,87.809258 153.716660,87.070061 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M161.009155,374.673279 
	C161.009308,375.019714 160.604233,375.248901 160.402802,375.366028 
	C159.901459,374.569580 159.601517,373.656006 159.391953,372.415588 
	C159.647583,372.051880 159.812836,372.015015 159.978104,371.978180 
	C160.321747,372.761078 160.665375,373.543945 161.009155,374.673279 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M257.881348,396.859406 
	C257.545197,397.381805 257.061432,397.663605 256.284698,397.900452 
	C256.572388,397.443268 257.153076,397.031036 257.881348,396.859406 
z"
          />
          <path
            fill="#63BC90"
            opacity="1.000000"
            stroke="none"
            d="
M156.481003,121.118362 
	C156.517517,120.449974 156.885834,119.732918 157.577362,118.958038 
	C157.537994,119.623383 157.175400,120.346535 156.481003,121.118362 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M177.967346,383.633606 
	C177.453796,383.683411 176.934357,383.434845 176.131363,382.950806 
	C175.847809,382.715332 175.874527,382.374847 175.874527,382.374847 
	C176.570175,382.694977 177.265823,383.015137 177.967346,383.633606 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M175.338959,383.051056 
	C174.830627,383.402069 174.322281,383.753113 173.512970,384.171021 
	C173.692902,383.560883 174.173828,382.883881 174.998306,382.436279 
	C175.341843,382.665741 175.338959,383.051056 175.338959,383.051056 
z"
          />
          <path
            fill="#4DB783"
            opacity="1.000000"
            stroke="none"
            d="
M352.930542,113.266876 
	C352.690948,113.899231 352.103271,114.381454 351.213562,114.543671 
	C350.965179,113.825218 351.018860,113.426781 351.072540,113.028343 
	C351.575836,113.057816 352.079132,113.087280 352.930542,113.266876 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M231.405762,135.953537 
	C231.795242,135.716278 232.182556,135.718216 232.567703,135.748245 
	C232.578629,135.749115 232.566238,136.049301 232.564728,136.209915 
	C232.177597,136.205505 231.790451,136.201096 231.405762,135.953537 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M227.954758,130.593781 
	C227.718369,130.205536 227.720291,129.819489 227.750061,129.435608 
	C227.750900,129.424911 228.049911,129.437332 228.209885,129.438980 
	C228.205582,129.824753 228.201263,130.210526 227.954758,130.593781 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M287.923065,391.871979 
	C287.637665,391.971497 287.393097,391.686401 286.977295,391.173340 
	C286.850067,390.530670 286.894073,390.115997 286.987244,389.392456 
	C287.036407,389.083557 287.533569,389.093353 287.778503,389.137207 
	C288.003601,389.949829 287.983734,390.718597 287.923065,391.871979 
z"
          />
          <path
            fill="#B2E2CA"
            opacity="1.000000"
            stroke="none"
            d="
M214.696625,65.866898 
	C215.059952,66.399078 215.093109,66.845192 214.783875,67.500702 
	C213.880081,67.314301 213.318680,66.918510 212.757263,66.522713 
	C212.804672,66.349792 212.852066,66.176865 212.967590,65.742943 
	C213.479294,65.581573 213.922882,65.681206 214.696625,65.866898 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M217.093964,399.360840 
	C217.608444,399.035767 218.074539,399.040833 218.890869,399.078766 
	C218.689224,399.681732 218.137314,400.251801 217.302460,400.922882 
	C217.028183,400.579590 217.036865,400.135284 217.093964,399.360840 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M230.967239,400.355164 
	C231.044312,400.068726 231.235992,400.047852 231.716522,400.011139 
	C232.321289,400.465668 232.637207,400.936005 232.988861,401.699432 
	C233.024582,401.992493 232.581802,401.997650 232.360443,401.997711 
	C231.786667,401.538757 231.434250,401.079742 230.967239,400.355164 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M274.998993,160.998962 
	C274.961334,161.647476 274.924652,162.297012 274.888000,162.946564 
	C274.732574,162.944199 274.577148,162.941849 274.421722,162.939499 
	C274.459564,162.406616 274.497406,161.873749 274.768555,161.171036 
	C275.001892,161.001205 275.000000,161.000000 274.998993,160.998962 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M283.863831,158.809509 
	C283.248871,158.655029 282.644348,158.146988 281.913635,157.361298 
	C282.483063,157.541092 283.178680,157.998520 283.863831,158.809509 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M266.083008,164.915878 
	C266.761292,165.313766 267.372192,165.784561 268.083618,166.543106 
	C268.184143,166.830856 268.070343,166.934647 267.745605,166.878906 
	C266.907867,166.260605 266.394836,165.698044 265.881805,165.135483 
	C265.881805,165.135483 266.015656,164.988800 266.083008,164.915878 
z"
          />
          <path
            fill="#63BC90"
            opacity="1.000000"
            stroke="none"
            d="
M142.383362,131.628418 
	C142.414719,131.907867 141.984360,131.992096 141.769775,132.030670 
	C141.514938,131.217255 141.474686,130.365295 141.572784,129.100494 
	C141.711105,128.687668 141.967682,128.712311 142.059296,129.143173 
	C142.199127,129.791245 142.247314,130.008438 142.295517,130.225647 
	C142.314346,130.600098 142.333176,130.974533 142.383362,131.628418 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M195.054596,94.338440 
	C195.252136,93.962051 195.439163,93.962326 195.907074,93.946106 
	C196.372147,94.540489 196.556366,95.151375 196.766312,96.076096 
	C196.209366,95.831665 195.626709,95.273384 195.054596,94.338440 
z"
          />
          <path
            fill="#49B882"
            opacity="1.000000"
            stroke="none"
            d="
M149.264343,126.885078 
	C148.758102,126.840767 148.478714,126.637527 148.103394,126.191238 
	C148.415146,125.837097 148.822784,125.726021 149.546387,125.665878 
	C149.738602,126.053261 149.614883,126.389702 149.264343,126.885078 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M268.787323,329.885040 
	C268.363159,329.954742 267.815308,329.738098 267.113831,329.264771 
	C267.528015,329.204956 268.095825,329.401825 268.787323,329.885040 
z"
          />
          <path
            fill="#0DB867"
            opacity="1.000000"
            stroke="none"
            d="
M350.801819,113.187935 
	C351.018860,113.426781 350.965179,113.825218 350.913879,114.525024 
	C350.916229,114.826401 350.549438,115.123444 350.313843,115.118546 
	C350.229187,114.524940 350.380157,113.936234 350.801819,113.187935 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M251.663208,124.007538 
	C251.159256,124.144440 250.533600,123.930023 249.678574,123.468414 
	C250.146637,123.366211 250.844070,123.511215 251.663208,124.007538 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M325.820557,279.807678 
	C325.404816,279.897339 324.840942,279.717346 324.125122,279.278015 
	C324.539581,279.191803 325.106018,279.364899 325.820557,279.807678 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M237.996185,67.946198 
	C237.712509,67.914963 237.476562,67.723167 237.452850,67.574081 
	C237.948746,67.453903 238.468323,67.482811 238.987915,67.511719 
	C238.751892,67.666962 238.515869,67.822197 237.996185,67.946198 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M293.961304,398.460693 
	C293.922119,398.182953 294.363251,398.265015 294.585480,398.297180 
	C294.818207,398.701904 294.828705,399.074493 294.915222,399.716248 
	C294.660980,399.569763 294.330719,399.154114 293.961304,398.460693 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M257.146729,237.218414 
	C257.440765,236.988098 257.880768,236.983902 258.650330,236.972900 
	C258.417511,237.125580 257.855072,237.285049 257.146729,237.218414 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M299.702393,268.021179 
	C299.531677,268.319336 299.063324,268.638672 298.297485,268.979614 
	C298.468262,268.681610 298.936523,268.362000 299.702393,268.021179 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M271.777710,331.903015 
	C271.355164,331.961151 270.827545,331.730225 270.157104,331.241455 
	C270.567108,331.193787 271.119873,331.403900 271.777710,331.903015 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M235.205780,402.172760 
	C235.128479,401.704895 235.313828,401.445160 235.787720,401.120667 
	C235.997345,400.999573 236.259232,401.288513 236.294678,401.629883 
	C236.174271,402.221344 235.983002,402.440552 235.756317,402.628845 
	C235.756317,402.628845 235.389481,402.324554 235.205780,402.172760 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M272.860077,332.824097 
	C272.648468,332.922211 272.334534,332.776978 271.928528,332.383728 
	C272.143555,332.284058 272.450623,332.432404 272.860077,332.824097 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M374.134460,320.866028 
	C373.874481,320.938812 373.952179,320.494690 373.983398,320.271423 
	C374.014618,320.048187 374.487488,319.936981 374.730286,319.928040 
	C374.780182,320.210480 374.587311,320.501831 374.134460,320.866028 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M376.173401,318.864319 
	C376.046844,318.650604 376.168213,318.328064 376.526367,317.890503 
	C376.649200,318.102142 376.535248,318.428802 376.173401,318.864319 
z"
          />
          <path
            fill="#B7F2D9"
            opacity="1.000000"
            stroke="none"
            d="
M108.700714,318.019165 
	C108.718628,318.235596 108.458221,318.508026 107.908844,318.820831 
	C107.887383,318.599182 108.154884,318.337158 108.700714,318.019165 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M119.824753,315.639526 
	C119.640022,315.571350 119.645699,315.276642 119.742310,315.166077 
	C120.009407,315.214203 120.179886,315.372925 120.350365,315.531647 
	C120.236732,315.590332 120.123108,315.649048 119.824753,315.639526 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M165.965607,397.635803 
	C165.713211,397.256744 165.889603,396.990234 166.452194,396.759521 
	C166.545013,397.016846 166.397003,397.334534 165.965607,397.635803 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M269.888245,330.757935 
	C269.697266,330.851898 269.381561,330.720673 268.959229,330.350006 
	C269.156250,330.251312 269.459869,330.391998 269.888245,330.757935 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M217.141266,416.099731 
	C217.372864,416.001251 217.691406,416.167542 218.096024,416.593842 
	C217.864136,416.690735 217.546173,416.527618 217.141266,416.099731 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M331.971558,374.024780 
	C331.591949,373.958069 331.352814,373.759918 331.019714,373.323090 
	C330.887756,373.130249 331.110535,372.886169 331.432251,372.817200 
	C331.753998,372.748199 332.155487,372.904419 332.170715,373.122498 
	C332.185913,373.340576 332.278839,373.767792 332.278839,373.767792 
	C332.278839,373.767792 332.074066,373.939178 331.971558,374.024780 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M175.464813,383.058228 
	C175.338959,383.051056 175.341843,382.665741 175.358810,382.474121 
	C175.375778,382.282471 175.620605,382.354218 175.747559,382.364532 
	C175.874527,382.374847 175.847809,382.715332 175.845215,382.886200 
	C175.842606,383.057068 175.590652,383.065369 175.464813,383.058228 
z"
          />
          <path
            fill="#63BC90"
            opacity="1.000000"
            stroke="none"
            d="
M151.940674,124.726212 
	C151.905212,124.429901 152.172104,124.167885 152.729630,123.905441 
	C152.761185,124.190178 152.502106,124.475349 151.940674,124.726212 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M136.593262,120.078987 
	C136.833801,120.277763 136.746933,120.554939 136.325470,120.904877 
	C136.110764,120.710548 136.202423,120.437134 136.593262,120.078987 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M166.057098,377.210205 
	C166.117218,377.466064 165.883026,377.748901 165.374512,378.095703 
	C165.321060,377.852173 165.541931,377.544708 166.057098,377.210205 
z"
          />
          <path
            fill="#4DB783"
            opacity="1.000000"
            stroke="none"
            d="
M236.755615,66.106155 
	C236.460571,66.165413 236.184265,65.908722 235.860947,65.364975 
	C236.134079,65.315361 236.454193,65.552780 236.755615,66.106155 
z"
          />
          <path
            fill="#58BA8C"
            opacity="1.000000"
            stroke="none"
            d="
M145.773438,117.978958 
	C145.500595,118.119461 145.165665,117.957268 144.727173,117.523659 
	C144.986176,117.393578 145.348770,117.534920 145.773438,117.978958 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M159.828247,371.760803 
	C159.812836,372.015015 159.647583,372.051880 159.228394,372.093811 
	C158.974457,372.098877 158.791733,371.652496 158.756836,371.414368 
	C159.040771,371.298645 159.359573,371.421021 159.828247,371.760803 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M333.840759,354.158081 
	C333.928375,354.364960 333.766296,354.666016 333.359955,355.068604 
	C333.274139,354.864197 333.432587,354.558197 333.840759,354.158081 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M170.055084,111.892654 
	C169.872070,111.921799 169.987289,111.459312 170.087677,111.243332 
	C170.298218,111.227524 170.425400,111.421455 170.503204,111.633499 
	C170.517517,111.672501 170.331604,111.784958 170.055084,111.892654 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M142.551773,114.354668 
	C142.434967,114.659088 142.082123,114.592712 142.013184,114.139694 
	C141.938263,113.482872 141.932281,113.279076 141.926285,113.075272 
	C141.926285,113.075272 141.993500,113.011307 142.029083,112.980560 
	C142.265961,113.316620 142.467270,113.683434 142.551773,114.354668 
z"
          />
          <path
            fill="#45B581"
            opacity="1.000000"
            stroke="none"
            d="
M187.992096,73.131889 
	C188.199402,73.101768 188.363693,73.497986 188.299835,73.702301 
	C188.085571,73.658409 187.935181,73.410210 187.992096,73.131889 
z"
          />
          <path
            fill="#45B581"
            opacity="1.000000"
            stroke="none"
            d="
M196.461304,74.059784 
	C195.979874,74.224167 195.771072,73.986671 195.724899,73.364449 
	C196.017380,73.339859 196.299515,73.565926 196.461304,74.059784 
z"
          />
          <path
            fill="#45B781"
            opacity="1.000000"
            stroke="none"
            d="
M219.795258,73.197968 
	C220.299072,73.140015 220.548584,73.347969 220.799988,73.879082 
	C220.726425,74.232605 220.579239,74.349014 220.092148,74.458267 
	C219.564957,74.224892 219.395630,73.985939 219.244263,73.734261 
	C219.367065,73.615440 219.489868,73.496628 219.795258,73.197968 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M312.824158,271.120636 
	C312.927704,271.340454 312.726440,271.591522 312.226624,271.881287 
	C312.112061,271.656342 312.309174,271.400299 312.824158,271.120636 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M215.933838,152.920135 
	C216.035385,152.584503 216.234390,152.346039 216.681900,152.025543 
	C216.880005,151.901459 217.024612,152.030579 216.987396,152.324768 
	C216.659439,152.773560 216.368713,152.928177 216.077988,153.082794 
	C216.077988,153.082794 215.980881,152.975220 215.933838,152.920135 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M275.530975,267.548340 
	C275.477203,267.580078 275.584747,267.516632 275.530975,267.548340 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M216.884583,269.788452 
	C216.662842,269.912750 216.397018,269.724335 216.088608,269.221741 
	C216.309631,269.099487 216.574463,269.288879 216.884583,269.788452 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M354.050049,148.720261 
	C353.883636,148.980515 353.711212,148.985703 353.280273,148.985916 
	C353.055267,148.754166 353.088806,148.527420 353.277374,147.992584 
	C353.636261,147.944733 353.840149,148.204971 354.050049,148.720261 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M267.325134,148.630768 
	C267.482758,148.797195 267.463501,148.846863 267.481934,148.869949 
	C267.245483,148.778625 266.990601,148.664230 266.735718,148.549820 
	C266.879669,148.521332 267.023590,148.492828 267.325134,148.630768 
z"
          />
          <path
            fill="#49B882"
            opacity="1.000000"
            stroke="none"
            d="
M142.405792,130.061005 
	C142.247314,130.008438 142.199127,129.791245 142.144318,129.240036 
	C142.263824,129.236145 142.389938,129.566254 142.405792,130.061005 
z"
          />
          <path
            fill="#2AB575"
            opacity="1.000000"
            stroke="none"
            d="
M340.686523,344.100037 
	C340.771881,344.276154 340.651306,344.581604 340.286865,344.981201 
	C340.072876,344.733398 340.218750,344.451416 340.686523,344.100037 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M189.035431,96.975266 
	C189.177856,97.116074 189.282852,97.290985 189.387848,97.465897 
	C189.286804,97.427132 189.185760,97.388374 189.007996,97.217575 
	C188.931259,97.085526 188.998016,97.009377 189.035431,96.975266 
z"
          />
          <path
            fill="#58BA8C"
            opacity="1.000000"
            stroke="none"
            d="
M144.451950,104.979347 
	C144.845016,104.736427 145.106201,104.919044 145.331085,105.480957 
	C145.066162,105.570580 144.741272,105.418785 144.451950,104.979347 
z"
          />
          <path
            fill="#49B882"
            opacity="1.000000"
            stroke="none"
            d="
M142.243408,126.928459 
	C142.204559,126.757942 142.391708,126.477791 142.823822,126.111511 
	C142.869003,126.289864 142.669220,126.554352 142.243408,126.928459 
z"
          />
          <path
            fill="#E1F4EA"
            opacity="1.000000"
            stroke="none"
            d="
M339.790649,100.993500 
	C337.453949,108.482506 335.212494,115.605644 332.880859,123.015411 
	C329.395142,121.612686 327.299866,120.382362 328.446381,116.295753 
	C329.405487,112.877235 323.494080,108.534782 320.521118,110.499565 
	C317.029510,112.807114 315.164825,111.447182 312.761871,108.406441 
	C319.762207,103.537964 326.493500,98.714699 333.427948,94.203735 
	C334.351654,93.602859 336.422760,94.315529 337.757416,94.893448 
	C340.290070,95.990105 340.960144,98.052200 339.790649,100.993500 
z"
          />
          <path
            fill="#EDF7F2"
            opacity="1.000000"
            stroke="none"
            d="
M219.004425,73.517334 
	C219.395630,73.985939 219.564957,74.224892 219.873047,74.635010 
	C220.580261,75.939667 221.166672,77.060440 221.961456,78.430450 
	C222.650223,79.625999 223.130600,80.572319 223.808655,82.041672 
	C224.046265,82.943726 224.086197,83.322739 224.116928,84.070595 
	C224.580231,84.911446 225.052734,85.383469 225.692108,85.951408 
	C226.046387,86.240196 226.148300,86.470825 226.164719,86.739220 
	C226.122040,87.615952 226.079376,88.492676 226.058792,89.810120 
	C225.554047,90.433716 225.027191,90.616592 224.023590,90.566345 
	C222.836227,90.210617 222.125626,90.088005 221.415024,89.965393 
	C219.535309,88.783951 217.675323,86.682129 215.771194,86.641350 
	C213.058472,86.583252 209.993500,87.256699 209.570099,91.448578 
	C209.447433,92.662987 206.521729,93.594276 204.501740,94.267677 
	C204.098099,92.625824 204.073776,91.371643 204.049438,90.117470 
	C205.023651,83.365295 205.997879,76.613129 207.384903,69.413010 
	C208.839447,68.257660 209.881180,67.550255 210.922897,66.842850 
	C211.328812,66.762238 211.734741,66.681633 212.448959,66.561867 
	C213.318680,66.918510 213.880081,67.314301 214.759857,67.836044 
	C216.307007,69.741470 217.535797,71.520943 219.004425,73.517334 
z"
          />
          <path
            fill="#E1F4EA"
            opacity="1.000000"
            stroke="none"
            d="
M288.862732,92.150078 
	C285.894135,90.926025 283.789276,90.554672 281.506500,93.295845 
	C280.504547,94.499031 277.430664,93.976814 275.297577,94.238029 
	C275.076630,93.649254 274.855682,93.060471 274.634735,92.471695 
	C279.972748,85.846878 285.146179,79.078094 290.742767,72.679382 
	C292.573853,70.585815 298.098785,72.778442 298.174835,75.527092 
	C298.402374,83.752357 298.256653,91.987953 298.256653,100.573776 
	C294.549652,100.465378 292.081360,99.996643 291.968079,95.777077 
	C291.936157,94.589279 290.192719,93.447433 288.862732,92.150078 
M291.503387,80.269836 
	C290.280151,81.926407 289.056915,83.582977 287.473114,85.727875 
	C289.484863,86.576195 290.860168,87.156136 293.229950,88.155441 
	C292.740417,84.743431 292.393890,82.328178 291.503387,80.269836 
z"
          />
          <path
            fill="#E1F4EA"
            opacity="1.000000"
            stroke="none"
            d="
M221.328796,90.170738 
	C222.125626,90.088005 222.836227,90.210617 223.738770,90.527313 
	C223.247940,90.794876 222.565155,90.868362 221.535797,90.880066 
	C221.189240,90.818291 221.242584,90.376083 221.328796,90.170738 
z"
          />
          <path
            fill="#C6F9E4"
            opacity="1.000000"
            stroke="none"
            d="
M215.925751,153.375458 
	C216.368713,152.928177 216.659439,152.773560 217.057678,152.391525 
	C218.836716,151.085022 220.420303,149.809418 222.215225,149.005936 
	C223.179047,148.574493 224.505920,148.954071 225.668945,148.967667 
	C225.202057,150.067032 224.995331,151.425964 224.212723,152.210342 
	C222.702438,153.724045 220.866974,154.913345 218.997284,156.529968 
	C214.920853,162.039719 210.139404,166.834366 207.356491,172.594543 
	C204.675156,178.144547 204.058578,184.692093 201.773666,190.647858 
	C198.672729,184.021637 201.124298,177.918350 203.003662,171.384277 
	C203.022354,170.997177 203.347427,170.621719 203.617844,170.189209 
	C204.017685,169.230408 204.147125,168.704132 204.276550,168.177841 
	C204.276550,168.177841 204.306686,168.155273 204.319656,168.172028 
	C205.893051,165.739319 207.453461,163.289841 209.121567,160.518906 
	C211.410690,158.020996 213.592102,155.844559 215.925751,153.375458 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M188.007935,220.392670 
	C188.355408,223.686188 188.687225,227.371704 189.025146,231.510620 
	C186.112091,228.520721 186.112091,228.520721 188.007935,220.392670 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M203.977386,168.216202 
	C204.147125,168.704132 204.017685,169.230408 203.700256,169.954971 
	C203.567551,169.520355 203.622879,168.887451 203.977386,168.216202 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M187.863953,217.884689 
	C188.033813,218.475479 188.027145,218.904556 188.016266,219.655518 
	C187.903854,219.225937 187.795639,218.474457 187.863953,217.884689 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M270.992065,206.954315 
	C271.472534,210.797043 266.197784,216.368942 261.535431,217.970383 
	C253.844635,220.612045 245.897766,221.934982 238.134064,219.779526 
	C232.949188,218.340042 228.282898,214.938644 223.523636,212.175644 
	C222.907104,211.817719 223.124847,210.022781 222.918686,208.501846 
	C222.881226,208.110245 223.065216,207.949249 223.430969,208.055603 
	C228.845490,213.329086 234.361282,217.631790 242.451248,218.039841 
	C246.594711,217.698700 250.290527,217.316086 254.383499,217.021500 
	C258.952209,214.820267 263.123779,212.530991 267.211182,210.145828 
	C267.127075,210.049942 267.253815,210.271332 267.497925,210.166351 
	C267.904785,209.749313 268.067474,209.437286 268.494110,208.978256 
	C269.316254,208.034027 269.874481,207.236786 270.432709,206.439529 
	C270.555603,206.555496 270.678467,206.671463 270.992065,206.954315 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M260.966309,226.636749 
	C261.003113,226.986572 260.511963,227.003387 260.266541,227.007111 
	C258.704254,226.341263 257.387421,225.671692 255.483139,224.703415 
	C256.549683,223.828003 257.407501,223.123917 258.265320,222.419830 
	C259.153381,223.708847 260.041443,224.997894 260.966309,226.636749 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M225.541138,226.474304 
	C225.567291,226.521088 225.514969,226.427536 225.541138,226.474304 
z"
          />
          <path
            fill="#C8F9E5"
            opacity="1.000000"
            stroke="none"
            d="
M214.915619,208.965683 
	C214.524277,210.351044 214.153473,211.783554 213.984543,212.436203 
	C219.118423,214.863800 223.314362,224.742111 219.541351,230.960297 
	C218.096130,233.342117 214.480545,234.848770 211.545532,235.752213 
	C208.962509,236.547318 205.935593,235.769745 203.128387,235.989365 
	C189.677536,237.041718 189.055313,227.207520 192.331787,218.041656 
	C193.217316,215.564453 195.654541,213.641937 197.636917,211.139984 
	C195.597366,207.049881 195.111237,202.584320 199.130844,198.802963 
	C202.048355,196.058395 205.528564,195.404251 209.261261,197.043259 
	C214.117783,199.175751 215.367447,203.208618 214.886200,208.505157 
	C214.876907,208.920151 214.936172,209.012848 214.915619,208.965683 
M194.663879,223.755920 
	C194.619308,230.863342 195.627563,231.909225 202.590332,231.924927 
	C205.412582,231.931290 208.245285,232.051941 211.054749,231.855774 
	C215.309738,231.558640 217.209808,229.200867 216.790543,224.875732 
	C216.295486,219.768677 213.073669,215.348007 209.304703,214.870331 
	C200.261398,213.724182 197.022644,215.514679 194.663879,223.755920 
M210.891327,207.121933 
	C210.603058,201.668015 207.376404,198.617355 203.764481,200.773926 
	C202.076523,201.781754 200.396194,204.273972 200.359985,206.125641 
	C200.329254,207.696075 202.640778,210.593735 203.963394,210.621262 
	C206.174927,210.667297 208.424347,208.893402 210.891327,207.121933 
z"
          />
          <path
            fill="#01BF62"
            opacity="1.000000"
            stroke="none"
            d="
M221.974701,161.376236 
	C224.864044,162.112045 227.455704,156.785492 230.846375,161.205017 
	C231.350143,162.020859 231.475784,162.253036 231.543762,162.492126 
	C231.486099,162.499054 231.372910,162.524918 230.986923,162.384872 
	C224.037842,163.740219 222.300629,165.543610 222.044769,171.055450 
	C222.009155,171.020905 222.103363,171.052109 221.847733,171.153839 
	C221.450134,171.579865 221.308167,171.904160 221.191467,172.247849 
	C221.216751,172.267242 221.242706,172.325455 221.242706,172.325455 
	C219.823273,171.703049 218.449692,170.910568 216.969986,170.511795 
	C215.775864,170.189972 214.453720,170.343216 213.212143,170.939651 
	C217.651154,174.476807 217.651154,174.476807 211.007050,186.071350 
	C212.641327,186.653702 214.209442,187.212494 216.692902,188.097443 
	C212.961823,189.489609 209.901337,190.631546 206.840851,191.773499 
	C207.897125,192.739960 208.953384,193.706406 210.009659,194.672867 
	C207.572876,194.672867 205.136108,194.672867 203.213257,194.672867 
	C204.425888,191.444870 206.122849,188.344955 206.685822,185.051208 
	C207.315094,181.369568 207.660950,178.095688 212.491806,177.600693 
	C211.169510,177.230606 209.847214,176.860504 208.366928,176.446198 
	C207.941193,170.104095 213.140274,166.967087 216.174500,162.682816 
	C216.433258,162.317444 218.137329,163.196075 219.101822,163.049225 
	C220.101837,162.896957 221.018906,162.199875 221.974701,161.376236 
z"
          />
          <path
            fill="#CEFAE7"
            opacity="1.000000"
            stroke="none"
            d="
M242.003601,217.998367 
	C234.361282,217.631790 228.845490,213.329086 223.523407,207.975616 
	C221.162415,203.109299 219.074692,198.429321 217.369934,193.380249 
	C218.736603,192.662964 219.720337,192.314758 220.819672,192.242599 
	C221.019028,192.699707 221.102768,192.880783 221.161087,193.337219 
	C221.337509,194.110489 221.539337,194.608414 221.748535,195.461212 
	C222.098465,196.677048 222.441010,197.538025 222.828751,198.695755 
	C223.227432,199.678299 223.580902,200.364059 223.978119,201.309265 
	C224.279495,201.785065 224.537109,202.001434 224.817352,202.237518 
	C224.839966,202.257233 224.789230,202.289276 224.894409,202.604736 
	C225.967667,203.796539 227.281921,204.493912 227.843674,205.580368 
	C230.227066,210.190018 234.077301,212.391678 239.012878,213.011200 
	C238.983887,213.013214 238.979340,212.955307 239.022781,213.165497 
	C239.259674,213.608124 239.506714,213.740967 239.884918,214.119370 
	C240.642853,215.642487 241.323227,216.820435 242.003601,217.998367 
z"
          />
          <path
            fill="#C9F9E5"
            opacity="1.000000"
            stroke="none"
            d="
M234.333786,161.130249 
	C234.333786,161.130249 234.687378,161.119858 234.826660,161.011215 
	C235.142410,160.932251 235.318878,160.961914 235.817841,161.379959 
	C237.396057,162.553345 238.651779,163.338364 239.542389,164.098373 
	C235.842972,165.643051 232.508652,167.212738 228.399780,169.147064 
	C230.682281,170.756195 231.993591,171.680649 233.009872,172.732330 
	C232.457977,173.928635 232.201111,174.997696 231.619202,175.962738 
	C229.669113,174.925186 228.044067,173.991623 226.246201,172.958786 
	C224.748810,175.271301 223.452271,177.273636 221.951050,178.982391 
	C220.849426,178.463943 219.952469,178.239075 219.055527,178.014206 
	C219.730988,176.336014 220.406448,174.657837 221.162308,172.652557 
	C221.242706,172.325455 221.216751,172.267242 221.453613,172.156738 
	C221.828094,171.714874 221.965729,171.383484 222.103363,171.052109 
	C222.103363,171.052109 222.009155,171.020905 222.340134,170.895889 
	C225.571716,168.022217 228.472321,165.273575 231.372925,162.524933 
	C231.372910,162.524918 231.486099,162.499054 231.847931,162.473358 
	C232.917770,162.008514 233.625778,161.569382 234.333786,161.130249 
z"
          />
          <path
            fill="#EAFDF7"
            opacity="1.000000"
            stroke="none"
            d="
M218.816620,178.329559 
	C219.952469,178.239075 220.849426,178.463943 221.761185,179.287018 
	C221.524933,182.281250 221.273865,184.677261 221.029510,187.311646 
	C221.036224,187.550018 221.107635,188.021790 221.087830,188.397491 
	C221.053894,189.525085 221.039764,190.276993 220.947144,191.263947 
	C220.868637,191.499008 220.704056,191.966553 220.704056,191.966553 
	C219.720337,192.314758 218.736603,192.662964 217.430756,193.000626 
	C217.598328,188.208374 218.088013,183.426636 218.816620,178.329559 
z"
          />
          <path
            fill="#4DB783"
            opacity="1.000000"
            stroke="none"
            d="
M226.514755,86.710144 
	C226.148300,86.470825 226.046387,86.240196 225.602509,85.631760 
	C224.939392,84.711380 224.532761,84.206573 224.126129,83.701759 
	C224.086197,83.322739 224.046265,82.943726 224.027802,82.279053 
	C225.008499,81.993202 225.967758,81.993011 227.283691,81.987106 
	C227.381851,83.547958 227.123322,85.114510 226.514755,86.710144 
z"
          />
          <path
            fill="#2DB274"
            opacity="1.000000"
            stroke="none"
            d="
M263.977173,86.044052 
	C262.650543,85.235840 260.900299,84.390518 260.970612,83.742996 
	C261.428314,79.530739 262.281494,75.361450 263.021484,71.084053 
	C267.788361,71.531776 271.352783,72.308929 271.294495,77.632561 
	C271.236816,82.900864 269.304626,85.369362 263.977173,86.044052 
z"
          />
          <path
            fill="#25B173"
            opacity="1.000000"
            stroke="none"
            d="
M263.977234,330.944031 
	C266.816528,332.736023 269.479004,334.184814 271.743591,336.103271 
	C272.652649,336.873413 272.687500,338.675446 273.120270,340.007812 
	C271.732971,339.771057 269.986145,339.991974 269.013336,339.227692 
	C257.765472,330.391022 245.077667,327.476959 231.431396,331.191040 
	C225.666794,332.759979 220.288513,336.235535 215.181778,339.536255 
	C212.482758,341.280731 211.548080,340.831390 210.404984,338.454895 
	C221.538254,326.161652 244.985123,319.842865 263.977234,330.944031 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M217.588928,340.903809 
	C217.190842,341.570862 216.485321,342.287201 215.424438,343.011780 
	C215.806549,342.331085 216.544022,341.642090 217.588928,340.903809 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M219.604553,339.788452 
	C219.449539,340.116486 218.995300,340.515808 218.212234,340.905334 
	C218.357361,340.550232 218.831345,340.204956 219.604553,339.788452 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M266.260284,340.597961 
	C266.067688,340.734406 265.710449,340.626434 265.177795,340.294037 
	C265.366821,340.164276 265.731232,340.258911 266.260284,340.597961 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M268.905701,342.771942 
	C268.660034,342.926086 268.403992,342.754852 268.094360,342.292053 
	C268.347076,342.083984 268.631958,342.232666 268.905701,342.771942 
z"
          />
          <path
            fill="#58BA8C"
            opacity="1.000000"
            stroke="none"
            d="
M159.945251,92.297043 
	C162.110580,91.775978 164.084518,91.522171 166.058456,91.268364 
	C165.524460,92.751503 165.135986,94.314507 164.386841,95.679581 
	C164.074753,96.248245 162.994324,96.395241 161.723114,96.984253 
	C161.017395,95.400284 160.385635,93.982292 159.945251,92.297043 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M170.897247,101.642494 
	C169.657272,102.247444 168.280975,102.522568 166.591888,103.115433 
	C166.200241,102.522591 166.121384,101.612000 166.042526,100.701416 
	C167.615326,100.905167 169.188126,101.108917 170.897247,101.642494 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M184.772888,102.200623 
	C184.282425,102.862732 183.438400,103.447166 182.250259,103.978119 
	C182.190018,103.434029 182.473907,102.943405 182.873535,102.189651 
	C183.465988,101.991989 183.942673,102.057472 184.772888,102.200623 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M180.415039,104.623657 
	C180.280899,105.012520 179.849182,105.433075 179.081696,105.788200 
	C179.203094,105.366966 179.660278,105.011154 180.415039,104.623657 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M167.825531,106.399063 
	C168.070465,106.371643 168.350113,106.596802 168.585587,107.103806 
	C168.314346,107.140976 168.087311,106.896317 167.825531,106.399063 
z"
          />
          <path
            fill="#E1F5EC"
            opacity="1.000000"
            stroke="none"
            d="
M364.329193,166.586380 
	C364.729065,165.175323 364.998291,163.543564 365.831512,163.170135 
	C372.917938,159.994202 380.106903,157.047089 387.722656,153.838669 
	C389.474182,158.074951 391.349396,161.772827 392.530792,165.680450 
	C393.997955,170.533218 391.642273,173.619202 386.684265,174.725357 
	C385.172943,175.062531 383.458679,176.038895 382.548950,177.254898 
	C378.670135,182.439392 372.318146,182.499023 369.017731,176.926666 
	C367.164886,173.798386 365.957947,170.287521 364.329193,166.586380 
M374.776917,174.586929 
	C376.017517,173.609970 378.259766,172.650955 378.277649,171.652084 
	C378.309052,169.898544 377.404236,167.236328 376.096039,166.606171 
	C374.834534,165.998535 372.567596,167.478210 370.283600,168.182312 
	C371.908783,170.776703 373.020294,172.551071 374.776917,174.586929 
M386.953064,165.120636 
	C386.447693,164.009018 385.942352,162.897400 385.362000,161.620819 
	C383.713531,162.549393 382.503113,163.231216 380.540833,164.336548 
	C382.240540,166.138947 383.570007,167.548752 384.899506,168.958557 
	C385.639343,167.921829 386.379181,166.885086 386.953064,165.120636 
z"
          />
          <path
            fill="#17B56A"
            opacity="1.000000"
            stroke="none"
            d="
M249.511292,138.810364 
	C251.562485,140.574722 253.905075,142.064758 254.673523,144.138184 
	C256.412964,148.831558 254.586609,150.927139 249.499680,151.030426 
	C248.166992,151.057480 246.832428,151.012741 245.500595,151.056854 
	C242.016724,151.172241 238.589279,151.374420 238.708603,146.253952 
	C238.818298,141.546219 241.380219,138.883713 246.095444,138.885330 
	C247.092972,138.885666 248.090530,138.830490 249.511292,138.810364 
z"
          />
          <path
            fill="#4DB783"
            opacity="1.000000"
            stroke="none"
            d="
M130.947495,129.181732 
	C132.615417,129.503006 133.995346,129.995667 135.375275,130.488342 
	C134.384460,132.886200 133.393646,135.284073 132.085480,138.449951 
	C129.868774,136.540665 128.569519,135.421585 126.917664,133.998825 
	C128.270798,132.318832 129.465149,130.835983 130.947495,129.181732 
z"
          />
          <path
            fill="#63BC90"
            opacity="1.000000"
            stroke="none"
            d="
M124.773392,128.667175 
	C123.145988,128.807709 121.786110,128.671982 120.426224,128.536255 
	C120.826469,127.112625 120.909615,125.446693 121.743950,124.354721 
	C122.257881,123.682114 123.918411,123.885590 125.064133,123.695709 
	C125.056396,125.260780 125.048653,126.825844 124.773392,128.667175 
z"
          />
          <path
            fill="#63BC90"
            opacity="1.000000"
            stroke="none"
            d="
M130.461243,121.140106 
	C130.983978,121.254539 131.408142,121.597885 131.963684,122.340424 
	C131.517609,122.282753 130.940140,121.825882 130.461243,121.140106 
z"
          />
          <path
            fill="#D6F1E3"
            opacity="1.000000"
            stroke="none"
            d="
M133.008057,143.184845 
	C133.088089,143.424469 132.889450,143.725372 132.427917,144.105362 
	C132.353134,143.871658 132.541260,143.558884 133.008057,143.184845 
z"
          />
          <path
            fill="#63BC90"
            opacity="1.000000"
            stroke="none"
            d="
M157.695023,109.620590 
	C160.526459,111.264183 160.566177,113.905266 158.882874,116.998718 
	C158.298508,114.800278 158.009766,112.431145 157.695023,109.620590 
z"
          />
          <path
            fill="#58BA8C"
            opacity="1.000000"
            stroke="none"
            d="
M141.622437,113.074295 
	C141.932281,113.279076 141.938263,113.482872 141.910309,113.992569 
	C141.574936,114.082901 141.273529,113.867325 140.843719,113.399330 
	C140.916412,113.122368 141.117493,113.097839 141.622437,113.074295 
z"
          />
          <path
            fill="#12B969"
            opacity="1.000000"
            stroke="none"
            d="
M277.179016,221.080292 
	C280.077667,215.484024 286.640686,213.080383 293.193237,215.215240 
	C296.737793,216.370071 299.572754,221.364761 298.995636,226.342270 
	C298.792633,228.092987 297.359406,229.701050 295.755432,231.613495 
	C290.350037,231.895630 285.677124,231.938522 281.004242,231.981415 
	C280.253052,231.598450 279.501862,231.215485 278.323761,230.360260 
	C277.657562,226.952103 277.418304,224.016190 277.179016,221.080292 
z"
          />
          <path
            fill="#20B672"
            opacity="1.000000"
            stroke="none"
            d="
M292.884033,208.878235 
	C288.371735,212.864761 283.877136,212.392654 283.126495,207.935364 
	C282.805603,206.029846 283.707672,203.179871 285.103455,201.951889 
	C286.270294,200.925323 289.909119,200.796112 290.773041,201.766052 
	C292.230103,203.401962 292.357208,206.222412 292.884033,208.878235 
z"
          />
          <path
            fill="#C8FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M276.811951,221.009735 
	C277.418304,224.016190 277.657562,226.952103 278.024170,230.251526 
	C278.066071,231.546844 277.980652,232.478607 277.794159,233.872467 
	C272.567413,231.242477 271.370331,225.905701 274.585388,218.946472 
	C275.390808,219.415756 275.917816,220.177460 276.811951,221.009735 
z"
          />
          <path
            fill="#C8FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M281.294006,232.279633 
	C285.677124,231.938522 290.350037,231.895630 295.485046,231.854736 
	C291.159332,232.097122 286.371552,232.337479 281.294006,232.279633 
z"
          />
          <path
            fill="#C8FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M278.852356,234.747940 
	C278.654572,234.882492 278.317230,234.796646 277.861877,234.471176 
	C278.066864,234.330200 278.389801,234.428864 278.852356,234.747940 
z"
          />
          <path
            fill="#B2E2CA"
            opacity="1.000000"
            stroke="none"
            d="
M203.785675,90.168251 
	C204.073776,91.371643 204.098099,92.625824 204.143784,94.251053 
	C203.724731,94.794014 203.284317,94.965912 202.489105,95.160156 
	C202.092880,94.044083 202.051483,92.905655 202.041321,91.341446 
	C202.555664,90.683449 203.038788,90.451241 203.785675,90.168251 
z"
          />
          <path
            fill="#DDF4E8"
            opacity="1.000000"
            stroke="none"
            d="
M177.740021,87.286499 
	C177.465088,87.343689 177.140015,87.052269 176.717621,86.436157 
	C176.976837,86.386940 177.333374,86.662415 177.740021,87.286499 
z"
          />
          <path
            fill="#DDF4E8"
            opacity="1.000000"
            stroke="none"
            d="
M180.819366,96.243530 
	C180.589203,96.243561 180.328064,95.929504 180.031403,95.306839 
	C180.260071,95.308640 180.524231,95.619041 180.819366,96.243530 
z"
          />
          <path
            fill="#C4FAE4"
            opacity="1.000000"
            stroke="none"
            d="
M266.384644,288.947144 
	C266.166077,283.674683 266.157867,278.444336 266.150848,272.769043 
	C269.410919,272.313171 272.669830,272.302216 276.367645,272.357849 
	C276.950989,272.659241 277.148834,272.833313 277.641235,273.347839 
	C278.313416,277.116150 278.051147,280.431702 279.523865,283.843811 
	C280.660645,286.477509 278.048035,288.674103 274.930939,288.901123 
	C272.294250,289.093170 269.641815,289.069244 266.996368,289.140869 
	C266.996368,289.140869 266.595001,288.989227 266.384644,288.947144 
M274.641327,281.874695 
	C270.540436,280.365723 269.239258,281.710632 270.328522,286.145020 
	C272.827393,285.466644 277.039246,287.825317 274.641327,281.874695 
z"
          />
          <path
            fill="#C9F9E5"
            opacity="1.000000"
            stroke="none"
            d="
M285.037201,275.983612 
	C285.037201,275.983612 285.217590,275.724457 285.472656,275.304138 
	C287.473877,273.916443 289.220032,272.949097 290.966217,271.981750 
	C290.966217,271.981750 291.280212,272.182617 291.535889,272.573151 
	C293.460327,278.267365 295.129120,283.571075 296.797913,288.874756 
	C294.791016,288.921967 292.915131,289.698853 292.062775,286.400970 
	C291.383789,283.773804 286.873016,284.847687 284.599518,288.463684 
	C283.128876,288.874268 282.103058,288.857788 281.077240,288.841309 
	C281.077240,288.841309 281.066772,288.942657 281.146790,288.556000 
	C282.496918,284.107422 283.767059,280.045532 285.037201,275.983612 
z"
          />
          <path
            fill="#CDFAE7"
            opacity="1.000000"
            stroke="none"
            d="
M303.974945,272.125305 
	C305.053131,272.086700 306.131287,272.048126 307.783630,272.313171 
	C308.901825,272.749390 309.445831,272.881989 309.989868,273.014587 
	C310.350067,273.014618 310.636078,273.160339 310.926422,274.125244 
	C311.073181,275.988525 311.141357,277.178314 311.209534,278.368134 
	C307.895538,282.093964 312.635468,284.794525 312.556702,288.436768 
	C310.072815,289.465088 308.842010,288.279297 307.913422,285.902435 
	C307.292755,284.313721 305.858521,283.042816 304.831360,281.686432 
	C303.138519,284.791168 301.995178,286.888031 300.374115,288.509369 
	C299.935059,283.033356 299.973755,278.032867 300.368469,273.018738 
	C301.807953,272.711823 302.891449,272.418579 303.974945,272.125305 
M304.558990,279.427032 
	C305.928314,278.735474 307.297638,278.043915 309.635712,276.863129 
	C307.272858,275.534485 305.691376,274.645203 303.164856,273.224518 
	C303.656647,276.029510 303.905365,277.447998 304.558990,279.427032 
z"
          />
          <path
            fill="#2DB274"
            opacity="1.000000"
            stroke="none"
            d="
M300.012451,273.032379 
	C299.973755,278.032867 299.935059,283.033356 299.952087,288.493591 
	C299.205170,288.947571 298.402527,288.941833 297.198883,288.905457 
	C295.129120,283.571075 293.460327,278.267365 291.721191,272.593323 
	C293.191956,272.795319 294.733093,273.367706 296.862579,273.871582 
	C297.638611,273.533478 297.826324,273.263855 298.014038,272.994232 
	C298.014038,272.994232 298.029907,272.532257 298.034393,272.302002 
	C298.479828,272.049927 298.920746,272.028046 299.647400,272.270813 
	C299.959503,272.701080 299.985962,272.866730 300.012451,273.032379 
z"
          />
          <path
            fill="#2DB274"
            opacity="1.000000"
            stroke="none"
            d="
M284.717102,276.151062 
	C283.767059,280.045532 282.496918,284.107422 281.186310,288.523865 
	C276.638000,289.141144 272.130127,289.403900 267.309326,289.403748 
	C269.641815,289.069244 272.294250,289.093170 274.930939,288.901123 
	C278.048035,288.674103 280.660645,286.477509 279.523865,283.843811 
	C278.051147,280.431702 278.313416,277.116150 277.826355,273.424072 
	C278.508850,274.108673 279.462555,275.029236 279.926514,276.152191 
	C280.407593,277.316528 280.414246,278.676849 280.846863,281.252106 
	C282.613068,278.797668 283.505035,277.558105 284.717102,276.151062 
z"
          />
          <path
            fill="#D5FDEE"
            opacity="1.000000"
            stroke="none"
            d="
M251.016708,272.408508 
	C251.736389,272.275604 252.456085,272.142670 253.543137,272.022491 
	C254.900574,275.707520 255.890640,279.379791 256.885712,283.476440 
	C256.371124,284.111664 255.851547,284.322510 254.845062,284.740173 
	C253.853607,284.546417 253.349014,284.145874 252.874451,283.348663 
	C252.591385,280.986481 252.278305,279.020935 251.984711,277.031006 
	C252.004196,277.006592 251.948593,277.033783 251.889038,276.778381 
	C251.515518,276.110657 251.201569,275.698364 250.917740,274.927124 
	C250.970810,273.848297 250.993759,273.128387 251.016708,272.408508 
z"
          />
          <path
            fill="#2DB274"
            opacity="1.000000"
            stroke="none"
            d="
M281.250793,289.139740 
	C282.103058,288.857788 283.128876,288.874268 284.536011,288.836426 
	C283.752960,289.000854 282.588654,289.219513 281.250793,289.139740 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M354.979370,141.390747 
	C354.244629,141.062912 353.783173,140.572922 352.928467,139.764069 
	C359.101135,134.492508 359.563263,132.157974 355.938507,124.784126 
	C355.292877,123.470726 355.598663,121.689651 355.465149,120.124519 
	C357.129425,121.131149 359.010803,121.912308 360.377411,123.228104 
	C361.210693,124.030411 361.251312,125.655945 361.894714,127.230324 
	C360.380981,130.001785 357.444489,132.458023 362.557831,134.922668 
	C360.386261,137.044968 357.819458,139.136780 354.979370,141.390747 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M374.428711,135.718048 
	C374.050964,138.376236 372.924835,140.544113 369.143982,139.684601 
	C370.538116,138.277847 372.312561,137.010895 374.428711,135.718048 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M363.302765,134.961243 
	C364.370972,133.925888 365.783905,132.904617 367.554443,131.907684 
	C366.490540,132.946442 365.069000,133.960892 363.302765,134.961243 
z"
          />
          <path
            fill="#DBFDF0"
            opacity="1.000000"
            stroke="none"
            d="
M270.657349,206.171036 
	C269.874481,207.236786 269.316254,208.034027 268.228210,209.063065 
	C267.550201,209.620361 267.402008,209.945847 267.253815,210.271332 
	C267.253815,210.271332 267.127075,210.049942 266.841614,210.184357 
	C265.309906,210.112930 264.063629,209.907089 263.008606,209.443176 
	C262.133820,207.779678 261.067871,206.374268 260.007294,204.617950 
	C260.404694,203.494247 260.796722,202.721436 261.515869,202.089905 
	C268.162415,205.566147 271.930969,201.695389 272.413788,191.145767 
	C269.297150,191.145767 266.188904,191.145767 262.918945,190.962250 
	C261.868927,191.184753 260.980621,191.590790 259.820984,191.670746 
	C256.031158,191.179565 252.512665,191.014465 248.999268,190.478638 
	C249.021042,189.366714 249.037704,188.625473 249.494965,187.940689 
	C252.599045,187.953583 255.262558,187.910034 258.161621,188.159668 
	C259.983032,187.925110 261.568878,187.397354 263.595154,186.871490 
	C266.841980,186.873367 269.648407,186.873367 273.014771,186.873367 
	C271.913544,183.373337 271.293976,180.122559 269.846527,177.295685 
	C269.009644,175.661285 266.392853,173.365143 265.352570,173.709503 
	C262.483887,174.659042 259.792786,176.525421 262.058441,180.661026 
	C263.013062,182.403549 262.816681,184.776657 262.725098,186.905075 
	C261.467743,186.926254 260.628723,186.905472 259.818420,186.493057 
	C258.455841,178.210983 258.455841,178.210983 250.854797,178.381561 
	C250.920212,177.342316 250.942261,176.747498 251.299957,176.098511 
	C252.423599,175.717697 253.211578,175.391068 254.266357,174.855896 
	C253.990341,172.817535 253.447495,170.987701 252.907944,168.821381 
	C252.277939,167.987122 251.644638,167.489349 251.005661,166.995789 
	C251.000000,167.000000 251.008194,166.989059 251.016388,166.736176 
	C251.015213,166.314850 251.005814,166.146423 250.999390,165.990555 
	C251.002365,166.003098 250.977112,165.997833 251.289734,165.967636 
	C252.122955,165.613922 252.643539,165.290405 253.295074,164.964539 
	C253.426025,164.962204 253.685730,164.996307 253.944153,165.136414 
	C254.450455,165.577362 254.698334,165.878220 254.986694,166.472443 
	C255.443115,167.130096 255.859039,167.494400 256.535919,168.110626 
	C258.725250,173.069992 260.265991,173.350235 264.517853,169.073349 
	C261.225372,167.234146 258.123810,165.501602 255.234909,163.538910 
	C256.012024,162.492737 256.576538,161.676697 257.141022,160.860641 
	C259.831116,162.229355 262.521240,163.598083 265.546570,165.051147 
	C266.394836,165.698044 266.907867,166.260605 267.689819,166.931946 
	C272.582092,173.840927 276.123932,180.860138 276.172302,189.523865 
	C276.207275,195.791260 273.908630,200.855698 270.657349,206.171036 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M364.010010,118.281822 
	C364.613861,118.518883 365.210754,119.062904 365.710449,119.936691 
	C365.076508,119.707230 364.539795,119.148010 364.010010,118.281822 
z"
          />
          <path
            fill="#62C095"
            opacity="1.000000"
            stroke="none"
            d="
M360.629150,114.908501 
	C361.248749,114.982407 361.998108,115.312645 362.690613,116.020325 
	C362.008789,115.986786 361.383820,115.575813 360.629150,114.908501 
z"
          />
          <path
            fill="#D6F1E3"
            opacity="1.000000"
            stroke="none"
            d="
M118.725967,166.064606 
	C117.078667,166.743500 114.989090,167.392136 112.516724,168.153503 
	C112.944374,164.107010 116.239388,166.793777 118.725967,166.064606 
z"
          />
          <path
            fill="#B7F2D9"
            opacity="1.000000"
            stroke="none"
            d="
M93.037323,167.603195 
	C92.501694,167.069901 91.961311,166.193665 91.649200,165.132538 
	C92.262512,165.718506 92.647545,166.489380 93.037323,167.603195 
z"
          />
          <path
            fill="#D6F1E3"
            opacity="1.000000"
            stroke="none"
            d="
M111.495384,169.058258 
	C111.493668,169.994461 111.134766,171.011932 110.518364,172.247833 
	C110.553314,171.357330 110.845749,170.248428 111.495384,169.058258 
z"
          />
          <path
            fill="#B7F2D9"
            opacity="1.000000"
            stroke="none"
            d="
M93.342484,161.991577 
	C93.492973,161.359222 93.953529,160.687210 94.749725,160.072876 
	C94.607750,160.737671 94.130150,161.344788 93.342484,161.991577 
z"
          />
          <path
            fill="#B7F2D9"
            opacity="1.000000"
            stroke="none"
            d="
M96.079834,170.447449 
	C95.702927,170.421448 95.262688,170.100189 94.722031,169.508087 
	C95.086571,169.542221 95.551529,169.847198 96.079834,170.447449 
z"
          />
          <path
            fill="#B7F2D9"
            opacity="1.000000"
            stroke="none"
            d="
M104.702499,178.054398 
	C104.460266,178.154755 104.167236,177.959595 103.744522,177.530060 
	C103.960457,177.450089 104.306076,177.604477 104.702499,178.054398 
z"
          />
          <path
            fill="#D6F1E3"
            opacity="1.000000"
            stroke="none"
            d="
M110.121643,176.100220 
	C110.341499,176.056488 110.619072,176.264420 110.923828,176.737610 
	C110.693794,176.785904 110.436569,176.568893 110.121643,176.100220 
z"
          />
          <path
            fill="#D0FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M171.770538,287.854919 
	C168.592911,288.538177 165.442566,289.452026 162.229095,289.831818 
	C159.656372,290.135803 157.807037,289.074585 157.936768,285.909210 
	C158.086487,282.256012 157.986893,278.592621 158.464706,274.408508 
	C162.330338,273.570801 165.726822,273.258240 169.454803,273.095886 
	C170.447708,278.115692 171.109116,282.985291 171.770538,287.854919 
M163.887756,286.060974 
	C165.538651,285.293335 167.189560,284.525665 168.840469,283.758026 
	C167.460434,282.912201 166.038055,281.300507 164.708862,281.374023 
	C161.580673,281.547058 161.713120,283.621796 163.887756,286.060974 
M166.975311,276.080383 
	C166.085892,275.445709 165.196472,274.811005 164.307068,274.176331 
	C163.640976,275.502747 162.974869,276.829163 161.781281,279.205933 
	C164.222214,278.064575 165.613235,277.414185 166.975311,276.080383 
z"
          />
          <path
            fill="#37B980"
            opacity="1.000000"
            stroke="none"
            d="
M172.091141,287.984558 
	C171.109116,282.985291 170.447708,278.115692 169.252899,272.866302 
	C168.090439,272.036957 167.461365,271.587402 166.832306,271.137817 
	C169.624405,271.438324 172.416504,271.738831 175.571533,272.520996 
	C175.993256,278.315674 176.052032,283.628723 175.830231,288.971252 
	C175.361877,289.011902 175.174103,289.023071 174.986328,289.034210 
	C174.128128,288.727539 173.269943,288.420868 172.091141,287.984558 
M173.219238,274.190857 
	C173.405792,274.128784 173.592331,274.066742 173.778870,274.004669 
	C173.591492,273.945129 173.404114,273.885559 173.219238,274.190857 
z"
          />
          <path
            fill="#24B26F"
            opacity="1.000000"
            stroke="none"
            d="
M187.958740,282.987915 
	C187.892578,284.969574 187.826431,286.951202 187.385712,288.977966 
	C187.011169,289.023041 186.935089,288.929901 187.011047,288.519897 
	C185.554245,287.433685 183.994720,286.811096 182.497513,286.063690 
	C181.363663,285.497711 180.309296,284.772461 179.219543,284.118103 
	C180.193817,283.328949 181.088074,282.399414 182.162964,281.786774 
	C183.458725,281.048248 184.907822,280.578766 186.529938,280.017151 
	C187.165787,281.023651 187.562256,282.005768 187.958740,282.987915 
z"
          />
          <path
            fill="#01BE64"
            opacity="1.000000"
            stroke="none"
            d="
M188.367157,282.992371 
	C187.562256,282.005768 187.165787,281.023651 186.447144,279.768616 
	C186.071518,279.329681 186.018051,279.163666 185.964569,278.997620 
	C186.154037,278.118500 186.343506,277.239410 186.578522,276.148926 
	C188.623840,277.935883 190.384537,279.474182 192.664398,281.221130 
	C193.183594,281.429810 193.282303,281.910980 193.015579,282.018555 
	C192.510773,282.420380 192.272675,282.714630 192.034576,283.008850 
	C190.948242,283.004852 189.861893,283.000824 188.367157,282.992371 
z"
          />
          <path
            fill="#24B26F"
            opacity="1.000000"
            stroke="none"
            d="
M192.029968,283.427216 
	C192.272675,282.714630 192.510773,282.420380 193.262726,282.314880 
	C195.047607,284.153900 191.791672,288.412476 196.930786,287.931885 
	C196.993057,287.993774 197.117386,288.117859 197.117386,288.117859 
	C195.960861,288.639832 194.804337,289.161804 193.647827,289.683777 
	C193.106995,287.737701 192.566177,285.791626 192.029968,283.427216 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M166.620850,271.071411 
	C167.461365,271.587402 168.090439,272.036957 168.921387,272.716125 
	C165.726822,273.258240 162.330338,273.570801 158.535858,273.947510 
	C160.486328,272.995819 162.834778,271.980042 165.591171,270.900665 
	C165.999100,270.837097 166.409393,271.004974 166.620850,271.071411 
z"
          />
          <path
            fill="#01BE64"
            opacity="1.000000"
            stroke="none"
            d="
M199.150970,281.138580 
	C199.560349,281.093567 199.969742,281.048523 200.843521,281.235443 
	C201.829422,281.648773 202.350937,281.830170 202.872452,282.011536 
	C202.913071,282.757690 202.953690,283.503876 202.992676,284.623901 
	C201.933182,284.998322 200.875320,284.998840 199.413879,284.610352 
	C199.057190,283.193726 199.104080,282.166168 199.150970,281.138580 
z"
          />
          <path
            fill="#24B26F"
            opacity="1.000000"
            stroke="none"
            d="
M199.034302,281.028809 
	C199.104080,282.166168 199.057190,283.193726 199.017059,284.609283 
	C198.604233,285.967804 198.184647,286.938354 197.441223,288.013367 
	C197.117386,288.117859 196.993057,287.993774 196.961365,287.521118 
	C197.515244,284.931396 198.100800,282.814362 198.686371,280.697296 
	C198.686371,280.697296 198.917633,280.919037 199.034302,281.028809 
z"
          />
          <path
            fill="#24B26F"
            opacity="1.000000"
            stroke="none"
            d="
M175.284363,289.315002 
	C175.174103,289.023071 175.361877,289.011902 176.279022,288.988739 
	C180.317291,288.961121 183.626190,288.945496 186.935089,288.929871 
	C186.935089,288.929901 187.011169,289.023041 187.046173,289.072479 
	C183.248245,289.279877 179.415314,289.437836 175.284363,289.315002 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M248.689896,337.859924 
	C243.892960,338.450348 238.853455,338.693573 233.392365,338.900665 
	C233.778946,338.248108 234.584778,337.106476 235.395752,337.102814 
	C239.745575,337.083130 244.096680,337.346893 248.689896,337.859924 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M228.649887,340.012115 
	C227.925690,340.681396 226.819717,341.331970 225.388824,342.032654 
	C226.131973,341.386322 227.200027,340.689850 228.649887,340.012115 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M251.756531,338.710999 
	C251.085754,338.875061 250.195450,338.778839 249.088089,338.421143 
	C249.759689,338.256683 250.648331,338.353699 251.756531,338.710999 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M231.750458,339.016663 
	C231.298065,339.371948 230.495300,339.709808 229.354095,340.043640 
	C229.810471,339.692841 230.605270,339.346069 231.750458,339.016663 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M221.924896,343.946960 
	C221.940323,344.442291 221.732254,344.672546 221.195740,344.867004 
	C221.241455,344.534973 221.519501,344.151886 221.924896,343.946960 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M224.849594,342.113037 
	C225.010468,342.410461 224.813416,342.663910 224.233643,342.819611 
	C224.122910,342.534302 224.336502,342.316711 224.849594,342.113037 
z"
          />
          <path
            fill="#25B173"
            opacity="1.000000"
            stroke="none"
            d="
M263.413391,349.170837 
	C262.214630,351.885742 260.782928,352.058350 258.408722,350.407867 
	C247.698120,342.962036 236.879089,342.990601 225.961716,350.228577 
	C224.691696,351.070557 222.638748,350.731628 219.703384,351.093872 
	C228.849487,338.680084 251.400421,336.450134 263.413391,349.170837 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M249.779938,348.691711 
	C245.295242,348.973877 240.543518,348.973419 235.348236,348.925079 
	C239.774094,348.721161 244.643494,348.565125 249.779938,348.691711 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M234.506714,348.826050 
	C233.106812,349.849457 231.353058,350.874878 229.205566,351.826599 
	C230.592178,350.777924 232.372528,349.802979 234.506714,348.826050 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M252.433533,352.000305 
	C252.029816,351.486237 252.036880,350.970123 252.084351,350.067322 
	C253.325546,350.259705 254.526337,350.838806 255.934799,351.680054 
	C255.043076,351.960876 253.943680,351.979553 252.433533,352.000305 
z"
          />
          <path
            fill="#26B471"
            opacity="1.000000"
            stroke="none"
            d="
M258.214478,353.629089 
	C258.003204,353.689880 257.647339,353.487518 257.193298,352.983582 
	C257.420044,352.909943 257.744965,353.137909 258.214478,353.629089 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M300.371918,386.950684 
	C299.224792,386.404755 298.385773,385.682281 297.162537,384.927063 
	C299.276245,383.339844 301.774170,381.785370 304.272095,380.230865 
	C304.753754,380.466827 305.235413,380.702759 305.717072,380.938721 
	C305.274536,382.160522 305.117401,383.637421 304.313843,384.536591 
	C303.405426,385.553101 301.916504,386.050842 300.371918,386.950684 
z"
          />
          <path
            fill="#EAFDF7"
            opacity="1.000000"
            stroke="none"
            d="
M332.155518,372.904419 
	C332.155487,372.904419 331.753998,372.748199 331.544983,372.696350 
	C328.955475,370.459778 326.574982,368.275024 323.664215,365.603577 
	C325.297668,364.332275 327.105438,362.925293 328.119263,362.136261 
	C330.096680,365.023315 331.732056,367.411011 333.657928,370.252533 
	C333.350769,371.439056 332.753143,372.171753 332.155518,372.904419 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M332.170715,373.122498 
	C332.753143,372.171753 333.350769,371.439056 333.961365,370.406433 
	C334.136383,370.059753 334.298431,370.013000 334.710327,370.006104 
	C336.267273,371.503906 337.535583,372.999084 338.890686,374.410980 
	C340.865570,376.468567 340.272797,377.835663 337.489349,378.805908 
	C335.694733,377.261963 334.244019,375.703979 332.536072,373.956909 
	C332.278839,373.767792 332.185913,373.340576 332.170715,373.122498 
z"
          />
          <path
            fill="#01BE64"
            opacity="1.000000"
            stroke="none"
            d="
M321.014526,385.018982 
	C320.914612,385.056915 320.799744,385.077576 320.824860,385.035187 
	C320.964813,384.972137 320.999603,385.001678 321.014526,385.018982 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M156.645264,389.753784 
	C156.055130,390.579651 155.204758,391.214813 154.126190,391.703735 
	C154.222504,390.521729 154.547028,389.485931 154.871552,388.450134 
	C155.376053,388.821106 155.880539,389.192078 156.645264,389.753784 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M151.965942,389.752075 
	C151.791397,389.495514 151.633621,388.873169 151.707047,388.086578 
	C151.953064,388.410309 151.967880,388.898285 151.965942,389.752075 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M157.493988,382.029419 
	C157.421478,382.375549 157.052292,382.763275 156.398621,383.241028 
	C156.475174,382.911011 156.836243,382.490997 157.493988,382.029419 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M156.351028,376.788452 
	C156.260544,376.421997 156.397125,375.862610 156.739670,375.092041 
	C156.823120,375.452362 156.700607,376.023956 156.351028,376.788452 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M152.137131,387.864380 
	C151.964935,387.529999 152.022064,387.096008 152.224731,386.366669 
	C152.368988,386.635803 152.367722,387.200287 152.137131,387.864380 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M167.754669,390.763611 
	C167.778915,390.327728 168.126877,389.854370 168.747009,389.270477 
	C168.705582,389.682007 168.391983,390.204041 167.754669,390.763611 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M158.644714,379.198425 
	C158.765518,379.373383 158.670898,379.727112 158.359238,380.263367 
	C158.237900,380.089691 158.333603,379.733459 158.644714,379.198425 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M173.729218,389.093689 
	C173.886856,389.328674 173.718552,389.591064 173.213333,389.867310 
	C173.078415,389.640228 173.254028,389.386841 173.729218,389.093689 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M174.797638,388.103516 
	C174.962234,388.364868 174.779816,388.631866 174.234940,388.880707 
	C174.098557,388.626678 174.291275,388.375549 174.797638,388.103516 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M175.911346,387.138550 
	C175.947510,387.328705 175.731094,387.595398 175.263901,387.941956 
	C175.228348,387.752930 175.443542,387.484009 175.911346,387.138550 
z"
          />
          <path
            fill="#C4FAE4"
            opacity="1.000000"
            stroke="none"
            d="
M187.011047,288.519897 
	C183.626190,288.945496 180.317291,288.961121 176.559601,288.959229 
	C176.052032,283.628723 175.993256,278.315674 175.998444,272.546173 
	C176.062424,272.089722 176.525833,271.994324 176.747223,271.911285 
	C180.204025,271.828247 183.439438,271.828247 186.674866,271.828247 
	C186.906113,272.417267 187.137360,273.006256 187.368607,273.595276 
	C185.486938,274.650604 183.605270,275.705963 181.308411,276.994141 
	C182.561798,277.607574 183.907425,278.266113 185.608810,278.961151 
	C186.018051,279.163666 186.071518,279.329681 186.207779,279.744263 
	C184.907822,280.578766 183.458725,281.048248 182.162964,281.786774 
	C181.088074,282.399414 180.193817,283.328949 179.219543,284.118103 
	C180.309296,284.772461 181.363663,285.497711 182.497513,286.063690 
	C183.994720,286.811096 185.554245,287.433685 187.011047,288.519897 
z"
          />
          <path
            fill="#D0FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M207.349686,285.610870 
	C207.349686,285.610870 206.953827,285.788483 206.390381,285.478607 
	C205.548920,285.112610 205.270889,285.056519 204.992844,285.000397 
	C204.992844,285.000397 204.793091,284.774414 204.848663,284.282227 
	C204.643341,283.202545 204.382477,282.615051 204.121582,282.027588 
	C204.065857,281.571136 204.010147,281.114655 204.273529,280.068848 
	C204.720062,278.299957 204.847504,277.120483 204.974945,275.940979 
	C205.675018,274.951996 206.375107,273.963043 207.859192,272.967010 
	C211.090347,272.967865 213.537506,272.975739 215.984665,272.983643 
	C215.984665,272.983643 216.006027,272.986450 216.114761,273.213562 
	C216.651154,273.633453 217.078827,273.826233 217.757507,274.320129 
	C220.411346,278.974243 221.166382,283.189850 216.644836,286.945435 
	C215.856140,286.215149 215.399216,285.532410 215.070221,284.482239 
	C216.705154,280.872009 216.747162,277.483459 213.733826,275.471832 
	C212.632172,274.736389 209.909637,276.428955 207.724213,277.131775 
	C207.519104,277.797913 207.516342,278.346130 207.539444,279.168365 
	C207.536743,279.623657 207.508194,279.804932 207.316803,280.349243 
	C207.219193,282.345184 207.284439,283.978027 207.349686,285.610870 
z"
          />
          <path
            fill="#D5FDEE"
            opacity="1.000000"
            stroke="none"
            d="
M198.770004,280.319702 
	C198.100800,282.814362 197.515244,284.931396 196.899094,287.459229 
	C191.791672,288.412476 195.047607,284.153900 193.529449,282.207306 
	C193.282303,281.910980 193.183594,281.429810 193.032394,281.236633 
	C191.717438,278.770721 190.553665,276.498047 189.389893,274.225372 
	C189.689026,273.832123 189.988159,273.438873 190.287292,273.045624 
	C192.054520,274.612671 193.821747,276.179749 195.718872,277.861969 
	C196.193359,277.433258 197.031250,276.676208 198.853638,275.029663 
	C198.853638,277.367737 198.853638,278.654938 198.770004,280.319702 
z"
          />
          <path
            fill="#01BE64"
            opacity="1.000000"
            stroke="none"
            d="
M191.995163,269.004974 
	C191.996338,268.836823 191.997528,268.668640 192.000580,268.248108 
	C194.117432,267.567413 196.232437,267.139069 198.347427,266.710724 
	C198.492905,267.415222 198.638367,268.119751 198.783829,268.824280 
	C197.423080,269.221191 196.062332,269.618103 194.312164,270.034363 
	C193.493912,270.048462 193.065063,270.043182 192.316071,269.777191 
	C191.995667,269.346008 191.995422,269.175507 191.995163,269.004974 
z"
          />
          <path
            fill="#D0FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M213.978210,288.829529 
	C211.342209,288.984009 208.378433,290.143280 207.665146,286.201843 
	C208.653488,285.866119 208.944199,285.871063 209.434570,285.895386 
	C209.634232,285.914825 209.992386,286.095642 210.223434,286.339783 
	C211.629059,287.332489 212.803635,288.080994 213.978210,288.829529 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M214.296356,288.847351 
	C212.803635,288.080994 211.629059,287.332489 210.599731,286.304840 
	C212.144089,285.633728 213.543182,285.241699 214.942276,284.849701 
	C215.399216,285.532410 215.856140,286.215149 216.708893,287.200684 
	C217.098862,287.678864 217.093002,287.854218 217.087128,288.029541 
	C217.087128,288.029541 217.024963,288.014923 217.024643,288.047028 
	C216.221054,288.341156 215.417770,288.603180 214.296356,288.847351 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M215.707825,272.707947 
	C213.537506,272.975739 211.090347,272.967865 208.176086,272.921448 
	C210.283005,272.732697 212.856995,272.582489 215.707825,272.707947 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M207.380432,285.599182 
	C207.284439,283.978027 207.219193,282.345184 207.380829,280.748383 
	C207.830811,282.109497 208.053925,283.434540 208.067871,284.962463 
	C207.730759,285.311493 207.602829,285.457672 207.474884,285.603851 
	C207.474884,285.603851 207.411179,285.587494 207.380432,285.599182 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M204.752502,276.220581 
	C204.847504,277.120483 204.720062,278.299957 204.339264,279.727905 
	C204.233963,278.817596 204.382004,277.658905 204.752502,276.220581 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M202.809372,281.769470 
	C202.350937,281.830170 201.829422,281.648773 201.152771,281.229004 
	C201.580505,281.169586 202.163406,281.348480 202.809372,281.769470 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M217.506485,274.019043 
	C217.078827,273.826233 216.651154,273.633453 216.122925,273.220581 
	C216.187790,272.974609 216.353210,272.948730 216.767090,272.886475 
	C217.015549,272.850098 217.228760,273.100250 217.392395,273.349579 
	C217.556015,273.598907 217.506485,274.019043 217.506485,274.019043 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M204.090332,282.356140 
	C204.382477,282.615051 204.643341,283.202545 204.864944,284.132324 
	C204.570129,283.877991 204.314606,283.281342 204.090332,282.356140 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M205.082550,285.303162 
	C205.270889,285.056519 205.548920,285.112610 206.215591,285.350159 
	C206.126907,285.556335 205.649582,285.581116 205.082550,285.303162 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M209.234909,285.875977 
	C208.944199,285.871063 208.653488,285.866119 207.930664,285.791107 
	C207.498581,285.721008 207.525574,285.655090 207.500229,285.629456 
	C207.602829,285.457672 207.730759,285.311493 208.286530,285.089752 
	C208.887894,285.301453 209.061401,285.588715 209.234909,285.875977 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M191.775513,269.115875 
	C191.995422,269.175507 191.995667,269.346008 191.993683,269.772583 
	C191.991455,270.028717 191.495163,270.028931 191.246964,270.026123 
	C191.097229,269.696777 191.282928,269.431274 191.775513,269.115875 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M359.373657,328.140198 
	C359.339081,327.449127 359.683777,326.788239 360.240265,325.803284 
	C361.683380,326.034576 362.914703,326.589935 365.360596,327.693054 
	C362.550262,327.932281 361.151581,328.051331 359.373657,328.140198 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M354.364685,328.957397 
	C354.638153,328.653809 355.258728,328.397369 356.234894,328.191315 
	C355.964233,328.496002 355.338013,328.750275 354.364685,328.957397 
z"
          />
          <path
            fill="#D0FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M347.342499,343.177765 
	C346.289276,342.732147 345.236023,342.286560 344.109863,341.486420 
	C344.036896,341.131897 344.031647,341.046997 344.346191,341.018555 
	C345.109436,340.713470 345.558136,340.436829 346.006866,340.160187 
	C347.114655,339.842865 348.222412,339.525574 349.827118,339.431183 
	C350.544647,339.836700 350.797302,339.943268 351.082031,339.973785 
	C354.038544,342.057648 356.995056,344.141510 359.986755,346.848480 
	C360.244171,347.968018 360.466400,348.464447 360.688599,348.960876 
	C360.328705,350.530884 359.968811,352.100861 359.319214,353.864929 
	C358.492188,353.381653 357.954865,352.704346 357.111023,351.597290 
	C356.108490,345.964783 353.632690,343.874207 347.342499,343.177765 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M348.935669,358.391052 
	C350.432068,358.096954 352.239227,358.037720 354.491364,357.977722 
	C353.039703,358.193268 351.143097,358.409576 348.935669,358.391052 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M360.753784,348.677216 
	C360.466400,348.464447 360.244171,347.968018 360.034180,347.189240 
	C360.303925,347.402435 360.561432,347.898010 360.753784,348.677216 
z"
          />
          <path
            fill="#C8FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M345.710907,340.162659 
	C345.558136,340.436829 345.109436,340.713470 344.388611,341.021667 
	C344.549316,340.757202 344.982117,340.461182 345.710907,340.162659 
z"
          />
          <path
            fill="#C8FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M350.966064,339.778259 
	C350.797302,339.943268 350.544647,339.836700 350.190369,339.495178 
	C350.393524,339.185394 350.657959,339.267578 350.966064,339.778259 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M198.595642,401.641144 
	C197.685623,399.943054 197.122391,398.382568 196.559143,396.822113 
	C197.187988,396.427856 197.816849,396.033600 198.445694,395.639343 
	C199.927277,396.905762 201.408859,398.172211 202.890442,399.438660 
	C201.574417,400.218689 200.258408,400.998749 198.595642,401.641144 
z"
          />
          <path
            fill="#1EB56E"
            opacity="1.000000"
            stroke="none"
            d="
M141.338791,367.411072 
	C144.100952,364.773102 146.714905,363.958893 149.304153,366.877502 
	C152.245468,370.193024 149.827545,372.689789 147.677261,374.967133 
	C145.579010,377.189423 142.875427,378.368134 140.344208,375.855621 
	C137.555939,373.087982 138.459457,370.202606 141.338791,367.411072 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M238.093521,287.951477 
	C234.318008,290.855957 232.792114,287.476746 231.101501,285.258118 
	C229.731888,283.460754 228.821976,281.313080 227.423630,278.810059 
	C227.867111,277.364166 228.595108,276.429047 229.323105,275.493896 
	C230.664337,277.084808 232.005569,278.675751 233.318726,280.233368 
	C235.921967,277.955841 231.210052,272.789795 237.391495,272.578552 
	C237.917084,278.039093 238.005310,282.995300 238.093521,287.951477 
z"
          />
          <path
            fill="#D0FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M250.634201,272.255371 
	C250.993759,273.128387 250.970810,273.848297 250.491913,274.847778 
	C246.854202,274.496063 245.447723,275.693970 245.780746,279.018188 
	C246.009979,281.306427 245.964188,283.622223 245.976105,286.285217 
	C244.640762,287.092194 243.370590,287.539612 242.100433,287.987061 
	C242.100433,287.987061 241.919678,287.538910 241.918396,286.839233 
	C241.982040,281.447723 242.046951,276.755859 242.111877,272.064026 
	C242.675705,271.932465 243.239548,271.800873 243.918655,271.397583 
	C246.106522,271.451324 248.179108,271.776794 250.634201,272.255371 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M229.249420,275.152771 
	C228.595108,276.429047 227.867111,277.364166 227.128510,278.650513 
	C227.117889,282.083893 227.117889,285.166016 227.117889,289.217163 
	C225.422409,288.571350 224.324554,288.153168 223.189713,286.997314 
	C223.069519,285.497253 222.986328,284.734924 222.966278,283.649292 
	C222.992783,282.889954 222.956146,282.453949 222.987091,281.761047 
	C223.004578,281.334351 222.954468,281.164490 222.971756,280.668274 
	C223.015762,279.900513 222.992355,279.459076 223.046509,278.757507 
	C223.077606,278.322449 223.031189,278.147522 223.041534,277.652161 
	C223.037811,276.904388 222.977325,276.477020 223.012787,275.677826 
	C223.079803,274.544617 223.050842,273.783234 223.021881,273.021881 
	C225.812088,271.077820 227.862381,271.677826 229.249420,275.152771 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M241.675064,272.042999 
	C242.046951,276.755859 241.982040,281.447723 241.847000,286.608398 
	C240.746307,287.285034 239.715744,287.492798 238.389343,287.826019 
	C238.005310,282.995300 237.917084,278.039093 237.786102,272.633942 
	C238.908325,272.130646 240.073288,272.076324 241.675064,272.042999 
z"
          />
          <path
            fill="#24B26F"
            opacity="1.000000"
            stroke="none"
            d="
M222.903137,283.972595 
	C222.986328,284.734924 223.069519,285.497253 223.063812,286.635681 
	C221.263260,287.346100 219.551605,287.680450 217.463531,288.022186 
	C217.093002,287.854218 217.098862,287.678864 217.040665,287.248291 
	C221.166382,283.189850 220.411346,278.974243 217.757507,274.320129 
	C217.506485,274.019043 217.556015,273.598907 217.552277,273.387665 
	C219.137909,273.137848 220.727310,273.099304 222.669281,273.041321 
	C223.050842,273.783234 223.079803,274.544617 222.638138,275.753876 
	C220.208054,280.358734 220.455612,282.973907 222.903137,283.972595 
z"
          />
          <path
            fill="#C4FAE4"
            opacity="1.000000"
            stroke="none"
            d="
M264.616516,228.672241 
	C265.238953,229.444168 265.455872,230.295410 265.587158,231.478058 
	C253.969284,236.510742 242.312347,237.049316 230.582626,232.662842 
	C229.597046,232.294296 228.969208,230.969116 228.175156,230.088379 
	C229.293930,229.747086 230.634613,228.823700 231.497803,229.152786 
	C242.484482,233.341537 253.349899,232.205353 264.616516,228.672241 
z"
          />
          <path
            fill="#A9F9D6"
            opacity="1.000000"
            stroke="none"
            d="
M311.450500,278.096558 
	C311.141357,277.178314 311.073181,275.988525 311.024475,274.353546 
	C311.259766,275.213928 311.475616,276.519440 311.450500,278.096558 
z"
          />
          <path
            fill="#A9F9D6"
            opacity="1.000000"
            stroke="none"
            d="
M309.952240,272.815521 
	C309.445831,272.881989 308.901825,272.749390 308.181946,272.390686 
	C308.421112,272.145752 308.836121,272.126923 309.562439,272.160706 
	C309.873779,272.213348 309.914612,272.616455 309.952240,272.815521 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M242.256348,288.376770 
	C243.370590,287.539612 244.640762,287.092194 246.360397,286.303619 
	C248.821396,285.223450 250.832916,284.484406 252.844421,283.745331 
	C253.349014,284.145874 253.853607,284.546417 254.692596,284.978760 
	C253.272720,286.334351 251.689178,288.272858 249.719177,288.820038 
	C247.462570,289.446777 244.862885,288.838348 242.256348,288.376770 
z"
          />
          <path
            fill="#EAFDF7"
            opacity="1.000000"
            stroke="none"
            d="
M250.964325,176.152679 
	C250.942261,176.747498 250.920212,177.342316 250.588867,178.445251 
	C249.738083,179.646866 249.196594,180.340347 248.536316,181.125214 
	C248.257278,181.520416 248.329010,181.768646 248.679047,182.311310 
	C248.674393,183.126648 248.623428,183.591949 248.385818,184.187592 
	C248.324036,184.890228 248.448898,185.462540 248.686234,186.333771 
	C248.883926,187.049881 248.969147,187.467056 249.054367,187.884247 
	C249.037704,188.625473 249.021042,189.366714 248.658035,190.715271 
	C248.198364,192.938965 247.884048,194.571182 248.009964,196.168686 
	C248.366455,200.691574 252.803604,198.202896 254.932068,199.850952 
	C255.157410,200.025406 257.052216,198.043747 258.441711,196.916718 
	C258.778534,196.178268 258.846130,195.585480 259.041443,194.695404 
	C259.476837,193.597687 259.784576,192.797272 260.092316,191.996826 
	C260.980621,191.590790 261.868927,191.184753 262.896851,191.363037 
	C262.420563,195.281113 261.804626,198.614868 261.188721,201.948639 
	C260.796722,202.721436 260.404694,203.494247 259.775085,204.750885 
	C259.097076,205.535477 258.656677,205.836243 257.840027,206.081467 
	C256.872009,205.589737 256.280243,205.153549 255.655975,204.369370 
	C253.277786,203.243729 250.932098,202.466049 248.016891,201.499557 
	C248.016891,205.510056 248.016891,208.254074 247.791443,211.265472 
	C246.656464,211.663681 245.746964,211.794510 244.908875,211.486313 
	C244.942291,208.093872 244.904297,205.140427 244.900787,201.762741 
	C244.963501,198.224686 244.991714,195.110870 245.017792,191.583618 
	C245.249161,189.572296 245.746338,187.954742 245.629013,186.383057 
	C245.542023,185.217789 244.656616,184.112122 244.044189,182.734604 
	C243.911713,182.324112 243.861938,182.158936 243.897888,181.673065 
	C243.960968,180.911713 243.938324,180.471039 244.216156,179.774536 
	C244.584808,178.217285 244.652969,176.915863 244.797943,175.257324 
	C244.977890,173.932419 245.081024,172.964645 245.402786,171.763397 
	C245.460693,170.357086 245.299988,169.184280 245.079926,167.731750 
	C244.493576,163.705124 243.158890,167.413193 241.904114,167.077637 
	C241.017700,166.316238 240.481339,165.629562 239.946655,164.737518 
	C239.948334,164.532135 239.907486,164.123398 239.907486,164.123398 
	C238.651779,163.338364 237.396057,162.553345 236.081421,161.430725 
	C242.046432,160.743027 248.070374,160.392899 254.757156,160.326874 
	C255.990067,160.703293 256.560120,160.795609 257.130188,160.887924 
	C257.130188,160.887924 257.121124,160.890640 257.131073,160.875641 
	C256.576538,161.676697 256.012024,162.492737 254.938324,163.658905 
	C254.181335,164.338120 253.933533,164.667221 253.685730,164.996307 
	C253.685730,164.996307 253.426025,164.962204 252.973953,165.002823 
	C252.006958,165.361572 251.492035,165.679703 250.977112,165.997833 
	C250.977112,165.997833 251.002365,166.003098 250.753937,165.977676 
	C250.505493,165.952255 250.015762,165.996201 249.672043,166.091522 
	C249.121582,167.102310 248.914856,168.017776 248.370834,169.022354 
	C248.257889,170.769943 248.482239,172.428421 248.869583,174.388962 
	C249.657227,174.912201 250.281860,175.133377 250.904221,175.555298 
	C250.901932,175.756042 250.964325,176.152679 250.964325,176.152679 
z"
          />
          <path
            fill="#DBFDF0"
            opacity="1.000000"
            stroke="none"
            d="
M256.961548,160.630890 
	C256.560120,160.795609 255.990067,160.703293 255.222519,160.391235 
	C255.614334,160.238953 256.203613,160.306412 256.961548,160.630890 
z"
          />
          <path
            fill="#45B581"
            opacity="1.000000"
            stroke="none"
            d="
M136.758774,356.819855 
	C134.847092,356.614075 133.135330,356.296844 131.609634,355.582275 
	C131.331024,355.451782 131.454041,353.228027 132.018234,352.803711 
	C133.036530,352.037964 134.527954,351.901398 135.821777,351.502045 
	C136.222046,353.191986 136.622330,354.881927 136.758774,356.819855 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M245.294617,356.326233 
	C248.035004,357.487335 250.379639,358.548706 252.724274,359.610046 
	C252.706573,360.240631 252.688889,360.871185 252.671188,361.501770 
	C251.025101,361.683746 249.061325,362.530609 247.792038,361.924072 
	C243.855270,360.042877 240.260010,360.232483 236.367096,361.954437 
	C235.145935,362.494598 233.396362,361.840179 230.730438,361.649811 
	C235.346817,356.132690 239.992813,355.782318 245.294617,356.326233 
z"
          />
          <path
            fill="#A9F9D6"
            opacity="1.000000"
            stroke="none"
            d="
M245.774384,378.877563 
	C244.703735,378.841003 243.500580,379.344910 242.765396,378.958496 
	C240.633606,377.837921 237.739395,376.755768 236.966248,374.899628 
	C236.322922,373.355194 237.679703,369.779694 239.208984,368.855804 
	C240.828903,367.877075 244.593063,368.119690 245.785431,369.378174 
	C247.132751,370.800232 246.733292,373.941071 246.921600,376.347900 
	C246.963303,376.880890 246.285065,377.470215 245.839813,378.377808 
	C245.741287,378.721954 245.855652,379.011292 245.774384,378.877563 
M241.704559,370.256195 
	C239.424561,371.341064 237.951843,373.009674 239.995697,375.204895 
	C240.665665,375.924530 243.507111,375.851837 244.194183,375.091736 
	C246.126328,372.954193 245.088867,371.165314 241.704559,370.256195 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M377.621918,312.268677 
	C377.727478,313.163452 377.593506,314.308502 377.221741,315.709778 
	C377.116760,314.816986 377.249573,313.667999 377.621918,312.268677 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M374.258789,314.927948 
	C374.120026,314.826019 374.130524,314.656769 374.260620,314.263000 
	C374.667236,314.312378 374.676514,314.586395 374.258789,314.927948 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M228.001724,412.867401 
	C225.386108,415.178436 222.756851,415.555115 220.288162,412.724823 
	C218.322479,410.471161 218.813919,404.667236 221.296097,402.677521 
	C224.219757,400.333893 226.788742,401.345184 229.065430,404.391632 
	C229.229630,404.685791 229.089294,404.903229 228.685364,404.961945 
	C226.086456,404.083527 223.609528,402.619049 222.087204,405.601807 
	C221.417664,406.913666 221.431396,409.949921 222.116119,410.303650 
	C223.767471,411.156647 225.997040,410.890289 227.994751,411.374054 
	C227.997955,412.070984 227.999847,412.469208 228.001724,412.867401 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M228.353546,412.890472 
	C227.999847,412.469208 227.997955,412.070984 228.327942,411.341614 
	C229.105652,410.999908 229.551483,410.989380 229.997330,410.978882 
	C230.008087,411.363434 230.018860,411.747986 230.062424,412.417419 
	C229.631943,412.772675 229.168640,412.843109 228.353546,412.890472 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M289.000702,400.419891 
	C289.324493,399.706085 289.648468,399.187042 289.998413,398.338104 
	C289.872009,399.069550 289.719574,400.130859 289.291687,401.098022 
	C289.016205,401.003876 289.000854,400.614655 289.000702,400.419891 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M233.921783,161.081085 
	C233.625778,161.569382 232.917770,162.008514 231.905579,162.466431 
	C231.475784,162.253036 231.350143,162.020859 231.129150,161.404709 
	C231.859116,161.024475 232.684448,161.028198 233.921783,161.081085 
z"
          />
          <path
            fill="#CDFAE7"
            opacity="1.000000"
            stroke="none"
            d="
M235.611511,402.946320 
	C235.983002,402.440552 236.174271,402.221344 236.425354,401.774567 
	C239.979660,400.787903 243.438766,399.997894 247.310638,399.276123 
	C255.258331,405.809326 254.685303,414.822510 246.540451,418.174561 
	C242.183167,419.967865 238.561905,419.304260 235.701294,414.873932 
	C235.474380,410.826660 235.470551,407.045227 235.611511,402.946320 
M243.387817,415.696106 
	C248.106491,413.958954 250.177658,409.347260 247.677414,405.278778 
	C246.880432,403.981934 244.854599,402.861145 243.324829,402.769867 
	C242.009201,402.691406 240.076996,403.867981 239.332977,405.060699 
	C237.418198,408.130219 239.193710,413.227417 243.387817,415.696106 
z"
          />
          <path
            fill="#1EB56E"
            opacity="1.000000"
            stroke="none"
            d="
M347.095398,343.429565 
	C353.632690,343.874207 356.108490,345.964783 356.758606,351.541809 
	C352.815216,355.422272 349.855347,355.495514 346.261871,351.948151 
	C343.331665,349.055511 343.628387,346.222839 347.095398,343.429565 
z"
          />
          <path
            fill="#E5F6EE"
            opacity="1.000000"
            stroke="none"
            d="
M117.985809,315.581512 
	C116.583595,316.937653 115.177155,317.903870 113.467361,318.972992 
	C112.479355,318.622406 111.794701,318.168854 111.075760,317.385223 
	C111.142433,316.156952 111.243393,315.258759 111.381271,314.032166 
	C113.335678,314.119202 116.222397,310.566345 117.985809,315.581512 
z"
          />
          <path
            fill="#2DB274"
            opacity="1.000000"
            stroke="none"
            d="
M290.932861,271.618439 
	C289.220032,272.949097 287.473877,273.916443 285.460815,275.146698 
	C285.821198,273.365784 286.448486,271.321960 287.075775,269.278137 
	C288.350342,269.937134 289.624939,270.596130 290.932861,271.618439 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M297.791809,273.105103 
	C297.826324,273.263855 297.638611,273.533478 297.222595,273.906311 
	C297.100708,273.683105 297.292450,273.418579 297.791809,273.105103 
z"
          />
          <path
            fill="#DBFDF0"
            opacity="1.000000"
            stroke="none"
            d="
M183.568695,387.038940 
	C184.723557,388.144470 185.464371,389.248810 186.093872,390.640503 
	C185.245026,390.934326 184.507477,390.940765 183.203339,390.705017 
	C179.904938,392.088928 178.836075,393.717285 182.630203,395.352142 
	C182.630203,395.352142 182.673798,395.419159 182.758301,395.756470 
	C182.545425,396.613892 182.092636,397.620270 181.973679,397.582245 
	C179.669037,396.845642 177.323975,397.087891 177.375549,399.756439 
	C177.403595,401.207581 179.707123,402.614746 180.984314,404.041748 
	C181.951294,404.829620 182.918274,405.617493 184.717224,407.083252 
	C179.717026,408.374969 177.122528,404.979858 173.535004,403.870697 
	C175.225739,398.318115 177.174667,392.790039 179.448868,387.399170 
	C179.678635,386.854523 181.872360,387.138367 183.568695,387.038940 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M180.934021,403.687592 
	C179.707123,402.614746 177.403595,401.207581 177.375549,399.756439 
	C177.323975,397.087891 179.669037,396.845642 181.973679,397.582245 
	C182.092636,397.620270 182.545425,396.613892 182.763428,395.796143 
	C183.516953,395.083252 184.349869,394.668030 185.975235,393.857788 
	C185.724152,396.267426 185.548080,397.957275 185.354538,399.814667 
	C183.314667,399.550110 181.469482,399.310822 178.587799,398.937073 
	C179.663315,400.996552 180.273514,402.164978 180.934021,403.687592 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M182.751068,394.917664 
	C178.836075,393.717285 179.904938,392.088928 182.833847,390.702576 
	C182.977951,392.122620 182.924942,393.302887 182.751068,394.917664 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M293.148560,396.920471 
	C293.338287,396.931122 293.553131,397.215607 293.803650,397.769348 
	C293.617432,397.757202 293.395538,397.475769 293.148560,396.920471 
z"
          />
          <path
            fill="#B2E2CA"
            opacity="1.000000"
            stroke="none"
            d="
M210.547211,66.821198 
	C209.881180,67.550255 208.839447,68.257660 207.479431,69.024170 
	C208.164612,68.322029 209.168076,67.560791 210.547211,66.821198 
z"
          />
          <path
            fill="#A9F9D6"
            opacity="1.000000"
            stroke="none"
            d="
M300.368469,273.018738 
	C299.985962,272.866730 299.959503,272.701080 299.978424,272.288269 
	C301.082275,272.014679 302.140778,271.988281 303.587097,272.043610 
	C302.891449,272.418579 301.807953,272.711823 300.368469,273.018738 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M230.209778,410.703674 
	C229.551483,410.989380 229.105652,410.999908 228.326630,411.042877 
	C225.997040,410.890289 223.767471,411.156647 222.116119,410.303650 
	C221.431396,409.949921 221.417664,406.913666 222.087204,405.601807 
	C223.609528,402.619049 226.086456,404.083527 228.615631,405.070953 
	C231.123703,406.423370 233.991516,407.532959 230.209778,410.703674 
z"
          />
          <path
            fill="#E1F4EA"
            opacity="1.000000"
            stroke="none"
            d="
M224.116928,84.070595 
	C224.532761,84.206573 224.939392,84.711380 225.435623,85.535843 
	C225.052734,85.383469 224.580231,84.911446 224.116928,84.070595 
z"
          />
          <path
            fill="#8FB4A4"
            opacity="1.000000"
            stroke="none"
            d="
M291.775360,80.091377 
	C292.393890,82.328178 292.740417,84.743431 293.229950,88.155441 
	C290.860168,87.156136 289.484863,86.576195 287.473114,85.727875 
	C289.056915,83.582977 290.280151,81.926407 291.775360,80.091377 
z"
          />
          <path
            fill="#F4FEFA"
            opacity="1.000000"
            stroke="none"
            d="
M244.837448,211.925323 
	C245.746964,211.794510 246.656464,211.663681 248.115677,211.393768 
	C249.091568,211.420029 249.517761,211.585388 250.102188,212.030945 
	C251.302002,212.573318 252.343597,212.835510 253.350586,213.315598 
	C253.514053,213.771362 253.765717,213.916061 254.068390,214.338562 
	C254.039307,215.450851 254.012817,216.192154 253.986328,216.933456 
	C250.290527,217.316086 246.594711,217.698700 242.451248,218.039841 
	C241.323227,216.820435 240.642853,215.642487 239.813904,213.927414 
	C239.472580,213.188644 239.243927,213.043655 238.979340,212.955307 
	C238.979340,212.955307 238.983887,213.013214 238.999359,212.634872 
	C238.996002,211.503510 238.977142,210.750488 239.323242,210.014786 
	C241.404633,210.663177 243.121033,211.294250 244.837448,211.925323 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M254.383484,217.021500 
	C254.012817,216.192154 254.039307,215.450851 254.247864,214.193954 
	C254.684372,213.493713 254.884018,213.261871 255.017090,212.990768 
	C255.005325,212.998688 254.986267,213.019745 255.255432,213.148422 
	C256.164001,213.419907 257.019806,213.898026 257.406128,213.648697 
	C259.278992,212.439972 261.025848,211.036011 262.817383,209.701263 
	C264.063629,209.907089 265.309906,210.112930 266.925720,210.280243 
	C263.123779,212.530991 258.952209,214.820267 254.383484,217.021500 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M267.497925,210.166351 
	C267.402008,209.945847 267.550201,209.620361 267.964294,209.210052 
	C268.067474,209.437286 267.904785,209.749313 267.497925,210.166351 
z"
          />
          <path
            fill="#12B969"
            opacity="1.000000"
            stroke="none"
            d="
M194.718689,223.329788 
	C197.022644,215.514679 200.261398,213.724182 209.304703,214.870331 
	C213.073669,215.348007 216.295486,219.768677 216.790543,224.875732 
	C217.209808,229.200867 215.309738,231.558640 211.054749,231.855774 
	C208.245285,232.051941 205.412582,231.931290 202.590332,231.924927 
	C195.627563,231.909225 194.619308,230.863342 194.718689,223.329788 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M210.774567,207.503738 
	C208.424347,208.893402 206.174927,210.667297 203.963394,210.621262 
	C202.640778,210.593735 200.329254,207.696075 200.359985,206.125641 
	C200.396194,204.273972 202.076523,201.781754 203.764481,200.773926 
	C207.376404,198.617355 210.603058,201.668015 210.774567,207.503738 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M230.986938,162.384888 
	C228.472321,165.273575 225.571716,168.022217 222.375748,170.930450 
	C222.300629,165.543610 224.037842,163.740219 230.986938,162.384888 
z"
          />
          <path
            fill="#1AB76C"
            opacity="1.000000"
            stroke="none"
            d="
M221.847733,171.153839 
	C221.965729,171.383484 221.828094,171.714874 221.428329,172.137360 
	C221.308167,171.904160 221.450134,171.579865 221.847733,171.153839 
z"
          />
          <path
            fill="#0DB867"
            opacity="1.000000"
            stroke="none"
            d="
M223.934357,201.049820 
	C223.580902,200.364059 223.227432,199.678299 222.899109,198.310379 
	C222.529892,196.787598 222.135529,195.946960 221.741165,195.106339 
	C221.539337,194.608414 221.337509,194.110489 221.536743,193.316833 
	C224.582550,193.034744 227.227295,193.048355 229.962036,193.059265 
	C230.052002,193.056580 230.208023,192.966782 230.168091,193.298981 
	C230.141022,194.077164 230.153900,194.523148 229.874512,195.182098 
	C229.725113,197.595886 229.867996,199.796692 229.763901,202.009888 
	C229.516937,202.022247 229.029221,202.104233 228.773972,202.084259 
	C228.349060,202.082962 228.179413,202.101639 227.606567,202.113678 
	C226.398682,202.167786 225.593948,202.228531 224.789230,202.289276 
	C224.789230,202.289276 224.839966,202.257233 224.787933,201.973450 
	C224.468719,201.476395 224.201538,201.263107 223.934357,201.049820 
z"
          />
          <path
            fill="#45B581"
            opacity="1.000000"
            stroke="none"
            d="
M224.894409,202.604736 
	C225.593948,202.228531 226.398682,202.167786 227.720825,202.306046 
	C228.440781,202.740402 228.691315,202.900864 229.139603,203.140625 
	C229.289352,203.294815 229.590912,203.601181 229.442871,203.920227 
	C232.850784,204.702591 235.508560,206.445374 237.273941,209.617935 
	C237.471436,209.972855 238.434998,209.901505 239.016769,210.034866 
	C238.990219,210.041916 238.958282,209.997467 238.958282,209.997467 
	C238.977142,210.750488 238.996002,211.503510 239.028351,212.632858 
	C234.077301,212.391678 230.227066,210.190018 227.843674,205.580368 
	C227.281921,204.493912 225.967667,203.796539 224.894409,202.604736 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M229.872040,193.061966 
	C227.227295,193.048355 224.582550,193.034744 221.562134,193.041504 
	C221.102768,192.880783 221.019028,192.699707 220.819672,192.242599 
	C220.704056,191.966553 220.868637,191.499008 221.391068,191.220825 
	C224.587448,190.973206 227.261414,191.003769 229.971573,191.372894 
	C229.962540,192.161621 229.917297,192.611801 229.872040,193.061966 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M221.748535,195.461212 
	C222.135529,195.946960 222.529892,196.787598 222.853882,198.013611 
	C222.441010,197.538025 222.098465,196.677048 221.748535,195.461212 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M223.978134,201.309265 
	C224.201538,201.263107 224.468719,201.476395 224.765305,201.953735 
	C224.537109,202.001434 224.279495,201.785065 223.978134,201.309265 
z"
          />
          <path
            fill="#45B581"
            opacity="1.000000"
            stroke="none"
            d="
M239.022781,213.165497 
	C239.243927,213.043655 239.472580,213.188644 239.736328,213.582230 
	C239.506714,213.740967 239.259674,213.608124 239.022781,213.165497 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M221.022797,187.073273 
	C221.273865,184.677261 221.524933,182.281250 221.965851,179.580612 
	C223.452271,177.273636 224.748810,175.271301 226.246201,172.958786 
	C228.044067,173.991623 229.669113,174.925186 231.656128,176.199127 
	C232.018127,176.539505 232.116760,177.007187 231.921661,177.333405 
	C231.118744,180.709305 230.510925,183.758972 229.534668,186.844467 
	C228.431885,186.960449 227.697540,187.040619 226.540848,187.067505 
	C224.419937,187.033890 222.721359,187.053574 221.022797,187.073273 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M239.542389,164.098373 
	C239.907486,164.123398 239.948334,164.532135 239.648895,164.877899 
	C237.955154,167.169937 236.560852,169.116211 235.006622,171.247131 
	C234.332764,171.822891 233.818832,172.214005 233.304901,172.605103 
	C231.993591,171.680649 230.682281,170.756195 228.399780,169.147064 
	C232.508652,167.212738 235.842972,165.643051 239.542389,164.098373 
z"
          />
          <path
            fill="#F0F8F6"
            opacity="1.000000"
            stroke="none"
            d="
M233.009872,172.732330 
	C233.818832,172.214005 234.332764,171.822891 235.351593,171.310852 
	C236.260834,172.457153 236.665192,173.724365 236.894318,175.304825 
	C235.184967,176.081116 233.650864,176.544144 232.116760,177.007172 
	C232.116760,177.007187 232.018127,176.539505 231.981186,176.303131 
	C232.201111,174.997696 232.457977,173.928635 233.009872,172.732330 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M226.963196,187.120789 
	C227.697540,187.040619 228.431885,186.960449 229.582733,187.184387 
	C229.977951,188.670441 229.956650,189.852371 229.935364,191.034317 
	C227.261414,191.003769 224.587448,190.973206 221.469574,190.985779 
	C221.039764,190.276993 221.053894,189.525085 221.474411,188.391083 
	C223.574936,187.712906 225.269073,187.416840 226.963196,187.120789 
z"
          />
          <path
            fill="#C8FBE8"
            opacity="1.000000"
            stroke="none"
            d="
M226.540848,187.067490 
	C225.269073,187.416840 223.574936,187.712906 221.494232,188.015381 
	C221.107635,188.021790 221.036224,187.550018 221.029510,187.311646 
	C222.721359,187.053574 224.419937,187.033890 226.540848,187.067490 
z"
          />
          <path
            fill="#4DB783"
            opacity="1.000000"
            stroke="none"
            d="
M374.454346,174.456192 
	C373.020294,172.551071 371.908783,170.776703 370.283600,168.182312 
	C372.567596,167.478210 374.834534,165.998535 376.096039,166.606171 
	C377.404236,167.236328 378.309052,169.898544 378.277649,171.652084 
	C378.259766,172.650955 376.017517,173.609970 374.454346,174.456192 
z"
          />
          <path
            fill="#58BA8C"
            opacity="1.000000"
            stroke="none"
            d="
M387.036041,165.484497 
	C386.379181,166.885086 385.639343,167.921829 384.899506,168.958557 
	C383.570007,167.548752 382.240540,166.138947 380.540833,164.336548 
	C382.503113,163.231216 383.713531,162.549393 385.362000,161.620819 
	C385.942352,162.897400 386.447693,164.009018 387.036041,165.484497 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M274.988403,282.079742 
	C277.039246,287.825317 272.827393,285.466644 270.328522,286.145020 
	C269.239258,281.710632 270.540436,280.365723 274.988403,282.079742 
z"
          />
          <path
            fill="#A9F9D6"
            opacity="1.000000"
            stroke="none"
            d="
M304.356537,279.146790 
	C303.905365,277.447998 303.656647,276.029510 303.164856,273.224518 
	C305.691376,274.645203 307.272858,275.534485 309.635712,276.863129 
	C307.297638,278.043915 305.928314,278.735474 304.356537,279.146790 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M252.874451,283.348663 
	C250.832916,284.484406 248.821396,285.223450 246.425598,285.944092 
	C245.964188,283.622223 246.009979,281.306427 245.780746,279.018188 
	C245.447723,275.693970 246.854202,274.496063 250.461777,275.206726 
	C251.201569,275.698364 251.515518,276.110657 251.477570,276.775146 
	C249.789642,277.586334 247.299026,278.203644 247.323776,278.693939 
	C247.415512,280.511139 248.336456,282.286499 248.945877,284.077576 
	C249.398743,284.011322 249.851593,283.945068 250.304459,283.878815 
	C250.858032,281.604340 251.411621,279.329895 251.965225,277.055420 
	C252.278305,279.020935 252.591385,280.986481 252.874451,283.348663 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M263.143494,186.863113 
	C262.816681,184.776657 263.013062,182.403549 262.058441,180.661026 
	C259.792786,176.525421 262.483887,174.659042 265.352570,173.709503 
	C266.392853,173.365143 269.009644,175.661285 269.846527,177.295685 
	C271.293976,180.122559 271.913544,183.373337 273.014771,186.873367 
	C269.648407,186.873367 266.841980,186.873367 263.526306,186.937073 
	C263.017090,187.000778 263.143494,186.863113 263.143494,186.863113 
z"
          />
          <path
            fill="#20B16D"
            opacity="1.000000"
            stroke="none"
            d="
M261.515839,202.089905 
	C261.804626,198.614868 262.420563,195.281113 263.058563,191.546570 
	C266.188904,191.145767 269.297150,191.145767 272.413788,191.145767 
	C271.930969,201.695389 268.162415,205.566147 261.515839,202.089905 
z"
          />
          <path
            fill="#3CA977"
            opacity="1.000000"
            stroke="none"
            d="
M248.655090,181.033844 
	C249.196594,180.340347 249.738083,179.646866 250.545502,178.889679 
	C258.455841,178.210983 258.455841,178.210983 259.531982,186.511993 
	C258.786621,187.237228 258.356354,187.551865 257.926056,187.866486 
	C255.262558,187.910034 252.599045,187.953583 249.494965,187.940689 
	C248.969147,187.467056 248.883926,187.049881 248.770355,186.007477 
	C248.685486,184.940598 248.628967,184.498932 248.572449,184.057266 
	C248.623428,183.591949 248.674393,183.126648 248.763336,182.081360 
	C248.801315,181.501373 248.655090,181.033844 248.655090,181.033844 
M250.993790,181.511749 
	C248.715286,187.706299 253.807800,184.258423 255.622681,184.853195 
	C256.139160,185.022476 257.897949,183.489594 257.790680,183.064270 
	C257.517181,181.980042 256.657104,180.464142 255.765106,180.254257 
	C254.492691,179.954849 252.982269,180.666824 250.993790,181.511749 
z"
          />
          <path
            fill="#3CA977"
            opacity="1.000000"
            stroke="none"
            d="
M258.172485,197.062378 
	C257.052216,198.043747 255.157410,200.025406 254.932068,199.850952 
	C252.803604,198.202896 248.366455,200.691574 248.009964,196.168686 
	C247.884048,194.571182 248.198364,192.938965 248.652924,191.085968 
	C252.512665,191.014465 256.031158,191.179565 259.820984,191.670746 
	C259.784576,192.797272 259.476837,193.597687 258.795074,194.431427 
	C256.734375,193.665359 255.008926,192.188828 253.373444,192.282547 
	C252.082993,192.356491 250.903275,194.362823 249.674377,195.510925 
	C249.935242,196.028076 250.196106,196.545242 250.456985,197.062393 
	C253.028824,197.062393 255.600677,197.062393 258.172485,197.062378 
z"
          />
          <path
            fill="#45B581"
            opacity="1.000000"
            stroke="none"
            d="
M263.008606,209.443176 
	C261.025848,211.036011 259.278992,212.439972 257.406128,213.648697 
	C257.019806,213.898026 256.164001,213.419907 255.224304,212.791901 
	C256.021423,210.250122 257.118866,208.193573 258.216309,206.137009 
	C258.656677,205.836243 259.097076,205.535477 259.769684,205.101776 
	C261.067871,206.374268 262.133820,207.779678 263.008606,209.443176 
z"
          />
          <path
            fill="#3CA977"
            opacity="1.000000"
            stroke="none"
            d="
M253.944153,165.136414 
	C253.933533,164.667221 254.181335,164.338120 254.725708,163.889038 
	C258.123810,165.501602 261.225372,167.234146 264.517853,169.073349 
	C260.265991,173.350235 258.725250,173.069992 256.452209,167.840012 
	C255.720459,166.938004 255.333344,166.558548 254.946213,166.179092 
	C254.698334,165.878220 254.450455,165.577362 253.944153,165.136414 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M250.906509,175.354553 
	C250.281860,175.133377 249.657227,174.912201 248.966278,173.965881 
	C248.836014,171.804901 248.772064,170.369064 248.708130,168.933243 
	C248.914856,168.017776 249.121582,167.102310 249.756348,166.329300 
	C250.458984,166.644196 250.733582,166.816620 251.008194,166.989059 
	C251.008194,166.989059 251.000000,167.000000 251.105927,167.271667 
	C251.776123,168.081512 252.340393,168.619690 252.904648,169.157883 
	C253.447495,170.987701 253.990341,172.817535 253.875916,174.813477 
	C252.447937,175.104568 251.677216,175.229568 250.906509,175.354553 
z"
          />
          <path
            fill="#EAFDF7"
            opacity="1.000000"
            stroke="none"
            d="
M258.161621,188.159683 
	C258.356354,187.551865 258.786621,187.237228 259.503296,186.903656 
	C260.628723,186.905472 261.467743,186.926254 262.725128,186.905075 
	C263.143494,186.863113 263.017090,187.000778 263.085938,186.935181 
	C261.568878,187.397354 259.983032,187.925110 258.161621,188.159683 
z"
          />
          <path
            fill="#B7F2D9"
            opacity="1.000000"
            stroke="none"
            d="
M252.907944,168.821381 
	C252.340393,168.619690 251.776123,168.081512 251.111603,167.267456 
	C251.644638,167.489349 252.277939,167.987122 252.907944,168.821381 
z"
          />
          <path
            fill="#B7F2D9"
            opacity="1.000000"
            stroke="none"
            d="
M250.904221,175.555298 
	C251.677216,175.229568 252.447937,175.104568 253.609100,175.022003 
	C253.211578,175.391068 252.423599,175.717697 251.299973,176.098511 
	C250.964325,176.152679 250.901932,175.756042 250.904221,175.555298 
z"
          />
          <path
            fill="#B7F2D9"
            opacity="1.000000"
            stroke="none"
            d="
M254.986694,166.472443 
	C255.333344,166.558548 255.720459,166.938004 256.191284,167.588089 
	C255.859039,167.494400 255.443115,167.130096 254.986694,166.472443 
z"
          />
          <path
            fill="#B7F2D9"
            opacity="1.000000"
            stroke="none"
            d="
M251.289734,165.967636 
	C251.492035,165.679703 252.006958,165.361572 252.843002,165.005157 
	C252.643539,165.290405 252.122955,165.613922 251.289734,165.967636 
z"
          />
          <path
            fill="#B7F2D9"
            opacity="1.000000"
            stroke="none"
            d="
M251.016388,166.736176 
	C250.733582,166.816620 250.458984,166.644196 250.100067,166.233978 
	C250.015762,165.996201 250.505493,165.952255 250.750961,165.965134 
	C251.005814,166.146423 251.015213,166.314850 251.016388,166.736176 
z"
          />
          <path
            fill="#45B581"
            opacity="1.000000"
            stroke="none"
            d="
M163.510010,285.938629 
	C161.713120,283.621796 161.580673,281.547058 164.708862,281.374023 
	C166.038055,281.300507 167.460434,282.912201 168.840469,283.757996 
	C167.189560,284.525665 165.538651,285.293335 163.510010,285.938629 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M166.989792,276.422058 
	C165.613235,277.414185 164.222214,278.064575 161.781281,279.205933 
	C162.974869,276.829163 163.640976,275.502747 164.307068,274.176331 
	C165.196472,274.811005 166.085892,275.445709 166.989792,276.422058 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M173.217987,274.008423 
	C173.404114,273.885559 173.591492,273.945129 173.778870,274.004700 
	C173.592331,274.066742 173.405792,274.128784 173.217987,274.008423 
z"
          />
          <path
            fill="#1EB56E"
            opacity="1.000000"
            stroke="none"
            d="
M209.434570,285.895386 
	C209.061401,285.588715 208.887894,285.301453 208.495712,284.886902 
	C208.053925,283.434540 207.830811,282.109497 207.543686,280.385315 
	C207.508194,279.804932 207.536743,279.623657 207.689621,278.877350 
	C207.851471,277.879486 207.889008,277.446686 207.926544,277.013855 
	C209.909637,276.428955 212.632172,274.736389 213.733826,275.471832 
	C216.747162,277.483459 216.705154,280.872009 215.070221,284.482239 
	C213.543182,285.241699 212.144089,285.633728 210.368683,286.060669 
	C209.992386,286.095642 209.634232,285.914825 209.434570,285.895386 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M207.724197,277.131775 
	C207.889008,277.446686 207.851471,277.879486 207.663757,278.603333 
	C207.516342,278.346130 207.519104,277.797913 207.724197,277.131775 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M222.966278,283.649292 
	C220.455612,282.973907 220.208054,280.358734 222.542175,276.125732 
	C222.977325,276.477020 223.037811,276.904388 222.873962,277.744995 
	C222.588608,278.269104 222.448151,278.433929 222.480392,278.481384 
	C222.614990,278.679352 222.801498,278.842010 222.968964,279.017639 
	C222.992355,279.459076 223.015762,279.900513 222.815826,280.763184 
	C222.701477,281.462250 222.810486,281.740082 222.919510,282.017944 
	C222.956146,282.453949 222.992783,282.889954 222.966278,283.649292 
z"
          />
          <path
            fill="#24B26F"
            opacity="1.000000"
            stroke="none"
            d="
M223.046509,278.757507 
	C222.801498,278.842010 222.614990,278.679352 222.480392,278.481384 
	C222.448151,278.433929 222.588608,278.269104 222.817200,278.065430 
	C223.031189,278.147522 223.077606,278.322449 223.046509,278.757507 
z"
          />
          <path
            fill="#24B26F"
            opacity="1.000000"
            stroke="none"
            d="
M222.987091,281.761047 
	C222.810486,281.740082 222.701477,281.462250 222.748413,281.089508 
	C222.954468,281.164490 223.004578,281.334351 222.987091,281.761047 
z"
          />
          <path
            fill="#C8F9E5"
            opacity="1.000000"
            stroke="none"
            d="
M229.971573,191.372894 
	C229.956650,189.852371 229.977951,188.670441 229.951172,187.148560 
	C230.510925,183.758972 231.118744,180.709305 231.921661,177.333405 
	C233.650864,176.544144 235.184967,176.081116 237.271790,175.264801 
	C238.075104,174.872498 238.325684,174.833496 238.926605,174.813812 
	C241.091675,175.093567 242.906403,175.354004 244.721130,175.614441 
	C244.652969,176.915863 244.584808,178.217285 243.850693,179.768234 
	C242.455811,180.066727 241.726883,180.115677 240.811142,180.076462 
	C240.624329,179.988297 240.214401,179.936874 240.091492,179.666992 
	C239.629105,179.263275 239.289627,179.129440 238.629257,178.954453 
	C237.884186,178.988617 237.460007,179.063934 236.670212,179.073181 
	C235.897720,180.976654 234.539139,184.064301 235.275299,184.690887 
	C236.987778,186.148438 239.709854,186.419846 242.117386,187.311157 
	C242.468582,187.347229 242.725204,187.244064 243.262177,186.976791 
	C243.617828,186.194153 243.693146,185.575592 243.847809,184.630981 
	C243.993713,183.863251 244.060287,183.421585 244.126862,182.979904 
	C244.656616,184.112122 245.542023,185.217789 245.629013,186.383057 
	C245.746338,187.954742 245.249161,189.572296 244.742828,191.599121 
	C244.287033,192.041595 244.104080,192.055115 243.944870,192.067184 
	C243.968628,192.065720 243.939056,192.101868 243.926926,191.805939 
	C243.643692,191.150375 243.372589,190.790771 243.101501,190.431152 
	C242.734421,190.873413 242.367325,191.315674 241.567017,191.815704 
	C239.094528,191.921875 237.055267,191.970276 234.772095,192.025223 
	C234.249634,192.153793 233.971069,192.275803 233.692505,192.397812 
	C234.072556,192.598831 234.452606,192.799850 234.870422,193.283997 
	C234.830032,193.740784 234.751877,193.914429 234.473083,194.326233 
	C234.172928,195.391998 234.073410,196.219604 233.742905,196.935898 
	C232.737579,196.886536 231.963257,196.948486 231.072968,196.726257 
	C230.942368,196.035309 230.927719,195.628555 230.932739,194.909821 
	C230.704285,194.054153 230.456146,193.510468 230.208008,192.966782 
	C230.208023,192.966782 230.052002,193.056580 229.962021,193.059265 
	C229.917297,192.611801 229.962540,192.161621 229.971573,191.372894 
z"
          />
          <path
            fill="#31B377"
            opacity="1.000000"
            stroke="none"
            d="
M244.908875,211.486313 
	C243.121033,211.294250 241.404633,210.663177 239.323242,210.014786 
	C238.958282,209.997467 238.990219,210.041916 239.000183,209.635071 
	C238.751404,207.178253 238.492691,205.128311 238.614716,203.090637 
	C240.952408,202.797623 242.909363,202.492310 244.866302,202.186996 
	C244.904297,205.140427 244.942291,208.093872 244.908875,211.486313 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M249.943954,211.750763 
	C249.517761,211.585388 249.091568,211.420029 248.341125,211.126373 
	C248.016891,208.254074 248.016891,205.510056 248.016891,201.499557 
	C250.932098,202.466049 253.277786,203.243729 255.395462,204.579285 
	C253.426285,207.341690 251.685120,209.546234 249.943954,211.750763 
z"
          />
          <path
            fill="#CDFAE7"
            opacity="1.000000"
            stroke="none"
            d="
M244.900803,201.762741 
	C242.909363,202.492310 240.952408,202.797623 238.307678,202.963867 
	C237.061417,201.927032 236.502945,201.029266 235.962738,199.892792 
	C235.981018,199.654083 235.963974,199.177994 236.316406,199.168549 
	C237.138641,199.173355 237.608444,199.187622 238.254425,199.398331 
	C238.956070,199.106934 239.481552,198.619080 240.411835,198.066498 
	C245.717056,198.046707 243.398575,194.314407 243.921112,192.068649 
	C244.104080,192.055115 244.287033,192.041595 244.744949,192.012573 
	C244.991714,195.110870 244.963501,198.224686 244.900803,201.762741 
z"
          />
          <path
            fill="#2FB276"
            opacity="1.000000"
            stroke="none"
            d="
M244.797943,175.257324 
	C242.906403,175.354004 241.091675,175.093567 238.800735,174.493805 
	C239.634415,171.820450 240.944305,169.486404 242.254181,167.152344 
	C243.158890,167.413193 244.493576,163.705124 245.015167,168.126984 
	C245.067856,169.866913 245.126007,170.931885 245.184143,171.996872 
	C245.081024,172.964645 244.977890,173.932419 244.797943,175.257324 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M258.441711,196.916718 
	C255.600677,197.062393 253.028824,197.062393 250.456985,197.062393 
	C250.196106,196.545242 249.935242,196.028076 249.674377,195.510925 
	C250.903275,194.362823 252.082993,192.356491 253.373444,192.282547 
	C255.008926,192.188828 256.734375,193.665359 258.667389,194.728714 
	C258.846130,195.585480 258.778534,196.178268 258.441711,196.916718 
z"
          />
          <path
            fill="#BBF6DD"
            opacity="1.000000"
            stroke="none"
            d="
M250.102188,212.030945 
	C251.685120,209.546234 253.426285,207.341690 255.427979,204.927246 
	C256.280243,205.153549 256.872009,205.589737 257.840027,206.081482 
	C257.118866,208.193573 256.021423,210.250122 254.955139,212.663208 
	C254.986267,213.019745 255.005325,212.998688 254.741714,213.004959 
	C254.113800,213.040054 253.749481,213.068878 253.385178,213.097702 
	C252.343597,212.835510 251.302002,212.573318 250.102188,212.030945 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M240.214401,179.936874 
	C240.214401,179.936874 240.624329,179.988297 240.988770,180.295319 
	C242.172867,181.066147 242.992508,181.529953 243.812149,181.993774 
	C243.861938,182.158936 243.911713,182.324112 244.044189,182.734604 
	C244.060287,183.421585 243.993713,183.863251 243.423889,184.641815 
	C241.159088,184.978699 239.397537,184.978699 237.035812,184.978699 
	C237.035812,182.659027 237.035812,180.899139 237.035812,179.139267 
	C237.460007,179.063934 237.884186,178.988617 238.774033,179.190216 
	C239.564590,179.623718 239.889496,179.780304 240.214401,179.936874 
z"
          />
          <path
            fill="#C6F9E4"
            opacity="1.000000"
            stroke="none"
            d="
M241.904114,167.077637 
	C240.944305,169.486404 239.634415,171.820450 238.450409,174.474487 
	C238.325684,174.833496 238.075104,174.872498 237.447021,174.951538 
	C236.665192,173.724365 236.260834,172.457153 235.511520,171.126190 
	C236.560852,169.116211 237.955154,167.169937 239.647217,165.083282 
	C240.481339,165.629562 241.017700,166.316238 241.904114,167.077637 
z"
          />
          <path
            fill="#B7F2D9"
            opacity="1.000000"
            stroke="none"
            d="
M248.370819,169.022354 
	C248.772064,170.369064 248.836014,171.804901 248.803284,173.663818 
	C248.482239,172.428421 248.257889,170.769943 248.370819,169.022354 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M243.897888,181.673065 
	C242.992508,181.529953 242.172867,181.066147 241.175598,180.383484 
	C241.726883,180.115677 242.455811,180.066727 243.550201,180.024078 
	C243.938324,180.471039 243.960968,180.911713 243.897888,181.673065 
z"
          />
          <path
            fill="#C8F9E5"
            opacity="1.000000"
            stroke="none"
            d="
M245.402771,171.763397 
	C245.126007,170.931885 245.067856,169.866913 245.074493,168.406693 
	C245.299988,169.184280 245.460693,170.357086 245.402771,171.763397 
z"
          />
          <path
            fill="#DBFDF0"
            opacity="1.000000"
            stroke="none"
            d="
M248.385803,184.187592 
	C248.628967,184.498932 248.685486,184.940598 248.657883,185.708557 
	C248.448898,185.462540 248.324036,184.890228 248.385803,184.187592 
z"
          />
          <path
            fill="#DBFDF0"
            opacity="1.000000"
            stroke="none"
            d="
M248.536316,181.125214 
	C248.655090,181.033844 248.801315,181.501373 248.717041,181.731323 
	C248.329010,181.768646 248.257278,181.520416 248.536316,181.125214 
z"
          />
          <path
            fill="#27AD6F"
            opacity="1.000000"
            stroke="none"
            d="
M242.082016,370.270203 
	C245.088867,371.165314 246.126328,372.954193 244.194183,375.091736 
	C243.507111,375.851837 240.665665,375.924530 239.995697,375.204895 
	C237.951843,373.009674 239.424561,371.341064 242.082016,370.270203 
z"
          />
          <path
            fill="#20B672"
            opacity="1.000000"
            stroke="none"
            d="
M243.002335,415.697571 
	C239.193710,413.227417 237.418198,408.130219 239.332977,405.060699 
	C240.076996,403.867981 242.009201,402.691406 243.324829,402.769867 
	C244.854599,402.861145 246.880432,403.981934 247.677414,405.278778 
	C250.177658,409.347260 248.106491,413.958954 243.002335,415.697571 
z"
          />
          <path
            fill="#45B581"
            opacity="1.000000"
            stroke="none"
            d="
M253.350586,213.315598 
	C253.749481,213.068878 254.113800,213.040054 254.753479,212.997040 
	C254.884018,213.261871 254.684372,213.493713 254.250458,213.822968 
	C253.765717,213.916061 253.514053,213.771362 253.350586,213.315598 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M230.913086,195.221802 
	C230.927719,195.628555 230.942368,196.035309 231.076889,197.067780 
	C231.174469,199.146378 231.152176,200.599289 230.850403,202.032654 
	C230.384262,202.007935 230.197556,202.002731 230.010864,201.997513 
	C229.867996,199.796692 229.725113,197.595886 230.069763,195.219360 
	C230.557281,195.043655 230.913086,195.221802 230.913086,195.221802 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M230.932739,194.909821 
	C230.913086,195.221802 230.557281,195.043655 230.362030,195.006409 
	C230.153900,194.523148 230.141022,194.077164 230.168091,193.298981 
	C230.456146,193.510468 230.704285,194.054153 230.932739,194.909821 
z"
          />
          <path
            fill="#45B581"
            opacity="1.000000"
            stroke="none"
            d="
M229.763901,202.009888 
	C230.197556,202.002731 230.384262,202.007935 230.761444,202.303192 
	C230.498260,202.929245 230.044586,203.265228 229.590912,203.601196 
	C229.590912,203.601181 229.289352,203.294815 229.150620,202.920227 
	C229.011887,202.545624 229.029221,202.104233 229.029221,202.104233 
	C229.029221,202.104233 229.516937,202.022247 229.763901,202.009888 
z"
          />
          <path
            fill="#3AB17D"
            opacity="1.000000"
            stroke="none"
            d="
M228.773972,202.084259 
	C229.029221,202.104233 229.011887,202.545624 229.000870,202.766037 
	C228.691315,202.900864 228.440781,202.740402 228.123993,202.312683 
	C228.179413,202.101639 228.349060,202.082962 228.773972,202.084259 
z"
          />
          <path
            fill="#EAFDF7"
            opacity="1.000000"
            stroke="none"
            d="
M229.442871,203.920242 
	C230.044586,203.265228 230.498260,202.929245 231.040894,202.322723 
	C231.152176,200.599289 231.174469,199.146378 231.192841,197.351959 
	C231.963257,196.948486 232.737579,196.886536 233.761261,197.281189 
	C234.655212,198.535675 235.299850,199.333588 235.944473,200.131500 
	C236.502945,201.029266 237.061417,201.927032 237.926926,202.951569 
	C238.492691,205.128311 238.751404,207.178253 239.026733,209.628021 
	C238.434998,209.901505 237.471436,209.972855 237.273941,209.617935 
	C235.508560,206.445374 232.850784,204.702591 229.442871,203.920242 
z"
          />
          <path
            fill="#06BC63"
            opacity="1.000000"
            stroke="none"
            d="
M251.984711,277.031006 
	C251.411621,279.329895 250.858032,281.604340 250.304459,283.878815 
	C249.851593,283.945068 249.398743,284.011322 248.945877,284.077576 
	C248.336456,282.286499 247.415512,280.511139 247.323776,278.693939 
	C247.299026,278.203644 249.789642,277.586334 251.537125,277.030548 
	C251.948593,277.033783 252.004196,277.006592 251.984711,277.031006 
z"
          />
          <path
            fill="#03BE66"
            opacity="1.000000"
            stroke="none"
            d="
M251.283661,181.229279 
	C252.982269,180.666824 254.492691,179.954849 255.765106,180.254257 
	C256.657104,180.464142 257.517181,181.980042 257.790680,183.064270 
	C257.897949,183.489594 256.139160,185.022476 255.622681,184.853195 
	C253.807800,184.258423 248.715286,187.706299 251.283661,181.229279 
z"
          />
          <path
            fill="#0DB867"
            opacity="1.000000"
            stroke="none"
            d="
M238.078247,199.201874 
	C237.608444,199.187622 237.138641,199.173355 236.290268,198.782410 
	C235.499039,196.966507 235.086380,195.527298 234.673721,194.088074 
	C234.751877,193.914429 234.830032,193.740784 234.934708,193.041885 
	C234.979492,192.350647 234.997742,192.184662 235.015991,192.018677 
	C237.055267,191.970276 239.094528,191.921875 241.884308,191.902649 
	C243.069565,191.988495 243.504303,192.045181 243.939056,192.101868 
	C243.939056,192.101868 243.968628,192.065720 243.944870,192.067184 
	C243.398575,194.314407 245.717056,198.046707 240.094940,198.033508 
	C238.941574,198.444138 238.509918,198.823013 238.078247,199.201874 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M236.670212,179.073181 
	C237.035812,180.899139 237.035812,182.659027 237.035812,184.978699 
	C239.397537,184.978699 241.159088,184.978699 243.344559,184.967865 
	C243.693146,185.575592 243.617828,186.194153 243.020920,186.938385 
	C242.499329,187.064072 242.022812,187.171921 242.022812,187.171921 
	C239.709854,186.419846 236.987778,186.148438 235.275299,184.690887 
	C234.539139,184.064301 235.897720,180.976654 236.670212,179.073181 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M234.473083,194.326233 
	C235.086380,195.527298 235.499039,196.966507 235.937836,198.791870 
	C235.963974,199.177994 235.981018,199.654083 235.962738,199.892792 
	C235.299850,199.333588 234.655212,198.535675 233.992249,197.392487 
	C234.073410,196.219604 234.172928,195.391998 234.473083,194.326233 
z"
          />
          <path
            fill="#C6F9E4"
            opacity="1.000000"
            stroke="none"
            d="
M243.926926,191.805939 
	C243.504303,192.045181 243.069565,191.988495 242.317535,191.844879 
	C242.367325,191.315674 242.734421,190.873413 243.101501,190.431152 
	C243.372589,190.790771 243.643692,191.150375 243.926926,191.805939 
z"
          />
          <path
            fill="#C6F9E4"
            opacity="1.000000"
            stroke="none"
            d="
M234.772095,192.025223 
	C234.997742,192.184662 234.979492,192.350647 234.896942,192.758759 
	C234.452606,192.799850 234.072556,192.598831 233.692505,192.397812 
	C233.971069,192.275803 234.249634,192.153793 234.772095,192.025223 
z"
          />
          <path
            fill="#C6F9E4"
            opacity="1.000000"
            stroke="none"
            d="
M242.117386,187.311157 
	C242.022812,187.171921 242.499329,187.064072 242.740570,187.102478 
	C242.725204,187.244064 242.468582,187.347229 242.117386,187.311157 
z"
          />
          <path
            fill="#1BAF69"
            opacity="1.000000"
            stroke="none"
            d="
M240.091492,179.666992 
	C239.889496,179.780304 239.564590,179.623718 239.094910,179.231384 
	C239.289627,179.129440 239.629105,179.263275 240.091492,179.666992 
z"
          />
          <path
            fill="#C1FAE3"
            opacity="1.000000"
            stroke="none"
            d="
M238.254425,199.398331 
	C238.509918,198.823013 238.941574,198.444138 239.690125,198.098251 
	C239.481552,198.619080 238.956070,199.106934 238.254425,199.398331 
z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>; // Render logo without any link
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
